
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire023e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire023e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("doPjA", function(module, exports) {
module.exports = $parcel$import("fCoiS").then(()=>parcelRequire('jXuLE'));

});

var $6ead574841004d1e$exports = {};
$parcel$extendImportMap({
    "4uhYv": "konsens.8ebfcbc1.svg",
    "fCoiS": "es5.252774df.js"
});

var $51bb400a14a72998$exports = {};
!function(e) {
    "use strict";
    function r(e, r, t) {
        return t.a = e, t.f = r, t;
    }
    function F2(e) {
        return r(2, e, function(r) {
            return function(t) {
                return e(r, t);
            };
        });
    }
    function F3(e) {
        return r(3, e, function(r) {
            return function(t) {
                return function(n) {
                    return e(r, t, n);
                };
            };
        });
    }
    function F4(e) {
        return r(4, e, function(r) {
            return function(t) {
                return function(n) {
                    return function(u) {
                        return e(r, t, n, u);
                    };
                };
            };
        });
    }
    function F5(e) {
        return r(5, e, function(r) {
            return function(t) {
                return function(n) {
                    return function(u) {
                        return function(a) {
                            return e(r, t, n, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(e) {
        return r(6, e, function(r) {
            return function(t) {
                return function(n) {
                    return function(u) {
                        return function(a) {
                            return function(o) {
                                return e(r, t, n, u, a, o);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(e) {
        return r(7, e, function(r) {
            return function(t) {
                return function(n) {
                    return function(u) {
                        return function(a) {
                            return function(o) {
                                return function(i) {
                                    return e(r, t, n, u, a, o, i);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(e, r, t) {
        return 2 === e.a ? e.f(r, t) : e(r)(t);
    }
    function A3(e, r, t, n) {
        return 3 === e.a ? e.f(r, t, n) : e(r)(t)(n);
    }
    function A4(e, r, t, n, u) {
        return 4 === e.a ? e.f(r, t, n, u) : e(r)(t)(n)(u);
    }
    function A5(e, r, t, n, u, a) {
        return 5 === e.a ? e.f(r, t, n, u, a) : e(r)(t)(n)(u)(a);
    }
    function A6(e, r, t, n, u, a, o) {
        return 6 === e.a ? e.f(r, t, n, u, a, o) : e(r)(t)(n)(u)(a)(o);
    }
    function A7(e, r, t, n, u, a, o, i) {
        return 7 === e.a ? e.f(r, t, n, u, a, o, i) : e(r)(t)(n)(u)(a)(o)(i);
    }
    var t = F3(function(e, r, t) {
        for(var n = Array(e), u = 0; e > u; u++)n[u] = t(r + u);
        return n;
    }), n = F2(function(e, r) {
        for(var t = Array(e), n = 0; e > n && r.b; n++)t[n] = r.a, r = r.b;
        return t.length = n, g(t, r);
    }), u = F2(function(e, r) {
        return r[e];
    }), a = F3(function(e, r, t) {
        for(var n = t.length, u = Array(n), a = 0; n > a; a++)u[a] = t[a];
        return u[e] = r, u;
    }), o = F3(function(e, r, t) {
        for(var n = t.length, u = 0; n > u; u++)r = A2(e, t[u], r);
        return r;
    }), i = F3(function(e, r, t) {
        for(var n = t.length - 1; n >= 0; n--)r = A2(e, t[n], r);
        return r;
    }), c = F3(function(e, r, t) {
        for(var n = t.length, u = Array(n), a = 0; n > a; a++)u[a] = A2(e, r + a, t[a]);
        return u;
    });
    function f(e) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + e + ".md");
    }
    function s(e, r) {
        for(var t, n = [], u = l(e, r, 0, n); u && (t = n.pop()); u = l(t.a, t.b, 0, n));
        return u;
    }
    function l(e, r, t, n) {
        if (e === r) return !0;
        if ("object" != typeof e || null === e || null === r) return "function" == typeof e && f(5), !1;
        if (t > 100) return n.push(g(e, r)), !0;
        for(var u in 0 > e.$ && (e = ut(e), r = ut(r)), e)if (!l(e[u], r[u], t + 1, n)) return !1;
        return !0;
    }
    var b = F2(s);
    function d(e, r, t) {
        if ("object" != typeof e) return e === r ? 0 : r > e ? -1 : 1;
        if (void 0 === e.$) return (t = d(e.a, r.a)) || (t = d(e.b, r.b)) ? t : d(e.c, r.c);
        for(; e.b && r.b && !(t = d(e.a, r.a)); e = e.b, r = r.b);
        return t || (e.b ? 1 : r.b ? -1 : 0);
    }
    var p = F2(function(e, r) {
        var t = d(e, r);
        return 0 > t ? it : t ? ot : at;
    });
    function g(e, r) {
        return {
            a: e,
            b: r
        };
    }
    function x(e, r, t) {
        return {
            a: e,
            b: r,
            c: t
        };
    }
    function m(e) {
        return e;
    }
    function h(e, r) {
        var t = {};
        for(var n in e)t[n] = e[n];
        for(var n in r)t[n] = r[n];
        return t;
    }
    function v(e, r) {
        if ("string" == typeof e) return e + r;
        if (!e.b) return r;
        var t = y(e.a, r);
        e = e.b;
        for(var n = t; e.b; e = e.b)n = n.b = y(e.a, r);
        return t;
    }
    var w = {
        $: 0
    };
    function y(e, r) {
        return {
            $: 1,
            a: e,
            b: r
        };
    }
    var $ = F2(y);
    function k(e) {
        for(var r = w, t = e.length; t--;)r = y(e[t], r);
        return r;
    }
    function C(e) {
        for(var r = []; e.b; e = e.b)r.push(e.a);
        return r;
    }
    var _ = F3(function(e, r, t) {
        for(var n = []; r.b && t.b; r = r.b, t = t.b)n.push(A2(e, r.a, t.a));
        return k(n);
    }), j = F2(function(e, r) {
        return k(C(r).sort(function(r, t) {
            return d(e(r), e(t));
        }));
    }), F = F2(function(e, r) {
        return e + r;
    }), G = F2(function(e, r) {
        return e - r;
    }), M = F2(function(e, r) {
        var t = r % e;
        return 0 === e ? f(11) : t > 0 && 0 > e || 0 > t && e > 0 ? t + e : t;
    }), A = Math.ceil, X = Math.floor, L = Math.round, z = Math.log, R = isNaN, Z = F2(function(e, r) {
        return e + r;
    }), E = F3(function(e, r, t) {
        for(var n = t.length; n--;){
            var u = t[n], a = t.charCodeAt(n);
            56320 > a || a > 57343 || (u = t[--n] + u), r = A2(e, m(u), r);
        }
        return r;
    }), S = F2(function(e, r) {
        return r.split(e);
    }), H = F2(function(e, r) {
        return r.join(e);
    }), N = F3(function(e, r, t) {
        return t.slice(e, r);
    }), V = F2(function(e, r) {
        for(var t = r.length; t--;){
            var n = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (n = r[--t] + n), !e(m(n))) return !1;
        }
        return !0;
    }), I = F2(function(e, r) {
        return r.indexOf(e) > -1;
    }), T = F2(function(e, r) {
        return 0 === r.indexOf(e);
    }), q = F2(function(e, r) {
        return r.length >= e.length && r.lastIndexOf(e) === r.length - e.length;
    }), P = F2(function(e, r) {
        var t = e.length;
        if (1 > t) return w;
        for(var n = 0, u = []; (n = r.indexOf(e, n)) > -1;)u.push(n), n += t;
        return k(u);
    });
    function D(e) {
        return e + "";
    }
    function B(e) {
        return {
            $: 2,
            b: e
        };
    }
    var U = B(function(e) {
        return "number" != typeof e ? se("an INT", e) : e > -2147483647 && 2147483647 > e && (0 | e) === e ? bt(e) : !isFinite(e) || e % 1 ? se("an INT", e) : bt(e);
    }), O = B(function(e) {
        return "boolean" == typeof e ? bt(e) : se("a BOOL", e);
    }), J = B(function(e) {
        return "number" == typeof e ? bt(e) : se("a FLOAT", e);
    }), Q = B(function(e) {
        return bt(e);
    }), Y = B(function(e) {
        return "string" == typeof e ? bt(e) : e instanceof String ? bt(e + "") : se("a STRING", e);
    }), K = F2(function(e, r) {
        return {
            $: 6,
            d: e,
            b: r
        };
    });
    function W(e, r) {
        return {
            $: 9,
            f: e,
            g: r
        };
    }
    var ee = F2(function(e, r) {
        return {
            $: 10,
            b: r,
            h: e
        };
    }), re = F2(function(e, r) {
        return W(e, [
            r
        ]);
    }), te = F3(function(e, r, t) {
        return W(e, [
            r,
            t
        ]);
    }), ne = F5(function(e, r, t, n, u) {
        return W(e, [
            r,
            t,
            n,
            u
        ]);
    }), ue = F6(function(e, r, t, n, u, a) {
        return W(e, [
            r,
            t,
            n,
            u,
            a
        ]);
    }), ae = F2(function(e, r) {
        return oe(e, r);
    });
    function oe(e, r) {
        switch(e.$){
            case 2:
                return e.b(r);
            case 5:
                return null === r ? bt(e.c) : se("null", r);
            case 3:
                return ce(r) ? ie(e.b, r, k) : se("a LIST", r);
            case 4:
                return ce(r) ? ie(e.b, r, fe) : se("an ARRAY", r);
            case 6:
                var t = e.d;
                if ("object" != typeof r || null === r || !(t in r)) return se("an OBJECT with a field named `" + t + "`", r);
                var n = oe(e.b, r[t]);
                return cn(n) ? n : ct(A2(st, t, n.a));
            case 7:
                var u = e.e;
                return ce(r) ? r.length > u ? (n = oe(e.b, r[u]), cn(n) ? n : ct(A2(lt, u, n.a))) : se("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : se("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || ce(r)) return se("an OBJECT", r);
                var a = w;
                for(var o in r)if (r.hasOwnProperty(o)) {
                    if (n = oe(e.b, r[o]), !cn(n)) return ct(A2(st, o, n.a));
                    a = y(g(o, n.a), a);
                }
                return bt(Rt(a));
            case 9:
                for(var i = e.f, c = e.g, f = 0; c.length > f; f++){
                    if (n = oe(c[f], r), !cn(n)) return n;
                    i = i(n.a);
                }
                return bt(i);
            case 10:
                return n = oe(e.b, r), cn(n) ? oe(e.h(n.a), r) : n;
            case 11:
                for(var s = w, l = e.g; l.b; l = l.b){
                    if (n = oe(l.a, r), cn(n)) return n;
                    s = y(n.a, s);
                }
                return ct(dt(Rt(s)));
            case 1:
                return ct(A2(ft, e.a, r));
            case 0:
                return bt(e.a);
        }
    }
    function ie(e, r, t) {
        for(var n = r.length, u = Array(n), a = 0; n > a; a++){
            var o = oe(e, r[a]);
            if (!cn(o)) return ct(A2(lt, a, o.a));
            u[a] = o.a;
        }
        return bt(t(u));
    }
    function ce(e) {
        return Array.isArray(e) || "undefined" != typeof FileList && e instanceof FileList;
    }
    function fe(e) {
        return A2(on, e.length, function(r) {
            return e[r];
        });
    }
    function se(e, r) {
        return ct(A2(ft, "Expecting " + e, r));
    }
    function le(e, r) {
        if (e === r) return !0;
        if (e.$ !== r.$) return !1;
        switch(e.$){
            case 0:
            case 1:
                return e.a === r.a;
            case 2:
                return e.b === r.b;
            case 5:
                return e.c === r.c;
            case 3:
            case 4:
            case 8:
                return le(e.b, r.b);
            case 6:
                return e.d === r.d && le(e.b, r.b);
            case 7:
                return e.e === r.e && le(e.b, r.b);
            case 9:
                return e.f === r.f && be(e.g, r.g);
            case 10:
                return e.h === r.h && le(e.b, r.b);
            case 11:
                return be(e.g, r.g);
        }
    }
    function be(e, r) {
        var t = e.length;
        if (t !== r.length) return !1;
        for(var n = 0; t > n; n++)if (!le(e[n], r[n])) return !1;
        return !0;
    }
    var de = F2(function(e, r) {
        return JSON.stringify(r, null, e) + "";
    });
    function pe(e) {
        return e;
    }
    function ge(e) {
        return e;
    }
    var xe = F3(function(e, r, t) {
        return t[e] = r, t;
    });
    function me(e) {
        return {
            $: 0,
            a: e
        };
    }
    function he(e) {
        return {
            $: 2,
            b: e,
            c: null
        };
    }
    var ve = F2(function(e, r) {
        return {
            $: 3,
            b: e,
            d: r
        };
    }), we = F2(function(e, r) {
        return {
            $: 4,
            b: e,
            d: r
        };
    }), ye = 0;
    function $e(e) {
        var r = {
            $: 0,
            e: ye++,
            f: e,
            g: null,
            h: []
        };
        return je(r), r;
    }
    function ke(e, r) {
        e.h.push(r), je(e);
    }
    var Ce = !1, _e = [];
    function je(e) {
        if (_e.push(e), !Ce) {
            for(Ce = !0; e = _e.shift();)Fe(e);
            Ce = !1;
        }
    }
    function Fe(e) {
        for(; e.f;){
            var r = e.f.$;
            if (0 === r || 1 === r) {
                for(; e.g && e.g.$ !== r;)e.g = e.g.i;
                if (!e.g) return;
                e.f = e.g.b(e.f.a), e.g = e.g.i;
            } else {
                if (2 === r) return void (e.f.c = e.f.b(function(r) {
                    e.f = r, je(e);
                }));
                if (5 === r) {
                    if (0 === e.h.length) return;
                    e.f = e.f.b(e.h.shift());
                } else e.g = {
                    $: 3 === r ? 0 : 1,
                    b: e.f.b,
                    i: e.g
                }, e.f = e.f.d;
            }
        }
    }
    var Ge = {};
    function Me(e, r) {
        var t = {
            g: r,
            h: void 0
        }, n = e.c, u = e.d, a = e.e, o = e.f;
        function i(e) {
            return A2(ve, i, {
                $: 5,
                b: function(r) {
                    var i = r.a;
                    return 0 === r.$ ? A3(u, t, i, e) : a && o ? A4(n, t, i.i, i.j, e) : A3(n, t, a ? i.i : i.j, e);
                }
            });
        }
        return t.h = $e(A2(ve, i, e.b));
    }
    var Ae = F2(function(e, r) {
        return he(function(t) {
            e.g(r), t(me(0));
        });
    });
    function Xe(e) {
        return function(r) {
            return {
                $: 1,
                k: e,
                l: r
            };
        };
    }
    function Le(e) {
        return {
            $: 2,
            m: e
        };
    }
    var ze = F2(function(e, r) {
        return {
            $: 3,
            n: e,
            o: r
        };
    }), Re = [], Ze = !1;
    function Ee(e, r, t) {
        if (Re.push({
            p: e,
            q: r,
            r: t
        }), !Ze) {
            Ze = !0;
            for(var n; n = Re.shift();)Se(n.p, n.q, n.r);
            Ze = !1;
        }
    }
    function Se(e, r, t) {
        var n = {};
        for(var u in He(!0, r, n, null), He(!1, t, n, null), e)ke(e[u], {
            $: "fx",
            a: n[u] || {
                i: w,
                j: w
            }
        });
    }
    function He(e, r, t, n) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(e, r, t, n) {
                    function u(e) {
                        for(var r = t; r; r = r.t)e = r.s(e);
                        return e;
                    }
                    return A2(e ? Ge[r].e : Ge[r].f, u, n);
                }(e, u, n, r.l);
                return void (t[u] = function(e, r, t) {
                    return t = t || {
                        i: w,
                        j: w
                    }, e ? t.i = y(r, t.i) : t.j = y(r, t.j), t;
                }(e, a, t[u]));
            case 2:
                for(var o = r.m; o.b; o = o.b)He(e, o.a, t, n);
                return;
            case 3:
                return void He(e, r.o, t, {
                    s: r.n,
                    t: n
                });
        }
    }
    function Ne(e) {
        Ge[e] && f(3);
    }
    function Ve(e, r) {
        return Ne(e), Ge[e] = {
            e: Ie,
            u: r,
            a: Te
        }, Xe(e);
    }
    var Ie = F2(function(e, r) {
        return r;
    });
    function Te(e) {
        var r = [], t = Ge[e].u, n = he(function(e) {
            var r = setTimeout(function() {
                e(me(0));
            }, 0);
            return function() {
                clearTimeout(r);
            };
        });
        return Ge[e].b = n, Ge[e].c = F3(function(e, u) {
            for(; u.b; u = u.b)for(var a = r, o = ge(t(u.a)), i = 0; a.length > i; i++)a[i](o);
            return n;
        }), {
            subscribe: function(e) {
                r.push(e);
            },
            unsubscribe: function(e) {
                var t = (r = r.slice()).indexOf(e);
                0 > t || r.splice(t, 1);
            }
        };
    }
    var qe = F2(function(e, r) {
        return function(t) {
            return e(r(t));
        };
    });
    var Pe = "undefined" != typeof document ? document : {};
    function De(e, r) {
        e.appendChild(r);
    }
    function Be(e) {
        return {
            $: 0,
            a: e
        };
    }
    var Ue = F2(function(e, r) {
        return F2(function(t, n) {
            for(var u = [], a = 0; n.b; n = n.b){
                var o = n.a;
                a += o.b || 0, u.push(o);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: ir(t),
                e: u,
                f: e,
                b: a
            };
        });
    }), Oe = Ue(void 0);
    F2(function(e, r) {
        return F2(function(t, n) {
            for(var u = [], a = 0; n.b; n = n.b){
                var o = n.a;
                a += o.b.b || 0, u.push(o);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: ir(t),
                e: u,
                f: e,
                b: a
            };
        });
    })(void 0);
    var Je, Qe = F2(function(e, r) {
        return {
            $: 4,
            j: e,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), Ye = F2(function(e, r) {
        return {
            $: "a0",
            n: e,
            o: r
        };
    }), Ke = F2(function(e, r) {
        return {
            $: "a1",
            n: e,
            o: r
        };
    }), We = F2(function(e, r) {
        return {
            $: "a2",
            n: e,
            o: r
        };
    }), er = F2(function(e, r) {
        return {
            $: "a3",
            n: e,
            o: r
        };
    }), rr = F3(function(e, r, t) {
        return {
            $: "a4",
            n: r,
            o: {
                f: e,
                o: t
            }
        };
    }), tr = /^script$/i, nr = /^(on|formAction$)/i, ur = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, ar = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function or(e) {
        return ar.test(e) ? "" : e;
    }
    function ir(e) {
        for(var r = {}; e.b; e = e.b){
            var t = e.a, n = t.$, u = t.n, a = t.o;
            if ("a2" !== n) {
                var o = r[n] || (r[n] = {});
                "a3" === n && "class" === u ? cr(o, u, a) : o[u] = a;
            } else "className" === u ? cr(r, u, ge(a)) : r[u] = ge(a);
        }
        return r;
    }
    function cr(e, r, t) {
        var n = e[r];
        e[r] = n ? n + " " + t : t;
    }
    function fr(e, r) {
        var t = e.$;
        if (5 === t) return fr(e.k || (e.k = e.m()), r);
        if (0 === t) return Pe.createTextNode(e.a);
        if (4 === t) {
            for(var n = e.k, u = e.j; 4 === n.$;)"object" != typeof u ? u = [
                u,
                n.j
            ] : u.push(n.j), n = n.k;
            var a = {
                j: u,
                p: r
            };
            return (o = fr(n, a)).elm_event_node_ref = a, o;
        }
        if (3 === t) return sr(o = e.h(e.g), r, e.d), o;
        var o = e.f ? Pe.createElementNS(e.f, e.c) : Pe.createElement(e.c);
        sr(o, r, e.d);
        for(var i = e.e, c = 0; i.length > c; c++)De(o, fr(1 === t ? i[c] : i[c].b, r));
        return o;
    }
    function sr(e, r, t) {
        for(var n in t){
            var u = t[n];
            "a1" === n ? lr(e, u) : "a0" === n ? pr(e, r, u) : "a3" === n ? br(e, u) : "a4" === n ? dr(e, u) : ("value" !== n && "checked" !== n || e[n] !== u) && (e[n] = u);
        }
    }
    function lr(e, r) {
        var t = e.style;
        for(var n in r)t[n] = r[n];
    }
    function br(e, r) {
        for(var t in r){
            var n = r[t];
            void 0 !== n ? e.setAttribute(t, n) : e.removeAttribute(t);
        }
    }
    function dr(e, r) {
        for(var t in r){
            var n = r[t], u = n.f, a = n.o;
            void 0 !== a ? e.setAttributeNS(u, t, a) : e.removeAttributeNS(u, t);
        }
    }
    function pr(e, r, t) {
        var n = e.elmFs || (e.elmFs = {});
        for(var u in t){
            var a = t[u], o = n[u];
            if (a) {
                if (o) {
                    if (o.q.$ === a.$) {
                        o.q = a;
                        continue;
                    }
                    e.removeEventListener(u, o);
                }
                o = gr(r, a), e.addEventListener(u, o, Je && {
                    passive: 2 > dn(a)
                }), n[u] = o;
            } else e.removeEventListener(u, o), n[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Je = !0;
            }
        }));
    } catch (e) {}
    function gr(e, r) {
        function t(r) {
            var n = t.q, u = oe(n.a, r);
            if (cn(u)) {
                for(var a, o = dn(n), i = u.a, c = o ? 3 > o ? i.a : i.G : i, f = 1 == o ? i.b : 3 == o && i.ba, s = (f && r.stopPropagation(), (2 == o ? i.b : 3 == o && i.a2) && r.preventDefault(), e); a = s.j;){
                    if ("function" == typeof a) c = a(c);
                    else for(var l = a.length; l--;)c = a[l](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return t.q = r, t;
    }
    function xr(e, r) {
        return e.$ == r.$ && le(e.a, r.a);
    }
    function mr(e, r, t, n) {
        var u = {
            $: r,
            r: t,
            s: n,
            t: void 0,
            u: void 0
        };
        return e.push(u), u;
    }
    function hr(e, r, t, n) {
        if (e !== r) {
            var u = e.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void mr(t, 0, n, r);
                r = function(e) {
                    for(var r = e.e, t = r.length, n = Array(t), u = 0; t > u; u++)n[u] = r[u].b;
                    return {
                        $: 1,
                        c: e.c,
                        d: e.d,
                        e: n,
                        f: e.f,
                        b: e.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var o = e.l, i = r.l, c = o.length, f = c === i.length; f && c--;)f = o[c] === i[c];
                    if (f) return void (r.k = e.k);
                    r.k = r.m();
                    var s = [];
                    return hr(e.k, r.k, s, 0), void (s.length > 0 && mr(t, 1, n, s));
                case 4:
                    for(var l = e.j, b = r.j, d = !1, p = e.k; 4 === p.$;)d = !0, "object" != typeof l ? l = [
                        l,
                        p.j
                    ] : l.push(p.j), p = p.k;
                    for(var g = r.k; 4 === g.$;)d = !0, "object" != typeof b ? b = [
                        b,
                        g.j
                    ] : b.push(g.j), g = g.k;
                    return d && l.length !== b.length ? void mr(t, 0, n, r) : ((d ? function(e, r) {
                        for(var t = 0; e.length > t; t++)if (e[t] !== r[t]) return !1;
                        return !0;
                    }(l, b) : l === b) || mr(t, 2, n, b), void hr(p, g, t, n + 1));
                case 0:
                    return void (e.a !== r.a && mr(t, 3, n, r.a));
                case 1:
                    return void vr(e, r, t, n, yr);
                case 2:
                    return void vr(e, r, t, n, $r);
                case 3:
                    if (e.h !== r.h) return void mr(t, 0, n, r);
                    var x = wr(e.d, r.d);
                    x && mr(t, 4, n, x);
                    var m = r.i(e.g, r.g);
                    return void (m && mr(t, 5, n, m));
            }
        }
    }
    function vr(e, r, t, n, u) {
        if (e.c === r.c && e.f === r.f) {
            var a = wr(e.d, r.d);
            a && mr(t, 4, n, a), u(e, r, t, n);
        } else mr(t, 0, n, r);
    }
    function wr(e, r, t) {
        var n;
        for(var u in e)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = e[u], o = r[u];
                a === o && "value" !== u && "checked" !== u || "a0" === t && xr(a, o) || ((n = n || {})[u] = o);
            } else (n = n || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: e[u].f,
                o: void 0
            } : "string" == typeof e[u] ? "" : null;
        } else {
            var i = wr(e[u], r[u] || {}, u);
            i && ((n = n || {})[u] = i);
        }
        for(var c in r)c in e || ((n = n || {})[c] = r[c]);
        return n;
    }
    function yr(e, r, t, n) {
        var u = e.e, a = r.e, o = u.length, i = a.length;
        o > i ? mr(t, 6, n, {
            v: i,
            i: o - i
        }) : i > o && mr(t, 7, n, {
            v: o,
            e: a
        });
        for(var c = i > o ? o : i, f = 0; c > f; f++){
            var s = u[f];
            hr(s, a[f], t, ++n), n += s.b || 0;
        }
    }
    function $r(e, r, t, n) {
        for(var u = [], a = {}, o = [], i = e.e, c = r.e, f = i.length, s = c.length, l = 0, b = 0, d = n; f > l && s > b;){
            var p = (j = i[l]).a, g = (F = c[b]).a, x = j.b, m = F.b, h = void 0, v = void 0;
            if (p !== g) {
                var w = i[l + 1], y = c[b + 1];
                if (w) {
                    var $ = w.a, k = w.b;
                    v = g === $;
                }
                if (y) {
                    var C = y.a, _ = y.b;
                    h = p === C;
                }
                if (h && v) hr(x, _, u, ++d), Cr(a, u, p, m, b, o), d += x.b || 0, _r(a, u, p, k, ++d), d += k.b || 0, l += 2, b += 2;
                else if (h) d++, Cr(a, u, g, m, b, o), hr(x, _, u, d), d += x.b || 0, l += 1, b += 2;
                else if (v) _r(a, u, p, x, ++d), d += x.b || 0, hr(k, m, u, ++d), d += k.b || 0, l += 2, b += 1;
                else {
                    if (!w || $ !== C) break;
                    _r(a, u, p, x, ++d), Cr(a, u, g, m, b, o), d += x.b || 0, hr(k, _, u, ++d), d += k.b || 0, l += 2, b += 2;
                }
            } else hr(x, m, u, ++d), d += x.b || 0, l++, b++;
        }
        for(; f > l;){
            var j;
            d++, _r(a, u, (j = i[l]).a, x = j.b, d), d += x.b || 0, l++;
        }
        for(; s > b;){
            var F, G = G || [];
            Cr(a, u, (F = c[b]).a, F.b, void 0, G), b++;
        }
        (u.length > 0 || o.length > 0 || G) && mr(t, 8, n, {
            w: u,
            x: o,
            y: G
        });
    }
    var kr = "_elmW6BL";
    function Cr(e, r, t, n, u, a) {
        var o = e[t];
        if (!o) return a.push({
            r: u,
            A: o = {
                c: 0,
                z: n,
                r: u,
                s: void 0
            }
        }), void (e[t] = o);
        if (1 === o.c) {
            a.push({
                r: u,
                A: o
            }), o.c = 2;
            var i = [];
            return hr(o.z, n, i, o.r), o.r = u, void (o.s.s = {
                w: i,
                A: o
            });
        }
        Cr(e, r, t + kr, n, u, a);
    }
    function _r(e, r, t, n, u) {
        var a = e[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var o = [];
                return hr(n, a.z, o, u), void mr(r, 9, u, {
                    w: o,
                    A: a
                });
            }
            _r(e, r, t + kr, n, u);
        } else {
            var i = mr(r, 9, u, void 0);
            e[t] = {
                c: 1,
                z: n,
                r: u,
                s: i
            };
        }
    }
    function jr(e, r, t, n) {
        Fr(e, r, t, 0, 0, r.b, n);
    }
    function Fr(e, r, t, n, u, a, o) {
        for(var i = t[n], c = i.r; c === u;){
            var f = i.$;
            if (1 === f) jr(e, r.k, i.s, o);
            else if (8 === f) i.t = e, i.u = o, (s = i.s.w).length > 0 && Fr(e, r, s, 0, u, a, o);
            else if (9 === f) {
                i.t = e, i.u = o;
                var s, l = i.s;
                l && (l.A.s = e, (s = l.w).length > 0 && Fr(e, r, s, 0, u, a, o));
            } else i.t = e, i.u = o;
            if (!(i = t[++n]) || (c = i.r) > a) return n;
        }
        var b = r.$;
        if (4 === b) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return Fr(e, d, t, n, u + 1, a, e.elm_event_node_ref);
        }
        for(var p = r.e, g = e.childNodes, x = 0; p.length > x; x++){
            u++;
            var m = 1 === b ? p[x] : p[x].b, h = u + (m.b || 0);
            if (!(u > c || c > h || (i = t[n = Fr(g[x], m, t, n, u, h, o)]) && (c = i.r) <= a)) return n;
            u = h;
        }
        return n;
    }
    function Gr(e, r) {
        for(var t = 0; r.length > t; t++){
            var n = r[t], u = n.t, a = Mr(u, n);
            u === e && (e = a);
        }
        return e;
    }
    function Mr(e, r) {
        switch(r.$){
            case 0:
                return function(e, r, t) {
                    var n = e.parentNode, u = fr(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = e.elm_event_node_ref), n && u !== e && n.replaceChild(u, e), u;
                }(e, r.s, r.u);
            case 4:
                return sr(e, r.u, r.s), e;
            case 3:
                return e.replaceData(0, e.length, r.s), e;
            case 1:
                return Gr(e, r.s);
            case 2:
                return e.elm_event_node_ref ? e.elm_event_node_ref.j = r.s : e.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, e;
            case 6:
                for(var t = r.s, n = 0; t.i > n; n++)e.removeChild(e.childNodes[t.v]);
                return e;
            case 7:
                for(var u = (t = r.s).e, a = e.childNodes[n = t.v]; u.length > n; n++)e.insertBefore(fr(u[n], r.u), a);
                return e;
            case 9:
                if (!(t = r.s)) return e.parentNode.removeChild(e), e;
                var o = t.A;
                return void 0 !== o.r && e.parentNode.removeChild(e), o.s = Gr(e, t.w), e;
            case 8:
                return function(e, r) {
                    var t = r.s, n = function(e, r) {
                        if (e) {
                            for(var t = Pe.createDocumentFragment(), n = 0; e.length > n; n++){
                                var u = e[n].A;
                                De(t, 2 === u.c ? u.s : fr(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    e = Gr(e, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var o = u[a], i = o.A, c = 2 === i.c ? i.s : fr(i.z, r.u);
                        e.insertBefore(c, e.childNodes[o.r]);
                    }
                    return n && De(e, n), e;
                }(e, r);
            case 5:
                return r.s(e);
            default:
                f(10);
        }
    }
    function Ar(e) {
        if (3 === e.nodeType) return Be(e.textContent);
        if (1 !== e.nodeType) return Be("");
        for(var r = w, t = e.attributes, n = t.length; n--;){
            var u = t[n];
            r = y(A2(er, u.name, u.value), r);
        }
        var a = e.tagName.toLowerCase(), o = w, i = e.childNodes;
        for(n = i.length; n--;)o = y(Ar(i[n]), o);
        return A3(Oe, a, r, o);
    }
    var Xr = F4(function(e, r, t, n) {
        return function(e, r, t, n, u, a) {
            var o = A2(ae, e, r ? r.flags : void 0);
            cn(o) || f(2);
            var i = {}, c = t(o.a), s = c.a, l = a(d, s), b = function(e, r) {
                var t;
                for(var n in Ge){
                    var u = Ge[n];
                    u.a && ((t = t || {})[n] = u.a(n, r)), e[n] = Me(u, r);
                }
                return t;
            }(i, d);
            function d(e, r) {
                var t = A2(n, e, s);
                l(s = t.a, r), Ee(i, t.b, u(s));
            }
            return Ee(i, c.b, u(s)), b ? {
                ports: b
            } : {};
        }(r, n, e.dP, e.fi, e.e8, function(r, t) {
            var u = e.fl, a = n.node, o = Ar(a);
            return function(e, r) {
                r(e);
                var t = 0;
                function n() {
                    t = 1 === t ? 0 : (Lr(n), r(e), 1);
                }
                return function(u, a) {
                    e = u, a ? (r(e), 2 === t && (t = 1)) : (0 === t && Lr(n), t = 2);
                };
            }(t, function(e) {
                var t = u(e), n = function(e, r) {
                    var t = [];
                    return hr(e, r, t, 0), t;
                }(o, t);
                a = function(e, r, t, n) {
                    return 0 === t.length ? e : (jr(e, r, t, n), Gr(e, t));
                }(a, o, n, r), o = t;
            });
        });
    }), Lr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(e) {
        return setTimeout(e, 1e3 / 60);
    });
    var zr = ("undefined" != typeof document && document, "undefined" != typeof window ? window : {
        addEventListener: function() {},
        removeEventListener: function() {}
    });
    var Rr = F2(function(e, r) {
        return function(e, r) {
            return he(function(t) {
                Lr(function() {
                    var n = document.getElementById(e);
                    t(n ? me(r(n)) : {
                        $: 1,
                        a: gn(e)
                    });
                });
            });
        }(r, function(r) {
            return r[e](), 0;
        });
    }), Zr = F2(function(e, r) {
        var t;
        return t = function() {
            return zr.scroll(e, r), 0;
        }, he(function(e) {
            Lr(function() {
                e(me(t()));
            });
        });
    }), Er = F2(function(e, r) {
        return e ^ r;
    }), Sr = F3(function(e, r, t) {
        return e.setInt8(r, t), r + 1;
    }), Hr = F4(function(e, r, t, n) {
        return e.setInt16(r, t, n), r + 2;
    }), Nr = F4(function(e, r, t, n) {
        return e.setInt32(r, t, n), r + 4;
    }), Vr = F3(function(e, r, t) {
        return e.setUint8(r, t), r + 1;
    }), Ir = F4(function(e, r, t, n) {
        return e.setUint16(r, t, n), r + 2;
    }), Tr = F4(function(e, r, t, n) {
        return e.setUint32(r, t, n), r + 4;
    }), qr = F4(function(e, r, t, n) {
        return e.setFloat32(r, t, n), r + 4;
    }), Pr = F4(function(e, r, t, n) {
        return e.setFloat64(r, t, n), r + 8;
    }), Dr = F3(function(e, r, t) {
        for(var n = 0, u = t.byteLength, a = u - 4; a >= n; n += 4)e.setUint32(r + n, t.getUint32(n));
        for(; u > n; n++)e.setUint8(r + n, t.getUint8(n));
        return r + u;
    });
    function Br(e) {
        for(var r = 0, t = 0; e.length > t; t++){
            var n = e.charCodeAt(t);
            r += 128 > n ? 1 : 2048 > n ? 2 : 55296 > n || n > 56319 ? 3 : (t++, 4);
        }
        return r;
    }
    var Ur = F3(function(e, r, t) {
        for(var n = 0; t.length > n; n++){
            var u = t.charCodeAt(n);
            r += 128 > u ? (e.setUint8(r, u), 1) : 2048 > u ? (e.setUint16(r, 49280 | (u >>> 6 & 31) << 8 | 63 & u), 2) : 55296 > u || u > 56319 ? (e.setUint16(r, 57472 | (u >>> 12 & 15) << 8 | u >>> 6 & 63), e.setUint8(r + 2, 128 | 63 & u), 3) : (u = 1024 * (u - 55296) + t.charCodeAt(++n) - 56320 + 65536, e.setUint32(r, 4034953344 | (u >>> 18 & 7) << 24 | (u >>> 12 & 63) << 16 | (u >>> 6 & 63) << 8 | 63 & u), 4);
        }
        return r;
    }), Or = F2(function(e, r) {
        try {
            return gt(A2(e, r, 0).b);
        } catch (e) {
            return xt;
        }
    }), Jr = F2(function(e, r) {
        return g(r + 1, e.getUint8(r));
    }), Qr = F2(function(e, r) {
        var t = "g";
        e.d1 && (t += "m"), e.cL && (t += "i");
        try {
            return gt(RegExp(r, t));
        } catch (e) {
            return xt;
        }
    }), Yr = F2(function(e, r) {
        return null !== r.match(e);
    }), Kr = F4(function(e, r, t, n) {
        var u = 0;
        return n.replace(r, function(r) {
            if (u++ >= e) return r;
            for(var n = arguments.length - 3, a = Array(n); n > 0;){
                var o = arguments[n];
                a[--n] = o ? gt(o) : xt;
            }
            return t(A4(Rs, r, arguments[arguments.length - 2], u, k(a)));
        });
    }), Wr = $, et = i, rt = F3(function(e, r, t) {
        var n = t.c, u = t.d, a = F2(function(r, t) {
            return A3(et, r.$ ? e : a, t, r.a);
        });
        return A3(et, a, A3(et, e, r, u), n);
    }), tt = function(e) {
        return A3(rt, Wr, w, e);
    }, nt = F3(function(e, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var n = t.d, u = e, a = A3(e, t.b, t.c, A3(nt, e, r, t.e));
            e = u, r = a, t = n;
        }
    }), ut = function(e) {
        return A3(nt, F3(function(e, r, t) {
            return A2(Wr, g(e, r), t);
        }), w, e);
    }, at = 1, ot = 2, it = 0, ct = function(e) {
        return {
            $: 1,
            a: e
        };
    }, ft = F2(function(e, r) {
        return {
            $: 3,
            a: e,
            b: r
        };
    }), st = F2(function(e, r) {
        return {
            $: 0,
            a: e,
            b: r
        };
    }), lt = F2(function(e, r) {
        return {
            $: 1,
            a: e,
            b: r
        };
    }), bt = function(e) {
        return {
            $: 0,
            a: e
        };
    }, dt = function(e) {
        return {
            $: 2,
            a: e
        };
    }, pt = F, gt = function(e) {
        return {
            $: 0,
            a: e
        };
    }, xt = {
        $: 1
    }, mt = V, ht = de, vt = D, wt = F2(function(e, r) {
        return A2(H, e, C(r));
    }), yt = F2(function(e, r) {
        return k(A2(S, e, r));
    }), $t = function(e) {
        return A2(wt, "\n    ", A2(yt, "\n", e));
    }, kt = F3(function(e, r, t) {
        for(;;){
            if (!t.b) return r;
            var n = t.b, u = e, a = A2(e, t.a, r);
            e = u, r = a, t = n;
        }
    }), Ct = function(e) {
        return A3(kt, F2(function(e, r) {
            return r + 1;
        }), 0, e);
    }, _t = _, jt = G, Ft = F3(function(e, r, t) {
        for(;;){
            if (d(e, r) >= 1) return t;
            var n = e, u = r - 1, a = A2(Wr, r, t);
            e = n, r = u, t = a;
        }
    }), Gt = F2(function(e, r) {
        return A3(Ft, e, r, w);
    }), Mt = F2(function(e, r) {
        return A3(_t, e, A2(Gt, 0, Ct(r) - 1), r);
    }), At = function(e) {
        var r = e.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + e.charCodeAt(1) - 56320 + 65536;
    }, Xt = function(e) {
        var r = At(e);
        return r >= 97 && 122 >= r;
    }, Lt = function(e) {
        var r = At(e);
        return 90 >= r && r >= 65;
    }, zt = function(e) {
        return Xt(e) || Lt(e) || function(e) {
            var r = At(e);
            return 57 >= r && r >= 48;
        }(e);
    }, Rt = function(e) {
        return A3(kt, Wr, w, e);
    }, Zt = function(e) {
        var r = e.charCodeAt(0);
        return isNaN(r) ? xt : gt(55296 > r || r > 56319 ? g(e[0], e.slice(1)) : g(e[0] + e[1], e.slice(2)));
    }, Et = F2(function(e, r) {
        return "\n\n(" + vt(e + 1) + ") " + $t(St(r));
    }), St = function(e) {
        return A2(Ht, e, w);
    }, Ht = F2(function(e, r) {
        e: for(;;)switch(e.$){
            case 0:
                var t = e.a, n = e.b, u = function() {
                    var e = Zt(t);
                    if (1 === e.$) return !1;
                    var r, n = e.a, u = n.b;
                    return (Xt(r = n.a) || Lt(r)) && A2(mt, zt, u);
                }();
                e = n, r = A2(Wr, u ? "." + t : "['" + t + "']", r);
                continue e;
            case 1:
                n = e.b;
                var a = "[" + vt(e.a) + "]";
                e = n, r = A2(Wr, a, r);
                continue e;
            case 2:
                var o = e.a;
                if (o.b) {
                    if (o.b.b) {
                        var i = function() {
                            return r.b ? "The Json.Decode.oneOf at json" + A2(wt, "", Rt(r)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + vt(Ct(o)) + " ways:";
                        return A2(wt, "\n\n", A2(Wr, i, A2(Mt, Et, o)));
                    }
                    e = n = o.a;
                    continue e;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return r.b ? " at json" + A2(wt, "", Rt(r)) : "!";
                }();
            default:
                var c = e.a, f = e.b;
                return (i = function() {
                    return r.b ? "Problem with the value at json" + A2(wt, "", Rt(r)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + ($t(A2(ht, 4, f)) + "\n\n") + c;
        }
    }), Nt = 32, Vt = F4(function(e, r, t, n) {
        return {
            $: 0,
            a: e,
            b: r,
            c: t,
            d: n
        };
    }), It = [], Tt = A, qt = F2(function(e, r) {
        return z(r) / z(e);
    }), Pt = Tt(A2(qt, 2, Nt)), Dt = A4(Vt, 0, Pt, It, It), Bt = t, Ut = function(e) {
        return {
            $: 1,
            a: e
        };
    }, Ot = F2(function(e, r) {
        return r(e);
    }), Jt = b, Qt = X, Yt = function(e) {
        return e.length;
    }, Kt = F2(function(e, r) {
        return d(e, r) > 0 ? e : r;
    }), Wt = function(e) {
        return {
            $: 0,
            a: e
        };
    }, en = n, rn = F2(function(e, r) {
        for(;;){
            var t = A2(en, Nt, e), n = t.b, u = A2(Wr, Wt(t.a), r);
            if (!n.b) return Rt(u);
            e = n, r = u;
        }
    }), tn = function(e) {
        return e.a;
    }, nn = F2(function(e, r) {
        for(;;){
            var t = Tt(r / Nt);
            if (1 === t) return A2(en, Nt, e).a;
            e = A2(rn, e, w), r = t;
        }
    }), un = F2(function(e, r) {
        if (r.g) {
            var t = r.g * Nt, n = Qt(A2(qt, Nt, t - 1)), u = e ? Rt(r.l) : r.l, a = A2(nn, u, r.g);
            return A4(Vt, Yt(r.j) + t, A2(Kt, 5, n * Pt), a, r.j);
        }
        return A4(Vt, Yt(r.j), Pt, It, r.j);
    }), an = F5(function(e, r, t, n, u) {
        for(;;){
            if (0 > r) return A2(un, !1, {
                l: n,
                g: t / Nt | 0,
                j: u
            });
            var a = Ut(A3(Bt, Nt, r, e));
            r -= Nt, n = A2(Wr, a, n);
        }
    }), on = F2(function(e, r) {
        if (e > 0) {
            var t = e % Nt;
            return A5(an, r, e - t - Nt, e, w, A3(Bt, t, e - t, r));
        }
        return Dt;
    }), cn = function(e) {
        return !e.$;
    }, fn = ee, sn = re, ln = te, bn = function(e) {
        return {
            $: 0,
            a: e
        };
    }, dn = function(e) {
        switch(e.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, pn = function(e) {
        return e;
    }, gn = pn, xn = F6(function(e, r, t, n, u, a) {
        return {
            bx: a,
            bE: r,
            bW: n,
            b$: t,
            b4: e,
            b5: u
        };
    }), mn = I, hn = function(e) {
        return e.length;
    }, vn = N, wn = F2(function(e, r) {
        return 1 > e ? r : A3(vn, e, hn(r), r);
    }), yn = P, $n = function(e) {
        return "" === e;
    }, kn = F2(function(e, r) {
        return 1 > e ? "" : A3(vn, 0, e, r);
    }), Cn = function(e) {
        for(var r = 0, t = e.charCodeAt(0), n = 43 == t || 45 == t ? 1 : 0, u = n; e.length > u; ++u){
            var a = e.charCodeAt(u);
            if (48 > a || a > 57) return xt;
            r = 10 * r + a - 48;
        }
        return u == n ? xt : gt(45 == t ? -r : r);
    }, _n = F5(function(e, r, t, n, u) {
        if ($n(u) || A2(mn, "@", u)) return xt;
        var a = A2(yn, ":", u);
        if (a.b) {
            if (a.b.b) return xt;
            var o = a.a, i = Cn(A2(wn, o + 1, u));
            if (1 === i.$) return xt;
            var c = i;
            return gt(A6(xn, e, A2(kn, o, u), c, r, t, n));
        }
        return gt(A6(xn, e, u, xt, r, t, n));
    }), jn = F4(function(e, r, t, n) {
        if ($n(n)) return xt;
        var u = A2(yn, "/", n);
        if (u.b) {
            var a = u.a;
            return A5(_n, e, A2(wn, a, n), r, t, A2(kn, a, n));
        }
        return A5(_n, e, "/", r, t, n);
    }), Fn = F3(function(e, r, t) {
        if ($n(t)) return xt;
        var n = A2(yn, "?", t);
        if (n.b) {
            var u = n.a;
            return A4(jn, e, gt(A2(wn, u + 1, t)), r, A2(kn, u, t));
        }
        return A4(jn, e, xt, r, t);
    }), Gn = F2(function(e, r) {
        if ($n(r)) return xt;
        var t = A2(yn, "#", r);
        if (t.b) {
            var n = t.a;
            return A3(Fn, e, gt(A2(wn, n + 1, r)), A2(kn, n, r));
        }
        return A3(Fn, e, xt, r);
    }), Mn = T, An = me, Xn = An(0), Ln = F4(function(e, r, t, n) {
        if (n.b) {
            var u = n.a, a = n.b;
            if (a.b) {
                var o = a.a, i = a.b;
                if (i.b) {
                    var c = i.a, f = i.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(e, u, A2(e, o, A2(e, c, A2(e, f.a, t > 500 ? A3(kt, e, r, Rt(s)) : A4(Ln, e, r, t + 1, s)))));
                    }
                    return A2(e, u, A2(e, o, A2(e, c, r)));
                }
                return A2(e, u, A2(e, o, r));
            }
            return A2(e, u, r);
        }
        return r;
    }), zn = F3(function(e, r, t) {
        return A4(Ln, e, r, 0, t);
    }), Rn = F2(function(e, r) {
        return A3(zn, F2(function(r, t) {
            return A2(Wr, e(r), t);
        }), w, r);
    }), Zn = ve, En = F2(function(e, r) {
        return A2(Zn, function(r) {
            return An(e(r));
        }, r);
    }), Sn = F3(function(e, r, t) {
        return A2(Zn, function(r) {
            return A2(Zn, function(t) {
                return An(A2(e, r, t));
            }, t);
        }, r);
    }), Hn = Ae, Nn = F2(function(e, r) {
        var t = r;
        return function(e) {
            return he(function(r) {
                r(me($e(e)));
            });
        }(A2(Zn, Hn(e), t));
    });
    Ge.Task = {
        b: Xn,
        c: F3(function(e, r) {
            var t;
            return A2(En, function() {
                return 0;
            }, (t = A2(Rn, Nn(e), r), A3(zn, Sn(Wr), An(w), t)));
        }),
        d: F3(function() {
            return An(0);
        }),
        e: F2(function(e, r) {
            return A2(En, e, r);
        }),
        f: void 0
    };
    var Vn, In, Tn, qn, Pn, Dn, Bn, Un = Xe("Task"), On = F2(function(e, r) {
        return Un(A2(En, e, r));
    }), Jn = Xr, Qn = K, Yn = J, Kn = function(e) {
        return {
            $: 9,
            a: e
        };
    }, Wn = function(e) {
        return {
            $: 7,
            a: e
        };
    }, eu = {
        $: 1
    }, ru = {
        $: 0
    }, tu = {
        $: 0
    }, nu = function(e) {
        return {
            $: 2,
            a: e
        };
    }, uu = Le, au = F2(function(e, r) {
        return {
            X: e,
            v: r
        };
    }), ou = pe, iu = function(e) {
        return A3(kt, F2(function(e, r) {
            return A3(xe, e.a, e.b, r);
        }), {}, e);
    }, cu = Ve("toJS", function(e) {
        return iu(k([
            g("tag", ou(e.X)),
            g("value", e.v)
        ]));
    }), fu = function(e) {
        return cu(A2(au, "GetQuestion", ou(e)));
    }, su = F2(function(e, r) {
        return {
            $: 0,
            a: e,
            b: r
        };
    }), lu = su, bu = he(function(e) {
        e(me(A2(lu, -(new Date).getTimezoneOffset(), w)));
    }), du = F2(function(e, r) {
        return {
            $: 0,
            a: e,
            b: r
        };
    }), pu = function(e) {
        var r = e.b;
        return A2(du, 1664525 * e.a + r >>> 0, r);
    }, gu = function(e) {
        var r = pu(A2(du, 0, 1013904223));
        return pu(A2(du, r.a + e >>> 0, r.b));
    }, xu = ze, mu = pn, hu = uu(w), vu = L, wu = {
        $: 2
    }, yu = F5(function(e, r, t, n, u) {
        return {
            L: n,
            N: t,
            I: r,
            v: u,
            S: e
        };
    }), $u = function(e) {
        return e.b && ("" !== e.a || e.b.b) ? A2(Wr, e.a, $u(e.b)) : w;
    }, ku = F2(function(e, r) {
        return gt(1 === r.$ ? k([
            e
        ]) : A2(Wr, e, r.a));
    }), Cu = function(e) {
        try {
            return gt(decodeURIComponent(e));
        } catch (e) {
            return xt;
        }
    }, _u = p, ju = F2(function(e, r) {
        e: for(;;){
            if (-2 === r.$) return xt;
            var t = r.c, n = r.d, u = r.e;
            switch(A2(_u, e, r.b)){
                case 0:
                    r = n;
                    continue e;
                case 1:
                    return gt(t);
                default:
                    r = u;
                    continue e;
            }
        }
    }), Fu = F5(function(e, r, t, n, u) {
        return {
            $: -1,
            a: e,
            b: r,
            c: t,
            d: n,
            e: u
        };
    }), Gu = {
        $: -2
    }, Mu = F5(function(e, r, t, n, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== n.$ || n.a || -1 !== n.d.$ || n.d.a) return A5(Fu, e, r, t, n, u);
            var a = n.d;
            return o = n.e, A5(Fu, 0, n.b, n.c, A5(Fu, 1, a.b, a.c, a.d, a.e), A5(Fu, 1, r, t, o, u));
        }
        var o, i = u.b, c = u.c, f = u.d, s = u.e;
        return -1 !== n.$ || n.a ? A5(Fu, e, i, c, A5(Fu, 0, r, t, n, f), s) : A5(Fu, 0, r, t, A5(Fu, 1, n.b, n.c, n.d, o = n.e), A5(Fu, 1, i, c, f, s));
    }), Au = F3(function(e, r, t) {
        if (-2 === t.$) return A5(Fu, 0, e, r, Gu, Gu);
        var n = t.a, u = t.b, a = t.c, o = t.d, i = t.e;
        switch(A2(_u, e, u)){
            case 0:
                return A5(Mu, n, u, a, A3(Au, e, r, o), i);
            case 1:
                return A5(Fu, n, u, r, o, i);
            default:
                return A5(Mu, n, u, a, o, A3(Au, e, r, i));
        }
    }), Xu = F3(function(e, r, t) {
        var n = A3(Au, e, r, t);
        return -1 !== n.$ || n.a ? n : A5(Fu, 1, n.b, n.c, n.d, n.e);
    }), Lu = function(e) {
        if (-1 === e.$ && -1 === e.d.$ && -1 === e.e.$) {
            if (-1 !== e.e.d.$ || e.e.d.a) {
                var r = e.d, t = e.e;
                return o = t.b, i = t.c, n = t.d, s = t.e, A5(Fu, 1, e.b, e.c, A5(Fu, 0, r.b, r.c, r.d, r.e), A5(Fu, 0, o, i, n, s));
            }
            var n, u = e.d, a = e.e, o = a.b, i = a.c, c = (n = a.d).d, f = n.e, s = a.e;
            return A5(Fu, 0, n.b, n.c, A5(Fu, 1, e.b, e.c, A5(Fu, 0, u.b, u.c, u.d, u.e), c), A5(Fu, 1, o, i, f, s));
        }
        return e;
    }, zu = function(e) {
        if (-1 === e.$ && -1 === e.d.$ && -1 === e.e.$) {
            if (-1 !== e.d.d.$ || e.d.d.a) {
                var r = e.d, t = e.e;
                return f = t.b, s = t.c, l = t.d, b = t.e, A5(Fu, 1, n = e.b, u = e.c, A5(Fu, 0, r.b, r.c, r.d, i = r.e), A5(Fu, 0, f, s, l, b));
            }
            var n = e.b, u = e.c, a = e.d, o = a.d, i = a.e, c = e.e, f = c.b, s = c.c, l = c.d, b = c.e;
            return A5(Fu, 0, a.b, a.c, A5(Fu, 1, o.b, o.c, o.d, o.e), A5(Fu, 1, n, u, i, A5(Fu, 0, f, s, l, b)));
        }
        return e;
    }, Ru = F7(function(e, r, t, n, u, a, o) {
        if (-1 !== a.$ || a.a) {
            e: for(;;){
                if (-1 === o.$ && 1 === o.a) {
                    if (-1 === o.d.$) {
                        if (1 === o.d.a) return zu(r);
                        break e;
                    }
                    return zu(r);
                }
                break e;
            }
            return r;
        }
        return A5(Fu, t, a.b, a.c, a.d, A5(Fu, 0, n, u, a.e, o));
    }), Zu = function(e) {
        if (-1 === e.$ && -1 === e.d.$) {
            var r = e.a, t = e.b, n = e.c, u = e.d, a = u.d, o = e.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var i = Lu(e);
                    if (-1 === i.$) {
                        var c = i.e;
                        return A5(Mu, i.a, i.b, i.c, Zu(i.d), c);
                    }
                    return Gu;
                }
                return A5(Fu, r, t, n, Zu(u), o);
            }
            return A5(Fu, r, t, n, Zu(u), o);
        }
        return Gu;
    }, Eu = F2(function(e, r) {
        if (-2 === r.$) return Gu;
        var t = r.a, n = r.b, u = r.c, a = r.d, o = r.e;
        if (0 > d(e, n)) {
            if (-1 === a.$ && 1 === a.a) {
                var i = a.d;
                if (-1 !== i.$ || i.a) {
                    var c = Lu(r);
                    if (-1 === c.$) {
                        var f = c.e;
                        return A5(Mu, c.a, c.b, c.c, A2(Eu, e, c.d), f);
                    }
                    return Gu;
                }
                return A5(Fu, t, n, u, A2(Eu, e, a), o);
            }
            return A5(Fu, t, n, u, A2(Eu, e, a), o);
        }
        return A2(Su, e, A7(Ru, e, r, t, n, u, a, o));
    }), Su = F2(function(e, r) {
        if (-1 === r.$) {
            var t = r.a, n = r.b, u = r.c, a = r.d, o = r.e;
            if (s(e, n)) {
                var i = function(e) {
                    for(;;){
                        if (-1 !== e.$ || -1 !== e.d.$) return e;
                        e = e.d;
                    }
                }(o);
                return -1 === i.$ ? A5(Mu, t, i.b, i.c, a, Zu(o)) : Gu;
            }
            return A5(Mu, t, n, u, a, A2(Eu, e, o));
        }
        return Gu;
    }), Hu = F2(function(e, r) {
        var t = A2(Eu, e, r);
        return -1 !== t.$ || t.a ? t : A5(Fu, 1, t.b, t.c, t.d, t.e);
    }), Nu = F3(function(e, r, t) {
        var n = r(A2(ju, e, t));
        return n.$ ? A2(Hu, e, t) : A3(Xu, e, n.a, t);
    }), Vu = F2(function(e, r) {
        var t = A2(yt, "=", e);
        if (t.b && t.b.b && !t.b.b.b) {
            var n = t.b.a, u = Cu(t.a);
            if (1 === u.$) return r;
            var a = u.a, o = Cu(n);
            return 1 === o.$ ? r : A3(Nu, a, ku(o.a), r);
        }
        return r;
    }), Iu = Gu, Tu = F2(function(e, r) {
        var t;
        return function(e) {
            e: for(;;){
                if (e.b) {
                    var r = e.a, t = r.I;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            e = e.b;
                            continue e;
                        }
                        return gt(r.v);
                    }
                    return gt(r.v);
                }
                return xt;
            }
        }(e(A5(yu, w, function(e) {
            var r = A2(yt, "/", e);
            return $u(r.b && "" === r.a ? r.b : r);
        }(r.bW), 1 === (t = r.b5).$ ? Iu : A3(zn, Vu, Iu, A2(yt, "&", t.a)), r.bx, pn)));
    }), qu = function(e) {
        return {
            $: 1,
            a: e
        };
    }, Pu = {
        $: 0
    }, Du = F2(function(e, r) {
        return A5(yu, r.S, r.I, r.N, r.L, e(r.v));
    }), Bu = F2(function(e, r) {
        var t = r;
        return function(r) {
            var n = r.L, u = r.N, a = r.I, o = r.S;
            return A2(Rn, Du(r.v), t(A5(yu, o, a, u, n, e)));
        };
    }), Uu = F2(function(e, r) {
        return r.b ? A3(zn, Wr, r, e) : e;
    }), Ou = function(e) {
        return A3(zn, Uu, w, e);
    }, Ju = F2(function(e, r) {
        return Ou(A2(Rn, e, r));
    }), Qu = F2(function(e, r) {
        return function(e) {
            var t = e.v, n = e.L, u = e.N, a = e.I, o = e.S;
            if (a.b) {
                var i = a.a, c = a.b, f = r(i);
                if (f.$) return w;
                var s = f.a;
                return k([
                    A5(yu, A2(Wr, i, o), c, u, n, t(s))
                ]);
            }
            return w;
        };
    }), Yu = A2(Qu, "STRING", gt), Ku = function(e) {
        return k([
            e
        ]);
    }, Wu = (Vn = k([
        A2(Bu, Pu, Ku),
        A2(Bu, qu, Yu)
    ]), function(e) {
        return A2(Ju, function(r) {
            return r(e);
        }, Vn);
    }), ea = F2(function(e, r) {
        return r.$ ? e : r.a;
    }), ra = A2(su, 0, w), ta = U, na = Y, ua = Le, aa = function(e) {
        return {
            $: 8,
            a: e
        };
    }, oa = function(e) {
        return {
            $: 0,
            a: e
        };
    }, ia = function(e) {
        return {
            $: 5,
            a: e
        };
    }, ca = function(e) {
        return {
            $: 3,
            a: e
        };
    }, fa = function(e) {
        return {
            $: 1,
            a: e
        };
    }, sa = function(e) {
        return {
            $: 4,
            a: e
        };
    }, la = {
        $: 3
    }, ba = {
        $: 2
    }, da = function(e) {
        return {
            $: 11,
            a: e
        };
    }, pa = function(e) {
        return {
            $: 9,
            a: e
        };
    }, ga = function(e) {
        return {
            $: 7,
            a: e
        };
    }, xa = function(e) {
        return {
            $: 6,
            a: e
        };
    }, ma = function(e) {
        return {
            $: 1,
            a: e
        };
    }, ha = function(e) {
        return {
            $: 2,
            a: e
        };
    }, va = function(e) {
        return {
            $: 8,
            a: e
        };
    }, wa = function(e) {
        return {
            $: 0,
            a: e
        };
    }, ya = function(e) {
        return {
            $: 5,
            a: e
        };
    }, $a = function(e) {
        return {
            $: 4,
            a: e
        };
    }, ka = {
        $: 6
    }, Ca = {
        $: 6
    }, _a = ae, ja = function(e) {
        return {
            $: 3,
            b: e
        };
    }, Fa = F2(function(e, r) {
        return r.$ ? ct(r.a) : bt(e(r.a));
    }), Ga = F2(function(e, r) {
        return r.$ ? ct(e(r.a)) : bt(r.a);
    }), Ma = F2(function(e, r) {
        return {
            b3: e,
            b7: r
        };
    }), Aa = F2(function(e, r) {
        return r.$ ? xt : gt(e(r.a));
    }), Xa = F2(function(e, r) {
        return r.$ ? xt : e(r.a);
    }), La = function(e) {
        return {
            $: 11,
            g: e
        };
    }, za = Q, Ra = F2(function(e, r) {
        return A2(fn, function(t) {
            return A2(_a, A2(Qn, e, za), t).$ ? bn(xt) : A2(sn, gt, A2(Qn, e, r));
        }, za);
    }), Za = F2(function(e, r) {
        return A2(sn, Xa(pn), A2(Ra, e, function(e) {
            var r;
            return La(k([
                (r = xt, {
                    $: 5,
                    c: r
                }),
                A2(sn, gt, e)
            ]));
        }(r)));
    }), Ea = A3(ln, Ma, A2(sn, Aa(mu), A2(Za, "proposalsEndedAt", ta)), A2(sn, Aa(mu), A2(Za, "ratingEndedAt", ta))), Sa = F5(function(e, r, t, n, u) {
        return {
            as: r,
            o: n,
            bG: e,
            dR: u,
            k: t
        };
    }), Ha = O, Na = ue, Va = A6(Na, Sa, A2(Qn, "id", na), A2(sn, mu, A2(Qn, "createdAt", ta)), A2(Qn, "title", na), A2(Za, "description", na), A2(Qn, "isExcluded", Ha)), Ia = function(e) {
        return {
            $: 0,
            a: e
        };
    }, Ta = function(e) {
        return {
            $: 1,
            a: e
        };
    }, qa = function(e) {
        return {
            $: 2,
            a: e
        };
    }, Pa = ln(Ot), Da = F4(function(e, r, t, n) {
        return {
            cF: r,
            as: n,
            ey: t,
            eB: e
        };
    }), Ba = ne, Ua = A5(Ba, Da, A2(Qn, "proposalId", na), A2(Qn, "author", na), A2(Qn, "points", ta), A2(sn, mu, A2(Qn, "createdAt", ta))), Oa = A2(Pa, A2(Za, "phaseCodePublic", na), A2(Pa, A2(Qn, "ratings", ja(Ua)), A2(Pa, A2(Qn, "proposals", ja(Va)), A2(Pa, A2(Za, "description", na), A2(Pa, A2(Qn, "author", na), A2(Pa, A2(Qn, "title", na), A2(Pa, A2(sn, Aa(mu), A2(Za, "ratingEndedAt", ta)), A2(Pa, A2(sn, Aa(mu), A2(Za, "proposalsEndedAt", ta)), A2(Pa, A2(sn, mu, A2(Qn, "expiresAt", ta)), A2(Pa, A2(sn, mu, A2(Qn, "createdAt", ta)), A2(Pa, A2(Qn, "id", na), bn(function(e) {
        return function(r) {
            return function(t) {
                return function(n) {
                    return function(u) {
                        return function(a) {
                            return function(o) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    cF: o,
                                                    as: r,
                                                    o: i,
                                                    dh: t,
                                                    bG: e,
                                                    en: s,
                                                    eF: c,
                                                    b3: n,
                                                    b7: u,
                                                    b9: f,
                                                    k: a
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), Ja = F3(function(e, r, t) {
        return A2(fn, function(e) {
            return r(e) ? t : {
                $: 1,
                a: "Check failed with input"
            };
        }, e);
    }), Qa = (In = A2(Qn, "phase", na), Tn = F2(function(e, r) {
        return s(e, r);
    }), La(k([
        A2(sn, Ia, A3(Ja, In, Tn("PROPOSAL"), Oa)),
        A2(sn, Ta, A3(Ja, In, Tn("RATING"), Oa)),
        A2(sn, qa, A3(Ja, In, Tn("RESULT"), Oa))
    ]))), Ya = function(e) {
        var r = function() {
            switch(e.X){
                case "GoToNotFound":
                    return bt(ba);
                case "ReceivedError":
                    return A2(Ga, oa, A2(Fa, Wn, A2(Fa, pa, A2(_a, na, e.v))));
                case "QuestionDeleted":
                    return bt(aa(ka));
                case "ReceivedQuestion":
                    return A2(Ga, fa, A2(Fa, Wn, A2(Fa, $a, A2(_a, Qa, e.v))));
                case "ReceivedPublishedProposal":
                    return A2(Ga, ca, A2(Fa, Wn, A2(Fa, wa, A2(_a, Va, e.v))));
                case "ReceivedNewProposals":
                    return A2(Ga, ca, A2(Fa, Wn, A2(Fa, ma, A2(_a, ja(Va), e.v))));
                case "ReceivedPublishedRating":
                    return A2(Ga, sa, A2(Fa, Wn, A2(Fa, ya, A2(_a, ja(Ua), e.v))));
                case "ReceivedNewRatings":
                    return A2(Ga, ca, A2(Fa, Wn, A2(Fa, ha, A2(_a, ja(Ua), e.v))));
                case "DeletedQuestion":
                    return bt(Wn(la));
                case "ReceivedHashedPhaseCode":
                    return A2(Ga, ia, A2(Fa, Wn, A2(Fa, xa, A2(_a, na, e.v))));
                case "ReceivedHashedDeleteCode":
                    return A2(Ga, ia, A2(Fa, Wn, A2(Fa, ga, A2(_a, na, e.v))));
                case "ReceivedPhaseChange":
                    return A2(Ga, fa, A2(Fa, Wn, A2(Fa, va, A2(_a, Ea, e.v))));
                default:
                    return ct(Ca);
            }
        }();
        if (!r.$) return r.a;
        var t = r.a;
        switch(t.$){
            case 6:
                return da("decodeJSMessage: unknown tag " + e.X);
            case 0:
                return da("DecodeErrorMessageError: " + St(t.a));
            case 1:
                return da("DecodeQuestionError: " + St(t.a));
            case 2:
                return da("DecodeProposalsError: " + St(t.a));
            case 5:
                return da("DecodeHashError: " + St(t.a));
            default:
                return da("decodeJSMessage: parsing error with tag " + e.X);
        }
    }, Ka = (qn = "fromJS", Pn = A2(fn, function(e) {
        return A2(fn, function(r) {
            return bn({
                X: r,
                v: e
            });
        }, A2(Qn, "tag", na));
    }, A2(Qn, "value", za)), Ne(qn), Ge[qn] = {
        f: qe,
        u: Pn,
        a: function(e, r) {
            var t = w, n = Ge[e].u, u = me(null);
            return Ge[e].b = u, Ge[e].c = F3(function(e, r) {
                return t = r, u;
            }), {
                send: function(e) {
                    var u = A2(ae, n, e);
                    cn(u) || f(4);
                    for(var a = u.a, o = t; o.b; o = o.b)r(o.a(a));
                }
            };
        }
    }, Xe(qn)), Wa = function(e) {
        return {
            $: 1,
            a: e
        };
    }, eo = function(e) {
        return {
            $: 3,
            a: e
        };
    }, ro = {
        $: 8
    }, to = {
        $: 10
    }, no = function(e) {
        return {
            $: 6,
            a: e
        };
    }, uo = {
        $: 5
    }, ao = function(e) {
        return {
            $: 7,
            a: e
        };
    }, oo = {
        $: 2
    }, io = F2(function(e, r) {
        return {
            o: r,
            k: e
        };
    }), co = {
        $: 3
    }, fo = {
        $: 4
    }, so = F2(function(e, r) {
        return {
            $: 3,
            a: e,
            b: r
        };
    }), lo = {
        $: 2
    }, bo = {
        $: 9
    }, po = F2(function(e, r) {
        return {
            $: 4,
            a: e,
            b: r
        };
    }), go = {
        $: 11
    }, xo = F2(function(e, r) {
        return {
            $: 5,
            a: e,
            b: r
        };
    }), mo = {
        $: 12
    }, ho = {
        $: 0
    }, vo = function(e) {
        return {
            $: 10,
            a: e
        };
    }, wo = F2(function(e, r) {
        return A3(kt, function(e) {
            return F2(function(r, t) {
                return t.push(e(r)), t;
            });
        }(e), [], r);
    }), yo = Ve("copyToClipboard", function(e) {
        var r = e.b;
        return A2(wo, pn, k([
            ou(e.a),
            ou(r)
        ]));
    }), $o = function(e) {
        var r = e.b;
        return cu(A2(au, "DeleteQuestion", iu(k([
            g("questionId", ou(e.a)),
            g("phaseCode", ou(r))
        ]))));
    }, ko = pe, Co = Ve("disableScrolling", ko), _o = Iu, jo = function(e) {
        return cu(A2(au, "ExcludeProposal", iu(k([
            g("questionId", ou(e.V)),
            g("proposalId", ou(e.eB)),
            g("isExcluded", ko(e.dR))
        ]))));
    }, Fo = F3(function(e, r, t) {
        var n = e(r);
        return n.$ ? t : A2(Wr, n.a, t);
    }), Go = F2(function(e, r) {
        return A3(zn, Fo(e), w, r);
    }), Mo = {
        $: 0
    }, Ao = F3(function(e, r, t) {
        return e(r(t));
    }), Xo = we, Lo = F2(function(e, r) {
        return Un(A2(Xo, A2(Ao, A2(Ao, An, e), ct), A2(Zn, A2(Ao, A2(Ao, An, e), bt), r)));
    }), zo = function(e) {
        switch(e.$){
            case 0:
                return "title-input";
            case 1:
                return "main-button";
            case 2:
                return "modal-button";
            default:
                return e.a;
        }
    }, Ro = Rr("focus"), Zo = function(e) {
        var r = zo(e);
        return A2(Lo, function() {
            return Mo;
        }, Ro(r));
    }, Eo = function(e) {
        return A3(kt, F2(function(e, r) {
            return A3(Xu, e.a, e.b, r);
        }), Iu, e);
    }, So = function(e) {
        var r = e.b;
        return cu(A2(au, "GoToRatingPhase", iu(k([
            g("questionId", ou(e.a)),
            g("phaseCode", ou(r))
        ]))));
    }, Ho = function(e) {
        var r = e.b;
        return cu(A2(au, "GoToResultPhase", iu(k([
            g("questionId", ou(e.a)),
            g("phaseCode", ou(r))
        ]))));
    }, No = F2(function(e, r) {
        return A3(Xu, e, 0, r);
    }), Vo = function(e) {
        return !e;
    }, Io = (Dn = mu, he(function(e) {
        e(me(Dn(Date.now())));
    })), To = F2(function(e, r) {
        return g(e, r);
    }), qo = function(e) {
        return e.trim();
    }, Po = F2(function(e, r) {
        return cu(A2(au, "PostNewProposal", iu(v(k([
            g("questionId", ou(r)),
            g("title", ou(qo(e.k)))
        ]), "" !== e.o ? k([
            g("description", ou(qo(e.o)))
        ]) : w))));
    }), Do = function(e) {
        var r;
        return cu(A2(au, "PostNewQuestion", iu(v(k([
            g("title", ou(qo(e.k))),
            g("author", ou(qo(e.cF)))
        ]), v("" !== e.o ? k([
            g("description", ou(qo(e.o)))
        ]) : w, (r = e.em).$ || "" === r.a ? w : k([
            g("phaseCode", ou(r.a))
        ]))))));
    }, Bo = F3(function(e, r, t) {
        var n = t.b;
        return A2(wo, pn, k([
            e(t.a),
            r(n)
        ]));
    }), Uo = pe, Oo = F2(function(e, r) {
        if (-2 === r.$) return Gu;
        var t = r.b, n = r.d, u = r.e;
        return A5(Fu, r.a, t, A2(e, t, r.c), A2(Oo, e, n), A2(Oo, e, u));
    }), Jo = function(e) {
        return e.toLowerCase();
    }, Qo = F2(function(e, r) {
        return cu(A2(au, "PostRatings", iu(k([
            g("questionId", ou(r)),
            g("author", ou(qo(Jo(e.fj)))),
            g("ratings", A2(wo, A2(Bo, ou, Uo), ut(A2(Oo, F2(function(e, r) {
                return r.a;
            }), e.fk))))
        ]))));
    }), Yo = Ve("pressedFoundErrorButton", ou), Ko = F2(function(e, r) {
        return A2(Hu, e, r);
    }), Wo = {
        $: 1
    }, ei = Zr, ri = A2(On, function() {
        return Wo;
    }, A2(ei, 0, 0)), ti = Ve("selectText", ou), ni = Ve("showToast", ou), ui = function(e) {
        return cu(A2(au, "SubscribeToNewProposals", ou(e)));
    }, ai = function(e) {
        return cu(A2(au, "SubscribeToNewRatings", ou(e)));
    }, oi = function(e) {
        return cu(A2(au, "SubscribeToPhaseChanges", ou(e)));
    }, ii = function(e) {
        return cu(A2(au, "UnsubscribeFromNewProposals", ou(e)));
    }, ci = function(e) {
        return cu(A2(au, "UnsubscribeFromNewRatings", ou(e)));
    }, fi = function(e) {
        return cu(A2(au, "UnsubscribeFromPhaseChanges", ou(e)));
    }, si = Ve("updateTitle", ou), li = Ve("updateUrl", ou), bi = F2(function(e, r) {
        var t = g(r.bX, e);
        e: for(;;){
            r: for(;;){
                t: for(;;){
                    n: for(;;){
                        u: for(;;){
                            a: for(;;){
                                o: for(;;){
                                    i: for(;;){
                                        c: for(;;){
                                            f: for(;;){
                                                s: for(;;){
                                                    l: for(;;){
                                                        b: for(;;){
                                                            d: for(;;){
                                                                p: for(;;){
                                                                    g: for(;;){
                                                                        x: for(;;){
                                                                            m: for(;;)switch(t.b.$){
                                                                                case 11:
                                                                                    return g(r, cu(A2(au, "LogError", ou(t.b.a))));
                                                                                case 2:
                                                                                    return g(h(r, {
                                                                                        bX: tu
                                                                                    }), hu);
                                                                                case 9:
                                                                                    return g(h(r, {
                                                                                        fd: t.b.a
                                                                                    }), hu);
                                                                                case 10:
                                                                                    return g(h(r, {
                                                                                        aY: t.b.a
                                                                                    }), hu);
                                                                                case 8:
                                                                                    switch(t.b.a.$){
                                                                                        case 1:
                                                                                            switch(t.a.$){
                                                                                                case 0:
                                                                                                    break e;
                                                                                                case 1:
                                                                                                    break d;
                                                                                                case 2:
                                                                                                    break p;
                                                                                                case 3:
                                                                                                    var n = t.a, u = n.a, a = n.b, o = t.b.a.a, i = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    });
                                                                                                    return g(h(r, {
                                                                                                        bX: A2(so, u, A2(i, Wa({
                                                                                                            at: "",
                                                                                                            au: "",
                                                                                                            en: u.en,
                                                                                                            V: o
                                                                                                        }), a))
                                                                                                    }), uu(k([
                                                                                                        Zo(oo),
                                                                                                        Co(!0)
                                                                                                    ])));
                                                                                                case 4:
                                                                                                    var c = t.a;
                                                                                                    return u = c.a, a = c.b, o = t.b.a.a, i = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(i, Wa({
                                                                                                            at: "",
                                                                                                            au: "",
                                                                                                            en: u.en,
                                                                                                            V: o
                                                                                                        }), a))
                                                                                                    }), uu(k([
                                                                                                        Zo(oo),
                                                                                                        Co(!0)
                                                                                                    ])));
                                                                                                default:
                                                                                                    var f = t.a;
                                                                                                    return u = f.a, a = f.b, o = t.b.a.a, i = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(xo, u, A2(i, Wa({
                                                                                                            at: "",
                                                                                                            au: "",
                                                                                                            en: u.en,
                                                                                                            V: o
                                                                                                        }), a))
                                                                                                    }), uu(k([
                                                                                                        Zo(oo),
                                                                                                        Co(!0)
                                                                                                    ])));
                                                                                            }
                                                                                        case 6:
                                                                                            switch(t.a.$){
                                                                                                case 0:
                                                                                                    break e;
                                                                                                case 1:
                                                                                                    break d;
                                                                                                case 2:
                                                                                                    break p;
                                                                                                case 3:
                                                                                                    var l = t.a;
                                                                                                    return u = l.a, a = l.b, i = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(so, u, A2(i, lo, a))
                                                                                                    }), Co(!0));
                                                                                                case 4:
                                                                                                    var b = t.a;
                                                                                                    return u = b.a, a = b.b, i = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(i, lo, a))
                                                                                                    }), Co(!0));
                                                                                                default:
                                                                                                    var d = t.a;
                                                                                                    return u = d.a, a = d.b, i = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(xo, u, A2(i, lo, a))
                                                                                                    }), Co(!0));
                                                                                            }
                                                                                        case 8:
                                                                                            switch(t.a.$){
                                                                                                case 0:
                                                                                                    break e;
                                                                                                case 1:
                                                                                                    break d;
                                                                                                case 2:
                                                                                                    return a = t.a.a, i = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: nu(A2(i, ru, a))
                                                                                                    }), Co(!1));
                                                                                                case 3:
                                                                                                    var p = t.a;
                                                                                                    return u = p.a, a = p.b, i = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(so, u, A2(i, ru, a))
                                                                                                    }), Co(!1));
                                                                                                case 4:
                                                                                                    var x = t.a;
                                                                                                    return u = x.a, a = x.b, i = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(i, ru, a))
                                                                                                    }), Co(!1));
                                                                                                default:
                                                                                                    var m = t.a;
                                                                                                    return u = m.a, a = m.b, i = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(xo, u, A2(i, ru, a))
                                                                                                    }), Co(!1));
                                                                                            }
                                                                                        case 4:
                                                                                            if (0 === t.a.$) break e;
                                                                                            break r;
                                                                                        case 5:
                                                                                            if (0 === t.a.$) break e;
                                                                                            break n;
                                                                                        case 2:
                                                                                            if (0 === t.a.$) break e;
                                                                                            break u;
                                                                                        case 3:
                                                                                            if (0 === t.a.$) break e;
                                                                                            break a;
                                                                                        case 9:
                                                                                            if (0 === t.a.$) break e;
                                                                                            break o;
                                                                                        case 0:
                                                                                            if (0 === t.a.$) break e;
                                                                                            break i;
                                                                                        default:
                                                                                            if (0 === t.a.$) break e;
                                                                                            break c;
                                                                                    }
                                                                                case 3:
                                                                                    switch(t.a.$){
                                                                                        case 0:
                                                                                            break e;
                                                                                        case 1:
                                                                                            break d;
                                                                                        case 2:
                                                                                            u = t.a.a;
                                                                                            var w = t.b.a;
                                                                                            switch(w.$){
                                                                                                case 0:
                                                                                                    return g(h(r, {
                                                                                                        bX: nu({
                                                                                                            cF: u.cF,
                                                                                                            o: u.o,
                                                                                                            d$: u.d$,
                                                                                                            em: u.em,
                                                                                                            k: G = w.a
                                                                                                        })
                                                                                                    }), hu);
                                                                                                case 1:
                                                                                                    return g(h(r, {
                                                                                                        bX: nu({
                                                                                                            cF: u.cF,
                                                                                                            o: A = w.a,
                                                                                                            d$: u.d$,
                                                                                                            em: u.em,
                                                                                                            k: u.k
                                                                                                        })
                                                                                                    }), hu);
                                                                                                case 2:
                                                                                                    return g(h(r, {
                                                                                                        bX: nu({
                                                                                                            cF: w.a,
                                                                                                            o: u.o,
                                                                                                            d$: u.d$,
                                                                                                            em: u.em,
                                                                                                            k: u.k
                                                                                                        })
                                                                                                    }), hu);
                                                                                                case 3:
                                                                                                    return g(h(r, {
                                                                                                        bX: nu({
                                                                                                            cF: u.cF,
                                                                                                            o: u.o,
                                                                                                            d$: u.d$,
                                                                                                            em: w.a ? gt("") : xt,
                                                                                                            k: u.k
                                                                                                        })
                                                                                                    }), hu);
                                                                                                case 4:
                                                                                                    return g(h(r, {
                                                                                                        bX: nu({
                                                                                                            cF: u.cF,
                                                                                                            o: u.o,
                                                                                                            d$: u.d$,
                                                                                                            em: gt(z = w.a),
                                                                                                            k: u.k
                                                                                                        })
                                                                                                    }), hu);
                                                                                                case 5:
                                                                                                    return g(r, uu(k([
                                                                                                        A2(xu, Wn, Do(u))
                                                                                                    ])));
                                                                                                default:
                                                                                                    return g(h(r, {
                                                                                                        bX: nu({
                                                                                                            cF: u.cF,
                                                                                                            o: u.o,
                                                                                                            d$: co,
                                                                                                            em: u.em,
                                                                                                            k: u.k
                                                                                                        })
                                                                                                    }), Co(!0));
                                                                                            }
                                                                                        case 3:
                                                                                            break g;
                                                                                        case 4:
                                                                                            break x;
                                                                                        default:
                                                                                            break m;
                                                                                    }
                                                                                case 4:
                                                                                    switch(t.a.$){
                                                                                        case 0:
                                                                                            break e;
                                                                                        case 1:
                                                                                            break d;
                                                                                        case 2:
                                                                                            break p;
                                                                                        case 3:
                                                                                            var y = t.a, $ = (u = y.a, a = y.b, t.b.a);
                                                                                            switch($.$){
                                                                                                case 7:
                                                                                                    return g(r, uu(k([
                                                                                                        A2(xu, Wn, A2(Po, a.d5, u.bG)),
                                                                                                        Co(!1)
                                                                                                    ])));
                                                                                                case 8:
                                                                                                    var C = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    });
                                                                                                    return g(h(r, {
                                                                                                        bX: A2(so, u, A2(C, uo, a))
                                                                                                    }), Co(!0));
                                                                                                case 9:
                                                                                                    return C = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(so, u, A2(C, fo, a))
                                                                                                    }), Co(!0));
                                                                                                case 3:
                                                                                                    var _ = $.a, j = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            a$: A2(No, e, r.a$)
                                                                                                        });
                                                                                                    });
                                                                                                    return g(h(r, {
                                                                                                        bX: A2(so, u, A2(j, _, a))
                                                                                                    }), Co(!0));
                                                                                                case 4:
                                                                                                    return _ = $.a, j = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            a$: A2(Ko, e, r.a$)
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(so, u, A2(j, _, a))
                                                                                                    }), uu(k([
                                                                                                        Co(!1),
                                                                                                        Zo(eo(_))
                                                                                                    ])));
                                                                                                case 1:
                                                                                                    var F = F2(function(e, r) {
                                                                                                        return A2(so, e, h(a, {
                                                                                                            e2: r
                                                                                                        }));
                                                                                                    });
                                                                                                    return g(h(r, {
                                                                                                        bX: A2(F, u, !0)
                                                                                                    }), uu(k([
                                                                                                        Zo(ho),
                                                                                                        Co(!0)
                                                                                                    ])));
                                                                                                case 2:
                                                                                                    return F = F2(function(e, r) {
                                                                                                        return A2(so, e, h(a, {
                                                                                                            e2: r
                                                                                                        }));
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(F, u, !1)
                                                                                                    }), Co(!1));
                                                                                                case 5:
                                                                                                    var G = $.a, M = F2(function(e, r) {
                                                                                                        return A2(so, e, h(a, {
                                                                                                            d5: r
                                                                                                        }));
                                                                                                    });
                                                                                                    return g(h(r, {
                                                                                                        bX: A2(M, u, A2(io, G, a.d5.o))
                                                                                                    }), hu);
                                                                                                case 6:
                                                                                                    var A = $.a;
                                                                                                    return M = F2(function(e, r) {
                                                                                                        return A2(so, e, h(a, {
                                                                                                            d5: r
                                                                                                        }));
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(M, u, A2(io, a.d5.k, A))
                                                                                                    }), hu);
                                                                                                case 10:
                                                                                                    return _ = $.a, C = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(so, u, A2(C, no(_), a))
                                                                                                    }), hu);
                                                                                                case 11:
                                                                                                    return _ = $.a, C = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(so, u, A2(C, ao(_), a))
                                                                                                    }), hu);
                                                                                                case 12:
                                                                                                    _ = $.a;
                                                                                                    var X = A2(Rn, function(e) {
                                                                                                        return s(e.bG, _) ? h(e, {
                                                                                                            dR: !0
                                                                                                        }) : e;
                                                                                                    }, a.eF), L = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            eF: e
                                                                                                        });
                                                                                                    });
                                                                                                    return j = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            a$: A2(Ko, e, r.a$)
                                                                                                        });
                                                                                                    }), C = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(so, u, A2(C, ru, A2(j, _, A2(L, X, a))))
                                                                                                    }), uu(k([
                                                                                                        Co(!1),
                                                                                                        A2(xu, Wn, jo({
                                                                                                            dR: !0,
                                                                                                            eB: _,
                                                                                                            V: u.bG
                                                                                                        }))
                                                                                                    ])));
                                                                                                case 13:
                                                                                                    return _ = $.a, X = A2(Rn, function(e) {
                                                                                                        return s(e.bG, _) ? h(e, {
                                                                                                            dR: !1
                                                                                                        }) : e;
                                                                                                    }, a.eF), L = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            eF: e
                                                                                                        });
                                                                                                    }), j = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            a$: A2(Ko, e, r.a$)
                                                                                                        });
                                                                                                    }), C = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(so, u, A2(C, ru, A2(j, _, A2(L, X, a))))
                                                                                                    }), uu(k([
                                                                                                        Co(!1),
                                                                                                        A2(xu, Wn, jo({
                                                                                                            dR: !1,
                                                                                                            eB: _,
                                                                                                            V: u.bG
                                                                                                        }))
                                                                                                    ])));
                                                                                                case 14:
                                                                                                    var z = $.a, R = F2(function(e, r) {
                                                                                                        return A2(so, e, h(a, {
                                                                                                            em: r
                                                                                                        }));
                                                                                                    });
                                                                                                    return g(h(r, {
                                                                                                        bX: A2(R, u, z)
                                                                                                    }), cu(A2(au, "HashPhaseCode", ou(z))));
                                                                                                case 0:
                                                                                                    var Z = F2(function(e, r) {
                                                                                                        return A2(so, e, h(a, {
                                                                                                            dS: r
                                                                                                        }));
                                                                                                    });
                                                                                                    return g(h(r, {
                                                                                                        bX: A2(Z, u, !1)
                                                                                                    }), hu);
                                                                                                case 15:
                                                                                                    return C = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(so, u, A2(C, ro, a))
                                                                                                    }), uu(k([
                                                                                                        Zo(oo),
                                                                                                        Co(!0)
                                                                                                    ])));
                                                                                                default:
                                                                                                    return g(r, uu(k([
                                                                                                        Co(!1),
                                                                                                        A2(xu, Wn, So(g(u.bG, a.em)))
                                                                                                    ])));
                                                                                            }
                                                                                        case 4:
                                                                                            break x;
                                                                                        default:
                                                                                            break m;
                                                                                    }
                                                                                case 5:
                                                                                    switch(t.a.$){
                                                                                        case 0:
                                                                                            break e;
                                                                                        case 1:
                                                                                            break d;
                                                                                        case 2:
                                                                                            break p;
                                                                                        case 3:
                                                                                            break g;
                                                                                        case 4:
                                                                                            var E = t.a, S = (u = E.a, a = E.b, t.b.a);
                                                                                            switch(S.$){
                                                                                                case 0:
                                                                                                    return _ = S.a, j = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            a$: A2(No, e, r.a$)
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(j, _, a))
                                                                                                    }), uu(k([
                                                                                                        Zo(ho),
                                                                                                        Co(!0)
                                                                                                    ])));
                                                                                                case 1:
                                                                                                    var H = S.a;
                                                                                                    return _ = S.b, j = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            a$: H.$ ? A2(Ko, e, r.a$) : A2(No, H.a, A2(Ko, e, r.a$))
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(j, _, a))
                                                                                                    }), function() {
                                                                                                        return 1 === H.$ ? Co(!1) : hu;
                                                                                                    }());
                                                                                                case 2:
                                                                                                    var N = S.a;
                                                                                                    return _ = S.b, j = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            a$: N.$ ? A2(Ko, e, r.a$) : A2(No, N.a, A2(Ko, e, r.a$))
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(j, _, a))
                                                                                                    }), function() {
                                                                                                        return 1 === N.$ ? Co(!1) : hu;
                                                                                                    }());
                                                                                                case 3:
                                                                                                    return _ = S.a, j = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            a$: A2(Ko, e, r.a$)
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(j, _, a))
                                                                                                    }), Co(!1));
                                                                                                case 13:
                                                                                                    return C = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(C, to, a))
                                                                                                    }), uu(k([
                                                                                                        Zo(oo),
                                                                                                        Co(!0)
                                                                                                    ])));
                                                                                                case 12:
                                                                                                    return C = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(C, bo, a))
                                                                                                    }), uu(k([
                                                                                                        Zo(oo),
                                                                                                        Co(!0)
                                                                                                    ])));
                                                                                                case 14:
                                                                                                    return g(r, uu(k([
                                                                                                        Zo(oo),
                                                                                                        A2(xu, Wn, A2(Qo, a, u.bG)),
                                                                                                        A2(On, vo, Io)
                                                                                                    ])));
                                                                                                case 15:
                                                                                                    return z = S.a, R = F2(function(e, r) {
                                                                                                        return A2(po, e, h(a, {
                                                                                                            em: r
                                                                                                        }));
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(R, u, z)
                                                                                                    }), cu(A2(au, "HashPhaseCode", ou(z))));
                                                                                                case 16:
                                                                                                    return g(r, uu(k([
                                                                                                        Co(!1),
                                                                                                        A2(xu, Wn, Ho(g(u.bG, a.em)))
                                                                                                    ])));
                                                                                                case 6:
                                                                                                    _ = S.a;
                                                                                                    var V = S.b, I = F3(function(e, r, t) {
                                                                                                        return h(e, {
                                                                                                            fk: A3(Xu, r, t, e.fk)
                                                                                                        });
                                                                                                    });
                                                                                                    return g(h(r, {
                                                                                                        bX: A2(po, u, A3(I, a, _, g(V, gt(V))))
                                                                                                    }), hu);
                                                                                                case 7:
                                                                                                case 8:
                                                                                                    return _ = S.a, V = S.b, I = F3(function(e, r, t) {
                                                                                                        return h(e, {
                                                                                                            fk: A3(Xu, r, t, e.fk)
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A3(I, a, _, V))
                                                                                                    }), hu);
                                                                                                case 9:
                                                                                                    var T = S.a, q = F2(function(e, r) {
                                                                                                        return h(e, {
                                                                                                            fj: r
                                                                                                        });
                                                                                                    });
                                                                                                    return g(h(r, {
                                                                                                        bX: A2(po, u, A2(q, a, T))
                                                                                                    }), hu);
                                                                                                case 10:
                                                                                                    return C = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(C, uo, a))
                                                                                                    }), Co(!0));
                                                                                                case 4:
                                                                                                    return _ = S.a, j = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            a$: A2(No, e, r.a$)
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(j, _, a))
                                                                                                    }), Co(!0));
                                                                                                case 5:
                                                                                                    return _ = S.a, j = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            a$: A2(Ko, e, r.a$)
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(j, _, a))
                                                                                                    }), uu(k([
                                                                                                        Co(!1),
                                                                                                        Zo(eo(_))
                                                                                                    ])));
                                                                                                default:
                                                                                                    return C = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(po, u, A2(C, fo, a))
                                                                                                    }), Co(!0));
                                                                                            }
                                                                                        default:
                                                                                            break m;
                                                                                    }
                                                                                case 7:
                                                                                    switch(t.a.$){
                                                                                        case 0:
                                                                                            break e;
                                                                                        case 1:
                                                                                            switch(t.b.a.$){
                                                                                                case 7:
                                                                                                    break t;
                                                                                                case 3:
                                                                                                    break f;
                                                                                                case 4:
                                                                                                    break s;
                                                                                                case 8:
                                                                                                    break l;
                                                                                                case 9:
                                                                                                    break b;
                                                                                                default:
                                                                                                    break d;
                                                                                            }
                                                                                        case 2:
                                                                                            switch(t.b.a.$){
                                                                                                case 7:
                                                                                                    break t;
                                                                                                case 3:
                                                                                                    break f;
                                                                                                case 4:
                                                                                                    break s;
                                                                                                case 8:
                                                                                                    break l;
                                                                                                case 9:
                                                                                                    break b;
                                                                                                default:
                                                                                                    break p;
                                                                                            }
                                                                                        case 3:
                                                                                            switch(t.b.a.$){
                                                                                                case 7:
                                                                                                    break t;
                                                                                                case 3:
                                                                                                    break f;
                                                                                                case 4:
                                                                                                    break s;
                                                                                                case 8:
                                                                                                    break l;
                                                                                                case 9:
                                                                                                    break b;
                                                                                                default:
                                                                                                    var P = t.a;
                                                                                                    switch(u = P.a, a = P.b, (Q = t.b.a).$){
                                                                                                        case 0:
                                                                                                            var D = Q.a, B = (L = F2(function(e, r) {
                                                                                                                return h(r, {
                                                                                                                    eF: e
                                                                                                                });
                                                                                                            }), F = F2(function(e, r) {
                                                                                                                return h(r, {
                                                                                                                    e2: e
                                                                                                                });
                                                                                                            }), function(e) {
                                                                                                                return h(e, {
                                                                                                                    d5: A2(io, "", "")
                                                                                                                });
                                                                                                            });
                                                                                                            return g(h(r, {
                                                                                                                bX: A2(so, u, A2(F, !1, B(A2(L, A2(Wr, D, a.eF), a))))
                                                                                                            }), hu);
                                                                                                        case 1:
                                                                                                            var U = Q.a;
                                                                                                            return L = F2(function(e, r) {
                                                                                                                return h(r, {
                                                                                                                    eF: e
                                                                                                                });
                                                                                                            }), g(h(r, {
                                                                                                                bX: A2(so, u, A2(L, U, a))
                                                                                                            }), hu);
                                                                                                        case 6:
                                                                                                            var O = Q.a, J = F2(function(e, r) {
                                                                                                                return h(r, {
                                                                                                                    bY: e
                                                                                                                });
                                                                                                            });
                                                                                                            return g(h(r, {
                                                                                                                bX: A2(so, u, A2(J, O, a))
                                                                                                            }), hu);
                                                                                                        default:
                                                                                                            return g(r, hu);
                                                                                                    }
                                                                                            }
                                                                                        case 4:
                                                                                            switch(t.b.a.$){
                                                                                                case 7:
                                                                                                    break t;
                                                                                                case 3:
                                                                                                    break f;
                                                                                                case 4:
                                                                                                    break s;
                                                                                                case 8:
                                                                                                    break l;
                                                                                                case 9:
                                                                                                    break b;
                                                                                                default:
                                                                                                    var Q, Y = t.a;
                                                                                                    switch(u = Y.a, a = Y.b, (Q = t.b.a).$){
                                                                                                        case 5:
                                                                                                            var K = Q.a, W = F2(function(e, r) {
                                                                                                                return h(r, {
                                                                                                                    ek: v(r.ek, e)
                                                                                                                });
                                                                                                            }), ee = (C = F2(function(e, r) {
                                                                                                                return h(r, {
                                                                                                                    d$: e
                                                                                                                });
                                                                                                            }), F2(function(e, r) {
                                                                                                                return h(r, {
                                                                                                                    dE: e
                                                                                                                });
                                                                                                            }));
                                                                                                            return g(h(r, {
                                                                                                                bX: A2(po, u, A2(ee, !0, A2(C, ru, A2(W, K, a))))
                                                                                                            }), Co(!1));
                                                                                                        case 2:
                                                                                                            var re = Q.a;
                                                                                                            return W = F2(function(e, r) {
                                                                                                                return h(r, {
                                                                                                                    ek: e
                                                                                                                });
                                                                                                            }), g(h(r, {
                                                                                                                bX: A2(po, u, A2(W, re, a))
                                                                                                            }), hu);
                                                                                                        case 6:
                                                                                                            return O = Q.a, J = F2(function(e, r) {
                                                                                                                return h(r, {
                                                                                                                    bY: e
                                                                                                                });
                                                                                                            }), g(h(r, {
                                                                                                                bX: A2(po, u, A2(J, O, a))
                                                                                                            }), hu);
                                                                                                        default:
                                                                                                            return g(r, hu);
                                                                                                    }
                                                                                            }
                                                                                        default:
                                                                                            switch(t.b.a.$){
                                                                                                case 7:
                                                                                                    break t;
                                                                                                case 3:
                                                                                                    break f;
                                                                                                case 4:
                                                                                                    break s;
                                                                                                case 8:
                                                                                                    break l;
                                                                                                case 9:
                                                                                                    break b;
                                                                                                default:
                                                                                                    break m;
                                                                                            }
                                                                                    }
                                                                                case 6:
                                                                                    switch(t.a.$){
                                                                                        case 0:
                                                                                            break e;
                                                                                        case 1:
                                                                                            break d;
                                                                                        case 2:
                                                                                            break p;
                                                                                        case 3:
                                                                                            break g;
                                                                                        case 4:
                                                                                            break x;
                                                                                        default:
                                                                                            var te = t.a, ne = (u = te.a, a = te.b, t.b.a);
                                                                                            switch(ne.$){
                                                                                                case 0:
                                                                                                    return _ = ne.a, j = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            a$: A2(No, e, r.a$)
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(xo, u, A2(j, _, a))
                                                                                                    }), Co(!0));
                                                                                                case 1:
                                                                                                    return _ = ne.a, j = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            a$: A2(Ko, e, r.a$)
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(xo, u, A2(j, _, a))
                                                                                                    }), Co(!1));
                                                                                                default:
                                                                                                    return C = F2(function(e, r) {
                                                                                                        return h(r, {
                                                                                                            d$: e
                                                                                                        });
                                                                                                    }), g(h(r, {
                                                                                                        bX: A2(xo, u, A2(C, uo, a))
                                                                                                    }), Co(!0));
                                                                                            }
                                                                                    }
                                                                                default:
                                                                                    switch(t.a.$){
                                                                                        case 0:
                                                                                            break e;
                                                                                        case 1:
                                                                                            break d;
                                                                                        case 2:
                                                                                            break p;
                                                                                        case 3:
                                                                                            break g;
                                                                                        case 4:
                                                                                            break x;
                                                                                        default:
                                                                                            break m;
                                                                                    }
                                                                            }
                                                                            return g(r, hu);
                                                                        }
                                                                        return g(r, hu);
                                                                    }
                                                                    return g(r, hu);
                                                                }
                                                                return g(r, hu);
                                                            }
                                                            return g(r, hu);
                                                        }
                                                        var ue = t.b.a.a;
                                                        return g(r, ni(A2(mn, "proposals_title_question_id_key", ue) ? r.ab.cA.eG : A2(mn, "ratings_proposal_id_question_id_author_key", ue) ? r.ab.cA.eU : A2(mn, "title length", ue) ? r.ab.cA.fg : A2(mn, "description length", ue) ? r.ab.cA.c2 : r.ab.cA.dy));
                                                    }
                                                    var ae = t.b.a.a;
                                                    switch((ie = t.a).$){
                                                        case 3:
                                                            u = ie.a, a = ie.b, i = F2(function(e, r) {
                                                                return h(r, {
                                                                    d$: e
                                                                });
                                                            });
                                                            var oe = function() {
                                                                var e = g(ae.b3, ae.b7);
                                                                return 1 === e.b.$ ? 1 === e.a.$ ? ru : go : mo;
                                                            }();
                                                            return g(h(r, {
                                                                bX: A2(so, u, A2(i, oe, a))
                                                            }), Co(function() {
                                                                return !!oe.$;
                                                            }()));
                                                        case 4:
                                                            return u = ie.a, a = ie.b, i = F2(function(e, r) {
                                                                return h(r, {
                                                                    d$: e
                                                                });
                                                            }), oe = function() {
                                                                var e = g(ae.b3, ae.b7);
                                                                return e.a.$ || e.b.$ ? ru : mo;
                                                            }(), g(h(r, {
                                                                bX: A2(po, u, A2(i, oe, a))
                                                            }), Co(function() {
                                                                return !!oe.$;
                                                            }()));
                                                        case 5:
                                                            return g(r, A2(xu, Wn, fi((ce = ie.a).bG)));
                                                        default:
                                                            return g(r, hu);
                                                    }
                                                }
                                                var ie = t.a, ce = t.b.a.a, fe = function() {
                                                    return 2 === ie.$;
                                                }();
                                                switch(ce.$){
                                                    case 0:
                                                        return g(h(r, {
                                                            bX: A2(so, u = ce.a, {
                                                                dS: fe,
                                                                d$: ru,
                                                                d5: A2(io, "", ""),
                                                                a$: _o,
                                                                em: "",
                                                                bY: "",
                                                                eF: u.eF,
                                                                e2: !1,
                                                                a7: !1
                                                            })
                                                        }), uu(k(fe ? [
                                                            li("/" + u.bG),
                                                            Zo(ho),
                                                            si(u.k),
                                                            ri,
                                                            Co(!1),
                                                            A2(xu, Wn, oi(u.bG)),
                                                            A2(xu, Wn, ui(u.bG))
                                                        ] : [
                                                            si(u.k),
                                                            Co(!1),
                                                            A2(xu, Wn, oi(u.bG)),
                                                            A2(xu, Wn, ui(u.bG))
                                                        ])));
                                                    case 1:
                                                        var se = Eo(A2(Rn, function(e) {
                                                            return A2(To, e.bG, g(0, xt));
                                                        }, A2(Go, function(e) {
                                                            return e.dR ? xt : gt(e);
                                                        }, (u = ce.a).eF)));
                                                        return g(h(r, {
                                                            bX: A2(po, u, {
                                                                dE: !1,
                                                                d$: ru,
                                                                a$: _o,
                                                                ek: u.b9,
                                                                em: "",
                                                                bY: "",
                                                                a7: !1,
                                                                fj: "",
                                                                fk: se
                                                            })
                                                        }), uu(k([
                                                            ri,
                                                            si(u.k),
                                                            Co(!1),
                                                            A2(xu, Wn, ii(u.bG)),
                                                            A2(xu, Wn, ai(u.bG)),
                                                            A2(xu, Wn, oi(u.bG))
                                                        ])));
                                                    default:
                                                        return g(h(r, {
                                                            bX: A2(xo, u = ce.a, {
                                                                d$: ru,
                                                                a$: _o,
                                                                a7: !1
                                                            })
                                                        }), uu(k([
                                                            ri,
                                                            si(u.k),
                                                            Co(!1),
                                                            A2(xu, Wn, ii(u.bG)),
                                                            A2(xu, Wn, ci(u.bG))
                                                        ])));
                                                }
                                            }
                                            return g(r, uu(k([
                                                li(r.aa.fn)
                                            ])));
                                        }
                                        return g(r, A2(xu, Wn, fu(o = t.b.a.a)));
                                    }
                                    ie = t.a;
                                    var le = F3(function(e, r, t) {
                                        return A2(e, r, h(t, {
                                            a7: !t.a7
                                        }));
                                    }), be = function(e) {
                                        return Co(!e.a7);
                                    };
                                    switch(ie.$){
                                        case 3:
                                            return g(h(r, {
                                                bX: A3(le, so, u = ie.a, a = ie.b)
                                            }), be(a));
                                        case 4:
                                            return g(h(r, {
                                                bX: A3(le, po, u = ie.a, a = ie.b)
                                            }), be(a));
                                        case 5:
                                            return g(h(r, {
                                                bX: A3(le, xo, u = ie.a, a = ie.b)
                                            }), be(a));
                                        default:
                                            return g(r, hu);
                                    }
                                }
                                return g(r, Yo(o = t.b.a.a));
                            }
                            var de = t.b.a;
                            return g(r, yo(g(de.a, de.b)));
                        }
                        return g(r, ti(t.b.a.a));
                    }
                    var pe = t.b.a;
                    return g(r, uu(k([
                        A2(xu, Wn, $o(g(o = pe.a, z = pe.b))),
                        Co(!1)
                    ])));
                }
                ie = t.a;
                var ge = t.b.a.a, xe = F2(function(e, r) {
                    return h(r, {
                        au: e
                    });
                });
                switch(C = F2(function(e, r) {
                    var t;
                    return h(r, {
                        d$: (t = r.d$, 1 === t.$ ? Wa(A2(xe, e, t.a)) : r.d$)
                    });
                }), ie.$){
                    case 3:
                        return g(h(r, {
                            bX: A2(so, u = ie.a, A2(C, ge, a = ie.b))
                        }), hu);
                    case 4:
                        return g(h(r, {
                            bX: A2(po, u = ie.a, A2(C, ge, a = ie.b))
                        }), hu);
                    case 5:
                        return g(h(r, {
                            bX: A2(xo, u = ie.a, A2(C, ge, a = ie.b))
                        }), hu);
                    default:
                        return g(r, hu);
                }
            }
            ie = t.a;
            var me = t.b.a.a, he = F2(function(e, r) {
                return h(r, {
                    at: e
                });
            });
            switch(C = F2(function(e, r) {
                var t;
                return h(r, {
                    d$: (t = r.d$, 1 === t.$ ? Wa(A2(he, e, t.a)) : r.d$)
                });
            }), ie.$){
                case 3:
                    return g(h(r, {
                        bX: A2(so, u = ie.a, A2(C, me, a = ie.b))
                    }), cu(A2(au, "HashDeleteCode", ou(me))));
                case 4:
                    return g(h(r, {
                        bX: A2(po, u = ie.a, A2(C, me, a = ie.b))
                    }), cu(A2(au, "HashDeleteCode", ou(me))));
                case 5:
                    return g(h(r, {
                        bX: A2(xo, u = ie.a, A2(C, me, a = ie.b))
                    }), cu(A2(au, "HashDeleteCode", ou(me))));
                default:
                    return g(r, hu);
            }
        }
        return g(r, hu);
    }), di = er("class"), pi = F2(function(e, r) {
        return A3(zn, F2(function(r, t) {
            return e(r) ? A2(Wr, r, t) : t;
        }), w, r);
    }), gi = function(e) {
        return e.b;
    }, xi = function(e) {
        return di(A2(wt, " ", A2(Rn, tn, A2(pi, gi, e))));
    }, mi = er("d"), hi = er("fill-rule"), vi = Ue("http://www.w3.org/2000/svg"), wi = vi("path"), yi = vi("svg"), $i = er("viewBox"), ki = A2(rr, "http://www.w3.org/XML/1998/namespace", "xml:space"), Ci = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                mi("M6.22 3.22a.75.75 0 011.06 0l4.25 4.25a.75.75 0 010 1.06l-4.25 4.25a.75.75 0 01-1.06-1.06L9.94 8 6.22 4.28a.75.75 0 010-1.06z")
            ]), w)
        ]));
    }), _i = F2(function(e, r) {
        return A2(We, e, ou(r));
    }), ji = _i("className"), Fi = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                mi("M1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0zM8 0a8 8 0 100 16A8 8 0 008 0zm.5 4.75a.75.75 0 00-1.5 0v3.5a.75.75 0 00.471.696l2.5 1a.75.75 0 00.557-1.392L8.5 7.742V4.75z")
            ]), w)
        ]));
    }), Gi = er("fill"), Mi = er("preserveAspectRatio"), Ai = function(e) {
        return A2(yi, k([
            di(e),
            Gi("none"),
            ki("http://www.w3.org/2000/svg"),
            $i("0 0 320 6"),
            Mi("none")
        ]), k([
            A2(wi, k([
                mi("M0 0h320v2.5S298 6 252.5 6s-93-6-138.5-6S0 6 0 6V0Z")
            ]), w)
        ]));
    }, Xi = F2(function(e, r) {
        return r ? k([
            Ai("absolute w-full max-h-3 left-0 bottom-full z-10 rotate-180 translate-y-px " + e)
        ]) : w;
    }), Li = Oe("div"), zi = F3(function(e, r, t) {
        var n = " py-14 xl:py-20";
        return e ? A2(Li, k([
            ji(n)
        ]), t) : A2(Li, k([
            ji("relative bg-grey-100" + n)
        ]), v(t, A2(Xi, "fill-grey-100", r)));
    }), Ri = Oe("a"), Zi = function(e) {
        return ji(A2(wt, " ", A2(Rn, tn, A2(pi, gi, e))));
    }, Ei = function(e) {
        var r;
        return A2(_i, "href", ur.test(r = e) ? "" : r);
    }, Si = Oe("li"), Hi = Oe("p"), Ni = Be, Vi = Ni, Ii = Oe("ul"), Ti = F3(function(e, r, t) {
        return k([
            A2(Ii, k([
                ji("flex flex-col w-full max-w-screen-xl mb-8 mx-auto px-6 gap-6 text-center text-base md:flex-row md:justify-start md:gap-16 lg:px-14")
            ]), k([
                A2(Si, w, k([
                    A2(Ri, k([
                        Ei(e.fn + "/faq/"),
                        ji("underline-offset-2 hover:underline")
                    ]), k([
                        Vi(r.dl)
                    ]))
                ])),
                A2(Si, w, k([
                    A2(Ri, k([
                        Ei(e.fn + "/privacy-policy/"),
                        ji("underline-offset-2 hover:underline")
                    ]), k([
                        Vi(r.eA)
                    ]))
                ])),
                A2(Si, w, k([
                    A2(Ri, k([
                        Ei(e.fn + "/terms-of-use/"),
                        ji("underline-offset-2 hover:underline")
                    ]), k([
                        Vi(r.fb)
                    ]))
                ])),
                A2(Si, w, k([
                    A2(Ri, k([
                        Ei(e.fn + "/legal-notice/"),
                        ji("underline-offset-2 hover:underline")
                    ]), k([
                        Vi(r.dV)
                    ]))
                ]))
            ])),
            A2(Li, k([
                ji("flex flex-col w-full max-w-screen-xl mx-auto px-6 gap-6 text-center text-base md:flex-row-reverse md:justify-between md:gap-16 lg:px-14")
            ]), k([
                A2(Hi, k([
                    ji("font-serif font-bold italic"),
                    Zi(k([
                        g("text-grey-400", 1 === t),
                        g("text-primary-600 selection:bg-white", !t)
                    ]))
                ]), k([
                    Vi(r.cX)
                ])),
                A2(Hi, k([
                    Zi(k([
                        g("text-grey-400", 1 === t),
                        g("text-primary-600 selection:bg-white", !t)
                    ]))
                ]), k([
                    Vi(r.cV)
                ]))
            ]))
        ]);
    }), qi = Oe("h1"), Pi = F2(function(e, r) {
        return {
            $: 3,
            a: e,
            b: r
        };
    }), Di = F2(function(e, r) {
        return A2(er, function(e) {
            return nr.test(e) ? "data-" + e : e;
        }(e), or(r));
    }), Bi = Di, Ui = Oe("button"), Oi = Oe("details"), Ji = F2(function(e, r) {
        return r.$ ? ct(r.a) : e(r.a);
    }), Qi = 4294967295 >>> 32 - Pt, Yi = u, Ki = F3(function(e, r, t) {
        for(;;){
            var n = A2(Yi, Qi & r >>> e, t);
            if (n.$) return A2(Yi, Qi & r, n.a);
            e -= Pt, t = n.a;
        }
    }), Wi = function(e) {
        return e >>> 5 << 5;
    }, ec = F2(function(e, r) {
        var t = r.a, n = r.b, u = r.c, a = r.d;
        return 0 > e || d(e, t) > -1 ? xt : d(e, Wi(t)) > -1 ? gt(A2(Yi, Qi & e, a)) : gt(A3(Ki, n, e, u));
    }), rc = F3(function(e, r, t) {
        return e * r + t;
    }), tc = F4(function(e, r, t, n) {
        var u = A2(ec, A3(rc, t, e, r), n);
        return !u.$ && !u.a.$;
    }), nc = function(e) {
        var r = e.bk, t = e.cf;
        return h(e, e.B ? {
            bk: r - 1,
            B: !1
        } : e.ac ? {
            bk: r + 1,
            B: !0,
            cf: t - 1
        } : {
            bk: r + 1,
            B: !0,
            cf: t + 1
        });
    }, uc = F2(function(e, r) {
        return 1 == (1 & e >> 7 - r);
    }), ac = a, oc = F4(function(e, r, t, n) {
        var u = Qi & r >>> e, a = A2(Yi, u, n);
        return A3(ac, u, a.$ ? Ut(A3(ac, Qi & r, t, a.a)) : Wt(A4(oc, e - Pt, r, t, a.a)), n);
    }), ic = F3(function(e, r, t) {
        var n = t.a, u = t.b, a = t.c, o = t.d;
        return 0 > e || d(e, n) > -1 ? t : d(e, Wi(n)) > -1 ? A4(Vt, n, u, a, A3(ac, Qi & e, r, o)) : A4(Vt, n, u, A4(oc, u, e, r, a), o);
    }), cc = F3(function(e, r, t) {
        return A2(ic, A3(rc, e.cj, e.cf, e.bk), gt(g(!1, A2(uc, r, t))));
    }), fc = F4(function(e, r, t, n) {
        e: for(;;){
            var u = e.bk, a = e.cf, o = e.cj;
            if (!r.b) return n;
            var i = r.a, c = r.b;
            if (8 > t) {
                if (6 === u) {
                    e = f = h(e, {
                        bk: u - 1,
                        B: !0
                    }), r = s = r, t = l = t, n = b = n;
                    continue e;
                }
                if (0 > a) {
                    e = f = h(e, {
                        bk: u - 2,
                        B: !0,
                        ac: !1,
                        cf: 0
                    }), r = s = r, t = l = t, n = b = n;
                    continue e;
                }
                if (d(a, o) > -1) {
                    e = f = h(e, {
                        bk: u - 2,
                        B: !0,
                        ac: !0,
                        cf: o - 1
                    }), r = s = r, t = l = t, n = b = n;
                    continue e;
                }
                if (A4(tc, a, u, o, n)) {
                    e = f = nc(e), r = s = r, t = l = t, n = b = n;
                    continue e;
                }
                var f = nc(e), s = r, l = t + 1, b = A4(cc, e, i, t, n);
                e = f, r = s, t = l, n = b;
            } else e = f = e, r = s = c, t = l = 0, n = b = n;
        }
    }), sc = F3(function(e, r, t) {
        return A4(fc, function(e) {
            return {
                bk: e + 1,
                B: !0,
                ac: !0,
                cf: e + 1,
                cj: e
            };
        }(e), r, 0, t);
    }), lc = {
        $: 0
    }, bc = F3(function(e, r, t) {
        for(;;){
            var n = A2(en, Nt, e), u = n.a, a = n.b;
            if (0 > d(Yt(u), Nt)) return A2(un, !0, {
                l: r,
                g: t,
                j: u
            });
            e = a, r = A2(Wr, Ut(u), r), t += 1;
        }
    }), dc = function(e) {
        return e.b ? A3(bc, e, w, 0) : Dt;
    }, pc = dc(k([
        w,
        k([
            6,
            18
        ]),
        k([
            6,
            22
        ]),
        k([
            6,
            26
        ]),
        k([
            6,
            30
        ]),
        k([
            6,
            34
        ]),
        k([
            6,
            22,
            38
        ]),
        k([
            6,
            24,
            42
        ]),
        k([
            6,
            26,
            46
        ]),
        k([
            6,
            28,
            50
        ]),
        k([
            6,
            30,
            54
        ]),
        k([
            6,
            32,
            58
        ]),
        k([
            6,
            34,
            62
        ]),
        k([
            6,
            26,
            46,
            66
        ]),
        k([
            6,
            26,
            48,
            70
        ]),
        k([
            6,
            26,
            50,
            74
        ]),
        k([
            6,
            30,
            54,
            78
        ]),
        k([
            6,
            30,
            56,
            82
        ]),
        k([
            6,
            30,
            58,
            86
        ]),
        k([
            6,
            34,
            62,
            90
        ]),
        k([
            6,
            28,
            50,
            72,
            94
        ]),
        k([
            6,
            26,
            50,
            74,
            98
        ]),
        k([
            6,
            30,
            54,
            78,
            102
        ]),
        k([
            6,
            28,
            54,
            80,
            106
        ]),
        k([
            6,
            32,
            58,
            84,
            110
        ]),
        k([
            6,
            30,
            58,
            86,
            114
        ]),
        k([
            6,
            34,
            62,
            90,
            118
        ]),
        k([
            6,
            26,
            50,
            74,
            98,
            122
        ]),
        k([
            6,
            30,
            54,
            78,
            102,
            126
        ]),
        k([
            6,
            26,
            52,
            78,
            104,
            130
        ]),
        k([
            6,
            30,
            56,
            82,
            108,
            134
        ]),
        k([
            6,
            34,
            60,
            86,
            112,
            138
        ]),
        k([
            6,
            30,
            58,
            86,
            114,
            142
        ]),
        k([
            6,
            34,
            62,
            90,
            118,
            146
        ]),
        k([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]),
        k([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]),
        k([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]),
        k([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]),
        k([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]),
        k([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ])
    ])), gc = F2(function(e, r) {
        return r.$ ? ct(e) : bt(r.a);
    }), xc = F2(function(e, r) {
        return A3(kt, F2(function(e, t) {
            return A3(kt, F2(function(r, t) {
                return A2(Wr, g(e, r), t);
            }), t, r);
        }), w, e);
    }), mc = F2(function(e, r) {
        var t = r.a, n = r.b;
        return (t > 10 || n > 10 && 0 > d(n, e - 10)) && (0 > d(t, e - 10) || n > 10);
    }), hc = A2(Gt, -2, 2), vc = F2(function(e, r) {
        return s(e, -2) || 2 === e || s(r, -2) || 2 === r || !e && !r ? gt(g(!0, !0)) : gt(g(!0, !1));
    }), wc = F4(function(e, r, t, n) {
        var u = n.a, a = n.b;
        return A2(ic, A3(rc, e, u + r, a + t), A2(vc, u, a));
    }), yc = F3(function(e, r, t) {
        return A3(kt, A3(wc, e, r.a, r.b), t, A2(xc, hc, hc));
    }), $c = F3(function(e, r, t) {
        return A3(kt, yc(e), t, A2(pi, mc(e), A2(xc, r, r)));
    }), kc = F3(function(e, r, t) {
        return A2(Fa, function(e) {
            return A3($c, r, e, t);
        }, A2(gc, lc, A2(ec, e - 1, pc)));
    }), Cc = F2(function(e) {
        return e;
    }), _c = F2(function(e, r) {
        return A2(ic, A3(rc, r, 4 * e + 9, 8), gt(g(!0, !0)));
    }), jc = A2(Gt, 0, 8), Fc = F2(function(e, r) {
        return !((1 > e || e > 7 || 1 !== r && 7 !== r) && (1 > r || r > 7 || 1 !== e && 7 !== e) && (3 > e || e > 5 || 3 > r || r > 5));
    }), Gc = F5(function(e, r, t, n, u) {
        var a = n.a, o = n.b, i = a + r, c = o + t;
        return 0 > i || 0 > c || d(i, e) > -1 || d(c, e) > -1 ? u : A3(ic, A3(rc, e, i, c), gt(g(!0, A2(Fc, a, o))), u);
    }), Mc = F4(function(e, r, t, n) {
        return A3(kt, A3(Gc, e, r, t), n, A2(xc, jc, jc));
    }), Ac = F2(function(e, r) {
        return r ? e.$ || e.a.a ? e : gt(g(!1, !e.a.b)) : e;
    }), Xc = M, Lc = F2(function(e, r) {
        return g(r / e | 0, A2(Xc, e, r));
    }), zc = F4(function(e, r, t, n) {
        return A2(Ac, n, e(A2(Lc, r, t)));
    }), Rc = o, Zc = c, Ec = F2(function(e, r) {
        var t = r.c, n = r.d, u = {
            l: w,
            g: 0,
            j: A3(Zc, e, Wi(r.a), n)
        }, a = F2(function(r, t) {
            if (r.$) {
                var n = Ut(A3(Zc, e, t.g * Nt, r.a));
                return {
                    l: A2(Wr, n, t.l),
                    g: t.g + 1,
                    j: t.j
                };
            }
            return A3(Rc, a, t, r.a);
        });
        return A2(un, !0, A3(Rc, a, u, t));
    }), Sc = F3(function(e, r, t) {
        return A2(Ec, A2(zc, function(e) {
            switch(e){
                case 0:
                    return function(e) {
                        return !A2(Xc, 2, e.a + e.b);
                    };
                case 1:
                    return function(e) {
                        return !A2(Xc, 2, e.a);
                    };
                case 2:
                    return function(e) {
                        return !A2(Xc, 3, e.b);
                    };
                case 3:
                    return function(e) {
                        return !A2(Xc, 3, e.a + e.b);
                    };
                case 4:
                    return function(e) {
                        var r = e.b;
                        return !A2(Xc, 2, Qt(e.a / 2) + Qt(r / 3));
                    };
                case 5:
                    return function(e) {
                        var r = e.a, t = e.b;
                        return !(A2(Xc, 2, r * t) + A2(Xc, 3, r * t));
                    };
                case 6:
                    return function(e) {
                        var r = e.a, t = e.b;
                        return !A2(Xc, 2, A2(Xc, 2, r * t) + A2(Xc, 3, r * t));
                    };
                default:
                    return function(e) {
                        var r = e.a, t = e.b;
                        return !A2(Xc, 2, A2(Xc, 3, r * t) + A2(Xc, 2, r + t));
                    };
            }
        }(r), e), t);
    }), Hc = F2(function(e, r) {
        e: for(;;){
            if (e > 0) {
                if (r.b) {
                    e -= 1, r = r.b;
                    continue e;
                }
                return r;
            }
            return r;
        }
    }), Nc = F3(function(e, r, t) {
        e: for(;;){
            if (e > 0) {
                if (r.b) {
                    var n = r.a;
                    e -= 1, r = r.b, t = A2(Wr, n, t);
                    continue e;
                }
                return t;
            }
            return t;
        }
    }), Vc = F2(function(e, r) {
        return Rt(A3(Nc, e, r, w));
    }), Ic = F3(function(e, r, t) {
        if (r > 0) {
            var n = g(r, t);
            e: for(;;){
                r: for(;;){
                    if (!n.b.b) return t;
                    if (!n.b.b.b) {
                        if (1 === n.a) break e;
                        break r;
                    }
                    switch(n.a){
                        case 1:
                            break e;
                        case 2:
                            var u = n.b;
                            return k([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (n.b.b.b.b) {
                                var a = n.b, o = a.b;
                                return k([
                                    a.a,
                                    o.a,
                                    o.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (n.b.b.b.b && n.b.b.b.b.b) {
                                var i = n.b, c = i.b, f = c.b, s = f.b, l = s.b;
                                return A2(Wr, i.a, A2(Wr, c.a, A2(Wr, f.a, A2(Wr, s.a, e > 1e3 ? A2(Vc, r - 4, l) : A3(Ic, e + 1, r - 4, l)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return k([
                n.b.a
            ]);
        }
        return w;
    }), Tc = F2(function(e, r) {
        return A3(Ic, 0, e, r);
    }), qc = F3(function(e, r, t) {
        for(;;){
            if (!r.b) return Rt(t);
            var n = e, u = A2(Hc, e, r), a = A2(Wr, A2(Tc, e, r), t);
            e = n, r = u, t = a;
        }
    }), Pc = F3(function(e, r, t) {
        return r(e(t));
    }), Dc = A2(Pc, Aa(gi), ea(!1)), Bc = F2(function(e, r) {
        for(;;){
            var t = r.a, n = r.b, u = r.c;
            if (!e.b) return 5 > n ? u : u + n - 2;
            var a = e.a, o = e.b;
            s(t, a) ? (e = o, r = x(t, n + 1, u)) : 5 > n ? (e = o, r = x(a, 0, u)) : (e = o, r = x(a, 0, u + n - 2));
        }
    }), Uc = function(e) {
        return A3(kt, pt, 0, e);
    }, Oc = A2(Pc, Rn(function(e) {
        return A2(Bc, e, x(!1, 0, 0));
    }), Uc), Jc = F4(function(e, r, t, n) {
        e: for(;;){
            if (e.b) {
                var u = e.a, a = e.b;
                if (r.b) {
                    var o = r.b;
                    if (s(u, r.a)) {
                        if (s(gt(u), t)) {
                            e = a, r = o, t = gt(u), n += 3;
                            continue e;
                        }
                        e = a, r = o, t = gt(u);
                        continue e;
                    }
                    e = a, r = o, t = xt;
                    continue e;
                }
                return n;
            }
            return n;
        }
    }), Qc = F2(function(e, r) {
        for(;;){
            if (!e.b || !e.b.b) return r;
            var t = e.a, n = e.b;
            e = n.b, r += A4(Jc, t, n.a, xt, 0);
        }
    }), Yc = F2(function(e, r) {
        e: for(;;){
            r: for(;;){
                if (e.b) {
                    if (e.a) {
                        if (e.b.b && !e.b.a && e.b.b.b && e.b.b.a && e.b.b.b.b && e.b.b.b.a && e.b.b.b.b.b && e.b.b.b.b.a && e.b.b.b.b.b.b && !e.b.b.b.b.b.a && e.b.b.b.b.b.b.b && e.b.b.b.b.b.b.a && e.b.b.b.b.b.b.b.b && !e.b.b.b.b.b.b.b.a && e.b.b.b.b.b.b.b.b.b && !e.b.b.b.b.b.b.b.b.a && e.b.b.b.b.b.b.b.b.b.b && !e.b.b.b.b.b.b.b.b.b.a && e.b.b.b.b.b.b.b.b.b.b.b && !e.b.b.b.b.b.b.b.b.b.b.a) {
                            e = e.b.b.b.b.b.b.b.b.b.b.b, r += 40;
                            continue e;
                        }
                        break r;
                    }
                    if (e.b.b && !e.b.a && e.b.b.b && !e.b.b.a && e.b.b.b.b && !e.b.b.b.a && e.b.b.b.b.b && e.b.b.b.b.a && e.b.b.b.b.b.b && !e.b.b.b.b.b.a && e.b.b.b.b.b.b.b && e.b.b.b.b.b.b.a && e.b.b.b.b.b.b.b.b && e.b.b.b.b.b.b.b.a && e.b.b.b.b.b.b.b.b.b && e.b.b.b.b.b.b.b.b.a && e.b.b.b.b.b.b.b.b.b.b && !e.b.b.b.b.b.b.b.b.b.a && e.b.b.b.b.b.b.b.b.b.b.b && e.b.b.b.b.b.b.b.b.b.b.a) {
                        e = e.b.b.b.b.b.b.b.b.b.b.b, r += 40;
                        continue e;
                    }
                    break r;
                }
                return r;
            }
            e = e.b;
        }
    }), Kc = A2(kt, Yc, 0), Wc = function(e) {
        return 0 > e ? -e : e;
    }, ef = F2(function(e, r) {
        return 0 > d(e, r) ? e : r;
    }), rf = F2(function(e, r) {
        var t = e * e, n = Ct(A2(pi, pn, r)), u = vu(100 * n / t), a = u % 5, o = vu(Wc(u + (5 - a) - 50) / 5), i = vu(Wc(u - a - 50) / 5);
        return 10 * A2(ef, i, o);
    }), tf = function(e) {
        return e.b ? gt(e.a) : xt;
    }, nf = function(e) {
        return e.b ? gt(e.b) : xt;
    }, uf = function(e) {
        for(;;){
            if (!e.b) return w;
            if (e.a.b) {
                var r = e.a, t = r.a, n = r.b, u = A2(Go, nf, a = e.b);
                return A2(Wr, A2(Wr, t, A2(Go, tf, a)), uf(A2(Wr, n, u)));
            }
            var a;
            e = a = e.b;
        }
    }, af = F2(function(e, r) {
        var t = A2(Rn, Dc, tt(r)), n = A3(qc, e, t, w), u = uf(n);
        return g(n, A2(rf, e, t) + (Kc(u) + (Kc(n) + (A2(Qc, n, 0) + (Oc(u) + Oc(n))))));
    }), of = function(e) {
        return A2(F2(function(e, r) {
            for(;;){
                if (!r) return e;
                e += 1, r >>>= 1;
            }
        }), 0, e);
    }, cf = Er, ff = F2(function(e, r) {
        var t = of(1335), n = function(e) {
            switch(e){
                case 0:
                    return 0;
                case 1:
                    return 1;
                case 2:
                    return 2;
                case 3:
                    return 3;
                case 4:
                    return 4;
                case 5:
                    return 5;
                case 6:
                    return 6;
                default:
                    return 7;
            }
        }(r) | function(e) {
            switch(e){
                case 0:
                    return 1;
                case 1:
                    return 0;
                case 2:
                    return 3;
                default:
                    return 2;
            }
        }(e) << 3;
        return function(e) {
            for(;;){
                if (0 > of(e) - t) return 21522 ^ (e | n << 10);
                e ^= 1335 << of(e) - t;
            }
        }(n << 10);
    }), sf = F2(function(e, r) {
        return g(8, 8 > r ? e - r - 1 : 9 > r ? 15 - r : 15 - r - 1);
    }), lf = F2(function(e, r) {
        return g(6 > r ? r : 8 > r ? r + 1 : e - 15 + r, 8);
    }), bf = F4(function(e, r, t, n) {
        return A2(ic, A3(rc, e, t, n), gt(g(!0, r)));
    }), df = F4(function(e, r, t, n) {
        for(;;){
            if (t >= 15) return n;
            var u = r(t), a = A2(lf, e, t), o = a.a, i = a.b, c = A2(sf, e, t), f = e, s = r, l = t + 1, b = A5(bf, e, u, o, i, A5(bf, e, u, c.a, c.b, n));
            e = f, r = s, t = l, n = b;
        }
    }), pf = F4(function(e, r, t, n) {
        return A4(df, r, F2(function(e, r) {
            return 1 == (1 & e >> r);
        })(A2(ff, e, t)), 0, n);
    }), gf = F5(function(e, r, t, n, u) {
        var a = u.a, o = u.b, i = A2(af, r, A4(pf, e, r, n, A3(Sc, r, n, t))), c = i.a, f = i.b;
        return 0 > d(o, f) && !s(o, -1) ? g(a, o) : g(c, f);
    }), xf = k([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7
    ]), mf = F3(function(e, r, t) {
        return A3(kt, A3(gf, e, r, t), g(w, -1), xf).a;
    }), hf = F2(function(e, r) {
        return A4(df, e, Cc(!0), 0, r);
    }), vf = F3(function(e, r, t) {
        return A2(ic, A3(rc, e, t.a, t.b), gt(g(!0, r)));
    }), wf = F4(function(e, r, t, n) {
        for(;;){
            if (t >= 18) return n;
            var u = g(Qt(t / 3), A2(Xc, 3, t) + e - 8 - 3), a = r(t), o = g(A2(Xc, 3, t) + e - 8 - 3, Qt(t / 3)), i = e, c = r, f = t + 1, s = A4(vf, e, a, o, A4(vf, e, a, u, n));
            e = i, r = c, t = f, n = s;
        }
    }), yf = F3(function(e, r, t) {
        if (7 > e) return t;
        var n = F2(function(e, r) {
            return 1 == (1 & e >> r);
        }), u = function(e) {
            var r = of(7973);
            return function(t) {
                for(;;){
                    if (0 > of(t) - r) return t | e << 12;
                    t ^= 7973 << of(t) - r;
                }
            }(e << 12);
        }(e);
        return A4(wf, r, n(u), 0, t);
    }), $f = F2(function(e, r) {
        return gt(g(!0, !A2(Xc, 2, e + r)));
    }), kf = F3(function(e, r, t) {
        return A2(ic, A3(rc, e, r, t), A2($f, r, t));
    }), Cf = F2(function(e, r) {
        var t = A2(Gt, 8, e - 9);
        return A3(kt, function(r) {
            return A3(kf, e, r, 6);
        }, A3(kt, A2(kf, e, 6), r, t), t);
    }), _f = {
        $: 0
    }, jf = {
        $: 7
    }, Ff = {
        $: 2
    }, Gf = {
        $: 1
    }, Mf = {
        $: 3
    }, Af = {
        $: 6
    }, Xf = {
        $: 5
    }, Lf = function(e) {
        switch(e.$){
            case 0:
                return _f;
            case 1:
                return Gf;
            case 2:
                return Ff;
            case 3:
                return Mf;
            case 4:
                return {
                    $: 4,
                    a: e.a
                };
            case 5:
                return Xf;
            case 6:
                return Af;
            default:
                return jf;
        }
    }, zf = F3(function(e, r, t) {
        for(;;){
            if (0 >= r) return e;
            e = A2(Wr, t, e), r -= 1;
        }
    }), Rf = F2(function(e, r) {
        return A3(zf, w, e, r);
    }), Zf = F2(function(e, r) {
        var t = (e / 8 | 0) - Ct(r), n = Ou(A2(Rf, t / 2 | 0, k([
            236,
            17
        ])));
        return v(r, A2(Xc, 2, t) ? v(n, k([
            236
        ])) : n);
    }), Ef = F3(function(e, r, t) {
        return v(t, k([
            g(0, A2(ef, 4, e - r))
        ]));
    }), Sf = F2(function(e, r) {
        var t = e.b, n = r.a, u = r.b;
        return function(e) {
            for(;;){
                var r = e.a, t = r.a, n = r.b, u = e.b;
                if (8 > n) return g(g(t, n), u);
                var a = n - 8, o = t >> a;
                e = g(g(t & (1 << a) - 1, a), A2(Wr, o, u));
            }
        }(g(g(e.a | n.a << t, t + n.b), u));
    }), Hf = F2(function(e, r) {
        for(;;){
            var t = r.a, n = t.a, u = t.b, a = r.b;
            if (!e.b) return Rt(u ? A2(Wr, n << 8 - u, a) : a);
            var o = e.a;
            e = e.b, r = A2(Sf, o, g(g(n, u), a));
        }
    }), Nf = F2(function(e, r) {
        if (r > 9) {
            if (r > 26) switch(e){
                case 0:
                    return 14;
                case 1:
                    return 13;
                default:
                    return 16;
            }
            else switch(e){
                case 0:
                    return 12;
                case 1:
                    return 11;
                default:
                    return 16;
            }
        } else switch(e){
            case 0:
                return 10;
            case 1:
                return 9;
            default:
                return 8;
        }
    }), Vf = F2(function(e, r) {
        var t = e.ay, n = e.aW, u = A2(Nf, t, e.dB.bc);
        return g(3 === t ? Ct(r) : hn(n), u);
    }), If = function(e) {
        var r = e.a, t = e.b;
        return g(t, A2(Zf, t.dB.an, function(e) {
            return A2(Hf, e, g(g(0, 0), w));
        }(A3(Ef, t.dB.an, t.aF, A2(Wr, g(function(e) {
            switch(e){
                case 0:
                    return 1;
                case 1:
                    return 2;
                default:
                    return 4;
            }
        }(t.ay), 4), A2(Wr, A2(Vf, t, r), r))))));
    }, Tf = function(e) {
        var r = e.c;
        return g(e.a, Ou(v(uf(e.b), uf(r))));
    }, qf = F2(function(e, r) {
        e: for(;;){
            if (r.b) {
                if (r.b.b) {
                    var t = r.b, n = t.b;
                    e = A2(Wr, k([
                        r.a,
                        t.a
                    ]), e), r = n;
                    continue e;
                }
                return Rt(A2(Wr, r, e));
            }
            return Rt(e);
        }
    }), Pf = F3(function(e, r, t) {
        if (1 === r.$) return ct(r.a);
        var n = r.a;
        return 1 === t.$ ? ct(t.a) : bt(A2(e, n, t.a));
    }), Df = {
        $: 2
    }, Bf = Eo(k([
        g("0", 0),
        g("1", 1),
        g("2", 2),
        g("3", 3),
        g("4", 4),
        g("5", 5),
        g("6", 6),
        g("7", 7),
        g("8", 8),
        g("9", 9),
        g("A", 10),
        g("B", 11),
        g("C", 12),
        g("D", 13),
        g("E", 14),
        g("F", 15),
        g("G", 16),
        g("H", 17),
        g("I", 18),
        g("J", 19),
        g("K", 20),
        g("L", 21),
        g("M", 22),
        g("N", 23),
        g("O", 24),
        g("P", 25),
        g("Q", 26),
        g("R", 27),
        g("S", 28),
        g("T", 29),
        g("U", 30),
        g("V", 31),
        g("W", 32),
        g("X", 33),
        g("Y", 34),
        g("Z", 35),
        g(" ", 36),
        g("$", 37),
        g("%", 38),
        g("*", 39),
        g("+", 40),
        g("-", 41),
        g(".", 42),
        g("/", 43),
        g(":", 44)
    ])), Uf = function(e) {
        return A2(gc, Df, A2(ju, e, Bf));
    }, Of = function(e) {
        e: for(;;){
            if (e.b) {
                if (e.b.b) {
                    if (e.b.b.b) break e;
                    var r = e.a, t = e.b.a;
                    return A3(Pf, F2(function(e, r) {
                        return g(45 * e + r, 11);
                    }), Uf(r), Uf(t));
                }
                return A2(Fa, function(e) {
                    return g(e, 6);
                }, Uf(e.a));
            }
            break e;
        }
        return ct(Df);
    }, Jf = E, Qf = function(e) {
        return A3(Jf, Wr, w, e);
    }, Yf = function(e) {
        var r;
        return A3(zn, Pf(Wr), bt(w), A2(Rn, Of, (r = Qf(e), A2(qf, w, r))));
    }, Kf = function(e) {
        return bt(A2(Rn, function(e) {
            return g(At(e), 8);
        }, Qf(e)));
    }, Wf = {
        $: 1
    }, es = function(e) {
        var r = function(e) {
            return C(e).join("");
        }(e);
        return A2(gc, Wf, A2(Aa, function(e) {
            return g(e, function(e) {
                switch(hn(e)){
                    case 1:
                        return 4;
                    case 2:
                        return 7;
                    default:
                        return 10;
                }
            }(r));
        }, Cn(r)));
    }, rs = F2(function(e, r) {
        e: for(;;){
            if (r.b) {
                if (r.b.b && r.b.b.b) {
                    var t = r.b, n = t.b, u = n.b;
                    e = A2(Wr, k([
                        r.a,
                        t.a,
                        n.a
                    ]), e), r = u;
                    continue e;
                }
                return Rt(A2(Wr, r, e));
            }
            return Rt(e);
        }
    }), ts = function(e) {
        var r;
        return A3(zn, Pf(Wr), bt(w), A2(Rn, es, (r = Qf(e), A2(rs, w, r))));
    }, ns = {
        $: 3
    }, us = F3(function(e, r, t) {
        switch(e.$){
            case 0:
                return A3(Sr, r, t, e.a);
            case 1:
                return A4(Hr, r, t, e.b, !e.a);
            case 2:
                return A4(Nr, r, t, e.b, !e.a);
            case 3:
                return A3(Vr, r, t, e.a);
            case 4:
                return A4(Ir, r, t, e.b, !e.a);
            case 5:
                return A4(Tr, r, t, e.b, !e.a);
            case 6:
                return A4(qr, r, t, e.b, !e.a);
            case 7:
                return A4(Pr, r, t, e.b, !e.a);
            case 8:
                return A3(as, e.b, r, t);
            case 9:
                return A3(Ur, r, t, e.b);
            default:
                return A3(Dr, r, t, e.a);
        }
    }), as = F3(function(e, r, t) {
        for(;;){
            if (!e.b) return t;
            var n = e.b, u = r, a = A3(us, e.a, r, t);
            e = n, r = u, t = a;
        }
    }), os = F2(function(e, r) {
        return A2(Or, e, r);
    }), is = Br, cs = F4(function(e, r, t, n) {
        for(;;){
            var u = A2(r(e), t, n), a = u.a, o = u.b;
            if (o.$) return g(a, o.a);
            e = o.a, n = a;
        }
    }), fs = F2(function(e, r) {
        return A2(cs, e, r);
    }), ss = F2(function(e, r) {
        var t = r;
        return F2(function(r, n) {
            var u = A2(t, r, n);
            return g(u.a, e(u.b));
        });
    }), ls = Jr, bs = function(e) {
        var r, t = e.a, n = e.b;
        return t > 0 ? A2(ss, function(e) {
            return {
                $: 0,
                a: g(t - 1, A2(Wr, g(e, 8), n))
            };
        }, ls) : (r = {
            $: 1,
            a: Rt(n)
        }, F2(function(e, t) {
            return g(t, r);
        }));
    }, ds = F2(function(e, r) {
        return {
            $: 9,
            a: e,
            b: r
        };
    }), ps = function(e) {
        var r, t, n = is(e), u = A2(fs, g(n, w), bs);
        return A2(gc, ns, A2(os, u, (r = function(e) {
            return A2(ds, Br(e), e);
        }(e), t = new DataView(new ArrayBuffer(function(e) {
            switch(e.$){
                case 0:
                case 3:
                    return 1;
                case 1:
                case 4:
                    return 2;
                case 2:
                case 5:
                case 6:
                    return 4;
                case 7:
                    return 8;
                case 8:
                case 9:
                    return e.a;
                default:
                    return e.a.byteLength;
            }
        }(r))), us(r)(t)(0), t)));
    }, gs = function(e) {
        switch(e){
            case 0:
                return ts;
            case 1:
                return Yf;
            case 2:
                return Kf;
            default:
                return ps;
        }
    }, xs = dc(k([
        1,
        2,
        4,
        8,
        16,
        32,
        64,
        128,
        29,
        58,
        116,
        232,
        205,
        135,
        19,
        38,
        76,
        152,
        45,
        90,
        180,
        117,
        234,
        201,
        143,
        3,
        6,
        12,
        24,
        48,
        96,
        192,
        157,
        39,
        78,
        156,
        37,
        74,
        148,
        53,
        106,
        212,
        181,
        119,
        238,
        193,
        159,
        35,
        70,
        140,
        5,
        10,
        20,
        40,
        80,
        160,
        93,
        186,
        105,
        210,
        185,
        111,
        222,
        161,
        95,
        190,
        97,
        194,
        153,
        47,
        94,
        188,
        101,
        202,
        137,
        15,
        30,
        60,
        120,
        240,
        253,
        231,
        211,
        187,
        107,
        214,
        177,
        127,
        254,
        225,
        223,
        163,
        91,
        182,
        113,
        226,
        217,
        175,
        67,
        134,
        17,
        34,
        68,
        136,
        13,
        26,
        52,
        104,
        208,
        189,
        103,
        206,
        129,
        31,
        62,
        124,
        248,
        237,
        199,
        147,
        59,
        118,
        236,
        197,
        151,
        51,
        102,
        204,
        133,
        23,
        46,
        92,
        184,
        109,
        218,
        169,
        79,
        158,
        33,
        66,
        132,
        21,
        42,
        84,
        168,
        77,
        154,
        41,
        82,
        164,
        85,
        170,
        73,
        146,
        57,
        114,
        228,
        213,
        183,
        115,
        230,
        209,
        191,
        99,
        198,
        145,
        63,
        126,
        252,
        229,
        215,
        179,
        123,
        246,
        241,
        255,
        227,
        219,
        171,
        75,
        150,
        49,
        98,
        196,
        149,
        55,
        110,
        220,
        165,
        87,
        174,
        65,
        130,
        25,
        50,
        100,
        200,
        141,
        7,
        14,
        28,
        56,
        112,
        224,
        221,
        167,
        83,
        166,
        81,
        162,
        89,
        178,
        121,
        242,
        249,
        239,
        195,
        155,
        43,
        86,
        172,
        69,
        138,
        9,
        18,
        36,
        72,
        144,
        61,
        122,
        244,
        245,
        247,
        243,
        251,
        235,
        203,
        139,
        11,
        22,
        44,
        88,
        176,
        125,
        250,
        233,
        207,
        131,
        27,
        54,
        108,
        216,
        173,
        71,
        142,
        1
    ])), ms = function(e) {
        return A2(ea, 0, A2(ec, A2(Xc, 255, e), xs));
    }, hs = {
        $: 5
    }, vs = function(e) {
        return {
            $: 4,
            a: e
        };
    }, ws = dc(k([
        0,
        1,
        25,
        2,
        50,
        26,
        198,
        3,
        223,
        51,
        238,
        27,
        104,
        199,
        75,
        4,
        100,
        224,
        14,
        52,
        141,
        239,
        129,
        28,
        193,
        105,
        248,
        200,
        8,
        76,
        113,
        5,
        138,
        101,
        47,
        225,
        36,
        15,
        33,
        53,
        147,
        142,
        218,
        240,
        18,
        130,
        69,
        29,
        181,
        194,
        125,
        106,
        39,
        249,
        185,
        201,
        154,
        9,
        120,
        77,
        228,
        114,
        166,
        6,
        191,
        139,
        98,
        102,
        221,
        48,
        253,
        226,
        152,
        37,
        179,
        16,
        145,
        34,
        136,
        54,
        208,
        148,
        206,
        143,
        150,
        219,
        189,
        241,
        210,
        19,
        92,
        131,
        56,
        70,
        64,
        30,
        66,
        182,
        163,
        195,
        72,
        126,
        110,
        107,
        58,
        40,
        84,
        250,
        133,
        186,
        61,
        202,
        94,
        155,
        159,
        10,
        21,
        121,
        43,
        78,
        212,
        229,
        172,
        115,
        243,
        167,
        87,
        7,
        112,
        192,
        247,
        140,
        128,
        99,
        13,
        103,
        74,
        222,
        237,
        49,
        197,
        254,
        24,
        227,
        165,
        153,
        119,
        38,
        184,
        180,
        124,
        17,
        68,
        146,
        217,
        35,
        32,
        137,
        46,
        55,
        63,
        209,
        91,
        149,
        188,
        207,
        205,
        144,
        135,
        151,
        178,
        220,
        252,
        190,
        97,
        242,
        86,
        211,
        171,
        20,
        42,
        93,
        158,
        132,
        60,
        57,
        83,
        71,
        109,
        65,
        162,
        31,
        45,
        67,
        216,
        183,
        123,
        164,
        118,
        196,
        23,
        73,
        236,
        127,
        12,
        111,
        246,
        108,
        161,
        59,
        82,
        41,
        157,
        85,
        170,
        251,
        96,
        134,
        177,
        187,
        204,
        62,
        90,
        203,
        89,
        95,
        176,
        156,
        169,
        160,
        81,
        11,
        245,
        22,
        235,
        122,
        117,
        44,
        215,
        79,
        174,
        213,
        233,
        230,
        231,
        173,
        232,
        116,
        214,
        244,
        234,
        168,
        80,
        88,
        175
    ])), ys = function(e) {
        return 1 > e ? ct(vs(e)) : A2(gc, vs(e), A2(ec, e - 1, ws));
    }, $s = function(e) {
        return e.a;
    }, ks = F2(function(e, r) {
        var t = function(e) {
            for(;;){
                var r = e.a, t = e.b;
                if (!r.b) return t;
                if (r.a) return t;
                e = g(r.b, t + 1);
            }
        }(g(e, 0)), n = dc(e);
        return A2(on, Ct(e) - t + r, function(e) {
            return A2(ea, 0, A2(ec, e + t, n));
        });
    }), Cs = F2(function(e, r) {
        var t = A2(Mt, F2(function(e, t) {
            return A2(Mt, F2(function(r, n) {
                return x(e + r, t, n);
            }), tt(r));
        }), tt(e)), n = F3(function(e, r, t) {
            return A2(gc, hs, A2(Aa, cf(t), A2(ec, e, r)));
        }), u = F2(function(e, r) {
            var t = e.a, u = e.b, a = e.c;
            return A2(Fa, function(e) {
                return A3(ic, t, e, r);
            }, A2(Ji, A2(n, t, r), A2(Fa, ms, A3(Pf, pt, ys(u), ys(a)))));
        }), a = F2(function(e, r) {
            return A2(Ji, u(e), r);
        }), o = A2(on, $s(e) + $s(r) - 1, Cc(0));
        return A2(Fa, function(e) {
            return A2(ks, e, 0);
        }, A2(Fa, tt, A3(kt, a, bt(o), Ou(t))));
    }), _s = F2(function(e, r) {
        return tt(A2(on, e, function(t) {
            var n = t + $s(r) - e;
            return 0 > n ? 0 : A2(ea, 0, A2(ec, n, r));
        }));
    }), js = {
        $: 6
    }, Fs = F3(function(e, r, t) {
        var n = t.c, u = t.d, a = F2(function(r, t) {
            return A3(Rc, r.$ ? e : a, t, r.a);
        });
        return A3(Rc, e, A3(Rc, a, r, n), u);
    }), Gs = F2(function(e, r) {
        if (0 > $s(e) - $s(r)) return bt(e);
        var t = F3(function(e, r, t) {
            return A2(gc, js, A2(Aa, cf(t), A2(ec, e, r)));
        }), n = function(e) {
            return A2(Ji, ys, A2(gc, js, A2(ec, 0, e)));
        }, u = A3(Pf, jt, n(e), n(r)), a = F2(function(e, r) {
            var n = e.a, a = e.b;
            return A2(Fa, function(e) {
                return A3(ic, n, e, r);
            }, A2(Ji, A2(t, n, r), A2(Fa, ms, A3(Pf, pt, u, ys(a)))));
        }), o = A3(Fs, F2(function(e, r) {
            return A2(Ji, a(e), r);
        }), bt(e), A2(Ec, F2(function(e, r) {
            return g(e, r);
        }), r));
        return A2(Ji, function(e) {
            return A2(Gs, e, r);
        }, A2(Fa, function(e) {
            return A2(ks, e, 0);
        }, A2(Fa, tt, o)));
    }), Ms = F2(function(e, r) {
        return A2(Fa, _s($s(e) - 1), A2(Gs, A2(ks, r, $s(e) - 1), e));
    }), As = F3(function(e, r, t) {
        if (t.b) {
            var n = t.b;
            return A2(Ji, function(r) {
                return A3(As, e, r, n);
            }, A2(Fa, function(e) {
                return A2(Wr, e, r);
            }, e(t.a)));
        }
        return bt(Rt(r));
    }), Xs = F2(function(e, r) {
        return A3(As, Ms(r), w, e);
    }), Ls = F2(function(e, r) {
        var t;
        return A2(Ji, Xs(r), (t = e, A2(F2(function(e, r) {
            for(;;){
                if (d(e, t) >= 0) return r;
                var n = e + 1, u = A2(Ji, function(r) {
                    return A2(Cs, r, A2(ks, k([
                        1,
                        ms(e)
                    ]), 0));
                }, r);
                e = n, r = u;
            }
        }), 0, bt(A2(ks, k([
            1
        ]), 0)))));
    }), zs = function(e) {
        var r = e.a, t = e.b;
        return A2(Fa, function(e) {
            return x(r, t, e);
        }, A2(Ls, r.dB.c7, t));
    }, Rs = F4(function(e, r, t, n) {
        return {
            dN: r,
            dX: e,
            eg: t,
            e6: n
        };
    }), Zs = Yr, Es = Qr, Ss = A2(Es, {
        cL: !1,
        d1: !1
    }, "^[0-9A-Z $%*+\\-.\\/:]+$"), Hs = A2(Es, {
        cL: !1,
        d1: !1
    }, "^[\\u0000-\\u00ff]+$"), Ns = A2(Es, {
        cL: !1,
        d1: !1
    }, "^[0-9]+$"), Vs = {
        $: 7
    }, Is = F3(function(e, r, t) {
        var n = t.an;
        return 1 > d(A2(Nf, e, t.bc) + r, n);
    }), Ts = function(e) {
        return e.a * e.b;
    }, qs = F2(function(e, r) {
        if (r.$) return Ts(e);
        var t = r.a;
        return Ts(e) + Ts(t);
    }), Ps = F4(function(e, r, t, n) {
        return {
            an: 8 * A2(qs, t, n),
            c7: r,
            bA: t,
            dZ: n,
            bc: e
        };
    }), Ds = k([
        A4(Ps, 1, 17, g(1, 9), xt),
        A4(Ps, 2, 28, g(1, 16), xt),
        A4(Ps, 3, 22, g(2, 13), xt),
        A4(Ps, 4, 16, g(4, 9), xt),
        A4(Ps, 5, 22, g(2, 11), gt(g(2, 12))),
        A4(Ps, 6, 28, g(4, 15), xt),
        A4(Ps, 7, 26, g(4, 13), gt(g(1, 14))),
        A4(Ps, 8, 26, g(4, 14), gt(g(2, 15))),
        A4(Ps, 9, 24, g(4, 12), gt(g(4, 13))),
        A4(Ps, 10, 28, g(6, 15), gt(g(2, 16))),
        A4(Ps, 11, 24, g(3, 12), gt(g(8, 13))),
        A4(Ps, 12, 28, g(7, 14), gt(g(4, 15))),
        A4(Ps, 13, 22, g(12, 11), gt(g(4, 12))),
        A4(Ps, 14, 24, g(11, 12), gt(g(5, 13))),
        A4(Ps, 15, 24, g(11, 12), gt(g(7, 13))),
        A4(Ps, 16, 30, g(3, 15), gt(g(13, 16))),
        A4(Ps, 17, 28, g(2, 14), gt(g(17, 15))),
        A4(Ps, 18, 28, g(2, 14), gt(g(19, 15))),
        A4(Ps, 19, 26, g(9, 13), gt(g(16, 14))),
        A4(Ps, 20, 28, g(15, 15), gt(g(10, 16))),
        A4(Ps, 21, 30, g(19, 16), gt(g(6, 17))),
        A4(Ps, 22, 24, g(34, 13), xt),
        A4(Ps, 23, 30, g(16, 15), gt(g(14, 16))),
        A4(Ps, 24, 30, g(30, 16), gt(g(2, 17))),
        A4(Ps, 25, 30, g(22, 15), gt(g(13, 16))),
        A4(Ps, 26, 30, g(33, 16), gt(g(4, 17))),
        A4(Ps, 27, 30, g(12, 15), gt(g(28, 16))),
        A4(Ps, 28, 30, g(11, 15), gt(g(31, 16))),
        A4(Ps, 29, 30, g(19, 15), gt(g(26, 16))),
        A4(Ps, 30, 30, g(23, 15), gt(g(25, 16))),
        A4(Ps, 31, 30, g(23, 15), gt(g(28, 16))),
        A4(Ps, 32, 30, g(19, 15), gt(g(35, 16))),
        A4(Ps, 33, 30, g(11, 15), gt(g(46, 16))),
        A4(Ps, 34, 30, g(59, 16), gt(g(1, 17))),
        A4(Ps, 35, 30, g(22, 15), gt(g(41, 16))),
        A4(Ps, 36, 30, g(2, 15), gt(g(64, 16))),
        A4(Ps, 37, 30, g(24, 15), gt(g(46, 16))),
        A4(Ps, 38, 30, g(42, 15), gt(g(32, 16))),
        A4(Ps, 39, 30, g(10, 15), gt(g(67, 16))),
        A4(Ps, 40, 30, g(20, 15), gt(g(61, 16)))
    ]), Bs = k([
        A4(Ps, 1, 7, g(1, 19), xt),
        A4(Ps, 2, 10, g(1, 34), xt),
        A4(Ps, 3, 15, g(1, 55), xt),
        A4(Ps, 4, 20, g(1, 80), xt),
        A4(Ps, 5, 26, g(1, 108), xt),
        A4(Ps, 6, 18, g(2, 68), xt),
        A4(Ps, 7, 20, g(2, 78), xt),
        A4(Ps, 8, 24, g(2, 97), xt),
        A4(Ps, 9, 30, g(2, 116), xt),
        A4(Ps, 10, 18, g(2, 68), gt(g(2, 69))),
        A4(Ps, 11, 20, g(4, 81), xt),
        A4(Ps, 12, 24, g(2, 92), gt(g(2, 93))),
        A4(Ps, 13, 26, g(4, 107), xt),
        A4(Ps, 14, 30, g(3, 115), gt(g(1, 116))),
        A4(Ps, 15, 22, g(5, 87), gt(g(1, 88))),
        A4(Ps, 16, 24, g(5, 98), gt(g(1, 99))),
        A4(Ps, 17, 28, g(1, 107), gt(g(5, 108))),
        A4(Ps, 18, 30, g(5, 120), gt(g(1, 121))),
        A4(Ps, 19, 28, g(3, 113), gt(g(4, 114))),
        A4(Ps, 20, 28, g(3, 107), gt(g(5, 108))),
        A4(Ps, 21, 28, g(4, 116), gt(g(4, 117))),
        A4(Ps, 22, 28, g(2, 111), gt(g(7, 112))),
        A4(Ps, 23, 30, g(4, 121), gt(g(5, 122))),
        A4(Ps, 24, 30, g(6, 117), gt(g(4, 118))),
        A4(Ps, 25, 26, g(8, 106), gt(g(4, 107))),
        A4(Ps, 26, 28, g(10, 114), gt(g(2, 115))),
        A4(Ps, 27, 30, g(8, 122), gt(g(4, 123))),
        A4(Ps, 28, 30, g(3, 117), gt(g(10, 118))),
        A4(Ps, 29, 30, g(7, 116), gt(g(7, 117))),
        A4(Ps, 30, 30, g(5, 115), gt(g(10, 116))),
        A4(Ps, 31, 30, g(13, 115), gt(g(3, 116))),
        A4(Ps, 32, 30, g(17, 115), xt),
        A4(Ps, 33, 30, g(17, 115), gt(g(1, 116))),
        A4(Ps, 34, 30, g(13, 115), gt(g(6, 116))),
        A4(Ps, 35, 30, g(12, 121), gt(g(7, 122))),
        A4(Ps, 36, 30, g(6, 121), gt(g(14, 122))),
        A4(Ps, 37, 30, g(17, 122), gt(g(4, 123))),
        A4(Ps, 38, 30, g(4, 122), gt(g(18, 123))),
        A4(Ps, 39, 30, g(20, 117), gt(g(4, 118))),
        A4(Ps, 40, 30, g(19, 118), gt(g(6, 119)))
    ]), Us = k([
        A4(Ps, 1, 10, g(1, 16), xt),
        A4(Ps, 2, 16, g(1, 28), xt),
        A4(Ps, 3, 26, g(1, 44), xt),
        A4(Ps, 4, 18, g(2, 32), xt),
        A4(Ps, 5, 24, g(2, 43), xt),
        A4(Ps, 6, 16, g(4, 27), xt),
        A4(Ps, 7, 18, g(4, 31), xt),
        A4(Ps, 8, 22, g(2, 38), gt(g(2, 39))),
        A4(Ps, 9, 22, g(3, 36), gt(g(2, 37))),
        A4(Ps, 10, 26, g(4, 43), gt(g(1, 44))),
        A4(Ps, 11, 30, g(1, 50), gt(g(4, 51))),
        A4(Ps, 12, 22, g(6, 36), gt(g(2, 37))),
        A4(Ps, 13, 22, g(8, 37), gt(g(1, 38))),
        A4(Ps, 14, 24, g(4, 40), gt(g(5, 41))),
        A4(Ps, 15, 24, g(5, 41), gt(g(5, 42))),
        A4(Ps, 16, 28, g(7, 45), gt(g(3, 46))),
        A4(Ps, 17, 28, g(10, 46), gt(g(1, 47))),
        A4(Ps, 18, 26, g(9, 43), gt(g(4, 44))),
        A4(Ps, 19, 26, g(3, 44), gt(g(11, 45))),
        A4(Ps, 20, 26, g(3, 41), gt(g(13, 42))),
        A4(Ps, 21, 26, g(17, 42), xt),
        A4(Ps, 22, 28, g(17, 46), xt),
        A4(Ps, 23, 28, g(4, 47), gt(g(14, 48))),
        A4(Ps, 24, 28, g(6, 45), gt(g(14, 46))),
        A4(Ps, 25, 28, g(8, 47), gt(g(13, 48))),
        A4(Ps, 26, 28, g(19, 46), gt(g(4, 47))),
        A4(Ps, 27, 28, g(22, 45), gt(g(3, 46))),
        A4(Ps, 28, 28, g(3, 45), gt(g(23, 46))),
        A4(Ps, 29, 28, g(21, 45), gt(g(7, 46))),
        A4(Ps, 30, 28, g(19, 47), gt(g(10, 48))),
        A4(Ps, 31, 28, g(2, 46), gt(g(29, 47))),
        A4(Ps, 32, 28, g(10, 46), gt(g(23, 47))),
        A4(Ps, 33, 28, g(14, 46), gt(g(21, 47))),
        A4(Ps, 34, 28, g(14, 46), gt(g(23, 47))),
        A4(Ps, 35, 28, g(12, 47), gt(g(26, 48))),
        A4(Ps, 36, 28, g(6, 47), gt(g(34, 48))),
        A4(Ps, 37, 28, g(29, 46), gt(g(14, 47))),
        A4(Ps, 38, 28, g(13, 46), gt(g(32, 47))),
        A4(Ps, 39, 28, g(40, 47), gt(g(7, 48))),
        A4(Ps, 40, 28, g(18, 47), gt(g(31, 48)))
    ]), Os = k([
        A4(Ps, 1, 13, g(1, 13), xt),
        A4(Ps, 2, 22, g(1, 22), xt),
        A4(Ps, 3, 18, g(2, 17), xt),
        A4(Ps, 4, 26, g(2, 24), xt),
        A4(Ps, 5, 18, g(2, 15), gt(g(2, 16))),
        A4(Ps, 6, 24, g(4, 19), xt),
        A4(Ps, 7, 18, g(2, 14), gt(g(4, 15))),
        A4(Ps, 8, 22, g(4, 18), gt(g(2, 19))),
        A4(Ps, 9, 20, g(4, 16), gt(g(4, 17))),
        A4(Ps, 10, 24, g(6, 19), gt(g(2, 20))),
        A4(Ps, 11, 28, g(4, 22), gt(g(4, 23))),
        A4(Ps, 12, 26, g(4, 20), gt(g(6, 21))),
        A4(Ps, 13, 24, g(8, 20), gt(g(4, 21))),
        A4(Ps, 14, 20, g(11, 16), gt(g(5, 17))),
        A4(Ps, 15, 30, g(5, 24), gt(g(7, 25))),
        A4(Ps, 16, 24, g(15, 19), gt(g(2, 20))),
        A4(Ps, 17, 28, g(1, 22), gt(g(15, 23))),
        A4(Ps, 18, 28, g(17, 22), gt(g(1, 23))),
        A4(Ps, 19, 26, g(17, 21), gt(g(4, 22))),
        A4(Ps, 20, 30, g(15, 24), gt(g(5, 25))),
        A4(Ps, 21, 28, g(17, 22), gt(g(6, 23))),
        A4(Ps, 22, 30, g(7, 24), gt(g(16, 25))),
        A4(Ps, 23, 30, g(11, 24), gt(g(14, 25))),
        A4(Ps, 24, 30, g(11, 24), gt(g(16, 25))),
        A4(Ps, 25, 30, g(7, 24), gt(g(22, 25))),
        A4(Ps, 26, 28, g(28, 22), gt(g(6, 23))),
        A4(Ps, 27, 30, g(8, 23), gt(g(26, 24))),
        A4(Ps, 28, 30, g(4, 24), gt(g(31, 25))),
        A4(Ps, 29, 30, g(1, 23), gt(g(37, 24))),
        A4(Ps, 30, 30, g(15, 24), gt(g(25, 25))),
        A4(Ps, 31, 30, g(42, 24), gt(g(1, 25))),
        A4(Ps, 32, 30, g(10, 24), gt(g(35, 25))),
        A4(Ps, 33, 30, g(29, 24), gt(g(19, 25))),
        A4(Ps, 34, 30, g(44, 24), gt(g(7, 25))),
        A4(Ps, 35, 30, g(39, 24), gt(g(14, 25))),
        A4(Ps, 36, 30, g(46, 24), gt(g(10, 25))),
        A4(Ps, 37, 30, g(49, 24), gt(g(10, 25))),
        A4(Ps, 38, 30, g(48, 24), gt(g(14, 25))),
        A4(Ps, 39, 30, g(43, 24), gt(g(22, 25))),
        A4(Ps, 40, 30, g(34, 24), gt(g(34, 25)))
    ]), Js = j, Qs = F3(function(e, r, t) {
        return A2(gc, Vs, tf(A2(Js, function(e) {
            return e.an;
        }, A2(pi, A2(Is, r, t), function(e) {
            switch(e){
                case 0:
                    return Bs;
                case 1:
                    return Us;
                case 2:
                    return Os;
                default:
                    return Ds;
            }
        }(e)))));
    }), Ys = F5(function(e, r, t, n, u) {
        return {
            aF: n + A2(Nf, t, u.bc),
            bp: r,
            dB: u,
            aW: e,
            ay: t
        };
    }), Ks = F4(function(e, r, t, n) {
        var u = 4 + A3(kt, F2(function(e, r) {
            return e.b + r;
        }), 0, n);
        return A2(Fa, function(e) {
            return g(n, e);
        }, A2(Fa, A4(Ys, e, r, t, u), A3(Qs, r, t, u)));
    }), Ws = F3(function(e, r, t) {
        for(;;){
            var n = r.a, u = r.b, a = t.a, o = t.b;
            if (0 >= n) return e && Ct(a) > 0 ? ct(Vs) : bt(g(a, o));
            var i = A2(Hc, u, a), c = A2(Tc, u, a);
            r = g(n - 1, u), t = g(i, A2(Wr, c, o));
        }
    }), el = function(e) {
        var r = e.a, t = r.dB, n = e.b, u = t.dZ;
        if (u.$) return A2(Fa, function(e) {
            return g(r, e);
        }, A2(Fa, A2(Pc, gi, Rt), A3(Ws, !0, t.bA, g(n, w))));
        var a = u.a;
        return A2(Fa, function(e) {
            return g(r, e);
        }, A2(Fa, A2(Pc, gi, Rt), A2(Ji, A2(Ws, !0, a), A3(Ws, !1, t.bA, g(n, w)))));
    }, rl = F2(function(e, r) {
        var t, n = function(e) {
            return A2(ea, !1, A2(Aa, function(r) {
                return A2(Zs, r, e);
            }, Ns));
        }(t = e) ? 0 : function(e) {
            return A2(ea, !1, A2(Aa, function(r) {
                return A2(Zs, r, e);
            }, Ss));
        }(t) ? 1 : function(e) {
            return A2(ea, !1, A2(Aa, function(r) {
                return A2(Zs, r, e);
            }, Hs));
        }(t) ? 2 : 3;
        return A2(Fa, Tf, A2(Ji, zs, A2(Ji, el, A2(Fa, If, A2(Ji, A3(Ks, e, r, n), A2(gs, n, e))))));
    }), tl = F2(function(e, r) {
        return A2(Ga, Lf, A2(Ji, function(e) {
            var r = e.a;
            return A2(Fa, function(e) {
                return {
                    af: e,
                    bc: r.dB.bc
                };
            }, function(e) {
                var r = e.b, t = e.a.dB.bc, n = 4 * (t - 1) + 21;
                return A2(Fa, A2(mf, e.a.bp, n), A2(Fa, A2(sc, n, r), A3(kc, t, n, A2(Cf, n, A3(_c, t, n, A3(yf, t, n, A2(hf, n, A4(Mc, n, -1, n - 8, A4(Mc, n, n - 8, -1, A4(Mc, n, -1, -1, A2(on, n * n, Cc(xt))))))))))));
            }(g(r, e.b)));
        }, A2(rl, r, function(e) {
            switch(e){
                case 0:
                    return 0;
                case 1:
                    return 1;
                case 2:
                    return 2;
                default:
                    return 3;
            }
        }(e))));
    }), nl = tl(2), ul = er("height"), al = _i("id"), ol = er("clip-rule"), il = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            Gi("none"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                ol("evenodd"),
                mi("M9.53691 4.54326C9.67528 4.4 9.8408 4.28572 10.0238 4.20711C10.2068 4.12849 10.4036 4.08712 10.6028 4.08538C10.802 4.08365 10.9995 4.12161 11.1838 4.19703C11.3682 4.27245 11.5357 4.38383 11.6765 4.52467C11.8173 4.66551 11.9287 4.83298 12.0041 5.01733C12.0796 5.20167 12.1175 5.39919 12.1158 5.59836C12.1141 5.79753 12.0727 5.99436 11.9941 6.17737C11.9154 6.36037 11.8012 6.52589 11.6579 6.66426L9.40791 8.91426C9.12662 9.19547 8.74516 9.35344 8.34741 9.35344C7.94966 9.35344 7.5682 9.19547 7.28691 8.91426C7.14546 8.77764 6.95601 8.70205 6.75936 8.70375C6.56271 8.70546 6.3746 8.78434 6.23555 8.9234C6.09649 9.06245 6.01761 9.25056 6.01591 9.44721C6.0142 9.64386 6.08979 9.83331 6.22641 9.97476C6.78899 10.5372 7.55192 10.8531 8.34741 10.8531C9.1429 10.8531 9.90583 10.5372 10.4684 9.97476L12.7184 7.72476C13.2649 7.15895 13.5673 6.40115 13.5604 5.61456C13.5536 4.82797 13.2381 4.07553 12.6819 3.5193C12.1256 2.96308 11.3732 2.64757 10.5866 2.64074C9.80002 2.6339 9.04222 2.93629 8.47641 3.48276L7.35141 4.60776C7.27978 4.67695 7.22264 4.7597 7.18334 4.85121C7.14403 4.94271 7.12334 5.04113 7.12247 5.14071C7.12161 5.24029 7.14058 5.33905 7.17829 5.43123C7.21601 5.5234 7.2717 5.60714 7.34211 5.67756C7.41253 5.74798 7.49627 5.80367 7.58844 5.84138C7.68062 5.87909 7.77938 5.89806 7.87896 5.8972C7.97855 5.89633 8.07696 5.87564 8.16846 5.83634C8.25997 5.79703 8.34273 5.73989 8.41191 5.66826L9.53691 4.54326ZM5.78691 8.29326C6.0682 8.01205 6.44967 7.85408 6.84741 7.85408C7.24516 7.85408 7.62662 8.01205 7.90791 8.29326C7.9771 8.36489 8.05985 8.42203 8.15136 8.46134C8.24286 8.50064 8.34128 8.52133 8.44086 8.5222C8.54044 8.52306 8.6392 8.50409 8.73138 8.46638C8.82355 8.42867 8.90729 8.37298 8.97771 8.30256C9.04813 8.23214 9.10382 8.1484 9.14153 8.05623C9.17924 7.96405 9.19821 7.86529 9.19735 7.76571C9.19648 7.66612 9.17579 7.56771 9.13649 7.47621C9.09718 7.3847 9.04004 7.30195 8.96841 7.23276C8.40583 6.67035 7.6429 6.3544 6.84741 6.3544C6.05192 6.3544 5.28899 6.67035 4.72641 7.23276L2.47641 9.48276C2.18988 9.7595 1.96133 10.0905 1.80411 10.4565C1.64688 10.8226 1.56412 11.2162 1.56066 11.6146C1.5572 12.0129 1.6331 12.4079 1.78395 12.7766C1.93479 13.1453 2.15755 13.4803 2.43923 13.7619C2.7209 14.0436 3.05586 14.2664 3.42455 14.4172C3.79324 14.5681 4.18828 14.644 4.58661 14.6405C4.98495 14.637 5.37861 14.5543 5.74462 14.3971C6.11064 14.2398 6.44167 14.0113 6.71841 13.7248L7.84341 12.5998C7.91504 12.5306 7.97218 12.4478 8.01149 12.3563C8.05079 12.2648 8.07148 12.1664 8.07235 12.0668C8.07321 11.9672 8.05424 11.8685 8.01653 11.7763C7.97882 11.6841 7.92313 11.6004 7.85271 11.53C7.78229 11.4595 7.69855 11.4039 7.60638 11.3661C7.5142 11.3284 7.41544 11.3095 7.31586 11.3103C7.21628 11.3112 7.11786 11.3319 7.02636 11.3712C6.93485 11.4105 6.8521 11.4676 6.78291 11.5393L5.65791 12.6643C5.51954 12.8075 5.35402 12.9218 5.17102 13.0004C4.98801 13.079 4.79118 13.1204 4.59201 13.1221C4.39284 13.1239 4.19532 13.0859 4.01098 13.0105C3.82664 12.9351 3.65916 12.8237 3.51832 12.6829C3.37748 12.542 3.2661 12.3745 3.19068 12.1902C3.11526 12.0058 3.07731 11.8083 3.07904 11.6092C3.08077 11.41 3.12215 11.2132 3.20076 11.0302C3.27937 10.8471 3.39365 10.6816 3.53691 10.5433L5.78691 8.29326Z")
            ]), w)
        ]));
    }), cl = _i("alt"), fl = Oe("img"), sl = function(e) {
        return A2(_i, "src", or(e));
    }, ll = _i("title"), bl = function(e) {
        return A2(Ri, k([
            ji("block outline-none focus-visible:ring-4 focus-visible:ring-primary-300 focus-visible:ring-offset-8 focus-visible:rounded-full"),
            Ei(e.fn),
            ll("go to website")
        ]), k([
            A2(fl, k([
                ji("w-20 sm:w-24 md:w-32"),
                sl(e.dW),
                cl("konsens")
            ]), w)
        ]));
    }, dl = function(e) {
        return Oe(function(e) {
            return tr.test(e) ? "p" : e;
        }(e));
    }, pl = Ye, gl = F2(function(e, r) {
        return A2(pl, e, {
            $: 0,
            a: r
        });
    }), xl = function(e) {
        return A2(gl, "click", bn(e));
    }, ml = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 256 256"),
            Gi("currentColor")
        ]), k([
            A2(wi, k([
                mi("M120,56v48a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40h48A16,16,0,0,1,120,56Zm-16,80H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm96-96H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40ZM144,184a8,8,0,0,0,8-8V144a8,8,0,0,0-16,0v32A8,8,0,0,0,144,184Zm64-32H184v-8a8,8,0,0,0-16,0v56H144a8,8,0,0,0,0,16h32a8,8,0,0,0,8-8V168h24a8,8,0,0,0,0-16Zm0,32a8,8,0,0,0-8,8v16a8,8,0,0,0,16,0V192A8,8,0,0,0,208,184Z")
            ]), w)
        ]));
    }), hl = function(e) {
        return "flex items-center gap-1 py-1.5 px-3 text-sm font-semibold shadow-md rounded-full transition-all md:text-base outline-none focus-visible:ring-4 focus-visible:ring-offset-4 focus-visible:ring-primary-600" + function() {
            switch(e){
                case 0:
                    return " text-black bg-white hover:bg-black hover:text-white hover:fill-white";
                case 1:
                    return " text-black bg-primary-300 hover:bg-black hover:text-white hover:fill-white";
                default:
                    return " text-white bg-black hover:bg-white hover:text-black hover:fill-black";
            }
        }();
    }, vl = Oe("span"), wl = Oe("summary"), yl = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                mi("M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z")
            ]), w)
        ]));
    }), $l = function(e) {
        var r = e.b;
        return A2(Wr, "h" + vt(5 * e.a.cs), r);
    }, kl = function(e) {
        return A2(wt, "", e);
    }, Cl = D, _l = er("shape-rendering"), jl = er("stroke"), Fl = er("stroke-width"), Gl = F2(function(e, r) {
        var t = r.a, n = r.b;
        return e ? t.P ? g({
            P: 0,
            cs: 1
        }, A2(Wr, kl(k([
            t.cs > 0 ? "h" + vt(5 * t.cs) : "",
            "m",
            vt(5 * t.P),
            " 0"
        ])), n)) : g(h(t, {
            cs: t.cs + 1
        }), n) : g(h(t, {
            P: t.P + 1
        }), n);
    }), Ml = er("transform"), Al = F3(function(e, r, t) {
        return A2(Wr, "M0 ", A2(Wr, vt(5 * r), t));
    }), Xl = F3(function(e, r, t) {
        var n, u = 5 * e, a = vt(5 * Ct(t) + 2 * u);
        return A2(yi, v(k([
            $i("0 0 " + a + " " + a),
            _l("crispEdges"),
            jl("#000"),
            Fl(vt(5) + "px")
        ]), r), (n = mi(kl(Ou(A2(Mt, Al(e), A2(Rn, A2(Pc, A2(kt, Gl, g({
            P: 0,
            cs: 0
        }, w)), A2(Pc, $l, Rt)), t))))), k([
            A2(wi, k([
                n,
                Ml("translate(" + vt(u) + ", " + Cl(u + 2.5) + ")"),
                Fl("5px")
            ]), w)
        ])));
    }), Ll = Xl(4), zl = F2(function(e, r) {
        return A2(Ll, e, r.af);
    }), Rl = _i("type"), Zl = er("width"), El = F2(function(e, r) {
        return r.$ ? e : r.a;
    }), Sl = vi("clipPath"), Hl = er("clip-path"), Nl = vi("defs"), Vl = vi("g"), Il = er("id"), Tl = vi("rect"), ql = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            Gi("currentColor")
        ]), k([
            A2(Vl, k([
                Hl("url(#clip0_3015_4435)")
            ]), k([
                A2(wi, k([
                    mi("M8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0ZM5.78 8.75C5.90674 10.2287 6.37319 11.6581 7.143 12.927C7.398 13.353 7.685 13.759 8 14.142C8.245 13.846 8.551 13.437 8.857 12.927C9.62681 11.6581 10.0933 10.2287 10.22 8.75H5.78ZM10.22 7.25C10.0933 5.77131 9.62681 4.34185 8.857 3.073C8.55 2.563 8.245 2.154 8 1.858C7.68436 2.24101 7.39789 2.64715 7.143 3.073C6.37319 4.34185 5.90674 5.77131 5.78 7.25H10.22ZM4.276 8.75H1.543C1.69169 10.0247 2.214 11.227 3.04424 12.2056C3.87447 13.1843 4.97556 13.8955 6.209 14.25C6.086 14.069 5.969 13.885 5.857 13.698C5.142 12.506 4.42 10.824 4.276 8.75ZM1.543 7.25H4.276C4.42 5.176 5.142 3.494 5.856 2.302C5.976 2.105 6.093 1.921 6.209 1.75C4.97556 2.10445 3.87447 2.81573 3.04424 3.79436C2.214 4.77299 1.69169 5.97528 1.543 7.25ZM11.724 8.75C11.58 10.824 10.858 12.506 10.144 13.698C10.024 13.895 9.907 14.079 9.791 14.25C11.0244 13.8955 12.1255 13.1843 12.9558 12.2056C13.786 11.227 14.3083 10.0247 14.457 8.75H11.724ZM14.457 7.25C14.3083 5.97528 13.786 4.77299 12.9558 3.79436C12.1255 2.81573 11.0244 2.10445 9.791 1.75C9.914 1.931 10.031 2.115 10.144 2.302C10.858 3.494 11.58 5.176 11.724 7.25H14.457Z")
                ]), w)
            ])),
            A2(Nl, w, k([
                A2(Sl, k([
                    Il("clip0_3015_4435")
                ]), k([
                    A2(Tl, k([
                        Zl("16"),
                        ul("16"),
                        Gi("white")
                    ]), w)
                ]))
            ]))
        ]));
    }), Pl = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 24 24"),
            Gi("none"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                mi("M4.88207 23L2.01448 20.106L20.1179 2L23 4.8795L4.88207 23ZM20.1179 23L2 4.8795L4.88207 2L22.9855 20.106L20.1179 23Z")
            ]), w)
        ]));
    }), Dl = F2(function(e, r) {
        return A2(Li, k([
            ji("flex justify-between items-center m-4 my-6 h-8 xs:m-6 sm:mx-8 md:h-9 md:my-10 lg:my-12 lg:mb-14")
        ]), k([
            A2(Li, k([
                ji("flex items-center gap-6 h-9")
            ]), k([
                A2(Li, k([
                    ji("-translate-y-0.5")
                ]), k([
                    bl(e)
                ])),
                A2(Oi, k([
                    ji("group relative")
                ]), k([
                    A2(wl, k([
                        ji("flex gap-1 font-semibold items-center text-base text-gray-400 cursor-pointer uppercase [&::-webkit-details-marker]:hidden")
                    ]), k([
                        A2(ql, "w-4 h-4", w),
                        Vi("ES"),
                        A2(Ci, "w-4 h-4 fill-gray-400 rotate-90 transition-transform group-open:-rotate-90", w)
                    ])),
                    A2(Li, k([
                        ji("absolute top-8 flex flex-col bg-white rounded-xl shadow-md text-lg w-40 z-10 overflow-hidden")
                    ]), k([
                        A2(Ri, k([
                            Ei(e.cB + "/" + A2(ea, "", A2(Aa, function(e) {
                                return e.V;
                            }, r))),
                            ji("inline-flex items-center gap-2 pl-10 pr-4 pt-3 pb-2 hover:bg-gray-50")
                        ]), k([
                            Vi("English")
                        ])),
                        A2(Ri, k([
                            Ei(e.cC + "/" + A2(ea, "", A2(Aa, function(e) {
                                return e.V;
                            }, r))),
                            ji("inline-flex items-center gap-2 pl-10 pr-4 py-2 hover:bg-gray-50")
                        ]), k([
                            Vi("Deutsch")
                        ])),
                        A2(Ri, k([
                            Ei(e.cD + "/" + A2(ea, "", A2(Aa, function(e) {
                                return e.V;
                            }, r))),
                            ji("inline-flex items-center gap-2 px-4 pt-2 pb-3 text-gray-400 hover:bg-gray-50")
                        ]), k([
                            A2(yl, "w-4 h-4 fill-gray-400", w),
                            Vi("Espa\xf1ol")
                        ]))
                    ]))
                ]))
            ])),
            function() {
                if (r.$) return Vi("");
                var t = r.a;
                return A2(Li, k([
                    ji("flex gap-3")
                ]), k([
                    A2(Ui, k([
                        Rl("button"),
                        A2(Bi, "commandfor", "qr-code"),
                        A2(Bi, "command", "show-modal")
                    ]), k([
                        A2(ml, "w-8 h-8 fill-grey-600 hover:fill-black focus-visible:fill-black transition-colors", w)
                    ])),
                    A3(dl, "dialog", k([
                        al("qr-code"),
                        ji("backdrop:bg-white"),
                        A2(Bi, "closedby", "any")
                    ]), k([
                        A2(Ui, k([
                            ji("block mt-1 mr-1 ml-auto p-4 rounded-full bg-white shadow-md ring-1 ring-grey-50 hover:bg-black hover:text-white hover:fill-white hover:ring-black outline-none focus-visible:ring-inset focus-visible:ring-4 focus-visible:ring-primary-600"),
                            Rl("button"),
                            A2(Bi, "commandfor", "qr-code"),
                            A2(Bi, "command", "close")
                        ]), k([
                            A2(Pl, "w-6 h-6 fill-current", w)
                        ])),
                        A2(El, Vi("Error while creating the QRCode."), A2(Fa, zl(k([
                            Zl("80vw"),
                            ul("80vh")
                        ])), nl(e.cD + "/" + t.V)))
                    ])),
                    A2(Li, k([
                        al("copy-link-button"),
                        ji("grid")
                    ]), k([
                        A2(Ui, k([
                            ji(hl(2) + " col-start-1 row-start-1"),
                            Rl("button"),
                            xl(aa(A2(Pi, "copy-link-button", e.cD + "/" + t.V)))
                        ]), k([
                            A2(il, "w-4 h-4 fill-current", w),
                            A2(vl, k([
                                ji("hidden xs:inline")
                            ]), k([
                                Vi(t.aH)
                            ])),
                            A2(vl, k([
                                ji("xs:hidden")
                            ]), k([
                                Vi(t.aI)
                            ]))
                        ])),
                        A2(Li, k([
                            ji(hl(1) + " col-start-1 row-start-1 justify-center shadow-primary-500/20 pointer-events-none opacity-0")
                        ]), k([
                            A2(yl, "w-4 h-4 fill-current", w),
                            Vi(t.aJ)
                        ]))
                    ]))
                ]));
            }()
        ]));
    }), Bl = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                mi("M10.5 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm.061 3.073a4 4 0 10-5.123 0 6.004 6.004 0 00-3.431 5.142.75.75 0 001.498.07 4.5 4.5 0 018.99 0 .75.75 0 101.498-.07 6.005 6.005 0 00-3.432-5.142z")
            ]), w)
        ]));
    }), Ul = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                mi("M8.66659 11.6667C8.66659 11.8435 8.59635 12.013 8.47132 12.1381C8.3463 12.2631 8.17673 12.3333 7.99992 12.3333C7.82311 12.3333 7.65354 12.2631 7.52851 12.1381C7.40349 12.013 7.33325 11.8435 7.33325 11.6667C7.33325 11.4899 7.40349 11.3203 7.52851 11.1953C7.65354 11.0702 7.82311 11 7.99992 11C8.17673 11 8.3463 11.0702 8.47132 11.1953C8.59635 11.3203 8.66659 11.4899 8.66659 11.6667ZM8.49992 6.16667C8.49992 6.03406 8.44724 5.90688 8.35347 5.81311C8.2597 5.71934 8.13253 5.66667 7.99992 5.66667C7.86731 5.66667 7.74013 5.71934 7.64637 5.81311C7.5526 5.90688 7.49992 6.03406 7.49992 6.16667V9.16667C7.49992 9.29927 7.5526 9.42645 7.64637 9.52022C7.74013 9.61399 7.86731 9.66667 7.99992 9.66667C8.13253 9.66667 8.2597 9.61399 8.35347 9.52022C8.44724 9.42645 8.49992 9.29927 8.49992 9.16667V6.16667Z")
            ]), w),
            A2(wi, k([
                hi("evenodd"),
                ol("evenodd"),
                mi("M6.20413 1.8325C6.84613 0.7225 8.44746 0.7225 9.08946 1.8325L15.0675 12.1685C15.7095 13.2798 14.9075 14.6698 13.6241 14.6698H1.66946C0.385458 14.6698 -0.415875 13.2798 0.226125 12.1685L6.20413 1.8325ZM8.22412 2.33317C8.16561 2.23183 8.08145 2.14768 7.98011 2.08917C7.87877 2.03066 7.76381 1.99986 7.64679 1.99986C7.52977 1.99986 7.41482 2.03066 7.31347 2.08917C7.21213 2.14768 7.12797 2.23183 7.06946 2.33317L1.09212 12.6692C1.03345 12.7705 1.00251 12.8856 1.00242 13.0027C1.00234 13.1198 1.03311 13.2349 1.09164 13.3363C1.15017 13.4378 1.23439 13.522 1.33583 13.5806C1.43727 13.6391 1.55234 13.6699 1.66946 13.6698H13.6241C13.7411 13.6698 13.8561 13.639 13.9575 13.5805C14.0588 13.522 14.143 13.4378 14.2015 13.3365C14.26 13.2351 14.2908 13.1202 14.2908 13.0032C14.2908 12.8861 14.26 12.7712 14.2015 12.6698L8.22412 2.3325V2.33317Z")
            ]), w)
        ]));
    }), Ol = function(e) {
        return A2(Li, k([
            ji("fixed top-4 inset-x-2 flex justify-center pointer-events-none z-50")
        ]), k([
            A2(Li, k([
                al("toast"),
                ji("flex items-center py-2 px-4 gap-3 md:gap-4 text-white bg-black/80 rounded-lg opacity-0 -translate-y-1/2 ease-[cubic-bezier(.34,1.56,.64,1)] duration-700")
            ]), k([
                A2(Ul, "w-4 h-4 md:w-5 md:h-5 fill-white shrink-0 self-start mt-1.5 md:mt-1", w),
                A2(vl, w, k([
                    Vi(e.dz)
                ]))
            ]))
        ]));
    }, Jl = F2(function(e, r) {
        var t = function(e) {
            return vl(k([
                ji("relative text-transparent before:absolute before:inset-x-0 before:inset-y-1 before:bg-black before:rounded-full before:animate-pulse " + e)
            ]));
        };
        return A2(Li, w, k([
            Ol(r),
            A2(Li, k([
                ji("flex flex-col max-w-screen-lg mx-auto lg:px-8")
            ]), k([
                A2(Dl, e, xt),
                A2(Li, k([
                    ji("flex flex-col mx-4 mb-6 bg-white rounded-xl shadow-md shadow-black/5 md:mx-8 md:mb-12 overflow-hidden")
                ]), k([
                    A2(Li, k([
                        ji("flex flex-col gap-4 p-4 text-left rounded-xl xs:p-5 md:p-8 lg:pb-8 outline-none focus-visible:ring-4 focus-visible:ring-primary-600 focus-visible:ring-inset")
                    ]), k([
                        A2(Li, k([
                            ji("flex w-full items-center gap-2 lg:flex-row-reverse lg:gap-5")
                        ]), k([
                            A2(Li, k([
                                ji("flex flex-col gap-1 grow")
                            ]), k([
                                A2(qi, k([
                                    ji("font-serif font-bold text-lg xs:text-xl md:text-2xl")
                                ]), k([
                                    A2(t, "opacity-40", k([
                                        Vi("Title")
                                    ]))
                                ])),
                                A2(Li, k([
                                    ji("flex flex-wrap gap-y-2 gap-x-4 sm:gap-x-6 text-sm xs:text-base sm:text-lg text-grey-400")
                                ]), k([
                                    A2(Li, k([
                                        ji("flex gap-1.5 items-center")
                                    ]), k([
                                        A2(Bl, "inline-block w-3 h-3 fill-grey-400 sm:w-4 sm:h-4", w),
                                        A2(t, "opacity-10", k([
                                            Vi("Author")
                                        ]))
                                    ])),
                                    A2(Li, k([
                                        ji("flex gap-1.5 items-center")
                                    ]), k([
                                        A2(Fi, "inline-block w-3 h-3 fill-grey-400 sm:w-4 sm:h-4", w),
                                        A2(t, "opacity-10", k([
                                            Vi("available until date")
                                        ]))
                                    ]))
                                ]))
                            ])),
                            A2(Ci, "shrink-0 w-4 h-4 transition-transform", w)
                        ]))
                    ]))
                ])),
                A2(Li, k([
                    ji("grid [grid-template-columns:auto_auto_auto_1fr] px-4 gap-x-2 gap-y-4 sm:gap-x-3 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), k([
                    A2(Li, k([
                        ji("col-start-1 row-start-1 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-1 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), w),
                    A2(Li, k([
                        ji("flex items-center gap-2 mr-2")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold text-grey-400")
                        ]), k([
                            A2(t, "opacity-20", k([
                                Vi("Question")
                            ]))
                        ])),
                        A2(yl, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", w)
                    ])),
                    A2(Li, k([
                        ji("col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                    ]), k([
                        A2(t, "opacity-10", k([
                            Vi("started some")
                        ]))
                    ])),
                    A2(Li, k([
                        ji("col-start-1 row-start-2 row-span-2 justify-self-center w-0.5 bg-grey-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-2 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-black text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-2 mr-2 flex items-center gap-2")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold text-black")
                        ]), k([
                            A2(t, "opacity-40", k([
                                Vi("Proposals")
                            ]))
                        ]))
                    ])),
                    A2(Li, k([
                        ji("text-transparent col-span-2 justify-self-end px-2 py-1 font-semibold text-xs text-primary-600 bg-primary-200 rounded-full xs:col-span-1 xs:text-sm xs:px-3 xs:justify-self-start md:text-base md:-my-0.5")
                    ]), k([
                        Vi("in progress")
                    ]))
                ])),
                A2(Li, k([
                    ji("group overflow-hidden lg:rounded-xl shadow-xl shadow-primary-500/10  bg-primary-200 h-screen")
                ]), k([
                    A2(Li, k([
                        ji("flex flex-col w-full h-1/2 px-4 py-10 bg-primary-300 xs:p-6 sm:p-8 md:p-12 lg:p-16")
                    ]), w)
                ]))
            ])),
            A2(Li, k([
                ji("mt-20 lg:mt-40")
            ]), k([
                A3(zi, 0, 1, A3(Ti, e, r.$7, 1))
            ]))
        ]));
    }), Ql = F2(function(e, r) {
        return " font-serif font-extrabold px-6 py-3.5 text-center rounded-full" + function() {
            switch(e){
                case 0:
                    return " text-black bg-white ring-1 ring-grey-100 shadow-md shadow-black/5 hover:bg-black hover:text-white hover:fill-white hover:ring-0";
                case 1:
                    return " text-black bg-primary-300 selection:bg-white shadow-md shadow-primary-400/30 hover:bg-black hover:text-white hover:shadow-black/20";
                default:
                    return " text-white bg-black selection:bg-white shadow-md shadow-black/20 hover:bg-white hover:text-black hover:shadow-black/5 transition-colors";
            }
        }() + function() {
            switch(r){
                case 1:
                    return " disabled:bg-grey-200 disabled:text-grey-400 disabled:shadow-none disabled:cursor-not-allowed group-invalid:bg-grey-200 group-invalid:text-grey-400 group-invalid:shadow-none group-invalid:cursor-not-allowed";
                case 2:
                    return " disabled:bg-primary-200 disabled:text-primary-400 disabled:shadow-none disabled:cursor-not-allowed group-invalid:bg-primary-200 group-invalid:text-primary-400 group-invalid:shadow-none group-invalid:cursor-not-allowed";
                case 3:
                    return " disabled:ring-[#C99727] disabled:ring-2 disabled:bg-transparent disabled:text-[#C99727] disabled:shadow-none disabled:cursor-not-allowed group-invalid:ring-[#C99727] group-invalid:ring-2 group-invalid:bg-transparent group-invalid:text-[#C99727] group-invalid:shadow-none group-invalid:cursor-not-allowed";
                default:
                    return "";
            }
        }() + " outline-none focus-visible:ring-4 focus-visible:ring-offset-4 focus-visible:ring-primary-600";
    }), Yl = F2(function(e, r) {
        return A2(Li, k([
            ji("min-h-screen bg-primary-300")
        ]), k([
            A2(Li, k([
                ji("flex flex-col max-w-screen-lg mx-auto lg:px-8")
            ]), k([
                A2(Li, k([
                    ji("flex justify-between items-center m-4 my-6 h-8 xs:m-6 sm:mx-8 md:h-9 md:my-10 lg:my-12 lg:mb-14")
                ]), k([
                    A2(Ri, k([
                        ji("outline-none focus-visible:ring-4 focus-visible:ring-primary-300 focus-visible:ring-offset-8 focus-visible:rounded-full"),
                        Ei(e.fn),
                        ll("go to website")
                    ]), k([
                        bl(e)
                    ]))
                ])),
                A2(Li, k([
                    ji("flex flex-col px-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), k([
                    A2(qi, k([
                        ji("text-3xl font-serif font-bold mb-4 mt-8 sm:text-center lg:text-4xl lg:mb-10 lg:mt-32")
                    ]), k([
                        Vi(r.ef.k)
                    ])),
                    A2(Hi, k([
                        ji("mb-14 sm:text-center lg:text-2xl lg:mb-20")
                    ]), k([
                        Vi(r.ef.o)
                    ])),
                    A2(Li, k([
                        ji("flex flex-col self-center")
                    ]), k([
                        A2(Ri, k([
                            ji("mb-4 " + A2(Ql, 2, 0)),
                            Ei(e.cD)
                        ]), k([
                            Vi(r.d0.eO.d9)
                        ])),
                        A2(Ri, k([
                            ji(A2(Ql, 0, 0)),
                            Ei(e.fn)
                        ]), k([
                            Vi(r.d0.eO.dA)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), Kl = function(e) {
        return {
            $: 1,
            a: e
        };
    }, Wl = {
        $: 0
    }, eb = {
        $: 0
    }, rb = function(e) {
        return {
            $: 4,
            a: e
        };
    }, tb = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                mi("M4.75 2.5a.25.25 0 00-.25.25v9.91l3.023-2.489a.75.75 0 01.954 0l3.023 2.49V2.75a.25.25 0 00-.25-.25h-6.5zM3 2.75C3 1.784 3.784 1 4.75 1h6.5c.966 0 1.75.784 1.75 1.75v11.5a.75.75 0 01-1.227.579L8 11.722l-3.773 3.107A.75.75 0 013 14.25V2.75z")
            ]), w)
        ]));
    }), nb = function(e) {
        return {
            $: 9,
            a: e
        };
    }, ub = Z, ab = function(e) {
        return A2(ub, e, "");
    }, ob = F3(function(e, r, t) {
        return e > 0 ? A3(ob, e >> 1, v(r, r), 1 & e ? v(t, r) : t) : t;
    }), ib = F2(function(e, r) {
        return A3(ob, e, r, "");
    }), cb = F3(function(e, r, t) {
        return v(A2(ib, e - hn(t), ab(r)), t);
    }), fb = F2(function(e, r) {
        return Qt(e / r);
    }), sb = function(e) {
        return e;
    }, lb = F3(function(e, r, t) {
        for(;;){
            if (!t.b) return r + e;
            var n = t.a, u = t.b;
            if (0 > d(n.a8, r)) return r + n.c;
            t = u;
        }
    }), bb = F2(function(e, r) {
        var t = e.b;
        return A3(lb, e.a, A2(fb, r, 6e4), t);
    }), db = function(e) {
        var r = A2(fb, e, 1440) + 719468, t = (0 > r ? r - 146096 : r) / 146097 | 0, n = r - 146097 * t, u = (n - (n / 1460 | 0) + (n / 36524 | 0) - (n / 146096 | 0)) / 365 | 0, a = n - (365 * u + (u / 4 | 0) - (u / 100 | 0)), o = (5 * a + 2) / 153 | 0, i = o + (10 > o ? 3 : -9);
        return {
            bo: a - ((153 * o + 2) / 5 | 0) + 1,
            bR: i,
            cv: u + 400 * t + (i > 2 ? 0 : 1)
        };
    }, pb = F2(function(e, r) {
        return db(A2(bb, e, r)).bo;
    }), gb = F2(function(e, r) {
        return A2(Xc, 24, A2(fb, A2(bb, e, r), 60));
    }), xb = F2(function(e, r) {
        return A2(Xc, 60, A2(bb, e, r));
    }), mb = F2(function(e, r) {
        switch(db(A2(bb, e, r)).bR){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), hb = function(e) {
        var r = e.a, t = e.b;
        return A3(cb, 2, "0", vt(A2(pb, r, t))) + " " + function(e) {
            switch(e){
                case 0:
                    return "January";
                case 1:
                    return "February";
                case 2:
                    return "March";
                case 3:
                    return "April";
                case 4:
                    return "May";
                case 5:
                    return "June";
                case 6:
                    return "July";
                case 7:
                    return "August";
                case 8:
                    return "September";
                case 9:
                    return "October";
                case 10:
                    return "November";
                default:
                    return "December";
            }
        }(A2(mb, r, t)) + " " + A3(cb, 2, "0", vt(A2(gb, r, t))) + ":" + A3(cb, 2, "0", vt(A2(xb, r, t)));
    }, vb = F3(function(e, r, t) {
        return A2(Li, k([
            ji("flex flex-col justify-center items-center gap-4 mt-20 md:mt-32")
        ]), k([
            A2(Li, k([
                ji("flex flex-col self-center gap-4")
            ]), k([
                A2(Ui, k([
                    ji(A2(Ql, 2, 0)),
                    xl(aa(nb(t))),
                    Rl("button")
                ]), k([
                    Vi(e.dx)
                ])),
                A2(Ui, k([
                    ji(" font-serif font-extrabold px-6 py-3.5 text-center rounded-full ring-2 ring-black ring-inset group-invalid:bg-grey-200 group-invalid:text-grey-400 group-invalid:shadow-none outline-none focus-visible:ring-4 focus-visible:ring-primary-600 hover:bg-black hover:text-white"),
                    xl(aa(Kl(t)))
                ]), k([
                    Vi(e.eM)
                ]))
            ])),
            A2(Hi, k([
                ji("text-center text-grey-400 max-w-xs sm:max-w-sm text-sm xs:text-base sm:text-lg whitespace-pre-line break-words")
            ]), k([
                Vi(e.eK + "\n" + hb(r))
            ]))
        ]));
    }), wb = function(e) {
        var r = e.a, t = e.b;
        return A3(cb, 2, "0", vt(A2(pb, r, t))) + "." + A3(cb, 2, "0", function(e) {
            switch(e){
                case 0:
                    return "01";
                case 1:
                    return "02";
                case 2:
                    return "03";
                case 3:
                    return "04";
                case 4:
                    return "05";
                case 5:
                    return "06";
                case 6:
                    return "07";
                case 7:
                    return "08";
                case 8:
                    return "09";
                case 9:
                    return "10";
                case 10:
                    return "11";
                default:
                    return "12";
            }
        }(A2(mb, r, t))) + ".";
    }, yb = Oe("input"), $b = Qe, kb = function(e) {
        return {
            $: 4,
            a: e
        };
    }, Cb = {
        $: 8
    }, _b = F2(function(e, r) {
        return {
            $: 5,
            a: e,
            b: r
        };
    }), jb = {
        $: 16
    }, Fb = {
        $: 16
    }, Gb = function(e) {
        return {
            $: 13,
            a: e
        };
    }, Mb = {
        $: 14
    }, Ab = function(e) {
        return {
            $: 5,
            a: e
        };
    }, Xb = function(e) {
        return {
            $: 7,
            a: e
        };
    }, Lb = F2(function(e, r) {
        return A2(We, e, ko(r));
    }), zb = Lb("disabled"), Rb = _i("htmlFor"), Zb = Oe("form"), Eb = Oe("h3"), Sb = Oe("label"), Hb = "text-xs tracking-wide uppercase font-bold sm:text-sm", Nb = function(e) {
        return A2(er, "minLength", vt(e));
    }, Vb = function(e) {
        return g(e, !0);
    }, Ib = F2(function(e, r) {
        return A2(pl, e, {
            $: 1,
            a: r
        });
    }), Tb = F2(function(e, r) {
        return A3(zn, Qn, r, e);
    }), qb = A2(Tb, k([
        "target",
        "value"
    ]), na), Pb = function(e) {
        return A2(Ib, "input", A2(sn, Vb, A2(sn, e, qb)));
    }, Db = function(e) {
        return g(e, !0);
    }, Bb = F2(function(e, r) {
        return A2(pl, e, {
            $: 2,
            a: r
        });
    }), Ub = function(e) {
        return A2(Bb, "submit", A2(sn, Db, bn(e)));
    }, Ob = _i("placeholder"), Jb = F3(function(e, r, t) {
        return A2(wt, r, A2(yt, e, t));
    }), Qb = Lb("required"), Yb = A2(Pc, function(e) {
        return A2(Es, {
            cL: !1,
            d1: !1
        }, e);
    }, ea(/.^/)), Kb = Kr(1 / 0), Wb = F2(function(e, r) {
        return A2(ea, "", A2(Aa, function(r) {
            var t = r.b;
            return A2(ub, e(r.a), t);
        }, Zt(r)));
    }), ed = function(e) {
        return e.toUpperCase();
    }, rd = function(e) {
        return A2(Wb, ed, e);
    }, td = function(e) {
        var r = A2(Kb, Yb("\\w+"), A2(Pc, function(e) {
            return e.dX;
        }, rd));
        return A3(Kb, Yb("^([a-z])|\\s+([a-z])"), A2(Pc, function(e) {
            return e.dX;
        }, r), e);
    }, nd = _i("value"), ud = F4(function(e, r, t, n) {
        var u, a = function(e) {
            return A2(Li, k([
                ji("fixed z-40 inset-0 flex flex-col bg-white lg:p-6 lg:justify-center lg:items-center lg:bg-primary-300/80 lg:backdrop-blur-sm")
            ]), k([
                A2(Li, k([
                    ji("relative flex flex-col p-6 overflow-auto max-w-3xl lg:p-14 lg:bg-white lg:max-h-[90%] lg:min-w-[30rem] lg:rounded-2xl lg:shadow-lg")
                ]), e)
            ]));
        }, o = function(e) {
            return A2(Li, k([
                ji("fixed z-40 inset-0 p-6 flex flex-col justify-center items-center bg-primary-300/80 backdrop-blur-sm")
            ]), k([
                A2(Li, k([
                    ji("flex flex-col p-6 max-w-md max-h-[90%] overflow-auto bg-white rounded-xl shadow-lg lg:max-w-lg lg:p-10 lg:rounded-2xl")
                ]), e)
            ]));
        };
        switch(n.$){
            case 1:
                var i = n.a.au, c = n.a.at, f = n.a.en, l = n.a.V;
                return o(k([
                    A2(Eb, k([
                        ji("text-2xl font-serif font-bold mb-4")
                    ]), k([
                        Vi(r.d0.c0.k)
                    ])),
                    A2(Hi, w, k([
                        Vi(A3(Jb, "{name}", td(t.cF), r.d0.c0.o))
                    ])),
                    f.$ ? Vi("") : A2(Hi, k([
                        ji("mt-4")
                    ]), k([
                        Vi(A3(Jb, "{name}", td(t.cF), r.d0.c0.ep))
                    ])),
                    f.$ ? A2(Li, k([
                        ji("mt-10 flex flex-col gap-4 justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), k([
                        A2(Ui, k([
                            al(zo(oo)),
                            ji(A2(Ql, 1, 1)),
                            xl(aa(A2(_b, l, c))),
                            Rl("button"),
                            zb(!f.$ && !s(i, f.a))
                        ]), k([
                            Vi(r.d0.c0.F)
                        ])),
                        A2(Ui, k([
                            ji(A2(Ql, 0, 0)),
                            xl(aa(Cb)),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.cJ)
                        ]))
                    ])) : A2(Zb, k([
                        Ub(aa(A2(_b, l, c)))
                    ]), k([
                        A2(Li, k([
                            ji("flex flex-col gap-1.5 mt-6")
                        ]), k([
                            A2(Sb, k([
                                Rb("code-test"),
                                ji(Hb + " text-grey-600 selection:bg-white")
                            ]), k([
                                Vi(r.es)
                            ])),
                            A2(Li, k([
                                ji("flex flex-wrap gap-4 items-center")
                            ]), k([
                                A2(yb, k([
                                    al("code-input"),
                                    ji("appearance-none w-full px-4 py-3.5 bg-grey-100 rounded-md outline-none focus:bg-white focus:ring-2 focus:ring-inset focus:ring-grey-200 filled-invalid:ring filled-invalid:ring-red-400"),
                                    Ob(r.bZ),
                                    Pb(A2(Ao, aa, kb)),
                                    nd(c),
                                    Nb(1),
                                    Qb(!0)
                                ]), w)
                            ])),
                            A2(Li, k([
                                ji("mt-10 flex flex-col gap-4 justify-between self-center lg:flex-row-reverse lg:w-full")
                            ]), k([
                                A2(Ui, k([
                                    ji(A2(Ql, 1, 1)),
                                    Rl("submit"),
                                    zb(!f.$ && !s(i, f.a))
                                ]), k([
                                    Vi(r.d0.c0.F)
                                ])),
                                A2(Ui, k([
                                    ji(A2(Ql, 0, 0)),
                                    xl(aa(Cb)),
                                    Rl("button")
                                ]), k([
                                    Vi(r.d0.cJ)
                                ]))
                            ]))
                        ]))
                    ]))
                ]));
            case 3:
                return a(k([
                    A2(Eb, k([
                        ji("mb-6 text-2xl font-serif font-bold lg:w-5/6 lg:mb-10")
                    ]), k([
                        Vi(r.d0.eq.k)
                    ])),
                    A2(Hi, k([
                        ji("whitespace-pre-wrap")
                    ]), k([
                        Vi(r.d0.eq.o)
                    ])),
                    A2(Ui, k([
                        ji("fixed bottom-6 right-6 !p-4 lg:absolute lg:bottom-auto lg:top-6 lg:right-6" + A2(Ql, 0, 0)),
                        xl(aa(Cb)),
                        Rl("button")
                    ]), k([
                        A2(Pl, "w-6 h-6 fill-current", w)
                    ]))
                ]));
            case 4:
                return a(k([
                    A2(Eb, k([
                        ji("mb-6 text-2xl font-serif font-bold lg:w-5/6 lg:mb-10")
                    ]), k([
                        Vi(r.d0.er.k)
                    ])),
                    A2(Hi, k([
                        ji("whitespace-pre-wrap")
                    ]), k([
                        Vi(A3(Jb, "{name}", td(t.cF), r.d0.er.o))
                    ])),
                    A2(Ui, k([
                        ji("fixed bottom-6 right-6 !p-4 lg:absolute lg:bottom-auto lg:top-6 lg:right-6" + A2(Ql, 0, 0)),
                        xl(aa(Cb)),
                        Rl("button")
                    ]), k([
                        A2(Pl, "w-6 h-6 fill-current", w)
                    ]))
                ]));
            case 5:
                return a(k([
                    A2(Eb, k([
                        ji("mb-6 text-2xl font-serif font-bold lg:w-5/6 lg:mb-10")
                    ]), k([
                        Vi(r.d0.dg.k)
                    ])),
                    A2(Hi, k([
                        ji("whitespace-pre-wrap")
                    ]), k([
                        Vi(r.d0.dg.o)
                    ])),
                    A2(Ui, k([
                        ji("fixed bottom-6 right-6 !p-4 lg:absolute lg:bottom-auto lg:top-6 lg:right-6" + A2(Ql, 0, 0)),
                        xl(aa(Cb)),
                        Rl("button")
                    ]), k([
                        A2(Pl, "w-6 h-6 fill-current", w)
                    ]))
                ]));
            case 6:
                var b = n.a;
                return o(k([
                    A2(Eb, k([
                        ji("text-2xl font-serif font-bold mb-4")
                    ]), k([
                        Vi(r.d0.de.k)
                    ])),
                    A2(Hi, k([
                        ji("mb-4")
                    ]), k([
                        Vi(r.d0.de.o)
                    ])),
                    A2(Li, k([
                        ji("flex flex-col gap-4 justify-center lg:justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), k([
                        A2(Ui, k([
                            ji(A2(Ql, 1, 0)),
                            xl(rb((u = b, {
                                $: 12,
                                a: u
                            }))),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.de.F)
                        ])),
                        A2(Ui, k([
                            ji(A2(Ql, 0, 0)),
                            xl(aa(Cb)),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.cJ)
                        ]))
                    ]))
                ]));
            case 7:
                return b = n.a, o(k([
                    A2(Eb, k([
                        ji("text-2xl font-serif font-bold mb-4")
                    ]), k([
                        Vi(r.d0.dM.k)
                    ])),
                    A2(Hi, k([
                        ji("mb-10")
                    ]), k([
                        Vi(r.d0.dM.o)
                    ])),
                    A2(Li, k([
                        ji("flex flex-col gap-4 justify-center lg:justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), k([
                        A2(Ui, k([
                            ji(A2(Ql, 1, 0)),
                            xl(rb(Gb(b))),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.dM.F)
                        ])),
                        A2(Ui, k([
                            ji(A2(Ql, 0, 0)),
                            xl(aa(Cb)),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.cJ)
                        ]))
                    ]))
                ]));
            case 8:
                return o(k([
                    A2(Eb, k([
                        ji("text-2xl font-serif font-bold mb-4")
                    ]), k([
                        Vi(r.d0.da.k)
                    ])),
                    A2(Hi, k([
                        ji("mb-10")
                    ]), k([
                        Vi(r.d0.da.o)
                    ])),
                    A2(Li, k([
                        ji("flex flex-col gap-4 justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), k([
                        A2(Ui, k([
                            al(zo(oo)),
                            ji(A2(Ql, 1, 0)),
                            xl(rb(jb)),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.da.F)
                        ])),
                        A2(Ui, k([
                            ji(A2(Ql, 0, 0)),
                            xl(aa(Cb)),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.cJ)
                        ]))
                    ]))
                ]));
            case 9:
                return o(k([
                    A2(Eb, k([
                        ji("text-2xl font-serif font-bold mb-4")
                    ]), k([
                        Vi(r.d0.eQ.k)
                    ])),
                    A2(Hi, k([
                        ji("mb-10 whitespace-pre-line break-words")
                    ]), k([
                        Vi(r.d0.eQ.o)
                    ])),
                    A2(Li, k([
                        ji("flex flex-col gap-4 justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), k([
                        A2(Ui, k([
                            al(zo(oo)),
                            ji(A2(Ql, 1, 0)),
                            xl(Ab(Mb)),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.eQ.F)
                        ])),
                        A2(Ui, k([
                            ji(A2(Ql, 0, 0)),
                            xl(aa(Cb)),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.cJ)
                        ]))
                    ]))
                ]));
            case 10:
                return o(k([
                    A2(Eb, k([
                        ji("text-2xl font-serif font-bold mb-4")
                    ]), k([
                        Vi(r.d0.db.k)
                    ])),
                    A2(Hi, k([
                        ji("mb-10")
                    ]), k([
                        Vi(r.d0.db.o)
                    ])),
                    A2(Li, k([
                        ji("flex flex-col gap-4 justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), k([
                        A2(Ui, k([
                            al(zo(oo)),
                            ji("px-6 py-4" + A2(Ql, 1, 0)),
                            xl(Ab(Fb)),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.db.F)
                        ])),
                        A2(Ui, k([
                            ji("px-6 py-4" + A2(Ql, 0, 0)),
                            xl(aa(Cb)),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.cJ)
                        ]))
                    ]))
                ]));
            case 11:
                return o(k([
                    A2(Eb, k([
                        ji("text-2xl font-serif font-bold mb-4")
                    ]), k([
                        Vi(r.d0.eS.k)
                    ])),
                    A2(Hi, k([
                        ji("mb-10")
                    ]), k([
                        Vi(r.d0.eS.o)
                    ])),
                    A2(Li, k([
                        ji("flex flex-col gap-4 justify-center self-center lg:flex-row-reverse lg:w-full")
                    ]), k([
                        A2(Ui, k([
                            ji("px-6 py-4" + A2(Ql, 1, 0)),
                            xl(aa(Xb(t.bG))),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.eS.F)
                        ]))
                    ]))
                ]));
            case 12:
                return o(k([
                    A2(Eb, k([
                        ji("text-2xl font-serif font-bold mb-4")
                    ]), k([
                        Vi(r.d0.e_.k)
                    ])),
                    A2(Hi, k([
                        ji("mb-10")
                    ]), k([
                        Vi(r.d0.e_.o)
                    ])),
                    A2(Li, k([
                        ji("flex flex-col gap-4 justify-center self-center lg:flex-row-reverse lg:w-full")
                    ]), k([
                        A2(Ui, k([
                            ji("px-6 py-4" + A2(Ql, 1, 0)),
                            xl(aa(Xb(t.bG))),
                            Rl("button")
                        ]), k([
                            Vi(r.d0.e_.F)
                        ]))
                    ]))
                ]));
            case 2:
                return o(k([
                    A2(Eb, k([
                        ji("text-2xl font-serif font-bold mb-4")
                    ]), k([
                        Vi(r.d0.eO.k)
                    ])),
                    A2(Hi, k([
                        ji("mb-10")
                    ]), k([
                        Vi(r.d0.eO.o)
                    ])),
                    A2(Li, k([
                        ji("flex flex-col gap-4 justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), k([
                        A2(Ri, k([
                            ji("px-6 py-4" + A2(Ql, 1, 0)),
                            Ei(e.cD)
                        ]), k([
                            Vi(r.d0.eO.d9)
                        ])),
                        A2(Ri, k([
                            ji("px-6 py-4" + A2(Ql, 0, 0)),
                            Ei(e.fn)
                        ]), k([
                            Vi(r.d0.eO.dA)
                        ]))
                    ]))
                ]));
            default:
                return Vi("");
        }
    }), ad = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                mi("M5.5 3.5a2 2 0 100 4 2 2 0 000-4zM2 5.5a3.5 3.5 0 115.898 2.549 5.507 5.507 0 013.034 4.084.75.75 0 11-1.482.235 4.001 4.001 0 00-7.9 0 .75.75 0 01-1.482-.236A5.507 5.507 0 013.102 8.05 3.49 3.49 0 012 5.5zM11 4a.75.75 0 100 1.5 1.5 1.5 0 01.666 2.844.75.75 0 00-.416.672v.352a.75.75 0 00.574.73c1.2.289 2.162 1.2 2.522 2.372a.75.75 0 101.434-.44 5.01 5.01 0 00-2.56-3.012A3 3 0 0011 4z")
            ]), w)
        ]));
    }), od = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 24 24"),
            Gi("none"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                mi("M11.6136 23.2726L14.25 20.6476L7.32951 13.7385H23.5454V9.89762H7.32951L14.25 2.97716L11.6136 0.363525L0.159058 11.8181L11.6136 23.2726Z")
            ]), w)
        ]));
    }), id = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            Gi("none"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                mi("M6.5 1.75a.25.25 0 01.25-.25h2.5a.25.25 0 01.25.25V3h-3V1.75zm4.5 0V3h2.25a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5H5V1.75C5 .784 5.784 0 6.75 0h2.5C10.216 0 11 .784 11 1.75zM4.496 6.675a.75.75 0 10-1.492.15l.66 6.6A1.75 1.75 0 005.405 15h5.19c.9 0 1.652-.681 1.741-1.576l.66-6.6a.75.75 0 00-1.492-.149l-.66 6.6a.25.25 0 01-.249.225h-5.19a.25.25 0 01-.249-.225l-.66-6.6z")
            ]), w)
        ]));
    }), cd = F6(function(e, r, t, n, u, a) {
        var o;
        return A2(Li, k([
            ji("flex flex-col mx-4 mb-6 bg-white rounded-xl shadow-md shadow-black/5 md:mx-8 md:mb-12 overflow-hidden")
        ]), k([
            A2(Ui, k([
                ji("flex flex-col gap-4 p-4 text-left rounded-xl xs:p-5 md:p-8 lg:pb-8 outline-none focus-visible:ring-4 focus-visible:ring-primary-600 focus-visible:ring-inset"),
                Zi(k([
                    g("lg:!pb-0", n)
                ])),
                Rl("button"),
                xl(u)
            ]), k([
                A2(Li, k([
                    ji("flex w-full items-center gap-2 lg:flex-row-reverse lg:gap-5")
                ]), k([
                    A2(Li, k([
                        ji("flex flex-col gap-1 grow")
                    ]), k([
                        A2(qi, k([
                            ji("font-serif font-bold text-lg xs:text-xl md:text-2xl")
                        ]), k([
                            Vi(t.k)
                        ])),
                        A2(Li, k([
                            ji("flex flex-wrap gap-y-2 gap-x-4 sm:gap-x-6 text-sm xs:text-base sm:text-lg text-grey-400")
                        ]), k([
                            A2(Li, k([
                                ji("flex gap-1.5 items-center capitalize")
                            ]), k([
                                A2(Bl, "inline-block w-3 h-3 fill-grey-400 sm:w-4 sm:h-4", w),
                                Vi(t.cF)
                            ])),
                            A2(Li, k([
                                ji("flex gap-1.5 items-center")
                            ]), k([
                                A2(Fi, "inline-block w-3 h-3 fill-grey-400 sm:w-4 sm:h-4", w),
                                Vi(e.eL + " " + wb(g(r, t.dh)))
                            ]))
                        ]))
                    ])),
                    A2(Ci, "shrink-0 w-4 h-4 transition-transform", k([
                        g("rotate-90", n)
                    ]))
                ]))
            ])),
            A2(Li, k([
                ji("fixed inset-0 px-6 py-10 z-40 bg-white flex flex-col gap-6 sm:px-8 lg:static lg:z-0 lg:m-0 lg:pt-6 lg:pb-10 lg:pl-16 lg:ml-1"),
                Zi(k([
                    g("hidden", !n)
                ]))
            ]), k([
                A2(Li, k([
                    ji("lg:hidden flex flex-col gap-1")
                ]), k([
                    A2(qi, k([
                        ji("font-serif font-bold text-lg xs:text-xl md:text-2xl")
                    ]), k([
                        Vi(t.k)
                    ])),
                    A2(Li, k([
                        ji("flex flex-wrap gap-y-2 gap-x-4 sm:gap-x-6 text-sm xs:text-base sm:text-lg text-grey-400")
                    ]), k([
                        A2(Li, k([
                            ji("flex gap-1.5 items-center capitalize")
                        ]), k([
                            A2(Bl, "inline-block w-3 h-3 fill-grey-400 sm:w-4 sm:h-4", w),
                            Vi(t.cF)
                        ])),
                        A2(Li, k([
                            ji("flex gap-1.5 items-center")
                        ]), k([
                            A2(Fi, "inline-block w-3 h-3 fill-grey-400 sm:w-4 sm:h-4", w),
                            Vi(e.eL + " " + wb(g(r, t.dh)))
                        ]))
                    ]))
                ])),
                function() {
                    var r = t.o;
                    if (r.$) return Vi("");
                    var n = r.a;
                    return A2(Li, k([
                        ji("lg:space-y-1")
                    ]), k([
                        A2(Li, k([
                            ji(Hb)
                        ]), k([
                            Vi(e.eP)
                        ])),
                        A2(Hi, k([
                            ji("whitespace-pre-line break-words")
                        ]), k([
                            Vi(n)
                        ]))
                    ]));
                }(),
                A2(Li, k([
                    ji("flex flex-col p-6 gap-4 text-sm text-grey-400 bg-grey-100 rounded-xl xs:text-base sm:text-lg lg:bg-transparent lg:p-0 lg:pt-8 lg:mt-2 lg:border-t lg:border-grey-200 lg:rounded-none")
                ]), k([
                    Vi(A3(Jb, "{time}", hb(g(r, t.dh)), e.eJ)),
                    A2(Ui, k([
                        (o = a, A2(Ib, "click", bn(g(o, !0)))),
                        ji("flex self-start px-3 py-2 gap-2 items-center text-sm md:text-base text-black fill-black font-semibold ring-2 ring-black rounded-full hover:bg-black hover:text-white hover:fill-white")
                    ]), k([
                        A2(id, "w-4 h-4 fill-current", w),
                        Vi(e.eN)
                    ]))
                ])),
                A2(Li, k([
                    ji("fixed bottom-0 inset-x-0 flex p-6 justify-start")
                ]), k([
                    A2(Ui, k([
                        ji("lg:hidden self-end p-4 rounded-full bg-white shadow-md ring-1 ring-grey-50 hover:bg-black hover:text-white hover:fill-white hover:ring-black outline-none focus-visible:ring-inset focus-visible:ring-4 focus-visible:ring-primary-600"),
                        xl(u),
                        Rl("button")
                    ]), k([
                        A2(od, "w-6 h-6 fill-current", w)
                    ]))
                ]))
            ]))
        ]));
    }), fd = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                mi("M8 .25a.75.75 0 01.673.418l1.882 3.815 4.21.612a.75.75 0 01.416 1.279l-3.046 2.97.719 4.192a.75.75 0 01-1.088.791L8 12.347l-3.766 1.98a.75.75 0 01-1.088-.79l.72-4.194L.818 6.374a.75.75 0 01.416-1.28l4.21-.611L7.327.668A.75.75 0 018 .25z")
            ]), w)
        ]));
    }), sd = F2(function(e, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (e(r.a)) return !0;
            r = t;
        }
    }), ld = F2(function(e, r) {
        return A2(sd, function(r) {
            return s(r, e);
        }, r);
    }), bd = F4(function(e, r, t, n) {
        for(;;){
            if (!t.b) return Rt(n);
            var u = t.a, a = t.b, o = e(u);
            A2(ld, o, r) ? t = a : (r = A2(Wr, o, r), t = a, n = A2(Wr, u, n));
        }
    }), dd = F2(function(e, r) {
        return A4(bd, e, w, r, w);
    }), pd = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                mi("M5.5 4a2.5 2.5 0 014.607-1.346.75.75 0 101.264-.808A4 4 0 004 4v2h-.501A1.5 1.5 0 002 7.5v6A1.5 1.5 0 003.5 15h9a1.5 1.5 0 001.5-1.5v-6A1.5 1.5 0 0012.5 6h-7V4zm-.75 3.5H3.5v6h9v-6H4.75z")
            ]), w)
        ]));
    }), gd = function(e) {
        return {
            $: 6,
            a: e
        };
    }, xd = function(e) {
        return {
            $: 5,
            a: e
        };
    }, md = function(e) {
        return {
            $: 14,
            a: e
        };
    }, hd = {
        $: 1
    }, vd = function(e) {
        return {
            $: 4,
            a: e
        };
    }, wd = {
        $: 15
    }, yd = function(e) {
        return {
            $: 10,
            a: e
        };
    }, $d = {
        $: 2
    }, kd = function(e) {
        return {
            $: 11,
            a: e
        };
    }, Cd = function(e) {
        return {
            $: 3,
            a: e
        };
    }, _d = {
        $: 1
    }, jd = {
        $: 8
    }, Fd = {
        $: 9
    }, Gd = {
        $: 7
    }, Md = F2(function(e, r) {
        return r.e2 ? Vi("") : A2(Si, k([
            ji("relative flex flex-col border-2 border-yellow-500 border-dashed rounded-xl lg:overflow-hidden")
        ]), k([
            A2(Ui, k([
                ji("flex items-center gap-x-4 p-4 rounded-xl md:p-6 lg:flex-row-reverse outline-none focus-visible:ring-inset focus-visible:ring-4 focus-visible:ring-primary-600"),
                xl(_d),
                Rl("button")
            ]), k([
                A2(vl, k([
                    ji("line-clamp-2 text-left grow text-yellow-800")
                ]), k([
                    Vi(e.eE)
                ]))
            ]))
        ]));
    }), Ad = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            Gi("none"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                mi("M8.66675 4.99992C8.66675 5.17673 8.59651 5.3463 8.47149 5.47132C8.34646 5.59635 8.17689 5.66659 8.00008 5.66659C7.82327 5.66659 7.6537 5.59635 7.52868 5.47132C7.40365 5.3463 7.33341 5.17673 7.33341 4.99992C7.33341 4.82311 7.40365 4.65354 7.52868 4.52851C7.6537 4.40349 7.82327 4.33325 8.00008 4.33325C8.17689 4.33325 8.34646 4.40349 8.47149 4.52851C8.59651 4.65354 8.66675 4.82311 8.66675 4.99992ZM6.66675 7.49992C6.66675 7.36731 6.71943 7.24013 6.81319 7.14637C6.90696 7.0526 7.03414 6.99992 7.16675 6.99992H8.16675C8.29936 6.99992 8.42653 7.0526 8.5203 7.14637C8.61407 7.24013 8.66675 7.36731 8.66675 7.49992V10.3333H9.16675C9.29936 10.3333 9.42653 10.3859 9.5203 10.4797C9.61407 10.5735 9.66675 10.7006 9.66675 10.8333C9.66675 10.9659 9.61407 11.093 9.5203 11.1868C9.42653 11.2806 9.29936 11.3333 9.16675 11.3333H7.16675C7.03414 11.3333 6.90696 11.2806 6.81319 11.1868C6.71943 11.093 6.66675 10.9659 6.66675 10.8333C6.66675 10.7006 6.71943 10.5735 6.81319 10.4797C6.90696 10.3859 7.03414 10.3333 7.16675 10.3333H7.66675V7.99992H7.16675C7.03414 7.99992 6.90696 7.94724 6.81319 7.85347C6.71943 7.7597 6.66675 7.63253 6.66675 7.49992Z")
            ]), w),
            A2(wi, k([
                hi("evenodd"),
                ol("evenodd"),
                mi("M8.00008 0.666748C3.95008 0.666748 0.666748 3.95008 0.666748 8.00008C0.666748 12.0501 3.95008 15.3334 8.00008 15.3334C12.0501 15.3334 15.3334 12.0501 15.3334 8.00008C15.3334 3.95008 12.0501 0.666748 8.00008 0.666748ZM1.66675 8.00008C1.66675 6.32038 2.33401 4.70947 3.52174 3.52174C4.70947 2.33401 6.32038 1.66675 8.00008 1.66675C9.67979 1.66675 11.2907 2.33401 12.4784 3.52174C13.6662 4.70947 14.3334 6.32038 14.3334 8.00008C14.3334 9.67979 13.6662 11.2907 12.4784 12.4784C11.2907 13.6662 9.67979 14.3334 8.00008 14.3334C6.32038 14.3334 4.70947 13.6662 3.52174 12.4784C2.33401 11.2907 1.66675 9.67979 1.66675 8.00008Z")
            ]), w)
        ]));
    }), Xd = F2(function(e, r) {
        return !A2(ju, e, r).$;
    }), Ld = F2(function(e, r) {
        return A2(Xd, e, r);
    }), zd = F4(function(e, r, t, n) {
        return A2(Si, k([
            ji("relative flex flex-col bg-white rounded-xl shadow-md shadow-primary-500/40")
        ]), k([
            A2(Li, k([
                ji("flex items-center lg:gap-6")
            ]), k([
                A2(Ui, k([
                    al(n.bG),
                    ji("flex grow items-center gap-x-4 p-4 rounded-xl text-grey-400 md:p-6 lg:flex-row-reverse lg:pr-0 outline-none focus-visible:ring-4 focus-visible:ring-primary-600 focus-visible:ring-inset"),
                    function() {
                        if (t.$) return e = t.a, xl(A2(Ld, n.bG, r.a$) ? e.aK(n.bG) : e.a_(n.bG));
                        var e = t.a;
                        return xl(A2(Ld, n.bG, r.a$) ? e.aK(n.bG) : e.a_(n.bG));
                    }(),
                    Rl("button")
                ]), k([
                    A2(vl, k([
                        ji("line-clamp-2 text-left grow")
                    ]), k([
                        Vi(n.k)
                    ])),
                    A2(Ci, "w-4 h-4 transition-transform", k([
                        g("rotate-90", A2(Ld, n.bG, r.a$))
                    ]))
                ])),
                function() {
                    if (t.$) return Vi("");
                    var r = t.a;
                    return A2(Ui, k([
                        ji(hl(1) + " hidden lg:block mr-4 md:mr-6 shadow-none"),
                        xl(r.dK(n.bG)),
                        Rl("button")
                    ]), k([
                        Vi(e.eF.dL)
                    ]));
                }()
            ])),
            A2(Li, k([
                ji("fixed lg:static z-40 lg:z-0 inset-0 flex flex-col gap-y-6 py-10 px-6 bg-white rounded-b-xl overflow-y-auto lg:pt-0 lg:pb-10 lg:pl-14"),
                Zi(k([
                    g("hidden", !A2(Ld, n.bG, r.a$))
                ]))
            ]), k([
                function() {
                    if (t.$) return Vi("");
                    var r = t.a;
                    return A2(Ui, k([
                        ji("absolute top-3 right-3 flex items-center gap-1.5 py-1 px-2.5 text-sm text-grey-400 bg-grey-100 font-semibold rounded-full cursor-pointer lg:hidden"),
                        xl(r.e3),
                        Rl("button")
                    ]), k([
                        A2(Ad, "w-4 h-4 fill-grey-400", w),
                        Vi(e.eF.df)
                    ]));
                }(),
                A2(Li, k([
                    ji("lg:hidden")
                ]), k([
                    A2(Li, k([
                        ji(Hb + " text-grey-400")
                    ]), k([
                        Vi(e.eD)
                    ])),
                    A2(Eb, k([
                        ji("text-2xl font-serif font-bold")
                    ]), k([
                        Vi(n.k)
                    ]))
                ])),
                function() {
                    var r = n.o;
                    if (r.$) return A2(Hi, k([
                        ji("whitespace-pre-line break-words text-grey-400")
                    ]), k([
                        Vi(e.c9)
                    ]));
                    var t = r.a;
                    return A2(Li, k([
                        ji("lg:space-y-1")
                    ]), k([
                        A2(Li, k([
                            ji(Hb + " text-grey-400")
                        ]), k([
                            Vi(e.eC)
                        ])),
                        A2(Hi, k([
                            ji("whitespace-pre-line break-words")
                        ]), k([
                            Vi(t)
                        ]))
                    ]));
                }(),
                A2(Li, k([
                    ji("fixed lg:hidden z-10 bottom-0 inset-x-0 flex p-6 justify-between lg:justify-end")
                ]), k([
                    A2(Ui, k([
                        ji("lg:hidden !p-4" + A2(Ql, 0, 0)),
                        xl(t.a.aK(n.bG)),
                        Rl("button")
                    ]), k([
                        A2(od, "w-6 h-6 fill-current", w)
                    ])),
                    function() {
                        if (t.$) return Vi("");
                        var r = t.a;
                        return A2(Ui, k([
                            ji(A2(Ql, 1, 0)),
                            xl(r.dK(n.bG)),
                            Rl("button")
                        ]), k([
                            Vi(e.eF.dL)
                        ]));
                    }()
                ]))
            ]))
        ]));
    }), Rd = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                mi("M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm9 3a1 1 0 11-2 0 1 1 0 012 0zM6.92 6.085c.081-.16.19-.299.34-.398.145-.097.371-.187.74-.187.28 0 .553.087.738.225A.613.613 0 019 6.25c0 .177-.04.264-.077.318a.956.956 0 01-.277.245c-.076.051-.158.1-.258.161l-.007.004a7.728 7.728 0 00-.313.195 2.416 2.416 0 00-.692.661.75.75 0 001.248.832.956.956 0 01.276-.245 6.3 6.3 0 01.26-.16l.006-.004c.093-.057.204-.123.313-.195.222-.149.487-.355.692-.662.214-.32.329-.702.329-1.15 0-.76-.36-1.348-.863-1.725A2.76 2.76 0 008 4c-.631 0-1.155.16-1.572.438-.413.276-.68.638-.849.977a.75.75 0 101.342.67z")
            ]), w)
        ]));
    }), Zd = F2(function(e, r) {
        return A2(Ui, k([
            ji("flex items-center gap-1.5 text-sm font-semibold text-primary-600 " + r),
            xl(e),
            Rl("button")
        ]), k([
            A2(Rd, "w-4 h-4 fill-primary-600", w)
        ]));
    }), Ed = F2(function(e, r) {
        for(;;){
            if (!r.b) return xt;
            var t = r.a, n = r.b;
            if (e(t)) return gt(t);
            r = n;
        }
    }), Sd = Oe("h2"), Hd = function(e) {
        return 1 !== e.$;
    }, Nd = function(e) {
        return A2(er, "maxlength", vt(e));
    }, Vd = function(e) {
        return 1 === e.$;
    }, Id = F3(function(e, r, t) {
        return A2(Si, k([
            ji("relative flex flex-col bg-white rounded-xl shadow-md shadow-primary-500/40 lg:overflow-hidden")
        ]), k([
            A2(Li, k([
                ji("flex items-center lg:gap-6")
            ]), k([
                A2(Ui, k([
                    ji("flex grow items-center gap-x-4 p-4 rounded-xl md:p-6 lg:flex-row-reverse lg:pr-0 max-lg:truncate lg:max-w-[707px] outline-none focus-visible:ring-inset focus-visible:ring-4 focus-visible:ring-primary-600"),
                    xl(A2(Ld, t.bG, r.a$) ? vd(t.bG) : Cd(t.bG)),
                    Rl("button")
                ]), k([
                    A2(vl, k([
                        ji("line-clamp-2 text-left grow")
                    ]), k([
                        Vi(t.k)
                    ])),
                    A2(Ci, "w-4 h-4 transition-transform", k([
                        g("rotate-90", A2(Ld, t.bG, r.a$)),
                        g("fill-grey-300", Vd(t.o))
                    ]))
                ])),
                A2(Ui, k([
                    ji(hl(1) + " hidden lg:block mr-4 md:mr-6 shadow-none"),
                    xl(yd(t.bG)),
                    Rl("button")
                ]), k([
                    Vi(e.eF.dd)
                ]))
            ])),
            A2(Li, k([
                ji("fixed lg:static z-40 lg:z-0 inset-0 flex flex-col gap-y-6 py-10 px-6 bg-white overflow-y-auto lg:pt-0 lg:pb-10 lg:pl-14"),
                Zi(k([
                    g("hidden", !A2(Ld, t.bG, r.a$))
                ]))
            ]), k([
                A2(Li, k([
                    ji("lg:hidden")
                ]), k([
                    A2(Li, k([
                        ji(Hb + " text-grey-400")
                    ]), k([
                        Vi(e.eD)
                    ])),
                    A2(Eb, k([
                        ji("text-2xl font-serif font-bold break-words")
                    ]), k([
                        Vi(t.k)
                    ]))
                ])),
                function() {
                    var r = t.o;
                    if (r.$) return A2(Hi, k([
                        ji("whitespace-pre-line break-words text-grey-400")
                    ]), k([
                        Vi(e.c9)
                    ]));
                    var n = r.a;
                    return A2(Li, k([
                        ji("lg:space-y-1")
                    ]), k([
                        A2(Li, k([
                            ji(Hb + " text-grey-400")
                        ]), k([
                            Vi(e.eC)
                        ])),
                        A2(Hi, k([
                            ji("whitespace-pre-line break-words")
                        ]), k([
                            Vi(n)
                        ]))
                    ]));
                }(),
                A2(Li, k([
                    ji("fixed lg:hidden z-10 bottom-0 inset-x-0 flex p-6 justify-between lg:justify-end")
                ]), k([
                    A2(Ui, k([
                        ji("lg:hidden !p-4" + A2(Ql, 0, 0)),
                        xl(vd(t.bG)),
                        Rl("button")
                    ]), k([
                        A2(od, "w-6 h-6 fill-current", w)
                    ])),
                    A2(Ui, k([
                        ji(A2(Ql, 1, 0)),
                        xl(yd(t.bG)),
                        Rl("button")
                    ]), k([
                        Vi(e.eF.dd)
                    ]))
                ]))
            ]))
        ]));
    }), Td = function(e) {
        return A2(Bb, "click", bn(g(e, !0)));
    }, qd = _i("pattern"), Pd = function(e) {
        return A2(er, "rows", vt(e));
    }, Dd = Oe("textarea"), Bd = F4(function(e, r, t, n) {
        var u, a = Hd(A2(Ed, Jt(t.d5.k), A2(Rn, function(e) {
            return e.k;
        }, A2(dd, function(e) {
            return e.k;
        }, t.eF)))), o = A2(Js, A2(Pc, function(e) {
            return e.as;
        }, sb), A2(pi, A2(Pc, function(e) {
            return e.dR;
        }, Jt(!1)), A2(dd, function(e) {
            return e.k;
        }, t.eF))), i = A2(Js, A2(Pc, function(e) {
            return e.as;
        }, sb), A2(pi, A2(Pc, function(e) {
            return e.dR;
        }, Jt(!0)), A2(dd, function(e) {
            return e.k;
        }, t.eF)));
        return A2(Zb, k([
            ji("group overflow-hidden lg:rounded-xl shadow-xl shadow-primary-500/10"),
            Ub(wd)
        ]), k([
            A2(Li, k([
                ji("flex flex-col w-full px-4 py-10 bg-primary-300 xs:p-6 sm:p-8 md:p-12 lg:p-16")
            ]), k([
                A2(Hi, k([
                    ji("mb-10 font-serif font-bold italic selection:bg-white")
                ]), k([
                    Vi(A3(Jb, "{name}", td(r.cF), e.eF.av))
                ])),
                A2(Sd, k([
                    ji("mb-2 text-primary-600 lg:mb-3 " + Hb)
                ]), k([
                    A2(vl, k([
                        ji("selection:bg-white")
                    ]), k([
                        Vi(e.eF.k)
                    ])),
                    A2(vl, k([
                        ji("inline-block ml-1 px-1.5 bg-primary-200 rounded-full selection:bg-white lg:ml-2")
                    ]), k([
                        Vi(vt(Ct(o)))
                    ]))
                ])),
                A2(Ii, k([
                    ji("relative flex flex-col gap-y-2 md:gap-y-4 mb-4 empty:mb-0")
                ]), n ? A2(Rn, A2(Id, e, t), o) : A2(Wr, A2(Md, e, t), A2(Rn, A2(Id, e, t), o))),
                A2(Zb, k([
                    ji("fixed group inset-0 z-40 flex flex-col px-6 py-10 gap-6 bg-white overflow-y-auto lg:static lg:z-0 lg:p-8 lg:rounded-xl lg:on-yellow-shadow"),
                    Zi(k([
                        g("hidden", !t.e2)
                    ])),
                    Ub(Gd)
                ]), k([
                    A2(Li, k([
                        ji("flex flex-col gap-2")
                    ]), k([
                        A2(Eb, k([
                            ji("text-xl font-serif font-bold mb-2")
                        ]), k([
                            Vi(e.eF.du)
                        ])),
                        A2(Li, k([
                            ji("flex flex-col gap-1.5")
                        ]), k([
                            A2(Sb, k([
                                Rb("title-input"),
                                ji(Hb + " text-grey-400")
                            ]), k([
                                Vi(e.eF.ds)
                            ])),
                            A2(yb, k([
                                al("title-input"),
                                ji("appearance-none w-full px-4 py-3.5 bg-grey-100 rounded-md outline-none focus:bg-white focus:ring-2 focus:ring-inset focus:ring-grey-200 filled-invalid:ring filled-invalid:ring-red-400"),
                                Pb(xd),
                                nd(t.d5.k),
                                Ob(" "),
                                qd(".*\\S.*"),
                                Nb(1),
                                Nd(80),
                                Qb(!0)
                            ]), w),
                            a ? A2(Hi, k([
                                ji("text-red-600 lg:text-lg")
                            ]), k([
                                Vi(e.eF.dv)
                            ])) : Vi("")
                        ]))
                    ])),
                    A2(Li, k([
                        ji("flex flex-col gap-4")
                    ]), k([
                        A2(Li, k([
                            ji("flex flex-col gap-1.5")
                        ]), k([
                            A2(Sb, k([
                                Rb("description-input"),
                                ji(Hb + " text-grey-400")
                            ]), k([
                                Vi(e.eF.dp)
                            ])),
                            A3(dl, "textarea-autosize", w, k([
                                A2(Dd, k([
                                    al("description-input"),
                                    ji("appearance-none w-full px-4 py-3.5 bg-grey-100 rounded-md outline-none focus:bg-white focus:ring-2 focus:ring-inset focus:ring-grey-200"),
                                    Pd(2),
                                    Pb(gd),
                                    nd(t.d5.o),
                                    Nd(500)
                                ]), w)
                            ]))
                        ]))
                    ])),
                    A2(Li, k([
                        ji("fixed flex bottom-0 inset-x-0 p-6 justify-between lg:p-0 lg:static")
                    ]), k([
                        A2(Ui, k([
                            ji(A2(Ql, 0, 0)),
                            xl($d),
                            Rl("button")
                        ]), k([
                            Vi(e.cK)
                        ])),
                        A2(Ui, k([
                            ji(A2(Ql, 1, 1)),
                            Rl("submit"),
                            zb(a || n >= 50)
                        ]), k([
                            Vi(e.eF.cy)
                        ]))
                    ]))
                ])),
                A2(Ui, k([
                    al(zo(hd)),
                    ji("mt-2 self-center lg:self-end" + A2(Ql, 2, 2)),
                    Zi(k([
                        g("hidden", t.e2)
                    ])),
                    xl(_d),
                    Rl("button"),
                    zb(n >= 50)
                ]), k([
                    Vi(e.eF.cx)
                ])),
                Ct(i) > 0 ? A2(Oi, k([
                    ji("group mt-4 lg:mt-8")
                ]), k([
                    A2(wl, k([
                        ji("flex gap-1 items-center text-primary-600 cursor-pointer [&::-webkit-details-marker]:hidden lg:mb-4 lg:gap-2 " + Hb + " outline-none focus-visible:outline-2 focus-visible:outline-primary-600 focus-visible:rounded-full")
                    ]), k([
                        A2(Ci, "w-3 stroke-1 stroke-primary-600 fill-primary-600 transition-transform group-open:rotate-90 md:-mr-0.5", w),
                        A2(vl, k([
                            ji("selection:bg-white")
                        ]), k([
                            Vi(e.eF.df)
                        ])),
                        A2(Zd, jd, "ml-auto order-1 md:order-none md:-ml-1"),
                        A2(vl, k([
                            ji("inline-block px-1.5 bg-primary-200 rounded-full selection:bg-white")
                        ]), k([
                            Vi(vt(Ct(i)))
                        ]))
                    ])),
                    A2(Li, k([
                        ji("flex flex-col mt-2 gap-2 md:gap-4")
                    ]), A2(Rn, A3(zd, e, t, (u = {
                        aK: vd,
                        dc: yd,
                        dK: kd,
                        a_: Cd,
                        e3: jd
                    }, {
                        $: 0,
                        a: u
                    })), i))
                ])) : Vi("")
            ])),
            A2(Li, k([
                ji("grid [grid-template-columns:auto_1fr] px-4 gap-x-2 bg-primary-100 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
            ]), k([
                A2(Li, k([
                    ji("row-start-1 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), w),
                A2(Li, k([
                    ji("row-start-5 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), w),
                A2(Li, k([
                    ji("col-start-1 row-start-1 row-span-5 w-0.5 justify-self-center bg-primary-300")
                ]), w),
                A2(Li, k([
                    ji("row-start-2 col-start-1 z-10 place-self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 text-black text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                ]), k([
                    Vi("3")
                ])),
                A2(Li, k([
                    ji("row-start-2 col-start-2 font-semibold")
                ]), k([
                    Vi(e.eR.k)
                ])),
                A2(Hi, k([
                    ji("row-start-3 col-start-2 mt-1 mb-4 text-primary-900 max-w-md")
                ]), k([
                    Vi(e.eR.di)
                ])),
                function() {
                    var u = r.en;
                    if (u.$) return A2(Ui, k([
                        ji(A2(Ql, 2, 2) + " row-start-4 col-start-1 col-span-2 justify-self-center mt-2 sm:mt-4"),
                        zb(2 > n),
                        Rl("submit")
                    ]), k([
                        Vi(e.eR.a9)
                    ]));
                    var a = u.a;
                    return A2(Li, k([
                        ji("row-start-4 col-start-2 mt-2 flex flex-col gap-1.5")
                    ]), k([
                        A2(Sb, k([
                            Rb("code-test"),
                            ji(Hb + " flex gap-1 items-center text-primary-600 selection:bg-white sm:leading-[18px]")
                        ]), k([
                            Vi(e.es),
                            A2(Ui, k([
                                Rl("button"),
                                Td(Fd)
                            ]), k([
                                A2(Rd, "w-4 h-4 fill-primary-600", w)
                            ]))
                        ])),
                        A2(Li, k([
                            ji("flex flex-wrap gap-4 justify-center items-center")
                        ]), k([
                            A2(yb, k([
                                al("code-test"),
                                ji("grow w-full xs:w-auto xs:min-w-[290px] px-4 py-3.5 bg-white placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300 filled-invalid:ring filled-invalid:ring-red-400"),
                                Ob(e.bZ),
                                Pb(md),
                                nd(t.em),
                                Nb(1)
                            ]), w),
                            A2(Ui, k([
                                ji(A2(Ql, 2, 2) + " justify-self-center"),
                                zb(2 > n || !s(a, t.bY)),
                                Rl("submit")
                            ]), k([
                                Vi(e.eR.a9)
                            ]))
                        ]))
                    ]));
                }()
            ]))
        ]));
    }), Ud = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 24 24"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                mi("M9.036 7.976a.75.75 0 00-1.06 1.06L10.939 12l-2.963 2.963a.75.75 0 101.06 1.06L12 13.06l2.963 2.964a.75.75 0 001.061-1.06L13.061 12l2.963-2.964a.75.75 0 10-1.06-1.06L12 10.939 9.036 7.976z")
            ]), w),
            A2(wi, k([
                hi("evenodd"),
                mi("M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM2.5 12a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z")
            ]), w)
        ]));
    }), Od = F3(function(e, r, t) {
        var n = e.aa.cD + "/" + r.bG, u = Ct(A2(pi, A2(Pc, function(e) {
            return e.dR;
        }, Jt(!1)), A2(dd, function(e) {
            return e.k;
        }, t.eF)));
        return A2(Li, w, k([
            Ol(e.ab),
            A2(Li, k([
                ji("flex flex-col max-w-screen-lg mx-auto lg:px-8")
            ]), k([
                A2(Dl, e.aa, gt({
                    aH: e.ab.cR,
                    aI: e.ab.cT,
                    aJ: e.ab.cS,
                    V: r.bG
                })),
                t.dS ? A2(Li, k([
                    ji("mx-4 md:mx-8 mb-6")
                ]), k([
                    A2(Li, k([
                        ji("relative bg-grey-100 rounded-xl px-5 pt-6 pb-8 sm:p-6 sm:py-8 lg:p-8")
                    ]), k([
                        A2(Ui, k([
                            ji("absolute top-1 right-1 p-3"),
                            xl(rb(Wl))
                        ]), k([
                            A2(Ud, "w-5 h-5 fill-black", w)
                        ])),
                        A2(Hi, k([
                            ji("mb-4 text-black font-semibold w-5/6")
                        ]), k([
                            Vi(e.ab.eF.ec)
                        ])),
                        A2(Li, k([
                            ji("relative w-full max-w-lg flex mb-8")
                        ]), k([
                            A2(yb, k([
                                ji("w-full text-sm sm:text-base leading-none border-black rounded-full text-grey-400 px-4 py-1.5 border-2 outline-none focus-visible:selection:bg-primary-300 selection:bg-white focus-visible:selection:text-black"),
                                Rl("url"),
                                nd(A3(Jb, "http://", "", A3(Jb, "https://", "", n)))
                            ]), w),
                            A2(Li, k([
                                al("info-copy-link-button"),
                                ji("absolute right-0 grid rounded-r-full h-full")
                            ]), k([
                                A2(Ui, k([
                                    ji("col-start-1 row-start-1 text-sm sm:text-base font-serif font-extrabold text-white bg-black rounded-r-full h-full px-4 transition-all focus-visible:bg-primary-300 focus-visible:text-black focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-inset outline-none hover:text-black hover:bg-primary-300 hover:ring-2 hover:ring-black hover:ring-inset"),
                                    Rl("button"),
                                    xl(aa(A2(Pi, "info-copy-link-button", n)))
                                ]), k([
                                    Vi(e.ab.eF.d7)
                                ])),
                                A2(Li, k([
                                    ji("opacity-0 col-start-1 row-start-1 transition-opacity pointer-events-none flex gap-1 items-center h-full px-4 text-sm sm:text-base font-serif font-extrabold text-black bg-primary-300 rounded-r-full ring-2 ring-black ring-inset")
                                ]), k([
                                    A2(yl, "w-4 h-4 fill-current stroke-black stroke-[0.5]", w),
                                    Vi(e.ab.eF.d8)
                                ]))
                            ]))
                        ])),
                        A2(Li, k([
                            ji("space-y-4")
                        ]), k([
                            A2(Li, k([
                                ji("flex items-start gap-3 sm:gap-4 md:items-center")
                            ]), k([
                                A2(tb, "w-4 shrink-0 translate-y-1 md:translate-y-0", w),
                                A2(Hi, k([
                                    ji("text-base md:text-lg")
                                ]), k([
                                    Vi(e.ab.eF.d6)
                                ]))
                            ])),
                            A2(Li, k([
                                ji("flex items-start gap-4 md:items-center")
                            ]), k([
                                A2(ad, "w-4 shrink-0 translate-y-1 md:translate-y-0", w),
                                A2(Hi, k([
                                    ji("text-base md:text-lg")
                                ]), k([
                                    Vi(e.ab.eF.ea)
                                ]))
                            ])),
                            A2(Li, k([
                                ji("flex items-start gap-4 md:items-center")
                            ]), k([
                                A2(pd, "w-4 shrink-0 translate-y-1 md:translate-y-0", w),
                                A2(Hi, k([
                                    ji("text-base md:text-lg")
                                ]), k([
                                    Vi(e.ab.eF.eb)
                                ]))
                            ]))
                        ]))
                    ]))
                ])) : Vi(""),
                A2($b, aa, A6(cd, e.ab, e.fd, r, t.a7, eb, Kl(r.bG))),
                A2(Li, k([
                    ji("grid [grid-template-columns:auto_auto_auto_1fr] px-4 gap-x-2 gap-y-4 sm:gap-x-3 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), k([
                    A2(Li, k([
                        ji("col-start-1 row-start-1 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-1 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), k([
                        Vi("1")
                    ])),
                    A2(Li, k([
                        ji("flex items-center gap-2 mr-2")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold text-grey-400")
                        ]), k([
                            Vi(e.ab.eI.k)
                        ])),
                        A2(yl, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", w)
                    ])),
                    A2(Li, k([
                        ji("col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                    ]), k([
                        Vi(e.ab.ew + " " + wb(g(e.fd, r.as)))
                    ])),
                    A2(Li, k([
                        ji("col-start-1 row-start-2 row-span-2 justify-self-center w-0.5 bg-grey-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-2 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-black text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), k([
                        Vi("2")
                    ])),
                    A2(Li, k([
                        ji("col-start-2 mr-2 flex items-center gap-2")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold text-black")
                        ]), k([
                            Vi(e.ab.eF.k)
                        ]))
                    ])),
                    A2(Li, k([
                        ji("col-span-2 justify-self-end px-2 py-1 font-semibold text-xs text-primary-600 bg-primary-200 rounded-full xs:col-span-1 xs:text-sm xs:px-3 xs:justify-self-start md:text-base md:-my-0.5")
                    ]), k([
                        Vi(e.ab.ev)
                    ]))
                ])),
                A2($b, rb, A4(Bd, e.ab, r, t, u)),
                A2(Li, k([
                    ji("grid grid-flow-col [grid-template-columns:auto_1fr] px-4 gap-x-2 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), k([
                    A2(Li, k([
                        ji("col-start-1 row-start-1 justify-self-center w-0.5 h-12 md:h-14 bg-primary-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-2 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 sm:w-6 sm:h-6")
                    ]), k([
                        A2(fd, "w-[10px] h-[10px] fill-black sm:w-3 sm:h-3", w)
                    ])),
                    A2(Li, k([
                        ji("col-start-2 row-start-2 flex items-center")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold")
                        ]), k([
                            Vi(e.ab.eZ.k)
                        ]))
                    ])),
                    A2(Hi, k([
                        ji("col-start-2 row-start-3 mt-1 text-grey-600 max-w-md")
                    ]), k([
                        Vi(e.ab.eZ.aQ)
                    ]))
                ]))
            ])),
            A3(vb, e.ab, g(e.fd, r.dh), r.bG),
            A2(Li, k([
                ji("mt-20 lg:mt-40")
            ]), k([
                A3(zi, 0, 1, A3(Ti, e.aa, e.ab.$7, 1))
            ])),
            A4(ud, e.aa, e.ab, {
                cF: r.cF,
                o: r.o,
                bG: r.bG,
                k: r.k
            }, t.d$)
        ]));
    }), Jd = function(e) {
        return {
            $: 3,
            a: e
        };
    }, Qd = function(e) {
        return {
            $: 2,
            a: e
        };
    }, Yd = function(e) {
        return {
            $: 1,
            a: e
        };
    }, Kd = function(e) {
        return {
            $: 0,
            a: e
        };
    }, Wd = function(e) {
        return {
            $: 4,
            a: e
        };
    }, ep = {
        $: 6
    }, rp = {
        $: 5
    }, tp = function(e) {
        return {
            $: 3,
            a: e
        };
    }, np = Lb("autofocus"), up = Lb("checked"), ap = A2(Tb, k([
        "target",
        "checked"
    ]), Ha), op = F2(function(e, r) {
        var t;
        return A2(Zb, k([
            ji("group overflow-hidden lg:rounded-xl shadow-xl shadow-primary-500/10"),
            Ub(rp)
        ]), k([
            A2(Li, k([
                ji("flex flex-col px-4 py-10 gap-6 bg-primary-300 xs:p-6 sm:p-8 md:p-12 lg:p-16")
            ]), k([
                A2(qi, k([
                    ji("font-serif font-bold italic selection:bg-white")
                ]), k([
                    Vi(e.eI.av)
                ])),
                A2(Li, k([
                    ji("flex flex-col gap-1.5")
                ]), k([
                    A2(Sb, k([
                        Rb("title-input"),
                        ji(Hb + " text-primary-600 selection:bg-white")
                    ]), k([
                        Vi(e.eI.dT)
                    ])),
                    A2(yb, k([
                        ji("w-full px-4 py-3.5 bg-primary-100 placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300 filled-invalid:ring filled-invalid:ring-red-400"),
                        Ob(e.eI.ex),
                        Pb(Kd),
                        nd(r.k),
                        qd(".*\\S.*"),
                        Nb(1),
                        Nd(80),
                        Qb(!0),
                        np(!0)
                    ]), w)
                ])),
                A2(Li, k([
                    ji("flex flex-col gap-1.5")
                ]), k([
                    A2(Sb, k([
                        Rb("info-input"),
                        ji(Hb + " text-primary-600 selection:bg-white")
                    ]), k([
                        Vi(e.eI.c1)
                    ])),
                    A3(dl, "textarea-autosize", w, k([
                        A2(Dd, k([
                            al("info-input"),
                            ji("w-full px-4 py-3.5 bg-primary-100 placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300"),
                            Ob(e.eI.c3),
                            Pb(Yd),
                            Pd(2),
                            nd(r.o),
                            Nd(250)
                        ]), w)
                    ]))
                ])),
                A2(Li, k([
                    ji("flex flex-col gap-1.5")
                ]), k([
                    A2(Sb, k([
                        Rb("author-input"),
                        ji(Hb + " text-primary-600 selection:bg-white")
                    ]), k([
                        Vi(e.eI.d3)
                    ])),
                    A2(yb, k([
                        al("author-input"),
                        ji("w-full px-4 py-3.5 bg-primary-100 placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300 filled-invalid:ring filled-invalid:ring-red-400"),
                        Ob(e.eI.d4),
                        Pb(Qd),
                        nd(r.cF),
                        qd(".*\\S.*"),
                        Nb(1),
                        Nd(50),
                        Qb(!0)
                    ]), w)
                ]))
            ])),
            A2(Li, k([
                ji("grid [grid-template-columns:auto_1fr] px-4 gap-x-2 bg-primary-100 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
            ]), k([
                A2(Li, k([
                    ji("row-start-1 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), w),
                A2(Li, k([
                    ji("row-start-6 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), w),
                A2(Li, k([
                    ji("col-start-1 row-start-1 row-span-6 w-0.5 justify-self-center bg-primary-300")
                ]), w),
                A2(Li, k([
                    ji("row-start-2 col-start-1 z-10 place-self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 text-black text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                ]), k([
                    Vi("2")
                ])),
                A2(Li, k([
                    ji("row-start-2 col-start-2 font-semibold")
                ]), k([
                    Vi(e.eF.k)
                ])),
                A2(Hi, k([
                    ji("row-start-3 col-start-2 mt-1 mb-4 md:mb-6 text-primary-900 max-w-md")
                ]), k([
                    Vi(e.eF.aQ)
                ])),
                A2(Li, k([
                    ji("row-start-4 col-start-2 flex justify-start")
                ]), k([
                    A2(Sb, k([
                        Rb("code-checkbox"),
                        ji("flex gap-2 xs:gap-3 items-center cursor-pointer")
                    ]), k([
                        A2(yb, k([
                            al("code-checkbox"),
                            Rl("checkbox"),
                            ji("peer sr-only"),
                            (t = tp, A2(gl, "change", A2(sn, t, ap))),
                            up(!r.em.$)
                        ]), w),
                        A2(Li, k([
                            ji("shrink-0 flex justify-center items-center w-5 h-5 xs:w-6 xs:h-6 rounded border-2 border-primary-600 peer-focus-visible:ring peer-focus-visible:ring-primary-600"),
                            Zi(k([
                                g("border-0 bg-primary-300", Hd(r.em))
                            ]))
                        ]), k([
                            r.em.$ ? Vi("") : A2(yl, "w-3 h-3 xs:w-4 xs:h-4", w)
                        ])),
                        A2(Li, k([
                            ji("flex gap-1.5 xs:gap-2 items-center max-xs:translate-y-px")
                        ]), k([
                            A2(Hi, k([
                                ji("text-primary-600 selection:bg-white leading-tight")
                            ]), k([
                                Vi(e.eI.eo)
                            ])),
                            A2(Ui, k([
                                Rl("button"),
                                Td(ep)
                            ]), k([
                                A2(Rd, "w-4 h-4 fill-primary-600 md:w-5 md:h-5", w)
                            ]))
                        ]))
                    ]))
                ])),
                r.em.$ ? A2(Ui, k([
                    ji(A2(Ql, 2, 2) + " row-start-5 col-start-2 justify-self-center mt-10"),
                    Rl("submit")
                ]), k([
                    Vi(e.eF.a9)
                ])) : A2(Li, k([
                    ji("row-start-5 col-start-2 mt-4 flex flex-col gap-1.5")
                ]), k([
                    A2(Sb, k([
                        Rb("code-test"),
                        ji(Hb + " text-primary-600 selection:bg-white sm:leading-[18px]")
                    ]), k([
                        Vi(e.es)
                    ])),
                    A2(Li, k([
                        ji("flex flex-wrap gap-4 justify-center items-center")
                    ]), k([
                        A2(yb, k([
                            al("code-input"),
                            ji("grow w-full xs:w-auto xs:min-w-[290px] px-4 py-3.5 bg-white placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300 filled-invalid:ring filled-invalid:ring-red-400"),
                            Ob(e.eI.bZ),
                            Pb(Wd),
                            nd(A2(ea, "", r.em)),
                            qd(".*\\S.*"),
                            Nb(1),
                            Qb(!0)
                        ]), w),
                        A2(Ui, k([
                            ji(A2(Ql, 2, 2)),
                            Rl("submit")
                        ]), k([
                            Vi(e.eF.a9)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), ip = F2(function(e, r) {
        return A2(Li, w, k([
            Ol(e.ab),
            A2(Li, k([
                ji("flex flex-col max-w-screen-lg mx-auto lg:px-8")
            ]), k([
                A2(Dl, e.aa, xt),
                A2(Li, k([
                    ji("grid [grid-template-columns:auto_auto_auto_1fr] px-4 gap-x-2 gap-y-4 sm:gap-x-3 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), k([
                    A2(Li, k([
                        ji("col-start-1 row-start-1 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-1 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-black text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), k([
                        Vi("1")
                    ])),
                    A2(Li, k([
                        ji("flex items-center gap-2 mr-2")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold")
                        ]), k([
                            Vi(e.ab.eI.k)
                        ]))
                    ]))
                ])),
                A2($b, Jd, A2(op, e.ab, r)),
                A2(Li, k([
                    ji("grid grid-flow-col [grid-template-columns:auto_1fr] px-4 gap-x-2 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), k([
                    A2(Li, k([
                        ji("col-start-1 row-start-1 justify-self-center h-14 w-0.5 bg-primary-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-2 row-span-3 justify-self-center w-0.5 bg-primary-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-3 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 text-black text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), k([
                        Vi("3")
                    ])),
                    A2(Li, k([
                        ji("col-start-2 row-start-3 flex items-center")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold")
                        ]), k([
                            Vi(e.ab.eR.k)
                        ]))
                    ])),
                    A2(Hi, k([
                        ji("col-start-2 row-start-4 mt-1 mb-4 text-grey-600 max-w-md")
                    ]), k([
                        Vi(e.ab.eR.aQ)
                    ]))
                ])),
                A2(Li, k([
                    ji("grid grid-flow-col [grid-template-columns:auto_1fr] px-4 gap-x-2 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), k([
                    A2(Li, k([
                        ji("col-start-1 row-start-1 justify-self-center w-0.5 h-12 md:h-14 bg-primary-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-2 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 sm:w-6 sm:h-6")
                    ]), k([
                        A2(fd, "w-[10px] h-[10px] fill-black sm:w-3 sm:h-3", w)
                    ])),
                    A2(Li, k([
                        ji("col-start-2 row-start-2 flex items-center")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold")
                        ]), k([
                            Vi(e.ab.eZ.k)
                        ]))
                    ])),
                    A2(Hi, k([
                        ji("col-start-2 row-start-3 mt-1 text-grey-600 max-w-md")
                    ]), k([
                        Vi(e.ab.eZ.aQ)
                    ]))
                ])),
                A2(Li, k([
                    ji("flex flex-col items-center mt-20 md:mt-32 gap-4")
                ]), k([
                    A2(Ui, k([
                        ji(A2(Ql, 2, 0)),
                        xl(aa(nb("not created"))),
                        Rl("button")
                    ]), k([
                        Vi(e.ab.dx)
                    ]))
                ]))
            ])),
            A2(Li, k([
                ji("mt-20 lg:mt-40")
            ]), k([
                A3(zi, 0, 1, A3(Ti, e.aa, e.ab.$7, 1))
            ])),
            A4(ud, e.aa, e.ab, {
                cF: r.cF,
                o: gt(r.o),
                bG: "",
                k: r.k
            }, r.d$)
        ]));
    }), cp = function(e) {
        return {
            $: 9,
            a: e
        };
    }, fp = function(e) {
        return {
            $: 15,
            a: e
        };
    }, sp = function(e) {
        return {
            $: 1,
            a: e
        };
    }, lp = function(e) {
        return {
            $: 5,
            a: e
        };
    }, bp = {
        $: 13
    }, dp = function(e) {
        return {
            $: 4,
            a: e
        };
    }, pp = {
        $: 10
    }, gp = {
        $: 11
    }, xp = {
        $: 12
    }, mp = F3(function(e, r, t) {
        var n = e.fq, u = vt, a = function(e) {
            var t = g(n, r);
            return t.a ? t.b ? "in " + e : e + " ago" : e;
        };
        switch(t.$){
            case 0:
            case 1:
                return "now";
            case 2:
                return 1 === (o = t.a) ? "now" : a("less than " + u(o) + " min");
            case 3:
                return a(1 === (o = t.a) ? "1 min" : u(o) + " mins");
            case 4:
                return a(1 === (o = t.a) ? "about 1 hour" : "about " + u(o) + " hours");
            case 5:
                return a(1 === (o = t.a) ? "1 day" : u(o) + " days");
            case 6:
                return a(1 === (o = t.a) ? "about 1 month" : "about " + u(o) + " months");
            case 7:
                return a(1 === (o = t.a) ? "1 month" : u(o) + " months");
            default:
                var o;
                return a(1 === (o = t.a) ? "1 year" : u(o) + " years");
        }
    }), hp = F2(function(e, r) {
        return 0 > e ? xt : tf(A2(Hc, e, r));
    }), vp = function(e) {
        return {
            $: 4,
            a: e
        };
    }, wp = function(e) {
        return {
            $: 2,
            a: e
        };
    }, yp = function(e) {
        return {
            $: 5,
            a: e
        };
    }, $p = function(e) {
        return {
            $: 3,
            a: e
        };
    }, kp = 43200, Cp = {
        $: 1
    }, _p = function(e) {
        return {
            $: 0,
            a: e
        };
    }, jp = F3(function(e, r, t) {
        var n = Wc(t - r) / 1e3 | 0, u = vu(n / 60);
        return e && 2 > u ? function(e) {
            return 5 > e ? _p(5) : 10 > e ? _p(10) : 20 > e ? _p(20) : 40 > e ? Cp : 60 > e ? wp(1) : $p(1);
        }(n) : u ? 2 > u || 45 > u ? $p(u) : 90 > u ? vp(1) : 0 > d(u, 1440) ? function(e) {
            var r = vu(e / 60);
            return vp(r);
        }(u) : 0 > d(u, 2520) ? yp(1) : 0 > d(u, kp) ? function(e) {
            var r = vu(e / 1440);
            return yp(r);
        }(u) : 0 > d(u, 86400) ? function(e) {
            return {
                $: 6,
                a: vu(e / kp)
            };
        }(u) : function(e) {
            var r = e / kp | 0;
            if (12 > r) return function(e) {
                return {
                    $: 7,
                    a: vu(e / kp)
                };
            }(e);
            var t = Qt(r / 12), n = A2(Xc, 12, r);
            var u;
            return 3 > n ? {
                $: 8,
                a: t
            } : 9 > n ? {
                $: 9,
                a: t
            } : (u = t + 1, {
                $: 10,
                a: u
            });
        }(u) : wp(1);
    }), Fp = F4(function(e, r, t, n) {
        var u = t, a = n, o = A3(jp, !0, u, a);
        return A3(r, e, 2 === A2(_u, a, u) ? 0 : 1, o);
    }), Gp = F2(function(e, r) {
        return A3(zn, F2(function(r, t) {
            var n = t.a, u = t.b;
            return e(r) ? g(A2(Wr, r, n), u) : g(n, A2(Wr, r, u));
        }), g(w, w), r);
    }), Mp = F2(function(e, r) {
        return {
            $: 6,
            a: e,
            b: r
        };
    }), Ap = F2(function(e, r) {
        return {
            $: 7,
            a: e,
            b: r
        };
    }), Xp = F2(function(e, r) {
        return {
            $: 8,
            a: e,
            b: r
        };
    }), Lp = function(e) {
        return {
            $: 3,
            a: e
        };
    }, zp = F2(function(e, r) {
        return {
            $: 2,
            a: e,
            b: r
        };
    }), Rp = F2(function(e, r) {
        return {
            $: 1,
            a: e,
            b: r
        };
    }), Zp = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 32 32"),
            Gi("none"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                ol("evenodd"),
                mi("M5.33333 9.33317C5.68696 9.33317 6.02609 9.19269 6.27614 8.94265C6.52619 8.6926 6.66667 8.35346 6.66667 7.99984C6.66667 7.64622 6.52619 7.30708 6.27614 7.05703C6.02609 6.80698 5.68696 6.6665 5.33333 6.6665C4.97971 6.6665 4.64057 6.80698 4.39052 7.05703C4.14048 7.30708 4 7.64622 4 7.99984C4 8.35346 4.14048 8.6926 4.39052 8.94265C4.64057 9.19269 4.97971 9.33317 5.33333 9.33317V9.33317ZM11.6667 7.33317C11.4015 7.33317 11.1471 7.43853 10.9596 7.62606C10.772 7.8136 10.6667 8.06795 10.6667 8.33317C10.6667 8.59839 10.772 8.85274 10.9596 9.04028C11.1471 9.22781 11.4015 9.33317 11.6667 9.33317H27C27.2652 9.33317 27.5196 9.22781 27.7071 9.04028C27.8946 8.85274 28 8.59839 28 8.33317C28 8.06795 27.8946 7.8136 27.7071 7.62606C27.5196 7.43853 27.2652 7.33317 27 7.33317H11.6667ZM11.6667 15.3332C11.4015 15.3332 11.1471 15.4385 10.9596 15.6261C10.772 15.8136 10.6667 16.068 10.6667 16.3332C10.6667 16.5984 10.772 16.8527 10.9596 17.0403C11.1471 17.2278 11.4015 17.3332 11.6667 17.3332H27C27.2652 17.3332 27.5196 17.2278 27.7071 17.0403C27.8946 16.8527 28 16.5984 28 16.3332C28 16.068 27.8946 15.8136 27.7071 15.6261C27.5196 15.4385 27.2652 15.3332 27 15.3332H11.6667ZM11.6667 23.3332C11.4015 23.3332 11.1471 23.4385 10.9596 23.6261C10.772 23.8136 10.6667 24.068 10.6667 24.3332C10.6667 24.5984 10.772 24.8527 10.9596 25.0403C11.1471 25.2278 11.4015 25.3332 11.6667 25.3332H27C27.2652 25.3332 27.5196 25.2278 27.7071 25.0403C27.8946 24.8527 28 24.5984 28 24.3332C28 24.068 27.8946 23.8136 27.7071 23.6261C27.5196 23.4385 27.2652 23.3332 27 23.3332H11.6667ZM6.66667 15.9998C6.66667 16.3535 6.52619 16.6926 6.27614 16.9426C6.02609 17.1927 5.68696 17.3332 5.33333 17.3332C4.97971 17.3332 4.64057 17.1927 4.39052 16.9426C4.14048 16.6926 4 16.3535 4 15.9998C4 15.6462 4.14048 15.3071 4.39052 15.057C4.64057 14.807 4.97971 14.6665 5.33333 14.6665C5.68696 14.6665 6.02609 14.807 6.27614 15.057C6.52619 15.3071 6.66667 15.6462 6.66667 15.9998V15.9998ZM5.33333 25.3332C5.68696 25.3332 6.02609 25.1927 6.27614 24.9426C6.52619 24.6926 6.66667 24.3535 6.66667 23.9998C6.66667 23.6462 6.52619 23.3071 6.27614 23.057C6.02609 22.807 5.68696 22.6665 5.33333 22.6665C4.97971 22.6665 4.64057 22.807 4.39052 23.057C4.14048 23.3071 4 23.6462 4 23.9998C4 24.3535 4.14048 24.6926 4.39052 24.9426C4.64057 25.1927 4.97971 25.3332 5.33333 25.3332V25.3332Z")
            ]), w)
        ]));
    }), Ep = _i("max"), Sp = _i("min"), Hp = function(e) {
        return A2(gl, "mouseleave", bn(e));
    }, Np = vi("circle"), Vp = er("cx"), Ip = er("cy"), Tp = vi("line"), qp = er("r"), Pp = er("stroke-linecap"), Dp = er("stroke-linejoin"), Bp = er("stroke-miterlimit"), Up = er("x1"), Op = er("x2"), Jp = er("y1"), Qp = er("y2"), Yp = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 72 72"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                Gi("#FCEA2B"),
                mi("M36,13c-12.6823,0-23,10.3177-23,23c0,12.6822,10.3177,23,23,23c12.6822,0,23-10.3178,23-23 C59,23.3177,48.6822,13,36,13z")
            ]), w),
            A2(Np, k([
                Vp("36"),
                Ip("36"),
                qp("23"),
                Gi("inherit"),
                jl("inherit"),
                Bp("10"),
                Fl("2")
            ]), w),
            A2(wi, k([
                mi("M30,32.9252c0,1.6567-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6553,1.3447-3,3-3C28.6552,29.9252,30,31.27,30,32.9252"),
                Gi("#000"),
                jl("#000")
            ]), w),
            A2(wi, k([
                mi("M48,32.9252c0,1.6567-1.3447,3-3,3s-3-1.3433-3-3c0-1.6553,1.3447-3,3-3S48,31.27,48,32.9252"),
                Gi("#000"),
                jl("#000")
            ]), w),
            A2(Tp, k([
                Up("23"),
                Op("30"),
                Jp("24"),
                Qp("28"),
                Gi("none"),
                jl("#000000"),
                Pp("round"),
                Dp("round"),
                Bp("10"),
                Fl("2")
            ]), w),
            A2(Tp, k([
                Up("49"),
                Op("42"),
                Jp("24"),
                Qp("28"),
                Gi("none"),
                jl("#000000"),
                Pp("round"),
                Dp("round"),
                Bp("10"),
                Fl("2")
            ]), w),
            A2(wi, k([
                Gi("none"),
                jl("#000000"),
                Pp("round"),
                Dp("round"),
                Bp("10"),
                Fl("2"),
                mi("M29.5,43c1.2841-0.6376,3.9847-1.0308,6.8421-0.9981c2.6235,0.03,4.9897,0.4146,6.1579,0.9981")
            ]), w)
        ]));
    }), Kp = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 72 72"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                Gi("inherit"),
                mi("M36,13c-12.6823,0-23,10.3177-23,23c0,12.6822,10.3177,23,23,23c12.6822,0,23-10.3178,23-23 C59,23.3177,48.6822,13,36,13z")
            ]), w),
            A2(Np, k([
                Vp("36"),
                Ip("36"),
                qp("23"),
                Gi("none"),
                jl("inherit"),
                Bp("10"),
                Fl("2")
            ]), w),
            A2(wi, k([
                mi("m26 48c10-5 21-4.03 21-4.03"),
                Gi("none"),
                jl("#000"),
                Pp("round"),
                Dp("round"),
                Fl("2")
            ]), w),
            A2(wi, k([
                mi("M30,31c0,1.6568-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6552,1.3447-3,3-3C28.6552,28,30,29.3448,30,31"),
                Gi("#000"),
                jl("none")
            ]), w),
            A2(wi, k([
                mi("M48,31c0,1.6568-1.3447,3-3,3s-3-1.3433-3-3c0-1.6552,1.3447-3,3-3S48,29.3448,48,31"),
                Gi("#000"),
                jl("none")
            ]), w)
        ]));
    }), Wp = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 72 72"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(Np, k([
                Vp("36"),
                Ip("36"),
                Gi("inherit"),
                qp("23")
            ]), w),
            A2(wi, k([
                Gi("#FFFFFF"),
                mi("M48.5859,42.6735c0,5.6296-4.1784,10.1046-12.5541,10.1046c-8.3738,0-12.6069-4.4888-12.6069-10.1047 C23.4249,42.6734,36.4503,45.7045,48.5859,42.6735z")
            ]), w),
            A2(wi, k([
                Gi("none"),
                jl("#000000"),
                Pp("round"),
                Dp("round"),
                Bp("10"),
                Fl("2"),
                mi("M48.5859,42.6735c0,5.6296-4.1784,10.1046-12.5541,10.1046c-8.3738,0-12.6069-4.4888-12.6069-10.1047 C23.4249,42.6734,36.4503,45.7045,48.5859,42.6735z")
            ]), w),
            A2(Vl, k([
                Gi("none"),
                Pp("round"),
                Fl("2")
            ]), k([
                A2(Np, k([
                    Vp("36"),
                    Ip("36"),
                    qp("23"),
                    Dp("round"),
                    jl("inherit")
                ]), w),
                A2(wi, k([
                    mi("m31.6941 32.4036a4.7262 4.7262 0 0 0 -8.6382 0"),
                    Bp("10"),
                    jl("#000")
                ]), w),
                A2(wi, k([
                    mi("m48.9441 32.4036a4.7262 4.7262 0 0 0 -8.6382 0"),
                    Bp("10"),
                    jl("#000")
                ]), w)
            ]))
        ]));
    }), eg = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 72 72"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                Gi("inherit"),
                mi("M36,13c-12.6823,0-23,10.3177-23,23c0,12.6822,10.3177,23,23,23c12.6822,0,23-10.3178,23-23 C59,23.3177,48.6822,13,36,13z")
            ]), w),
            A2(Np, k([
                Vp("36"),
                Ip("36"),
                qp("23"),
                Gi("none"),
                jl("inherit"),
                Bp("10"),
                Fl("2")
            ]), w),
            A2(Tp, k([
                Up("27"),
                Op("45"),
                Jp("43"),
                Qp("43"),
                Gi("none"),
                jl("#000"),
                Pp("round"),
                Dp("round"),
                Bp("10"),
                Fl("2")
            ]), w),
            A2(wi, k([
                mi("M30,31c0,1.6568-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6552,1.3447-3,3-3C28.6552,28,30,29.3448,30,31"),
                Gi("#000"),
                jl("none")
            ]), w),
            A2(wi, k([
                mi("M48,31c0,1.6568-1.3447,3-3,3s-3-1.3433-3-3c0-1.6552,1.3447-3,3-3S48,29.3448,48,31"),
                Gi("#000"),
                jl("none")
            ]), w)
        ]));
    }), rg = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 72 72"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                Gi("inherit"),
                mi("M36,13c-12.6823,0-23,10.3177-23,23c0,12.6822,10.3177,23,23,23c12.6822,0,23-10.3178,23-23 C59,23.3177,48.6822,13,36,13z")
            ]), w),
            A2(Np, k([
                Vp("36"),
                Ip("36"),
                qp("23"),
                Gi("none"),
                jl("inherit"),
                Bp("10"),
                Fl("2")
            ]), w),
            A2(wi, k([
                mi("m28 46c1.5805-2.5575 4.9043-4.1349 8.4211-4.0038 3.2288.1204 6.1411 1.6633 7.5789 4.0038"),
                Gi("none"),
                jl("#000"),
                Pp("round"),
                Dp("round"),
                Bp("10"),
                Fl("2")
            ]), w),
            A2(wi, k([
                mi("M30,31c0,1.6568-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6552,1.3447-3,3-3C28.6552,28,30,29.3448,30,31"),
                Gi("#000"),
                jl("none")
            ]), w),
            A2(wi, k([
                mi("M48,31c0,1.6568-1.3447,3-3,3s-3-1.3433-3-3c0-1.6552,1.3447-3,3-3S48,29.3448,48,31"),
                Gi("#000"),
                jl("none")
            ]), w)
        ]));
    }), tg = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 72 72"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(Np, k([
                Vp("36.0001"),
                Ip("36"),
                qp("22.9999"),
                Gi("inherit")
            ]), w),
            A2(Np, k([
                Vp("36"),
                Ip("36"),
                qp("23"),
                Gi("none"),
                jl("inherit"),
                Pp("round"),
                Dp("round"),
                Fl("2")
            ]), w),
            A2(wi, k([
                Gi("none"),
                jl("#000"),
                Pp("round"),
                Dp("round"),
                Fl("2"),
                mi("M45.8149,44.9293 c-2.8995,1.6362-6.2482,2.5699-9.8149,2.5699s-6.9153-0.9336-9.8149-2.5699")
            ]), w),
            A2(wi, k([
                mi("M30,31c0,1.6568-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6552,1.3447-3,3-3C28.6552,28,30,29.3448,30,31"),
                Gi("#000"),
                jl("none")
            ]), w),
            A2(wi, k([
                mi("M48,31c0,1.6568-1.3447,3-3,3s-3-1.3433-3-3c0-1.6552,1.3447-3,3-3S48,29.3448,48,31"),
                Gi("#000"),
                jl("none")
            ]), w)
        ]));
    }), ng = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 72 72"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                Gi("inherit"),
                mi("M36,12c-13.2548,0-24,10.7452-24,24s10.7452,24,24,24s24-10.7452,24-24S49.2548,12,36,12L36,12z")
            ]), w),
            A2(wi, k([
                Gi("#fff"),
                mi("M41.5405,37.4966L55.2873,43.81c0,0,3.8107-4.3777,7.3934-0.753c1.8042,1.6892,1.8974,4.5211,0.2082,6.3253 c0,0,0,0.0001-0.0001,0.0001c-0.0219,0.0235-0.0441,0.0468-0.0666,0.07c-0.0338,0.0348,3.46,3.3212,0.3024,6.4791 c-1.6137,1.6749-4.2497,1.8118-6.0282,0.313c0,0-2.5219,3.7564-6.086-0.2145s0.8088-7.42,0.8088-7.42L41.5405,37.4966z")
            ]), w),
            A2(wi, k([
                Gi("#fff"),
                mi("M30.4596,37.4966L16.7127,43.81c0,0-3.8107-4.3777-7.3934-0.753 c-1.8042,1.6892-1.8974,4.5211-0.2082,6.3253c0,0,0,0.0001,0.0001,0.0001c0.0219,0.0235,0.0441,0.0468,0.0666,0.07 c0.0338,0.0348-3.46,3.3212-0.3024,6.4791c1.6137,1.6749,4.2498,1.8118,6.0283,0.313c0,0,2.5218,3.7566,6.0858-0.2148 s-0.8088-7.42-0.8088-7.42L30.4596,37.4966z")
            ]), w),
            A2(wi, k([
                Gi("none"),
                jl("inherit"),
                Pp("round"),
                Dp("round"),
                Fl("2"),
                mi("M46.7165,56.3562 c-6.7467,3.5446-14.8098,3.5235-21.5379-0.0562")
            ]), w),
            A2(wi, k([
                Gi("none"),
                jl("inherit"),
                Pp("round"),
                Dp("round"),
                Fl("2"),
                mi("M47.4511,55.9513 c-0.2421,0.1393-0.4869,0.2743-0.7346,0.4049")
            ]), w),
            A2(wi, k([
                Gi("none"),
                jl("inherit"),
                Pp("round"),
                Dp("round"),
                Fl("2"),
                mi("M13.1224,38.3876 C13.0407,37.5944,12.9999,36.7974,13,36c0-12.7025,10.2975-23,23-23s23,10.2975,23,23c0,0.5043-0.0161,1.0046-0.0482,1.501")
            ]), w),
            A2(Tp, k([
                Up("23"),
                Op("30"),
                Jp("24.0001"),
                Qp("28.0001"),
                Gi("none"),
                jl("#000000"),
                Pp("round"),
                Dp("round"),
                Fl("2")
            ]), w),
            A2(Tp, k([
                Up("49"),
                Op("42"),
                Jp("24.0001"),
                Qp("28.0001"),
                Gi("none"),
                jl("#000000"),
                Pp("round"),
                Dp("round"),
                Fl("2")
            ]), w),
            A2(wi, k([
                Gi("none"),
                jl("#000000"),
                Pp("round"),
                Dp("round"),
                Fl("2"),
                mi("M30,43 c2.1924-0.7812,4.5179-1.1204,6.8421-0.9981C38.9397,41.9366,41.0304,42.2755,43,43")
            ]), w),
            A2(wi, k([
                Gi("none"),
                jl("#000000"),
                Pp("round"),
                Dp("round"),
                Fl("2"),
                mi("M22.5,33.0775 c1.3758,1.1372,3.1261,1.7206,4.9091,1.6364c1.503-0.0963,2.9361-0.6696,4.0909-1.6364")
            ]), w),
            A2(wi, k([
                Gi("none"),
                jl("#000000"),
                Pp("round"),
                Dp("round"),
                Fl("2"),
                mi("M40.5,33.0775 c1.3758,1.1372,3.1261,1.7206,4.9091,1.6364c1.503-0.0963,2.9361-0.6696,4.0909-1.6364")
            ]), w),
            A2(wi, k([
                Gi("none"),
                jl("#000000"),
                Pp("round"),
                Dp("round"),
                Fl("2"),
                mi("M30.4596,37.4966 L16.7127,43.81c0,0-3.8107-4.3777-7.3934-0.753c-1.8042,1.6892-1.8974,4.5211-0.2082,6.3253c0,0,0,0.0001,0.0001,0.0001 c0.0219,0.0235,0.0441,0.0468,0.0666,0.07c0.0338,0.0348-3.46,3.3212-0.3024,6.4791c1.6137,1.6749,4.2498,1.8118,6.0283,0.313 c0,0,2.5218,3.7566,6.0858-0.2148s-0.8088-7.42-0.8088-7.42L30.4596,37.4966z")
            ]), w),
            A2(wi, k([
                Gi("none"),
                jl("#000000"),
                Pp("round"),
                Dp("round"),
                Fl("2"),
                mi("M41.5405,37.4966 L55.2873,43.81c0,0,3.8107-4.3777,7.3934-0.753c1.8042,1.6892,1.8974,4.5211,0.2082,6.3253c0,0,0,0.0001-0.0001,0.0001 c-0.0219,0.0235-0.0441,0.0468-0.0666,0.07c-0.0338,0.0348,3.46,3.3212,0.3024,6.4791c-1.6137,1.6749-4.2497,1.8118-6.0282,0.313 c0,0-2.5219,3.7564-6.086-0.2145s0.8088-7.42,0.8088-7.42L41.5405,37.4966z")
            ]), w)
        ]));
    }), ug = function(e) {
        switch(e){
            case 0:
                return Wp;
            case 1:
            case 2:
                return tg;
            case 3:
            case 4:
                return eg;
            case 5:
                return Kp;
            case 6:
            case 7:
                return rg;
            case 8:
            case 9:
                return Yp;
            default:
                return ng;
        }
    }, ag = F2(function(e, r) {
        switch(r){
            case 0:
                return e.eR.ee;
            case 1:
                return "1 " + e.eR.eW;
            case 10:
                return e.eR.dY;
            default:
                return vt(r) + " " + e.eR.eX;
        }
    }), og = Ke, ig = F4(function(e, r, t, n) {
        var u, a = t.ed, o = t.ez, i = A2(ea, g(0, xt), A2(ju, n.bG, r.fk)), c = A2(ea, i.a, i.b);
        return A2(Si, k([
            ji("flex flex-col bg-white rounded-xl shadow-md shadow-primary-500/40")
        ]), k([
            A2(Li, k([
                ji("contents lg:flex lg:gap-x-4")
            ]), k([
                A2(Ui, k([
                    ji("flex gap-2 items-center p-4 gap-x-4 rounded-xl lg:flex-auto lg:p-6 lg:pr-0 outline-none focus-visible:ring-inset focus-visible:ring-4 focus-visible:ring-primary-600"),
                    Zi(k([
                        g("max-lg:truncate lg:max-w-[376px]", !r.dE),
                        g("lg:truncate", r.dE)
                    ])),
                    xl(A2(Ld, n.bG, r.a$) ? Lp(n.bG) : (u = n.bG, {
                        $: 0,
                        a: u
                    })),
                    Rl("button")
                ]), k([
                    A2(Ci, "hidden lg:block shrink-0 w-4 h-14 self-start transition-transform", k([
                        g("rotate-90", A2(Ld, n.bG, r.a$)),
                        g("opacity-30", 1 === n.o.$)
                    ])),
                    A2(vl, k([
                        ji("max-lg:overflow-hidden max-lg:overflow-ellipsis lg:line-clamp-2 text-left"),
                        Zi(k([
                            g("lg:line-clamp-none", A2(Ld, n.bG, r.a$))
                        ]))
                    ]), k([
                        Vi(n.k)
                    ])),
                    A2(vl, k([
                        ji("ml-auto inline-block px-2.5 py-0.5 bg-primary-300 shrink-0 rounded-full xs:px-3 lg:inline-block lg:text-xl lg:mr-6 lg:px-3.5 lg:py-1 lg:-my-1"),
                        Zi(k([
                            g("lg:hidden", !r.dE)
                        ]))
                    ]), k([
                        Vi(vt(i.a))
                    ]))
                ])),
                r.dE ? Vi("") : A2(Li, k([
                    ji("hidden relative lg:flex gap-2 self-start items-center pr-6 h-[104px]")
                ]), v(A2(Rn, function(e) {
                    var r;
                    return A2(Ui, k([
                        ji("relative group w-8 h-8 border-2 border-primary-300 rounded-full text-sm lg:text-base hover:border-transparent outline-none focus-visible:border-black ring-black"),
                        Rl("button"),
                        Zi(k([
                            g("focus-visible:ring-2", s(e, i.a))
                        ])),
                        xl(A2(Mp, n.bG, e)),
                        (r = A2(Ap, n.bG, g(i.a, gt(e))), A2(gl, "mouseenter", bn(r))),
                        Hp(A2(Xp, n.bG, g(i.a, xt)))
                    ]), k([
                        A2(vl, k([
                            ji("group-hover:opacity-0 group-focus-visible:opacity-0")
                        ]), k([
                            Vi(vt(e))
                        ])),
                        A3(ug, e, "absolute -top-2.5 -left-2.5 w-12 h-12 fill-primary-300 stroke-primary-300 group-focus-visible:opacity-60 group-hover:opacity-60", k([
                            g("opacity-0", !s(e, i.a))
                        ]))
                    ]));
                }, A2(Gt, 0, 10)), k([
                    A2(Li, k([
                        ji("max-lg:hidden left-4 -top-6 absolute -translate-x-1/2")
                    ]), k([
                        A2(Li, k([
                            ji("px-4 py-2 text-white bg-black/80 rounded pointer-events-none transition after:absolute after:top-full after:left-1/2 after:-translate-x-1/2 after:w-0 after:h-0 after:[border-left:8px_solid_transparent] after:[border-right:8px_solid_transparent] after:[border-top:8px_solid_rgba(0,0,0,.8)]"),
                            Zi(k([
                                g("opacity-0", !s(i.a, c) || s(i.b, xt))
                            ])),
                            A2(og, "transform", "translateX(" + vt(40 * c) + "px)")
                        ]), k([
                            Vi(A2(ag, e, c))
                        ]))
                    ]))
                ])))
            ])),
            A2(Li, k([
                ji("fixed inset-0 z-40 flex flex-col bg-white lg:static lg:z-0 lg:rounded-b-xl"),
                Zi(k([
                    g("hidden", !A2(Ld, n.bG, r.a$))
                ]))
            ]), k([
                A2(Li, k([
                    ji("flex flex-col py-10 px-6 gap-6 overflow-y-auto lg:pt-4 lg:pl-14 lg:gap-14")
                ]), k([
                    A2(Li, k([
                        ji("lg:hidden")
                    ]), k([
                        A2(Li, k([
                            ji(Hb + " text-grey-400")
                        ]), k([
                            Vi(e.eD)
                        ])),
                        A2(Li, k([
                            ji("flex justify-between items-baseline")
                        ]), k([
                            A2(Eb, k([
                                ji("min-w-0 text-2xl font-serif font-bold break-words")
                            ]), k([
                                Vi(n.k)
                            ])),
                            r.dE ? A2(vl, k([
                                ji("inline-block px-2.5 py-0.5 shrink-0 bg-primary-300 rounded-full xs:px-3")
                            ]), k([
                                Vi(vt(i.a))
                            ])) : Vi("")
                        ]))
                    ])),
                    function() {
                        var r = n.o;
                        if (r.$) return Vi("");
                        var t = r.a;
                        return A2(Li, w, k([
                            A2(Li, k([
                                ji(Hb + " text-grey-400 lg:mb-2")
                            ]), k([
                                Vi(e.eC)
                            ])),
                            A2(Hi, k([
                                ji("max-w-prose whitespace-pre-line break-words")
                            ]), k([
                                Vi(t)
                            ]))
                        ]));
                    }(),
                    1 === n.o.$ ? A2(vl, k([
                        ji("max-w-prose text-grey-400")
                    ]), k([
                        Vi(e.c9)
                    ])) : Vi("")
                ])),
                r.dE ? A2(Li, k([
                    ji("lg:hidden relative mt-auto flex flex-col p-6")
                ]), k([
                    A2(Ui, k([
                        ji("w-14 h-14 !p-0 flex justify-center items-center" + A2(Ql, 0, 0)),
                        xl(Lp(n.bG)),
                        Rl("button")
                    ]), k([
                        A2(od, "w-6 h-6 fill-current", w)
                    ]))
                ])) : A2(Li, k([
                    ji("lg:hidden relative mt-auto flex flex-col justify-between p-6 bg-primary-300 after:absolute after:block after:bottom-full z-10 after:inset-x-0 after:h-3 after:bg-gradient-to-t after:from-black/5 after:to-transparent")
                ]), k([
                    A2(Li, k([
                        ji("flex justify-between items-center mb-4 px-1")
                    ]), k([
                        A3(ug, A2(ea, i.a, i.b), "w-10 h-10 -ml-2 -my-2 fill-primary-300 stroke-black", w),
                        A2(Hi, w, k([
                            Vi(A2(ag, e, i.a))
                        ]))
                    ])),
                    A2(yb, k([
                        ji("range"),
                        Rl("range"),
                        Sp("0"),
                        Ep("10"),
                        nd(vt(i.a)),
                        Pb(A2(Ao, A2(Ao, Mp(n.bG), ea(0)), Cn))
                    ]), w),
                    A2(Li, k([
                        ji("flex w-full justify-between mb-4 px-3 text-sm text-primary-600")
                    ]), k([
                        A2(vl, k([
                            Zi(k([
                                g("text-black", !i.a)
                            ])),
                            ji("cursor-pointer"),
                            xl(A2(Mp, n.bG, 0))
                        ]), k([
                            Vi("0")
                        ])),
                        A2(vl, k([
                            Zi(k([
                                g("text-black", 1 === i.a)
                            ])),
                            ji("cursor-pointer"),
                            xl(A2(Mp, n.bG, 1))
                        ]), k([
                            Vi("1")
                        ])),
                        A2(vl, k([
                            Zi(k([
                                g("text-black", 2 === i.a)
                            ])),
                            ji("cursor-pointer"),
                            xl(A2(Mp, n.bG, 2))
                        ]), k([
                            Vi("2")
                        ])),
                        A2(vl, k([
                            Zi(k([
                                g("text-black", 3 === i.a)
                            ])),
                            ji("cursor-pointer"),
                            xl(A2(Mp, n.bG, 3))
                        ]), k([
                            Vi("3")
                        ])),
                        A2(vl, k([
                            Zi(k([
                                g("text-black", 4 === i.a)
                            ])),
                            ji("cursor-pointer"),
                            xl(A2(Mp, n.bG, 4))
                        ]), k([
                            Vi("4")
                        ])),
                        A2(vl, k([
                            Zi(k([
                                g("text-black", 5 === i.a)
                            ])),
                            ji("cursor-pointer"),
                            xl(A2(Mp, n.bG, 5))
                        ]), k([
                            Vi("5")
                        ])),
                        A2(vl, k([
                            Zi(k([
                                g("text-black", 6 === i.a)
                            ])),
                            ji("cursor-pointer"),
                            xl(A2(Mp, n.bG, 6))
                        ]), k([
                            Vi("6")
                        ])),
                        A2(vl, k([
                            Zi(k([
                                g("text-black", 7 === i.a)
                            ])),
                            ji("cursor-pointer"),
                            xl(A2(Mp, n.bG, 7))
                        ]), k([
                            Vi("7")
                        ])),
                        A2(vl, k([
                            Zi(k([
                                g("text-black", 8 === i.a)
                            ])),
                            ji("cursor-pointer"),
                            xl(A2(Mp, n.bG, 8))
                        ]), k([
                            Vi("8")
                        ])),
                        A2(vl, k([
                            Zi(k([
                                g("text-black", 9 === i.a)
                            ])),
                            ji("cursor-pointer"),
                            xl(A2(Mp, n.bG, 9))
                        ]), k([
                            Vi("9")
                        ])),
                        A2(vl, k([
                            Zi(k([
                                g("text-black", 10 === i.a)
                            ])),
                            ji("cursor-pointer -mr-2 -translate-x-1.5"),
                            xl(A2(Mp, n.bG, 10))
                        ]), k([
                            Vi("10")
                        ]))
                    ])),
                    A2(Li, k([
                        ji("flex justify-between")
                    ]), k([
                        A2(Ui, k([
                            ji("w-14 h-14 !p-0 flex justify-center items-center" + A2(Ql, 0, 0)),
                            xl(A2(Rp, o, n.bG)),
                            Rl("button")
                        ]), k([
                            A2(od, "w-6 h-6 fill-current", w)
                        ])),
                        A2(Ui, k([
                            ji("w-14 h-14 !p-0 flex justify-center items-center" + A2(Ql, 0, 0)),
                            xl(Lp(n.bG)),
                            Rl("button")
                        ]), k([
                            A2(Zp, "w-8 h-8 fill-current stroke-current", w)
                        ])),
                        A2(Ui, k([
                            ji("w-14 h-14 !p-0 flex justify-center items-center" + A2(Ql, 2, 0)),
                            xl(A2(zp, a, n.bG)),
                            Rl("button")
                        ]), k([
                            A2(od, "w-6 h-6 fill-current -scale-x-100", w)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), cg = function(e) {
        var r = e.a, t = 277803737 * (r ^ r >>> (r >>> 28) + 4);
        return (t >>> 22 ^ t) >>> 0;
    }, fg = F2(function(e, r) {
        return function(t) {
            var n = 0 > d(e, r) ? g(e, r) : g(r, e), u = n.a, a = n.b - u + 1;
            if (a - 1 & a) {
                var o = (-a >>> 0) % a >>> 0;
                return function(e) {
                    for(;;){
                        var r = cg(e), t = pu(e);
                        if (d(r, o) >= 0) return g(r % a + u, t);
                        e = t;
                    }
                }(t);
            }
            return g(((a - 1 & cg(t)) >>> 0) + u, pu(t));
        };
    }), sg = A2(fg, -2147483648, 2147483647), lg = F4(function(e, r, t, n) {
        var u = r, a = t, o = n;
        return function(r) {
            var t = u(r), n = t.a, i = a(t.b), c = i.a, f = o(i.b), s = f.b;
            return g(A3(e, n, c, f.a), s);
        };
    }), bg = F2(function(e, r) {
        return e(r);
    }), dg = function(e) {
        var r = F3(function(e, r, t) {
            return pu(A2(du, e, (1 | r ^ t) >>> 0));
        }), t = A2(fg, 0, 4294967295);
        return A2(bg, A4(lg, r, t, t, t), e);
    }, pg = F2(function(e, r) {
        var t = r;
        return function(r) {
            var n = t(r), u = n.b;
            return g(e(n.a), u);
        };
    }), gg = F3(function(e, r, t) {
        for(;;){
            if (!t.b) return xt;
            var n = t.b;
            if (r(t.a)) return gt(e);
            e += 1, t = n;
        }
    })(0), xg = F2(function(e, r) {
        return g(A2(Tc, e, r), A2(Hc, e, r));
    }), mg = F2(function(e, r) {
        return A2(Aa, function(e) {
            return A2(xg, e, r);
        }, A2(gg, e, r));
    }), hg = F2(function(e, r) {
        return A2(Li, k([
            ji(e.b8 ? "space-y-2" : 1 > Ct(r) ? "hidden lg:block space-y-2" : "space-y-2")
        ]), k([
            A2(Sd, k([
                Zi(k([
                    g(Hb + " mb-2", !0),
                    g("xs:mb-6 text-primary-600", !e.b8),
                    g("text-primary-600 lg:text-grey-400", 1 === e.b8)
                ]))
            ]), A2(Wr, A2(vl, w, k([
                Vi(e.dT)
            ])), e.bD ? w : k([
                A2(vl, k([
                    ji("inline-block ml-2 px-1.5 text-primary-600 bg-primary-200 rounded-full")
                ]), k([
                    Vi(vt(Ct(r)))
                ]))
            ]))),
            A2(Ii, k([
                ji("space-y-3"),
                Zi(k([
                    g("md:gap-x-20 md:grid md:grid-cols-2", 1 === e.b8)
                ]))
            ]), A2(Rn, function(r) {
                var t = r.a, n = r.b;
                return e.b8 ? A2(Si, k([
                    ji("flex items-center gap-4")
                ]), k([
                    A2(Li, k([
                        ji("flex shrink-0 text-base uppercase text-primary-600 w-8 h-8 rounded-full justify-center items-center bg-primary-200 selection:bg-white")
                    ]), k([
                        Vi(1 === n.$ ? A3(vn, 0, 1, t) : n.a)
                    ])),
                    A2(vl, k([
                        ji("capitalize selection:bg-white")
                    ]), k([
                        Vi(t)
                    ]))
                ])) : A2(Si, k([
                    ji("flex items-center gap-3")
                ]), k([
                    A2(Li, k([
                        ji("flex shrink-0 text-base uppercase text-primary-600 w-8 h-8 rounded-full justify-center items-center bg-primary-200")
                    ]), k([
                        Vi(A3(vn, 0, 1, t))
                    ])),
                    A2(Li, k([
                        ji("selection:bg-white")
                    ]), k([
                        A2(vl, k([
                            ji("capitalize")
                        ]), k([
                            Vi(t)
                        ])),
                        function() {
                            if (1 === n.$) return Vi("");
                            var e = n.a;
                            return A2(vl, k([
                                ji("shrink-0 text-sm text-primary-600 sm:text-base")
                            ]), k([
                                Vi(" \u2219 " + e)
                            ]));
                        }()
                    ]))
                ]));
            }, r))
        ]));
    }), vg = F5(function(e, r, t, n, u) {
        var a, o = Ct(A2(pi, A2(Pc, function(e) {
            return e.dR;
        }, Jt(!1)), A2(dd, function(e) {
            return e.k;
        }, n.eF))), i = Hd(A2(Ed, A3(Ao, Jt, Jo, u.fj), A2(Rn, function(e) {
            return e.cF;
        }, u.ek))), c = A2(Gp, function(e) {
            return !e.dR;
        }, A2(dd, function(e) {
            return e.k;
        }, n.eF)), f = c.b, l = A2(bg, (a = c.a, A2(pg, function(e) {
            return A2(Rn, tn, A2(Js, gi, A3(kt, F2(function(e, r) {
                var t = r.a, n = A2(bg, sg, r.b), u = n.b;
                return g(A2(Wr, g(e, n.a), t), u);
            }), g(w, e), a).a));
        }, dg)), e), b = l.a;
        return A2(Zb, k([
            ji("shadow-xl shadow-primary-500/10"),
            Ub(xp)
        ]), k([
            A2(Li, k([
                ji("px-4 py-10 bg-primary-300 lg:rounded-t-xl xs:p-6 sm:p-8 md:p-12 lg:p-16")
            ]), k([
                A2(Hi, k([
                    ji("mb-10 font-serif font-bold italic selection:bg-white max-w-xl")
                ]), k([
                    Vi(t.eR.av)
                ])),
                A2(Li, k([
                    ji("relative flex justify-between items-baseline mb-2 xs:mb-3")
                ]), k([
                    A2(Sd, k([
                        ji(Hb + " text-primary-600")
                    ]), k([
                        A2(vl, k([
                            ji("selection:bg-white")
                        ]), k([
                            Vi(t.eF.k)
                        ])),
                        A2(vl, k([
                            ji("inline-block ml-1 px-1.5 bg-primary-200 rounded-full selection:bg-white lg:ml-2")
                        ]), k([
                            Vi(vt(o))
                        ]))
                    ])),
                    A2(Eb, k([
                        ji("text-primary-600 selection:bg-white " + Hb),
                        Zi(k([
                            g("lg:absolute lg:right-[456px] lg:translate-x-full lg:bottom-0", !u.dE)
                        ]))
                    ]), k([
                        Vi(t.eR.fs)
                    ]))
                ])),
                A2(Ii, k([
                    ji("flex flex-col gap-2 md:gap-4")
                ]), A2(Rn, function(e) {
                    var r = function(e) {
                        e: for(;;){
                            if (e.b) {
                                if (e.b.b) {
                                    e = e.b;
                                    continue e;
                                }
                                return gt(e.a);
                            }
                            return xt;
                        }
                    }(A2(ea, w, A2(Aa, tn, A2(mg, Jt(e.bG), A2(Rn, function(e) {
                        return e.bG;
                    }, b))))), n = A2(hp, 1, A2(ea, w, A2(Aa, gi, A2(mg, Jt(e.bG), A2(Rn, function(e) {
                        return e.bG;
                    }, b)))));
                    return A4(ig, t, u, {
                        ed: n,
                        ez: r
                    }, e);
                }, b)),
                Ct(f) > 0 ? A2(Oi, k([
                    ji("group mt-4 lg:mt-8")
                ]), k([
                    A2(wl, k([
                        ji("flex gap-1 items-center text-primary-600 cursor-pointer mb-2 [&::-webkit-details-marker]:hidden xs:mb-3 lg:gap-2 " + Hb + " outline-none focus-visible:outline-4 focus-visible:outline-primary-600 focus-visible:rounded-full")
                    ]), k([
                        A2(Ci, "w-3 stroke-1 stroke-primary-600 fill-primary-600 transition-transform group-open:rotate-90 md:-mr-0.5", w),
                        A2(vl, k([
                            ji("selection:bg-white")
                        ]), k([
                            Vi(t.eF.df)
                        ])),
                        A2(Zd, pp, "ml-auto order-1 md:order-none md:-ml-1"),
                        A2(vl, k([
                            ji("inline-block px-1.5 bg-primary-200 rounded-full selection:bg-white")
                        ]), k([
                            Vi(vt(Ct(f)))
                        ]))
                    ])),
                    A2(Ii, k([
                        ji("flex flex-col mt-2 gap-2 md:gap-4")
                    ]), A2(Rn, A3(zd, t, u, sp({
                        aK: lp,
                        a_: dp
                    })), f))
                ])) : Vi(""),
                u.dE ? A2(Li, k([
                    ji("flex flex-wrap mt-16 pr-2 h-14 lg:h-16 justify-center items-center gap-3")
                ]), k([
                    A2(Li, k([
                        ji("p-1.5 bg-primary-200 rounded-full")
                    ]), k([
                        A2(yl, "w-4 h-4 stroke-primary-600", w)
                    ])),
                    A2(Sd, k([
                        ji("text-xl font-serif font-bold selection:bg-white")
                    ]), k([
                        Vi(t.eR.eT)
                    ]))
                ])) : A2(Li, k([
                    ji("flex flex-col mt-10 items-end gap-4 xs:flex-row md:gap-8")
                ]), k([
                    A2(Li, k([
                        ji("relative flex flex-col w-full gap-2 lg:gap-3")
                    ]), k([
                        A2(Sb, k([
                            Rb("author-input"),
                            ji(Hb + " text-primary-600 selection:bg-white")
                        ]), k([
                            Vi(t.eR.dq)
                        ])),
                        A2(yb, k([
                            al("author-input"),
                            ji("w-full px-4 py-3.5 bg-primary-100 placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300 filled-invalid:ring filled-invalid:ring-red-400"),
                            Ob(t.eR.dr),
                            Pb(cp),
                            nd(u.fj),
                            qd(".*\\S.*"),
                            Nb(1),
                            Nd(50),
                            Qb(!0)
                        ]), w),
                        i ? A2(Hi, k([
                            ji("text-red-600 xs:absolute xs:top-full xs:mt-1 xs:text-base")
                        ]), k([
                            Vi(t.eR.dt)
                        ])) : Vi("")
                    ])),
                    A2(Ui, k([
                        ji("shrink-0 self-center xs:self-end" + A2(Ql, 2, 2)),
                        zb(!hn(qo(u.fj)) || i)
                    ]), k([
                        Vi(t.eR.e7)
                    ]))
                ])),
                Ct(u.ek) > 0 ? A2(Li, k([
                    ji("flex flex-col mt-12 lg:flex-row gap-20 w-full")
                ]), k([
                    A2(hg, {
                        bD: !1,
                        dT: t.fo,
                        b8: 0
                    }, A2(Rn, function(e) {
                        return g(e.cF, gt(A4(Fp, {
                            fq: !0
                        }, mp, e.as, r)));
                    }, Rt(A2(dd, function(e) {
                        return e.cF;
                    }, A2(Js, A2(Pc, function(e) {
                        return e.as;
                    }, sb), u.ek)))))
                ])) : Vi("")
            ])),
            A2(Li, k([
                ji("grid [grid-template-columns:auto_1fr] px-4 gap-x-2 bg-primary-100 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
            ]), k([
                A2(Li, k([
                    ji("row-start-1 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), w),
                A2(Li, k([
                    ji("row-start-5 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), w),
                A2(Li, k([
                    ji("col-start-1 row-start-1 row-span-2 w-0.5 h-5/6 justify-self-center bg-primary-300")
                ]), w),
                A2(Li, k([
                    ji("row-start-2 col-start-1 z-10 place-self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 text-black text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                ]), k([
                    A2(fd, "w-[10px] h-[10px] fill-black sm:w-3 sm:h-3", w)
                ])),
                A2(Li, k([
                    ji("row-start-2 col-start-2 font-semibold")
                ]), k([
                    Vi(t.eZ.k)
                ])),
                A2(Hi, k([
                    ji("row-start-3 col-start-2 mt-1 mb-4 text-primary-900 max-w-md")
                ]), k([
                    Vi(t.eZ.dj)
                ])),
                function() {
                    var e = n.en;
                    if (e.$) return A2(Ui, k([
                        ji(A2(Ql, 2, 2) + " row-start-4 col-start-1 col-span-2 justify-self-center mt-2 sm:mt-4"),
                        xl(bp),
                        zb(2 > Ct(A2(dd, function(e) {
                            return e.cF;
                        }, u.ek))),
                        Rl("button")
                    ]), k([
                        Vi(t.eZ.a9)
                    ]));
                    var r = e.a;
                    return A2(Li, k([
                        ji("row-start-4 col-start-2 mt-2 flex flex-col gap-1.5")
                    ]), k([
                        A2(Sb, k([
                            Rb("code-test"),
                            ji(Hb + " flex gap-1 items-center text-primary-600 selection:bg-white sm:leading-[18px]")
                        ]), k([
                            Vi(t.es),
                            A2(Ui, k([
                                Rl("button"),
                                Td(gp)
                            ]), k([
                                A2(Rd, "w-4 h-4 fill-primary-600", w)
                            ]))
                        ])),
                        A2(Li, k([
                            ji("flex flex-wrap gap-4 justify-center items-center")
                        ]), k([
                            A2(yb, k([
                                al("code-test"),
                                ji("grow w-full xs:w-auto xs:min-w-[290px] px-4 py-3.5 bg-white placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300 filled-invalid:ring filled-invalid:ring-red-400"),
                                Ob(t.bZ),
                                Pb(fp),
                                nd(u.em),
                                Nb(1)
                            ]), w),
                            A2(Ui, k([
                                ji(A2(Ql, 2, 2) + " justify-self-center"),
                                xl(bp),
                                zb(2 > Ct(A2(dd, function(e) {
                                    return e.cF;
                                }, u.ek)) || !s(r, u.bY)),
                                Rl("button")
                            ]), k([
                                Vi(t.eZ.a9)
                            ]))
                        ]))
                    ]));
                }()
            ]))
        ]));
    }), wg = F3(function(e, r, t) {
        return A2(Li, w, k([
            Ol(e.ab),
            A2(Li, k([
                ji("flex flex-col max-w-screen-lg mx-auto lg:px-8")
            ]), k([
                A2(Dl, e.aa, gt({
                    aH: e.ab.cR,
                    aI: e.ab.cT,
                    aJ: e.ab.cS,
                    V: r.bG
                })),
                A2($b, aa, A6(cd, e.ab, e.fd, r, t.a7, eb, Kl(r.bG))),
                A2(Li, k([
                    ji("grid [grid-template-columns:auto_auto_auto_1fr] px-4 gap-x-2 gap-y-4 sm:gap-x-3 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), k([
                    A2(Li, k([
                        ji("col-start-1 row-start-1 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-1 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), k([
                        Vi("1")
                    ])),
                    A2(Li, k([
                        ji("flex items-center gap-2 mr-2")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold text-grey-400")
                        ]), k([
                            Vi(e.ab.eI.k)
                        ])),
                        A2(yl, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", w)
                    ])),
                    A2(Li, k([
                        ji("col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                    ]), k([
                        Vi(e.ab.ew + " " + wb(g(e.fd, r.as)))
                    ])),
                    A2(Li, k([
                        ji("col-start-1 row-start-2 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-2 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), k([
                        Vi("2")
                    ])),
                    A2(Li, k([
                        ji("row-start-2 flex items-center gap-2 mr-2")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold text-grey-400")
                        ]), k([
                            Vi(e.ab.eF.k)
                        ])),
                        A2(yl, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", w)
                    ])),
                    function() {
                        var t = r.b3;
                        if (t.$) return Vi("");
                        var n = t.a;
                        return A2(Li, k([
                            ji("row-start-2 col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                        ]), k([
                            Vi(e.ab.eu + " " + wb(g(e.fd, n)))
                        ]));
                    }(),
                    A2(Li, k([
                        ji("col-start-1 row-start-3 row-span-2 justify-self-center w-0.5 bg-grey-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-3 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-black text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), k([
                        Vi("3")
                    ])),
                    A2(Li, k([
                        ji("col-start-2 mr-2 flex items-center gap-2")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold text-black")
                        ]), k([
                            Vi(e.ab.eR.k)
                        ]))
                    ])),
                    A2(Li, k([
                        ji("col-span-2 justify-self-end px-2 py-1 font-semibold text-xs text-primary-600 bg-primary-200 rounded-full xs:col-span-1 xs:text-sm xs:px-3 xs:justify-self-start md:text-base md:-my-0.5")
                    ]), k([
                        Vi(e.ab.ev)
                    ]))
                ])),
                A2($b, Ab, A5(vg, e.a5, e.aY, e.ab, r, t))
            ])),
            A3(vb, e.ab, g(e.fd, r.dh), r.bG),
            A2(Li, k([
                ji("mt-20 lg:mt-40")
            ]), k([
                A3(zi, 0, 1, A3(Ti, e.aa, e.ab.$7, 1))
            ])),
            A4(ud, e.aa, e.ab, {
                cF: r.cF,
                o: r.o,
                bG: r.bG,
                k: r.k
            }, t.d$)
        ]));
    }), yg = function(e) {
        return {
            $: 6,
            a: e
        };
    }, $g = function(e) {
        return {
            $: 1,
            a: e
        };
    }, kg = function(e) {
        return {
            $: 0,
            a: e
        };
    }, Cg = {
        $: 2
    }, _g = F2(function(e, r) {
        e: for(;;){
            if (r.b) {
                var t = r.b;
                if (e(r.a)) {
                    r = t;
                    continue e;
                }
                return r;
            }
            return w;
        }
    }), jg = function(e) {
        return F2(function(r, t) {
            e: for(;;){
                if (t.b) {
                    var n = t.a, u = t.b;
                    if (e(n)) {
                        r = A2(Wr, n, r), t = u;
                        continue e;
                    }
                    return Rt(r);
                }
                return Rt(r);
            }
        })(w);
    }, Fg = F2(function(e, r) {
        return g(A2(jg, e, r), A2(_g, e, r));
    }), Gg = function(e) {
        return Fg(A2(Ao, Vo, e));
    }, Mg = F2(function(e, r) {
        e: for(;;){
            if (r.b) {
                var t = r.b, n = e(r.a);
                if (n.$) {
                    r = t;
                    continue e;
                }
                return gt(n.a);
            }
            return xt;
        }
    }), Ag = F2(function(e, r) {
        return A2(F2(function(r, t) {
            for(;;){
                if (!r.b) return Rt(t);
                var n = r.a, u = r.b, a = A2(Gp, e(n), u);
                r = a.b, t = A2(Wr, g(n, a.a), t);
            }
        }), r, w);
    }), Xg = F2(function(e, r) {
        return A2(Ag, F2(function(r, t) {
            return s(e(r), e(t));
        }), r);
    }), Lg = F2(function(e, r) {
        return A2(yi, k([
            di(e),
            xi(r),
            $i("0 0 16 16"),
            ki("http://www.w3.org/2000/svg")
        ]), k([
            A2(wi, k([
                hi("evenodd"),
                mi("M7.655 14.916L8 14.25l.345.666a.752.752 0 01-.69 0zm0 0L8 14.25l.345.666.002-.001.006-.003.018-.01a7.643 7.643 0 00.31-.17 22.08 22.08 0 003.433-2.414C13.956 10.731 16 8.35 16 5.5 16 2.836 13.914 1 11.75 1 10.203 1 8.847 1.802 8 3.02 7.153 1.802 5.797 1 4.25 1 2.086 1 0 2.836 0 5.5c0 2.85 2.045 5.231 3.885 6.818a22.075 22.075 0 003.744 2.584l.018.01.006.003h.002z")
            ]), w)
        ]));
    }), zg = Oe("iframe"), Rg = F3(function(e, r, t) {
        return 1 === t ? e : r;
    }), Zg = F2(function(e, r) {
        return 1 > e ? r : A3(vn, 0, -e, r);
    }), Eg = q, Sg = F2(function(e, r) {
        var t = A2(sd, function(e) {
            return "0" !== e && "." !== e;
        }, Qf(r));
        return v(e && t ? "-" : "", r);
    }), Hg = function(e) {
        var r = e.a, t = e.b;
        if ("9" === r) {
            var n = Zt(t);
            return 1 === n.$ ? "01" : A2(ub, "0", Hg(n.a));
        }
        var u, a = At(r);
        return a >= 48 && 57 > a ? A2(ub, 0 > (u = a + 1) || u > 1114111 ? "\uFFFD" : u > 65535 ? String.fromCharCode(Math.floor((u -= 65536) / 1024) + 55296, u % 1024 + 56320) : String.fromCharCode(u), t) : "0";
    }, Ng = R, Vg = F3(function(e, r, t) {
        return v(t, A2(ib, e - hn(t), ab(r)));
    }), Ig = function(e) {
        for(var r = e.length, t = Array(r), n = 0; r > n;){
            var u = e.charCodeAt(n);
            55296 > u || u > 56319 ? (t[r - n] = e[n], n++) : (t[r - n] = e[n + 1], t[r - ++n] = e[n - 1], n++);
        }
        return t.join("");
    }, Tg = function(e) {
        var r = A2(yt, ".", e);
        return r.b ? g(r.a, r.b.b ? r.b.a : "0") : g("0", "0");
    }, qg = F2(function(e, r) {
        var t = r.b;
        return g(e(r.a), t);
    }), Pg = F3(function(e, r, t) {
        if ((n = t) === 1 / 0 || n === -1 / 0 || Ng(t)) return Cl(t);
        var n, u = 0 > t, a = Tg(function(e) {
            var r = A2(yt, "e", Cl(Wc(e)));
            if (r.b) {
                if (r.b.b) {
                    var t = r.a, n = r.b.a, u = A2(ea, 0, Cn(A2(Mn, "+", n) ? A2(wn, 1, n) : n)), a = Tg(t), o = v(a.a, a.b), i = 0 > u ? A2(ea, "0", A2(Aa, function(e) {
                        return e.a + "." + e.b;
                    }, A2(Aa, qg(ab), Zt(v(A2(ib, Wc(u), "0"), o))))) : A3(Vg, u + 1, "0", o);
                    return v(0 > e ? "-" : "", i);
                }
                return v(0 > e ? "-" : "", t = r.a);
            }
            return "";
        }(Wc(t))), o = a.a, i = a.b, c = hn(o) + r, f = v(A2(ib, 1 - c, "0"), A3(Vg, c, "0", v(o, i))), s = hn(f), l = A2(Kt, 1, c), b = A2(e, u, A3(vn, l, s, f)), p = A3(vn, 0, l, f), g = b ? Ig(A2(ea, "1", A2(Aa, Hg, Zt(Ig(p))))) : p, x = hn(g), m = "0" === g ? g : r > 0 ? 0 > d(r, hn(i)) ? A3(vn, 0, x - r, g) + "." + A3(vn, x - r, x, g) : v(o + ".", A3(Vg, r, "0", i)) : v(g, A2(ib, Wc(r), "0"));
        return A2(Sg, u, m);
    })(F2(function(e, r) {
        var t, n = Zt(r);
        return 1 !== n.$ && ("5" === n.a.a ? "" !== n.a.b || !e : (t = At(n.a.a)) > 53 && e || t >= 53 && !e);
    })), Dg = F3(function(e, r, t) {
        return e(t) ? r(t) : t;
    }), Bg = F4(function(e, r, t, n) {
        var u = n.a, a = n.b, o = n.c, i = A3(Dg, Eg(".0"), A2(Jb, ".0", ""), A3(Dg, Eg("0"), Zg(1), A2(Pg, 2, o))), c = A2(Rn, function(e) {
            return g(e.cF, gt(vt(e.ey)));
        }, Rt(A2(Js, function(e) {
            return e.ey;
        }, A2(pi, A2(Pc, function(e) {
            return e.eB;
        }, Jt(u)), r.b9)))), f = A2(ea, xt, A2(ju, u, Eo(A2(Rn, function(e) {
            return g(e.bG, e.o);
        }, A2(dd, function(e) {
            return e.k;
        }, r.eF)))));
        return A2(Si, k([
            ji("relative flex flex-col bg-white rounded-xl shadow-md shadow-primary-500/40 lg:overflow-hidden")
        ]), k([
            A2(Ui, k([
                ji("flex items-center gap-x-4 p-4 rounded-xl lg:p-6 outline-none focus-visible:ring-inset focus-visible:ring-4 focus-visible:ring-primary-600"),
                xl(A2(Ld, u, t.a$) ? $g(u) : kg(u)),
                Rl("button")
            ]), k([
                A2(Ci, "hidden lg:block w-4 transition-transform", k([
                    g("rotate-90", A2(Ld, u, t.a$)),
                    g("fill-grey-300", Vd(f))
                ])),
                A2(vl, k([
                    ji("line-clamp-2 text-left")
                ]), k([
                    Vi(a)
                ])),
                A2(vl, k([
                    ji("inline-block ml-auto px-2.5 py-0.5 shrink-0 font-normal bg-primary-300 rounded-full xs:px-3 lg:px-3.5 lg:py-1.5 lg:-my-1.5 lg:min-w-[2.5rem]")
                ]), k([
                    Vi(i)
                ]))
            ])),
            A2(Li, k([
                ji("fixed z-40 inset-0 bg-primary-300 overflow-y-auto lg:static lg:z-0 lg:bg-white lg:pt-2"),
                Zi(k([
                    g("hidden", !A2(Ld, u, t.a$))
                ]))
            ]), k([
                A2(Li, k([
                    ji("relative flex flex-col py-10 px-6 bg-white  lg:pt-0 lg:py-4 lg:pl-14 lg:pb-0")
                ]), k([
                    A2(Li, k([
                        ji("mb-6 lg:hidden")
                    ]), k([
                        A2(Li, k([
                            ji(Hb + " text-grey-400")
                        ]), k([
                            Vi(e.eD)
                        ])),
                        A2(Li, k([
                            ji("flex justify-between items-baseline gap-4")
                        ]), k([
                            A2(Eb, k([
                                ji("min-w-0 text-2xl font-serif font-bold break-words")
                            ]), k([
                                Vi(a)
                            ])),
                            A2(vl, k([
                                ji("inline-block px-2.5 py-0.5 shrink-0 bg-primary-300 rounded-full xs:px-3")
                            ]), k([
                                Vi(i)
                            ]))
                        ]))
                    ])),
                    function() {
                        if (f.$) return A2(Hi, k([
                            ji("lg:mb-10 whitespace-pre-line break-words text-grey-400")
                        ]), k([
                            Vi(e.c9)
                        ]));
                        var r = f.a;
                        return A2(Li, k([
                            ji("lg:mb-10 lg:space-y-1")
                        ]), k([
                            A2(Li, k([
                                ji(Hb + " text-grey-400")
                            ]), k([
                                Vi(e.eC)
                            ])),
                            A2(Hi, k([
                                ji("whitespace-pre-line break-words max-w-prose")
                            ]), k([
                                Vi(r)
                            ]))
                        ]));
                    }(),
                    Ai("absolute w-full max-h-3 left-0 top-full z-10 fill-white lg:hidden")
                ])),
                A2(Li, k([
                    ji("flex flex-col py-14 px-6 lg:px-14 lg:pt-0 lg:pb-12")
                ]), k([
                    A2(hg, {
                        bD: !0,
                        dT: e.dO,
                        b8: 1
                    }, c)
                ])),
                A2(Li, k([
                    ji("fixed z-10 bottom-0 inset-x-0 flex p-6 justify-between lg:hidden")
                ]), k([
                    A2(Ui, k([
                        ji("p-4 rounded-full bg-white shadow-md outline-none focus-visible:outline-4 focus-visible:outline-yellow focus-visible:outline-offset-4"),
                        xl($g(u)),
                        Rl("button")
                    ]), k([
                        A2(od, "w-6 h-6 fill-current", w)
                    ]))
                ]))
            ]))
        ]));
    }), Ug = F4(function(e, r, t, n) {
        var u = A2(Rn, function(e) {
            var n = e.a, u = e.b;
            return x(n, A2(ea, r.c$, A2(Mg, function(e) {
                return s(e.bG, n) ? gt(e.k) : xt;
            }, t.eF)), u);
        }, A2(Js, gi, A2(Rn, function(e) {
            var r = e.a, t = e.b, n = Ct(A2(Wr, r, t)), u = Uc(A2(Rn, function(e) {
                return e.ey;
            }, A2(Wr, r, t)));
            return g(r.eB, u / n);
        }, A2(Xg, function(e) {
            return e.eB;
        }, t.b9)))), a = A2(ea, 0, A2(Aa, function(e) {
            return e.c;
        }, tf(u))), o = A2(Gg, function(e) {
            return d(e.c, a) > 0;
        }, u), i = o.a, c = o.b, f = A2(Gp, A2(Ao, Vo, function(e) {
            return e.dR;
        }), A2(dd, function(e) {
            return e.k;
        }, t.eF)).b;
        return A2(Li, k([
            ji("overflow-hidden lg:rounded-xl shadow-xl shadow-primary-500/10")
        ]), k([
            A2(Li, k([
                ji("px-4 py-10 bg-primary-300 xs:p-6 sm:p-8 md:p-12 lg:p-16")
            ]), k([
                A2(Hi, k([
                    ji("mb-10 font-serif font-bold italic selection:bg-white")
                ]), k([
                    Vi(r.eZ.av)
                ])),
                A2(Eb, k([
                    ji("flex mb-2 text-primary-600 xs:mb-3 " + Hb)
                ]), k([
                    A2(vl, k([
                        ji("selection:bg-white")
                    ]), k([
                        Vi(A3(Rg, r.eZ.cG, r.eZ.cH, Ct(i)))
                    ])),
                    A2(vl, k([
                        ji("inline-block ml-1 px-1.5 bg-primary-200 rounded-full selection:bg-white lg:ml-2"),
                        Zi(k([
                            g("hidden", 1 === Ct(i))
                        ]))
                    ]), k([
                        Vi(vt(Ct(i)))
                    ])),
                    A2(vl, k([
                        ji("inline-block ml-auto selection:bg-white")
                    ]), k([
                        Vi(r.eZ.dC)
                    ]))
                ])),
                A2(Ii, k([
                    ji("flex flex-col gap-2 md:gap-4")
                ]), A2(Rn, A3(Bg, r, t, n), i)),
                Ct(c) > 0 ? A2(Eb, k([
                    ji("flex mb-2 text-primary-600 mt-8 lg:mt-16 lg:mb-3 " + Hb)
                ]), k([
                    A2(vl, k([
                        ji("selection:bg-white")
                    ]), k([
                        Vi(r.eZ.el)
                    ])),
                    A2(vl, k([
                        ji("inline-block ml-1 px-1.5 bg-primary-200 rounded-full selection:bg-white lg:ml-2")
                    ]), k([
                        Vi(vt(Ct(c)))
                    ])),
                    A2(vl, k([
                        ji("inline-block ml-auto selection:bg-white")
                    ]), k([
                        Vi(r.eZ.dC)
                    ]))
                ])) : Vi(""),
                Ct(c) > 0 ? A2(Ii, k([
                    ji("flex flex-col gap-y-2 lg:gap-y-4")
                ]), A2(Rn, A3(Bg, r, t, n), c)) : Vi(""),
                Ct(f) > 0 ? A2(Oi, k([
                    ji("group mt-4 lg:mt-8")
                ]), k([
                    A2(wl, k([
                        ji("flex gap-1 order items-center text-primary-600 cursor-pointer mb-2 [&::-webkit-details-marker]:hidden xs:mb-3 md:gap-2 " + Hb + " outline-none focus-visible:outline-4 focus-visible:outline-primary-600 focus-visible:rounded-full")
                    ]), k([
                        A2(Ci, "w-3 stroke-1 stroke-primary-600 fill-primary-600 transition-transform group-open:rotate-90 md:-mr-0.5", w),
                        A2(vl, k([
                            ji("selection:bg-white")
                        ]), k([
                            Vi(r.eF.df)
                        ])),
                        A2(Zd, Cg, "ml-auto order-1 md:order-none md:-ml-1"),
                        A2(vl, k([
                            ji("inline-block px-1.5 bg-primary-200 rounded-full selection:bg-white")
                        ]), k([
                            Vi(vt(Ct(f)))
                        ]))
                    ])),
                    A2(Ii, k([
                        ji("flex flex-col mt-2 gap-2 md:gap-4")
                    ]), A2(Rn, A3(zd, r, n, sp({
                        aK: $g,
                        a_: kg
                    })), f))
                ])) : Vi(""),
                A2(Li, k([
                    ji("mt-12")
                ]), k([
                    A2(hg, {
                        bD: !1,
                        dT: r.fo,
                        b8: 0
                    }, A2(Rn, function(e) {
                        return g(e.cF, xt);
                    }, A2(dd, function(e) {
                        return e.cF;
                    }, A2(Js, A2(Pc, function(e) {
                        return e.as;
                    }, sb), t.b9))))
                ]))
            ])),
            A2(Li, k([
                ji("grid [grid-template-columns:auto_1fr] px-4 gap-x-2 bg-primary-100 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
            ]), k([
                A2(Li, k([
                    ji("row-start-1 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), w),
                A2(Li, k([
                    ji("row-start-6 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), w),
                A2(Li, k([
                    ji("col-start-1 row-start-1 row-span-2 w-0.5 h-5/6 justify-self-center bg-primary-300")
                ]), w),
                A2(Li, k([
                    ji("row-start-2 col-start-1 z-10 place-self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 text-black text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                ]), k([
                    A2(Lg, "w-[10px] h-[10px] fill-black sm:w-3 sm:h-3", w)
                ])),
                A2(Li, k([
                    ji("row-start-2 col-start-2 font-semibold")
                ]), k([
                    Vi(r.eZ.fa)
                ])),
                A2(Hi, k([
                    ji("row-start-3 col-start-2 mt-1 mb-6 sm:mb-8 text-primary-900 max-w-md")
                ]), k([
                    Vi(r.eZ.e9)
                ])),
                A2(Li, k([
                    ji("flex mt-12 justify-center row-start-5 col-start-1 col-span-2 h-[500px] sm:h-[410px] sm:col-start-2 sm:col-span-1")
                ]), k([
                    A2(zg, k([
                        ji("w-full sm:w-3/5"),
                        sl(e.dm),
                        ll("konsens feedback")
                    ]), w)
                ]))
            ]))
        ]));
    }), Og = F3(function(e, r, t) {
        return A2(Li, w, k([
            Ol(e.ab),
            A2(Li, k([
                ji("flex flex-col max-w-screen-lg mx-auto lg:px-8")
            ]), k([
                A2(Dl, e.aa, gt({
                    aH: e.ab.cU,
                    aI: e.ab.cT,
                    aJ: e.ab.cS,
                    V: r.bG
                })),
                A2($b, aa, A6(cd, e.ab, e.fd, r, t.a7, eb, Kl(r.bG))),
                A2(Li, k([
                    ji("grid [grid-template-columns:auto_auto_auto_1fr] px-4 gap-x-2 gap-y-4 sm:gap-x-3 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), k([
                    A2(Li, k([
                        ji("col-start-1 row-start-1 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-1 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), k([
                        Vi("1")
                    ])),
                    A2(Li, k([
                        ji("flex items-center gap-2 mr-2")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold text-grey-400")
                        ]), k([
                            Vi(e.ab.eI.k)
                        ])),
                        A2(yl, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", w)
                    ])),
                    A2(Li, k([
                        ji("col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                    ]), k([
                        Vi(e.ab.ew + " " + wb(g(e.fd, r.as)))
                    ])),
                    A2(Li, k([
                        ji("col-start-1 row-start-2 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-2 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), k([
                        Vi("2")
                    ])),
                    A2(Li, k([
                        ji("row-start-2 flex items-center gap-2 mr-2")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold text-grey-400")
                        ]), k([
                            Vi(e.ab.eF.k)
                        ])),
                        A2(yl, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", w)
                    ])),
                    function() {
                        var t = r.b3;
                        if (t.$) return Vi("");
                        var n = t.a;
                        return A2(Li, k([
                            ji("row-start-2 col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                        ]), k([
                            Vi(e.ab.eu + " " + wb(g(e.fd, n)))
                        ]));
                    }(),
                    A2(Li, k([
                        ji("col-start-1 row-start-3 row-span-2 justify-self-center w-0.5 bg-grey-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-3 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), k([
                        Vi("3")
                    ])),
                    A2(Li, k([
                        ji("col-start-2 row-start-3 mr-2 flex items-center gap-2")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold text-grey-400")
                        ]), k([
                            Vi(e.ab.eR.k)
                        ])),
                        A2(yl, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", w)
                    ])),
                    function() {
                        var t = r.b7;
                        if (t.$) return Vi("");
                        var n = t.a;
                        return A2(Li, k([
                            ji("row-start-3 col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                        ]), k([
                            Vi(e.ab.eu + " " + wb(g(e.fd, n)))
                        ]));
                    }(),
                    A2(Li, k([
                        ji("col-start-1 row-start-4 row-span-2 justify-self-center w-0.5 bg-grey-300")
                    ]), w),
                    A2(Li, k([
                        ji("col-start-1 row-start-4 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-black text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), k([
                        A2(fd, "w-[10px] h-[10px] fill-white sm:w-3 sm:h-3", w)
                    ])),
                    A2(Li, k([
                        ji("col-start-2 row-start-4 mr-2 flex items-center gap-2")
                    ]), k([
                        A2(vl, k([
                            ji("font-semibold text-black")
                        ]), k([
                            Vi(e.ab.eZ.k)
                        ]))
                    ])),
                    A2(Li, k([
                        ji("col-span-2 row-start-4 justify-self-end px-2 py-1 font-semibold text-xs text-primary-600 bg-primary-200 rounded-full xs:col-span-1 xs:text-sm xs:px-3 xs:justify-self-start md:text-base md:-my-0.5")
                    ]), k([
                        Vi(e.ab.et)
                    ]))
                ])),
                A2($b, yg, A4(Ug, e.aa, e.ab, r, t)),
                A3(vb, e.ab, g(e.fd, r.dh), r.bG)
            ])),
            A2(Li, k([
                ji("mt-20 lg:mt-40")
            ]), k([
                A3(zi, 0, 1, A3(Ti, e.aa, e.ab.$7, 1))
            ])),
            A4(ud, e.aa, e.ab, {
                cF: r.cF,
                o: r.o,
                bG: r.bG,
                k: r.k
            }, t.d$)
        ]));
    });
    Bn = {
        Main: {
            init: Jn({
                dP: function(e) {
                    var r, t, n = 1 === (t = e.cq, r = A2(Mn, "http://", t) ? A2(Gn, 0, A2(wn, 7, t)) : A2(Mn, "https://", t) ? A2(Gn, 1, A2(wn, 8, t)) : xt).$ ? wu : A2(ea, wu, A2(Tu, Wu, r.a));
                    return g({
                        aa: e.aa,
                        ab: e.ab,
                        aY: mu(e.aY),
                        bX: function() {
                            switch(n.$){
                                case 0:
                                    return nu({
                                        cF: "",
                                        o: "",
                                        d$: ru,
                                        em: xt,
                                        k: ""
                                    });
                                case 2:
                                    return tu;
                                default:
                                    return eu;
                            }
                        }(),
                        a5: gu(vu(e.a5)),
                        fd: ra
                    }, uu(k([
                        A2(On, Kn, bu),
                        1 === n.$ ? A2(xu, Wn, fu(n.a)) : hu
                    ])));
                },
                e8: function() {
                    return ua(k([
                        Ka(Ya)
                    ]));
                },
                fi: bi,
                fl: function(e) {
                    var r = e.bX;
                    switch(r.$){
                        case 0:
                            return A2(Yl, e.aa, e.ab);
                        case 1:
                            return A2(Jl, e.aa, e.ab);
                        case 2:
                            return A2(ip, e, r.a);
                        case 3:
                            return A3(Od, e, r.a, r.b);
                        case 4:
                            return A3(wg, e, r.a, r.b);
                        default:
                            return A3(Og, e, r.a, r.b);
                    }
                }
            })(A2(fn, function(e) {
                return A2(fn, function(r) {
                    return A2(fn, function(t) {
                        return A2(fn, function(n) {
                            return A2(fn, function(u) {
                                return bn({
                                    aa: u,
                                    ab: n,
                                    aY: t,
                                    a5: r,
                                    cq: e
                                });
                            }, A2(Qn, "config", A2(fn, function(e) {
                                return A2(fn, function(r) {
                                    return A2(fn, function(t) {
                                        return A2(fn, function(n) {
                                            return A2(fn, function(u) {
                                                return A2(fn, function(a) {
                                                    return A2(fn, function(o) {
                                                        return A2(fn, function(i) {
                                                            return bn({
                                                                cB: i,
                                                                cC: o,
                                                                cD: a,
                                                                c5: u,
                                                                dm: n,
                                                                dW: t,
                                                                ff: r,
                                                                fn: e
                                                            });
                                                        }, A2(Qn, "appUrlEnglish", na));
                                                    }, A2(Qn, "appUrlGerman", na));
                                                }, A2(Qn, "appUrlSpanish", na));
                                            }, A2(Qn, "donateUrl", na));
                                        }, A2(Qn, "feedbackFormUrl", na));
                                    }, A2(Qn, "logoUrl", na));
                                }, A2(Qn, "tinyteamUrl", na));
                            }, A2(Qn, "websiteUrl", na))));
                        }, A2(Qn, "copy", A2(fn, function(e) {
                            return A2(fn, function(r) {
                                return A2(fn, function(t) {
                                    return A2(fn, function(n) {
                                        return A2(fn, function(u) {
                                            return A2(fn, function(a) {
                                                return A2(fn, function(o) {
                                                    return A2(fn, function(i) {
                                                        return A2(fn, function(c) {
                                                            return A2(fn, function(f) {
                                                                return A2(fn, function(s) {
                                                                    return A2(fn, function(l) {
                                                                        return A2(fn, function(b) {
                                                                            return A2(fn, function(d) {
                                                                                return A2(fn, function(p) {
                                                                                    return A2(fn, function(g) {
                                                                                        return A2(fn, function(x) {
                                                                                            return A2(fn, function(m) {
                                                                                                return A2(fn, function(h) {
                                                                                                    return A2(fn, function(v) {
                                                                                                        return A2(fn, function(w) {
                                                                                                            return A2(fn, function(y) {
                                                                                                                return A2(fn, function($) {
                                                                                                                    return A2(fn, function(k) {
                                                                                                                        return A2(fn, function(C) {
                                                                                                                            return A2(fn, function(_) {
                                                                                                                                return A2(fn, function(j) {
                                                                                                                                    return A2(fn, function(F) {
                                                                                                                                        return A2(fn, function(G) {
                                                                                                                                            return A2(fn, function(M) {
                                                                                                                                                return A2(fn, function(A) {
                                                                                                                                                    return A2(fn, function(X) {
                                                                                                                                                        return A2(fn, function(L) {
                                                                                                                                                            return A2(fn, function(z) {
                                                                                                                                                                return A2(fn, function(R) {
                                                                                                                                                                    return bn({
                                                                                                                                                                        cA: R,
                                                                                                                                                                        cK: z,
                                                                                                                                                                        cR: L,
                                                                                                                                                                        cS: X,
                                                                                                                                                                        cT: A,
                                                                                                                                                                        cU: M,
                                                                                                                                                                        c_: G,
                                                                                                                                                                        c$: F,
                                                                                                                                                                        c9: j,
                                                                                                                                                                        $7: _,
                                                                                                                                                                        dx: C,
                                                                                                                                                                        dz: k,
                                                                                                                                                                        dO: $,
                                                                                                                                                                        d0: y,
                                                                                                                                                                        ef: w,
                                                                                                                                                                        es: v,
                                                                                                                                                                        bZ: h,
                                                                                                                                                                        et: m,
                                                                                                                                                                        eu: x,
                                                                                                                                                                        ev: g,
                                                                                                                                                                        ew: p,
                                                                                                                                                                        eC: d,
                                                                                                                                                                        eD: b,
                                                                                                                                                                        eE: l,
                                                                                                                                                                        eF: s,
                                                                                                                                                                        eI: f,
                                                                                                                                                                        eJ: c,
                                                                                                                                                                        eK: i,
                                                                                                                                                                        eL: o,
                                                                                                                                                                        eM: a,
                                                                                                                                                                        eN: u,
                                                                                                                                                                        eP: n,
                                                                                                                                                                        eR: t,
                                                                                                                                                                        eZ: r,
                                                                                                                                                                        fo: e
                                                                                                                                                                    });
                                                                                                                                                                }, A2(Qn, "api_response", A2(fn, function(e) {
                                                                                                                                                                    return A2(fn, function(r) {
                                                                                                                                                                        return A2(fn, function(t) {
                                                                                                                                                                            return A2(fn, function(n) {
                                                                                                                                                                                return A2(fn, function(u) {
                                                                                                                                                                                    return bn({
                                                                                                                                                                                        c2: u,
                                                                                                                                                                                        dy: n,
                                                                                                                                                                                        eG: t,
                                                                                                                                                                                        eU: r,
                                                                                                                                                                                        fg: e
                                                                                                                                                                                    });
                                                                                                                                                                                }, A2(Qn, "description_length", na));
                                                                                                                                                                            }, A2(Qn, "generic", na));
                                                                                                                                                                        }, A2(Qn, "proposals_title_question_id_key", na));
                                                                                                                                                                    }, A2(Qn, "ratings_proposal_id_question_id_author_key", na));
                                                                                                                                                                }, A2(Qn, "title_length", na))));
                                                                                                                                                            }, A2(Qn, "cancel_button", na));
                                                                                                                                                        }, A2(Qn, "copy_invite_link_button", na));
                                                                                                                                                    }, A2(Qn, "copy_link_button_pressed", na));
                                                                                                                                                }, A2(Qn, "copy_link_short_button", na));
                                                                                                                                            }, A2(Qn, "copy_result_link_button", na));
                                                                                                                                        }, A2(Qn, "default_proposal_description", na));
                                                                                                                                    }, A2(Qn, "default_proposal_title", na));
                                                                                                                                }, A2(Qn, "empty_proposal_description", na));
                                                                                                                            }, A2(Qn, "footer", A2(fn, function(e) {
                                                                                                                                return A2(fn, function(r) {
                                                                                                                                    return A2(fn, function(t) {
                                                                                                                                        return A2(fn, function(n) {
                                                                                                                                            return A2(fn, function(u) {
                                                                                                                                                return A2(fn, function(a) {
                                                                                                                                                    return bn({
                                                                                                                                                        cV: a,
                                                                                                                                                        cX: u,
                                                                                                                                                        dl: n,
                                                                                                                                                        dV: t,
                                                                                                                                                        eA: r,
                                                                                                                                                        fb: e
                                                                                                                                                    });
                                                                                                                                                }, A2(Qn, "copyright", na));
                                                                                                                                            }, A2(Qn, "created_by", na));
                                                                                                                                        }, A2(Qn, "faq", na));
                                                                                                                                    }, A2(Qn, "legal_notice", na));
                                                                                                                                }, A2(Qn, "privacy_policy", na));
                                                                                                                            }, A2(Qn, "terms_of_use", na))));
                                                                                                                        }, A2(Qn, "found_bug_button", na));
                                                                                                                    }, A2(Qn, "generic_error", na));
                                                                                                                }, A2(Qn, "individual_ratings", na));
                                                                                                            }, A2(Qn, "modals", A2(fn, function(e) {
                                                                                                                return A2(fn, function(r) {
                                                                                                                    return A2(fn, function(t) {
                                                                                                                        return A2(fn, function(n) {
                                                                                                                            return A2(fn, function(u) {
                                                                                                                                return A2(fn, function(a) {
                                                                                                                                    return A2(fn, function(o) {
                                                                                                                                        return A2(fn, function(i) {
                                                                                                                                            return A2(fn, function(c) {
                                                                                                                                                return A2(fn, function(f) {
                                                                                                                                                    return A2(fn, function(s) {
                                                                                                                                                        return A2(fn, function(l) {
                                                                                                                                                            return A2(fn, function(b) {
                                                                                                                                                                return bn({
                                                                                                                                                                    cJ: b,
                                                                                                                                                                    c0: l,
                                                                                                                                                                    da: s,
                                                                                                                                                                    db: f,
                                                                                                                                                                    de: c,
                                                                                                                                                                    dg: i,
                                                                                                                                                                    dM: o,
                                                                                                                                                                    eq: a,
                                                                                                                                                                    er: u,
                                                                                                                                                                    eO: n,
                                                                                                                                                                    eQ: t,
                                                                                                                                                                    eS: r,
                                                                                                                                                                    e_: e
                                                                                                                                                                });
                                                                                                                                                            }, A2(Qn, "cancel", na));
                                                                                                                                                        }, A2(Qn, "delete_question", A2(fn, function(e) {
                                                                                                                                                            return A2(fn, function(r) {
                                                                                                                                                                return A2(fn, function(t) {
                                                                                                                                                                    return A2(fn, function(n) {
                                                                                                                                                                        return bn({
                                                                                                                                                                            F: n,
                                                                                                                                                                            o: t,
                                                                                                                                                                            ep: r,
                                                                                                                                                                            k: e
                                                                                                                                                                        });
                                                                                                                                                                    }, A2(Qn, "button", na));
                                                                                                                                                                }, A2(Qn, "description", na));
                                                                                                                                                            }, A2(Qn, "phase_code_description", na));
                                                                                                                                                        }, A2(Qn, "title", na))));
                                                                                                                                                    }, A2(Qn, "end_proposal_phase", A2(fn, function(e) {
                                                                                                                                                        return A2(fn, function(r) {
                                                                                                                                                            return A2(fn, function(t) {
                                                                                                                                                                return bn({
                                                                                                                                                                    F: t,
                                                                                                                                                                    o: r,
                                                                                                                                                                    k: e
                                                                                                                                                                });
                                                                                                                                                            }, A2(Qn, "button", na));
                                                                                                                                                        }, A2(Qn, "description", na));
                                                                                                                                                    }, A2(Qn, "title", na))));
                                                                                                                                                }, A2(Qn, "end_rating_phase", A2(fn, function(e) {
                                                                                                                                                    return A2(fn, function(r) {
                                                                                                                                                        return A2(fn, function(t) {
                                                                                                                                                            return bn({
                                                                                                                                                                F: t,
                                                                                                                                                                o: r,
                                                                                                                                                                k: e
                                                                                                                                                            });
                                                                                                                                                        }, A2(Qn, "button", na));
                                                                                                                                                    }, A2(Qn, "description", na));
                                                                                                                                                }, A2(Qn, "title", na))));
                                                                                                                                            }, A2(Qn, "exclude_proposal", A2(fn, function(e) {
                                                                                                                                                return A2(fn, function(r) {
                                                                                                                                                    return A2(fn, function(t) {
                                                                                                                                                        return bn({
                                                                                                                                                            F: t,
                                                                                                                                                            o: r,
                                                                                                                                                            k: e
                                                                                                                                                        });
                                                                                                                                                    }, A2(Qn, "button", na));
                                                                                                                                                }, A2(Qn, "description", na));
                                                                                                                                            }, A2(Qn, "title", na))));
                                                                                                                                        }, A2(Qn, "exclusion_info", A2(fn, function(e) {
                                                                                                                                            return A2(fn, function(r) {
                                                                                                                                                return bn({
                                                                                                                                                    o: r,
                                                                                                                                                    k: e
                                                                                                                                                });
                                                                                                                                            }, A2(Qn, "description", na));
                                                                                                                                        }, A2(Qn, "title", na))));
                                                                                                                                    }, A2(Qn, "include_proposal", A2(fn, function(e) {
                                                                                                                                        return A2(fn, function(r) {
                                                                                                                                            return A2(fn, function(t) {
                                                                                                                                                return bn({
                                                                                                                                                    F: t,
                                                                                                                                                    o: r,
                                                                                                                                                    k: e
                                                                                                                                                });
                                                                                                                                            }, A2(Qn, "button", na));
                                                                                                                                        }, A2(Qn, "description", na));
                                                                                                                                    }, A2(Qn, "title", na))));
                                                                                                                                }, A2(Qn, "phase_code_explanation", A2(fn, function(e) {
                                                                                                                                    return A2(fn, function(r) {
                                                                                                                                        return bn({
                                                                                                                                            o: r,
                                                                                                                                            k: e
                                                                                                                                        });
                                                                                                                                    }, A2(Qn, "description", na));
                                                                                                                                }, A2(Qn, "title", na))));
                                                                                                                            }, A2(Qn, "phase_code_info", A2(fn, function(e) {
                                                                                                                                return A2(fn, function(r) {
                                                                                                                                    return bn({
                                                                                                                                        o: r,
                                                                                                                                        k: e
                                                                                                                                    });
                                                                                                                                }, A2(Qn, "description", na));
                                                                                                                            }, A2(Qn, "title", na))));
                                                                                                                        }, A2(Qn, "question_deleted", A2(fn, function(e) {
                                                                                                                            return A2(fn, function(r) {
                                                                                                                                return A2(fn, function(t) {
                                                                                                                                    return A2(fn, function(n) {
                                                                                                                                        return bn({
                                                                                                                                            o: n,
                                                                                                                                            dA: t,
                                                                                                                                            d9: r,
                                                                                                                                            k: e
                                                                                                                                        });
                                                                                                                                    }, A2(Qn, "description", na));
                                                                                                                                }, A2(Qn, "go_to_hompage_button", na));
                                                                                                                            }, A2(Qn, "new_decision_button", na));
                                                                                                                        }, A2(Qn, "title", na))));
                                                                                                                    }, A2(Qn, "rate_proposals", A2(fn, function(e) {
                                                                                                                        return A2(fn, function(r) {
                                                                                                                            return A2(fn, function(t) {
                                                                                                                                return bn({
                                                                                                                                    F: t,
                                                                                                                                    o: r,
                                                                                                                                    k: e
                                                                                                                                });
                                                                                                                            }, A2(Qn, "button", na));
                                                                                                                        }, A2(Qn, "description", na));
                                                                                                                    }, A2(Qn, "title", na))));
                                                                                                                }, A2(Qn, "rating_phase_started", A2(fn, function(e) {
                                                                                                                    return A2(fn, function(r) {
                                                                                                                        return A2(fn, function(t) {
                                                                                                                            return bn({
                                                                                                                                F: t,
                                                                                                                                o: r,
                                                                                                                                k: e
                                                                                                                            });
                                                                                                                        }, A2(Qn, "button", na));
                                                                                                                    }, A2(Qn, "description", na));
                                                                                                                }, A2(Qn, "title", na))));
                                                                                                            }, A2(Qn, "result_phase_started", A2(fn, function(e) {
                                                                                                                return A2(fn, function(r) {
                                                                                                                    return A2(fn, function(t) {
                                                                                                                        return bn({
                                                                                                                            F: t,
                                                                                                                            o: r,
                                                                                                                            k: e
                                                                                                                        });
                                                                                                                    }, A2(Qn, "button", na));
                                                                                                                }, A2(Qn, "description", na));
                                                                                                            }, A2(Qn, "title", na))))));
                                                                                                        }, A2(Qn, "not_found", A2(fn, function(e) {
                                                                                                            return A2(fn, function(r) {
                                                                                                                return bn({
                                                                                                                    o: r,
                                                                                                                    k: e
                                                                                                                });
                                                                                                            }, A2(Qn, "description", na));
                                                                                                        }, A2(Qn, "title", na))));
                                                                                                    }, A2(Qn, "phase_code_label", na));
                                                                                                }, A2(Qn, "phase_code_placeholder", na));
                                                                                            }, A2(Qn, "phase_done", na));
                                                                                        }, A2(Qn, "phase_ended", na));
                                                                                    }, A2(Qn, "phase_in_progress", na));
                                                                                }, A2(Qn, "phase_started", na));
                                                                            }, A2(Qn, "proposal_description", na));
                                                                        }, A2(Qn, "proposal_label", na));
                                                                    }, A2(Qn, "proposal_placeholder_title", na));
                                                                }, A2(Qn, "proposals", A2(fn, function(e) {
                                                                    return A2(fn, function(r) {
                                                                        return A2(fn, function(t) {
                                                                            return A2(fn, function(n) {
                                                                                return A2(fn, function(u) {
                                                                                    return A2(fn, function(a) {
                                                                                        return A2(fn, function(o) {
                                                                                            return A2(fn, function(i) {
                                                                                                return A2(fn, function(c) {
                                                                                                    return A2(fn, function(f) {
                                                                                                        return A2(fn, function(s) {
                                                                                                            return A2(fn, function(l) {
                                                                                                                return A2(fn, function(b) {
                                                                                                                    return A2(fn, function(d) {
                                                                                                                        return A2(fn, function(p) {
                                                                                                                            return A2(fn, function(g) {
                                                                                                                                return A2(fn, function(x) {
                                                                                                                                    return A2(fn, function(m) {
                                                                                                                                        return A2(fn, function(h) {
                                                                                                                                            return bn({
                                                                                                                                                cx: h,
                                                                                                                                                cy: m,
                                                                                                                                                dd: x,
                                                                                                                                                df: g,
                                                                                                                                                aQ: p,
                                                                                                                                                dp: d,
                                                                                                                                                ds: b,
                                                                                                                                                du: l,
                                                                                                                                                dv: s,
                                                                                                                                                av: f,
                                                                                                                                                dL: c,
                                                                                                                                                d6: i,
                                                                                                                                                d7: o,
                                                                                                                                                d8: a,
                                                                                                                                                ea: u,
                                                                                                                                                eb: n,
                                                                                                                                                ec: t,
                                                                                                                                                a9: r,
                                                                                                                                                k: e
                                                                                                                                            });
                                                                                                                                        }, A2(Qn, "add_proposal_button", na));
                                                                                                                                    }, A2(Qn, "add_proposal_button_short", na));
                                                                                                                                }, A2(Qn, "exclude_button", na));
                                                                                                                            }, A2(Qn, "excluded_label", na));
                                                                                                                        }, A2(Qn, "explanation", na));
                                                                                                                    }, A2(Qn, "form_label_description", na));
                                                                                                                }, A2(Qn, "form_label_title", na));
                                                                                                            }, A2(Qn, "form_title", na));
                                                                                                        }, A2(Qn, "form_title_error", na));
                                                                                                    }, A2(Qn, "headline", na));
                                                                                                }, A2(Qn, "include_button", na));
                                                                                            }, A2(Qn, "new_boomark_link", na));
                                                                                        }, A2(Qn, "new_copy_button", na));
                                                                                    }, A2(Qn, "new_copy_button_pressed", na));
                                                                                }, A2(Qn, "new_invite_link", na));
                                                                            }, A2(Qn, "new_public_info", na));
                                                                        }, A2(Qn, "new_title", na));
                                                                    }, A2(Qn, "start_phase_button", na));
                                                                }, A2(Qn, "title", na))));
                                                            }, A2(Qn, "question", A2(fn, function(e) {
                                                                return A2(fn, function(r) {
                                                                    return A2(fn, function(t) {
                                                                        return A2(fn, function(n) {
                                                                            return A2(fn, function(u) {
                                                                                return A2(fn, function(a) {
                                                                                    return A2(fn, function(o) {
                                                                                        return A2(fn, function(i) {
                                                                                            return A2(fn, function(c) {
                                                                                                return A2(fn, function(f) {
                                                                                                    return bn({
                                                                                                        c1: f,
                                                                                                        c3: c,
                                                                                                        av: i,
                                                                                                        dT: o,
                                                                                                        d3: a,
                                                                                                        d4: u,
                                                                                                        eo: n,
                                                                                                        bZ: t,
                                                                                                        ex: r,
                                                                                                        k: e
                                                                                                    });
                                                                                                }, A2(Qn, "description_label", na));
                                                                                            }, A2(Qn, "description_placeholder", na));
                                                                                        }, A2(Qn, "headline", na));
                                                                                    }, A2(Qn, "label", na));
                                                                                }, A2(Qn, "name_label", na));
                                                                            }, A2(Qn, "name_placeholder", na));
                                                                        }, A2(Qn, "phase_code_checkbox_label", na));
                                                                    }, A2(Qn, "phase_code_placeholder", na));
                                                                }, A2(Qn, "placeholder", na));
                                                            }, A2(Qn, "title", na))));
                                                        }, A2(Qn, "question_automatic_deletion", na));
                                                    }, A2(Qn, "question_automatic_deletion_short", na));
                                                }, A2(Qn, "question_available_until", na));
                                            }, A2(Qn, "question_delete_button", na));
                                        }, A2(Qn, "question_delete_now_button", na));
                                    }, A2(Qn, "question_description", na));
                                }, A2(Qn, "rating", A2(fn, function(e) {
                                    return A2(fn, function(r) {
                                        return A2(fn, function(t) {
                                            return A2(fn, function(n) {
                                                return A2(fn, function(u) {
                                                    return A2(fn, function(a) {
                                                        return A2(fn, function(o) {
                                                            return A2(fn, function(i) {
                                                                return A2(fn, function(c) {
                                                                    return A2(fn, function(f) {
                                                                        return A2(fn, function(s) {
                                                                            return A2(fn, function(l) {
                                                                                return A2(fn, function(b) {
                                                                                    return A2(fn, function(d) {
                                                                                        return A2(fn, function(p) {
                                                                                            return bn({
                                                                                                aQ: p,
                                                                                                di: d,
                                                                                                dq: b,
                                                                                                dr: l,
                                                                                                dt: s,
                                                                                                av: f,
                                                                                                dY: c,
                                                                                                ee: i,
                                                                                                eT: o,
                                                                                                eW: a,
                                                                                                eX: u,
                                                                                                a9: n,
                                                                                                e7: t,
                                                                                                k: r,
                                                                                                fs: e
                                                                                            });
                                                                                        }, A2(Qn, "explanation", na));
                                                                                    }, A2(Qn, "explanation_in_proposal", na));
                                                                                }, A2(Qn, "form_label_name", na));
                                                                            }, A2(Qn, "form_label_placeholder", na));
                                                                        }, A2(Qn, "form_name_error", na));
                                                                    }, A2(Qn, "headline", na));
                                                                }, A2(Qn, "maximum_resistance", na));
                                                            }, A2(Qn, "no_resistance", na));
                                                        }, A2(Qn, "rating_submitted", na));
                                                    }, A2(Qn, "resistant_point", na));
                                                }, A2(Qn, "resistant_points", na));
                                            }, A2(Qn, "start_phase_button", na));
                                        }, A2(Qn, "submit_rating_button", na));
                                    }, A2(Qn, "title", na));
                                }, A2(Qn, "your_resistance", na))));
                            }, A2(Qn, "result", A2(fn, function(e) {
                                return A2(fn, function(r) {
                                    return A2(fn, function(t) {
                                        return A2(fn, function(n) {
                                            return A2(fn, function(u) {
                                                return A2(fn, function(a) {
                                                    return A2(fn, function(o) {
                                                        return A2(fn, function(i) {
                                                            return A2(fn, function(c) {
                                                                return A2(fn, function(f) {
                                                                    return A2(fn, function(s) {
                                                                        return bn({
                                                                            cG: s,
                                                                            cH: f,
                                                                            aQ: c,
                                                                            dj: i,
                                                                            dC: o,
                                                                            av: a,
                                                                            el: u,
                                                                            a9: n,
                                                                            e9: t,
                                                                            fa: r,
                                                                            k: e
                                                                        });
                                                                    }, A2(Qn, "best_proposal", na));
                                                                }, A2(Qn, "best_proposals", na));
                                                            }, A2(Qn, "explanation", na));
                                                        }, A2(Qn, "explanation_in_rating", na));
                                                    }, A2(Qn, "group_resistance", na));
                                                }, A2(Qn, "headline", na));
                                            }, A2(Qn, "other_proposals", na));
                                        }, A2(Qn, "start_phase_button", na));
                                    }, A2(Qn, "support_description", na));
                                }, A2(Qn, "support_title", na));
                            }, A2(Qn, "title", na))));
                        }, A2(Qn, "who_rated", na))));
                    }, A2(Qn, "now", ta));
                }, A2(Qn, "seed", Yn));
            }, A2(Qn, "url", na)))(0)
        }
    }, e.Elm ? function e(r, t) {
        for(var n in t)n in r ? "init" == n ? f(6) : e(r[n], t[n]) : r[n] = t[n];
    }(e.Elm, Bn) : e.Elm = Bn;
}($51bb400a14a72998$exports);


var $48fcce4feeb834ff$var$e = new Map;
function $48fcce4feeb834ff$var$t(t) {
    var o = $48fcce4feeb834ff$var$e.get(t);
    o && o.destroy();
}
function $48fcce4feeb834ff$var$o(t) {
    var o = $48fcce4feeb834ff$var$e.get(t);
    o && o.update();
}
var $48fcce4feeb834ff$var$r = null;
"undefined" == typeof window ? (($48fcce4feeb834ff$var$r = function(e) {
    return e;
}).destroy = function(e) {
    return e;
}, $48fcce4feeb834ff$var$r.update = function(e) {
    return e;
}) : (($48fcce4feeb834ff$var$r = function(t, o) {
    return t && Array.prototype.forEach.call(t.length ? t : [
        t
    ], function(t) {
        return function(t) {
            if (t && t.nodeName && "TEXTAREA" === t.nodeName && !$48fcce4feeb834ff$var$e.has(t)) {
                var o, r = null, n = window.getComputedStyle(t), i = (o = t.value, function() {
                    a({
                        testForHeightReduction: "" === o || !t.value.startsWith(o),
                        restoreTextAlign: null
                    }), o = t.value;
                }), l = (function(o) {
                    t.removeEventListener("autosize:destroy", l), t.removeEventListener("autosize:update", s), t.removeEventListener("input", i), window.removeEventListener("resize", s), Object.keys(o).forEach(function(e) {
                        return t.style[e] = o[e];
                    }), $48fcce4feeb834ff$var$e.delete(t);
                }).bind(t, {
                    height: t.style.height,
                    resize: t.style.resize,
                    textAlign: t.style.textAlign,
                    overflowY: t.style.overflowY,
                    overflowX: t.style.overflowX,
                    wordWrap: t.style.wordWrap
                });
                t.addEventListener("autosize:destroy", l), t.addEventListener("autosize:update", s), t.addEventListener("input", i), window.addEventListener("resize", s), t.style.overflowX = "hidden", t.style.wordWrap = "break-word", $48fcce4feeb834ff$var$e.set(t, {
                    destroy: l,
                    update: s
                }), s();
            }
            function a(e) {
                var o, i, l = e.restoreTextAlign, s = void 0 === l ? null : l, d = e.testForHeightReduction, u = void 0 === d || d, c = n.overflowY;
                if (0 !== t.scrollHeight && ("vertical" === n.resize ? t.style.resize = "none" : "both" === n.resize && (t.style.resize = "horizontal"), u && (o = function(e) {
                    for(var t = []; e && e.parentNode && e.parentNode instanceof Element;)e.parentNode.scrollTop && t.push([
                        e.parentNode,
                        e.parentNode.scrollTop
                    ]), e = e.parentNode;
                    return function() {
                        return t.forEach(function(e) {
                            var t = e[0], o = e[1];
                            t.style.scrollBehavior = "auto", t.scrollTop = o, t.style.scrollBehavior = null;
                        });
                    };
                }(t), t.style.height = ""), i = "content-box" === n.boxSizing ? t.scrollHeight - (parseFloat(n.paddingTop) + parseFloat(n.paddingBottom)) : t.scrollHeight + parseFloat(n.borderTopWidth) + parseFloat(n.borderBottomWidth), "none" !== n.maxHeight && i > parseFloat(n.maxHeight) ? ("hidden" === n.overflowY && (t.style.overflow = "scroll"), i = parseFloat(n.maxHeight)) : "hidden" !== n.overflowY && (t.style.overflow = "hidden"), t.style.height = i + "px", s && (t.style.textAlign = s), o && o(), r !== i && (t.dispatchEvent(new Event("autosize:resized", {
                    bubbles: !0
                })), r = i), c !== n.overflow && !s)) {
                    var v = n.textAlign;
                    "hidden" === n.overflow && (t.style.textAlign = "start" === v ? "end" : "start"), a({
                        restoreTextAlign: v,
                        testForHeightReduction: !0
                    });
                }
            }
            function s() {
                a({
                    testForHeightReduction: !0,
                    restoreTextAlign: null
                });
            }
        }(t);
    }), t;
}).destroy = function(e) {
    return e && Array.prototype.forEach.call(e.length ? e : [
        e
    ], $48fcce4feeb834ff$var$t), e;
}, $48fcce4feeb834ff$var$r.update = function(e) {
    return e && Array.prototype.forEach.call(e.length ? e : [
        e
    ], $48fcce4feeb834ff$var$o), e;
});
var $48fcce4feeb834ff$var$n = $48fcce4feeb834ff$var$r;
var $48fcce4feeb834ff$export$2e2bcd8739ae039 = $48fcce4feeb834ff$var$n;


class $60b04fb58fc41388$export$dcaf143e197b2cd2 extends Error {
    constructor(e){
        super("ClientResponseError"), this.url = "", this.status = 0, this.response = {}, this.isAbort = !1, this.originalError = null, Object.setPrototypeOf(this, $60b04fb58fc41388$export$dcaf143e197b2cd2.prototype), null !== e && "object" == typeof e && (this.originalError = e.originalError, this.url = "string" == typeof e.url ? e.url : "", this.status = "number" == typeof e.status ? e.status : 0, this.isAbort = !!e.isAbort || "AbortError" === e.name || "Aborted" === e.message, null !== e.response && "object" == typeof e.response ? this.response = e.response : null !== e.data && "object" == typeof e.data ? this.response = e.data : this.response = {}), this.originalError || e instanceof $60b04fb58fc41388$export$dcaf143e197b2cd2 || (this.originalError = e), this.name = "ClientResponseError " + this.status, this.message = this.response?.message, this.message || (this.isAbort ? this.message = "The request was aborted (most likely autocancelled; you can find more info in https://github.com/pocketbase/js-sdk#auto-cancellation)." : this.originalError?.cause?.message?.includes("ECONNREFUSED ::1") ? this.message = "Failed to connect to the PocketBase server. Try changing the SDK URL from localhost to 127.0.0.1 (https://github.com/pocketbase/js-sdk/issues/21)." : this.message = "Something went wrong."), this.cause = this.originalError;
    }
    get data() {
        return this.response;
    }
    toJSON() {
        return {
            ...this
        };
    }
}
const $60b04fb58fc41388$var$e = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function $60b04fb58fc41388$export$2314e25186e9360(e, t) {
    const s = {};
    if ("string" != typeof e) return s;
    const i = Object.assign({}, t || {}).decode || $60b04fb58fc41388$var$defaultDecode;
    let n = 0;
    for(; n < e.length;){
        const t = e.indexOf("=", n);
        if (-1 === t) break;
        let r = e.indexOf(";", n);
        if (-1 === r) r = e.length;
        else if (r < t) {
            n = e.lastIndexOf(";", t - 1) + 1;
            continue;
        }
        const o = e.slice(n, t).trim();
        if (void 0 === s[o]) {
            let n = e.slice(t + 1, r).trim();
            34 === n.charCodeAt(0) && (n = n.slice(1, -1));
            try {
                s[o] = i(n);
            } catch (e) {
                s[o] = n;
            }
        }
        n = r + 1;
    }
    return s;
}
function $60b04fb58fc41388$export$879d2f108927fb90(t, s, i) {
    const n = Object.assign({}, i || {}), r = n.encode || $60b04fb58fc41388$var$defaultEncode;
    if (!$60b04fb58fc41388$var$e.test(t)) throw new TypeError("argument name is invalid");
    const o = r(s);
    if (o && !$60b04fb58fc41388$var$e.test(o)) throw new TypeError("argument val is invalid");
    let a = t + "=" + o;
    if (null != n.maxAge) {
        const e = n.maxAge - 0;
        if (isNaN(e) || !isFinite(e)) throw new TypeError("option maxAge is invalid");
        a += "; Max-Age=" + Math.floor(e);
    }
    if (n.domain) {
        if (!$60b04fb58fc41388$var$e.test(n.domain)) throw new TypeError("option domain is invalid");
        a += "; Domain=" + n.domain;
    }
    if (n.path) {
        if (!$60b04fb58fc41388$var$e.test(n.path)) throw new TypeError("option path is invalid");
        a += "; Path=" + n.path;
    }
    if (n.expires) {
        if (!function isDate(e) {
            return "[object Date]" === Object.prototype.toString.call(e) || e instanceof Date;
        }(n.expires) || isNaN(n.expires.valueOf())) throw new TypeError("option expires is invalid");
        a += "; Expires=" + n.expires.toUTCString();
    }
    if (n.httpOnly && (a += "; HttpOnly"), n.secure && (a += "; Secure"), n.priority) switch("string" == typeof n.priority ? n.priority.toLowerCase() : n.priority){
        case "low":
            a += "; Priority=Low";
            break;
        case "medium":
            a += "; Priority=Medium";
            break;
        case "high":
            a += "; Priority=High";
            break;
        default:
            throw new TypeError("option priority is invalid");
    }
    if (n.sameSite) switch("string" == typeof n.sameSite ? n.sameSite.toLowerCase() : n.sameSite){
        case !0:
            a += "; SameSite=Strict";
            break;
        case "lax":
            a += "; SameSite=Lax";
            break;
        case "strict":
            a += "; SameSite=Strict";
            break;
        case "none":
            a += "; SameSite=None";
            break;
        default:
            throw new TypeError("option sameSite is invalid");
    }
    return a;
}
function $60b04fb58fc41388$var$defaultDecode(e) {
    return -1 !== e.indexOf("%") ? decodeURIComponent(e) : e;
}
function $60b04fb58fc41388$var$defaultEncode(e) {
    return encodeURIComponent(e);
}
const $60b04fb58fc41388$var$t = "undefined" != typeof navigator && "ReactNative" === navigator.product || "undefined" != typeof $parcel$global && $parcel$global.HermesInternal;
let $60b04fb58fc41388$var$s;
function $60b04fb58fc41388$export$26ddc56bc995240a(e) {
    if (e) try {
        const t = decodeURIComponent($60b04fb58fc41388$var$s(e.split(".")[1]).split("").map(function(e) {
            return "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        return JSON.parse(t) || {};
    } catch (e) {}
    return {};
}
function $60b04fb58fc41388$export$b007d77a962aa175(e, t = 0) {
    let s = $60b04fb58fc41388$export$26ddc56bc995240a(e);
    return !(Object.keys(s).length > 0 && (!s.exp || s.exp - t > Date.now() / 1e3));
}
$60b04fb58fc41388$var$s = "function" != typeof atob || $60b04fb58fc41388$var$t ? (e)=>{
    let t = String(e).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var s, i, n = 0, r = 0, o = ""; i = t.charAt(r++); ~i && (s = n % 4 ? 64 * s + i : i, n++ % 4) && (o += String.fromCharCode(255 & s >> (-2 * n & 6))))i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(i);
    return o;
} : atob;
const $60b04fb58fc41388$var$i = "pb_auth";
class $60b04fb58fc41388$export$68a044b9d3f6e888 {
    constructor(){
        this.baseToken = "", this.baseModel = null, this._onChangeCallbacks = [];
    }
    get token() {
        return this.baseToken;
    }
    get record() {
        return this.baseModel;
    }
    get model() {
        return this.baseModel;
    }
    get isValid() {
        return !$60b04fb58fc41388$export$b007d77a962aa175(this.token);
    }
    get isSuperuser() {
        let e = $60b04fb58fc41388$export$26ddc56bc995240a(this.token);
        return "auth" == e.type && ("_superusers" == this.record?.collectionName || !this.record?.collectionName && "pbc_3142635823" == e.collectionId);
    }
    get isAdmin() {
        return console.warn("Please replace pb.authStore.isAdmin with pb.authStore.isSuperuser OR simply check the value of pb.authStore.record?.collectionName"), this.isSuperuser;
    }
    get isAuthRecord() {
        return console.warn("Please replace pb.authStore.isAuthRecord with !pb.authStore.isSuperuser OR simply check the value of pb.authStore.record?.collectionName"), "auth" == $60b04fb58fc41388$export$26ddc56bc995240a(this.token).type && !this.isSuperuser;
    }
    save(e, t) {
        this.baseToken = e || "", this.baseModel = t || null, this.triggerChange();
    }
    clear() {
        this.baseToken = "", this.baseModel = null, this.triggerChange();
    }
    loadFromCookie(e, t = $60b04fb58fc41388$var$i) {
        const s = $60b04fb58fc41388$export$2314e25186e9360(e || "")[t] || "";
        let n = {};
        try {
            n = JSON.parse(s), ("object" != typeof n || Array.isArray(n)) && (n = {});
        } catch (e) {}
        this.save(n.token || "", n.record || n.model || null);
    }
    exportToCookie(e, t = $60b04fb58fc41388$var$i) {
        const s = {
            secure: !0,
            sameSite: !0,
            httpOnly: !0,
            path: "/"
        }, n = $60b04fb58fc41388$export$26ddc56bc995240a(this.token);
        s.expires = n?.exp ? new Date(1e3 * n.exp) : new Date("1970-01-01"), e = Object.assign({}, s, e);
        const r = {
            token: this.token,
            record: this.record ? JSON.parse(JSON.stringify(this.record)) : null
        };
        let o = $60b04fb58fc41388$export$879d2f108927fb90(t, JSON.stringify(r), e);
        const a = "undefined" != typeof Blob ? new Blob([
            o
        ]).size : o.length;
        if (r.record && a > 4096) {
            r.record = {
                id: r.record?.id,
                email: r.record?.email
            };
            const s = [
                "collectionId",
                "collectionName",
                "verified"
            ];
            for(const e in this.record)s.includes(e) && (r.record[e] = this.record[e]);
            o = $60b04fb58fc41388$export$879d2f108927fb90(t, JSON.stringify(r), e);
        }
        return o;
    }
    onChange(e, t = !1) {
        return this._onChangeCallbacks.push(e), t && e(this.token, this.record), ()=>{
            for(let t = this._onChangeCallbacks.length - 1; t >= 0; t--)if (this._onChangeCallbacks[t] == e) return delete this._onChangeCallbacks[t], void this._onChangeCallbacks.splice(t, 1);
        };
    }
    triggerChange() {
        for (const e of this._onChangeCallbacks)e && e(this.token, this.record);
    }
}
class $60b04fb58fc41388$export$6439a4b85bcd7f5d extends $60b04fb58fc41388$export$68a044b9d3f6e888 {
    constructor(e = "pocketbase_auth"){
        super(), this.storageFallback = {}, this.storageKey = e, this._bindStorageEvent();
    }
    get token() {
        return (this._storageGet(this.storageKey) || {}).token || "";
    }
    get record() {
        const e = this._storageGet(this.storageKey) || {};
        return e.record || e.model || null;
    }
    get model() {
        return this.record;
    }
    save(e, t) {
        this._storageSet(this.storageKey, {
            token: e,
            record: t
        }), super.save(e, t);
    }
    clear() {
        this._storageRemove(this.storageKey), super.clear();
    }
    _storageGet(e) {
        if ("undefined" != typeof window && window?.localStorage) {
            const t = window.localStorage.getItem(e) || "";
            try {
                return JSON.parse(t);
            } catch (e) {
                return t;
            }
        }
        return this.storageFallback[e];
    }
    _storageSet(e, t) {
        if ("undefined" != typeof window && window?.localStorage) {
            let s = t;
            "string" != typeof t && (s = JSON.stringify(t)), window.localStorage.setItem(e, s);
        } else this.storageFallback[e] = t;
    }
    _storageRemove(e) {
        "undefined" != typeof window && window?.localStorage && window.localStorage?.removeItem(e), delete this.storageFallback[e];
    }
    _bindStorageEvent() {
        "undefined" != typeof window && window?.localStorage && window.addEventListener && window.addEventListener("storage", (e)=>{
            if (e.key != this.storageKey) return;
            const t = this._storageGet(this.storageKey) || {};
            super.save(t.token || "", t.record || t.model || null);
        });
    }
}
class $60b04fb58fc41388$var$BaseService {
    constructor(e){
        this.client = e;
    }
}
class $60b04fb58fc41388$var$SettingsService extends $60b04fb58fc41388$var$BaseService {
    async getAll(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/settings", e);
    }
    async update(e, t) {
        return t = Object.assign({
            method: "PATCH",
            body: e
        }, t), this.client.send("/api/settings", t);
    }
    async testS3(e = "storage", t) {
        return t = Object.assign({
            method: "POST",
            body: {
                filesystem: e
            }
        }, t), this.client.send("/api/settings/test/s3", t).then(()=>!0);
    }
    async testEmail(e, t, s, i) {
        return i = Object.assign({
            method: "POST",
            body: {
                email: t,
                template: s,
                collection: e
            }
        }, i), this.client.send("/api/settings/test/email", i).then(()=>!0);
    }
    async generateAppleClientSecret(e, t, s, i, n, r) {
        return r = Object.assign({
            method: "POST",
            body: {
                clientId: e,
                teamId: t,
                keyId: s,
                privateKey: i,
                duration: n
            }
        }, r), this.client.send("/api/settings/apple/generate-client-secret", r);
    }
}
const $60b04fb58fc41388$var$n = [
    "requestKey",
    "$cancelKey",
    "$autoCancel",
    "fetch",
    "headers",
    "body",
    "query",
    "params",
    "cache",
    "credentials",
    "headers",
    "integrity",
    "keepalive",
    "method",
    "mode",
    "redirect",
    "referrer",
    "referrerPolicy",
    "signal",
    "window"
];
function $60b04fb58fc41388$export$d4eab50bd87f5014(e) {
    if (e) {
        e.query = e.query || {};
        for(let t in e)$60b04fb58fc41388$var$n.includes(t) || (e.query[t] = e[t], delete e[t]);
    }
}
function $60b04fb58fc41388$export$a2e7490059781fcf(e) {
    const t = [];
    for(const s in e){
        const i = encodeURIComponent(s), n = Array.isArray(e[s]) ? e[s] : [
            e[s]
        ];
        for (let e of n)e = $60b04fb58fc41388$var$prepareQueryParamValue(e), null !== e && t.push(i + "=" + e);
    }
    return t.join("&");
}
function $60b04fb58fc41388$var$prepareQueryParamValue(e) {
    return null == e ? null : e instanceof Date ? encodeURIComponent(e.toISOString().replace("T", " ")) : "object" == typeof e ? encodeURIComponent(JSON.stringify(e)) : encodeURIComponent(e);
}
class $60b04fb58fc41388$export$94618cb2db738d0c extends $60b04fb58fc41388$var$BaseService {
    constructor(){
        super(...arguments), this.clientId = "", this.eventSource = null, this.subscriptions = {}, this.lastSentSubscriptions = [], this.maxConnectTimeout = 15e3, this.reconnectAttempts = 0, this.maxReconnectAttempts = 1 / 0, this.predefinedReconnectIntervals = [
            200,
            300,
            500,
            1e3,
            1200,
            1500,
            2e3
        ], this.pendingConnects = [], this.pendingSubmits = [], this.isProcessingPendingSubmits = !1;
    }
    get isConnected() {
        return !!this.eventSource && !!this.clientId && !this.pendingConnects.length;
    }
    async subscribe(e, t, s) {
        if (!e) throw new Error("topic must be set.");
        let i = e;
        if (s) {
            $60b04fb58fc41388$export$d4eab50bd87f5014(s = Object.assign({}, s));
            const e = "options=" + encodeURIComponent(JSON.stringify({
                query: s.query,
                headers: s.headers
            }));
            i += (i.includes("?") ? "&" : "?") + e;
        }
        const listener = function(e) {
            const s = e;
            let i;
            try {
                i = JSON.parse(s?.data);
            } catch  {}
            t(i || {});
        };
        return this.subscriptions[i] || (this.subscriptions[i] = []), this.subscriptions[i].push(listener), this.isConnected ? 1 === this.subscriptions[i].length ? await this.submitSubscriptions() : this.eventSource?.addEventListener(i, listener) : await this.connect(), async ()=>this.unsubscribeByTopicAndListener(e, listener);
    }
    async unsubscribe(e) {
        if (e) {
            const t = this.getSubscriptionsByTopic(e);
            for(let e in t)if (this.hasSubscriptionListeners(e)) {
                for (let t of this.subscriptions[e])this.eventSource?.removeEventListener(e, t);
                delete this.subscriptions[e];
            }
        } else this.subscriptions = {};
        await this.submitSubscriptions();
    }
    async unsubscribeByPrefix(e) {
        let t = !1;
        for(let s in this.subscriptions)if ((s + "?").startsWith(e)) {
            t = !0;
            for (let e of this.subscriptions[s])this.eventSource?.removeEventListener(s, e);
            delete this.subscriptions[s];
        }
        t && await this.submitSubscriptions();
    }
    async unsubscribeByTopicAndListener(e, t) {
        const s = this.getSubscriptionsByTopic(e);
        for(let e in s){
            if (!Array.isArray(this.subscriptions[e]) || !this.subscriptions[e].length) continue;
            let s = !1;
            for(let i = this.subscriptions[e].length - 1; i >= 0; i--)this.subscriptions[e][i] === t && (s = !0, delete this.subscriptions[e][i], this.subscriptions[e].splice(i, 1), this.eventSource?.removeEventListener(e, t));
            s && (this.subscriptions[e].length || delete this.subscriptions[e]);
        }
        await this.submitSubscriptions();
    }
    hasSubscriptionListeners(e) {
        if (this.subscriptions = this.subscriptions || {}, e) return !!this.subscriptions[e]?.length;
        for(let e in this.subscriptions)if (this.subscriptions[e]?.length) return !0;
        return !1;
    }
    async submitSubscriptions() {
        return new Promise((e, t)=>{
            this.pendingSubmits.push({
                resolve: e,
                reject: t
            }), 1 == this.pendingSubmits.length && queueMicrotask(()=>this.finalizePendingSubscriptions());
        });
    }
    async finalizePendingSubscriptions() {
        if (this.isProcessingPendingSubmits || !this.pendingSubmits.length) return;
        const e = this.pendingSubmits.slice();
        this.pendingSubmits = [], this.isProcessingPendingSubmits = !0;
        try {
            await this.sendSubscriptions();
            for (let t of e)t.resolve();
        } catch (t) {
            for (let s of e)t ? s.reject(t) : s.resolve();
        } finally{
            this.isProcessingPendingSubmits = !1, this.pendingSubmits.length > 0 && await this.finalizePendingSubscriptions();
        }
    }
    getSubscriptionsCancelKey() {
        return "realtime_" + this.clientId;
    }
    getSubscriptionsByTopic(e) {
        const t = {};
        e = e.includes("?") ? e : e + "?";
        for(let s in this.subscriptions)(s + "?").startsWith(e) && (t[s] = this.subscriptions[s]);
        return t;
    }
    getNonEmptySubscriptionKeys() {
        const e = [];
        for(let t in this.subscriptions)this.subscriptions[t].length && e.push(t);
        return e;
    }
    hasUnsentSubscriptions() {
        const e = this.getNonEmptySubscriptionKeys();
        if (e.length != this.lastSentSubscriptions.length) return !0;
        for (const t of e)if (!this.lastSentSubscriptions.includes(t)) return !0;
        return !1;
    }
    async sendSubscriptions() {
        if (this.clientId) {
            if (!this.hasSubscriptionListeners()) return this.disconnect();
            if (this.hasUnsentSubscriptions()) return this.addAllSubscriptionListeners(), this.lastSentSubscriptions = this.getNonEmptySubscriptionKeys(), this.client.send("/api/realtime", {
                method: "POST",
                body: {
                    clientId: this.clientId,
                    subscriptions: this.lastSentSubscriptions
                },
                requestKey: this.getSubscriptionsCancelKey()
            }).catch((e)=>{
                if (!e?.isAbort) throw e;
            });
        }
    }
    addAllSubscriptionListeners() {
        if (this.eventSource) {
            this.removeAllSubscriptionListeners();
            for(let e in this.subscriptions)for (let t of this.subscriptions[e])this.eventSource.addEventListener(e, t);
        }
    }
    removeAllSubscriptionListeners() {
        if (this.eventSource) for(let e in this.subscriptions)for (let t of this.subscriptions[e])this.eventSource.removeEventListener(e, t);
    }
    async connect() {
        if (!(this.reconnectAttempts > 0)) return new Promise((e, t)=>{
            this.pendingConnects.push({
                resolve: e,
                reject: t
            }), 1 == this.pendingConnects.length && queueMicrotask(()=>this.initConnect());
        });
    }
    initConnect() {
        this.disconnect(!0), clearTimeout(this.connectTimeoutId), this.connectTimeoutId = setTimeout(()=>{
            this.connectErrorHandler(new Error("EventSource connect took too long."));
        }, this.maxConnectTimeout), this.eventSource = new EventSource(this.client.buildURL("/api/realtime")), this.eventSource.onerror = (e)=>{
            this.connectErrorHandler(new Error("Failed to establish realtime connection."));
        }, this.eventSource.addEventListener("PB_CONNECT", (e)=>{
            const t = e;
            this.clientId = t?.lastEventId, this.lastSentSubscriptions = [], this.submitSubscriptions().then(()=>{
                for (let e of this.pendingConnects)e.resolve();
                this.pendingConnects = [], this.reconnectAttempts = 0, clearTimeout(this.reconnectTimeoutId), clearTimeout(this.connectTimeoutId);
                const t = this.getSubscriptionsByTopic("PB_CONNECT");
                for(let s in t)for (let i of t[s])i(e);
            }).catch((e)=>{
                this.clientId = "", this.lastSentSubscriptions = [], this.connectErrorHandler(e);
            });
        });
    }
    connectErrorHandler(e) {
        if (clearTimeout(this.connectTimeoutId), clearTimeout(this.reconnectTimeoutId), !this.clientId && !this.reconnectAttempts || this.reconnectAttempts > this.maxReconnectAttempts) {
            for (let t of this.pendingConnects)t.reject(new $60b04fb58fc41388$export$dcaf143e197b2cd2(e));
            return this.pendingConnects = [], void this.disconnect();
        }
        this.disconnect(!0);
        const t = this.predefinedReconnectIntervals[this.reconnectAttempts] || this.predefinedReconnectIntervals[this.predefinedReconnectIntervals.length - 1];
        this.reconnectAttempts++, this.reconnectTimeoutId = setTimeout(()=>{
            this.initConnect();
        }, t);
    }
    disconnect(e = !1) {
        if (this.clientId && this.onDisconnect && this.onDisconnect(Object.keys(this.subscriptions)), clearTimeout(this.connectTimeoutId), clearTimeout(this.reconnectTimeoutId), this.removeAllSubscriptionListeners(), this.client.cancelRequest(this.getSubscriptionsCancelKey()), this.eventSource?.close(), this.eventSource = null, this.clientId = "", this.lastSentSubscriptions = [], !e) {
            this.reconnectAttempts = 0;
            for (let e of this.pendingConnects)e.resolve();
            this.pendingConnects = [];
        }
    }
}
class $60b04fb58fc41388$export$d8ebe4a1f8b281ca extends $60b04fb58fc41388$var$BaseService {
    decode(e) {
        return e;
    }
    async getFullList(e, t) {
        if ("number" == typeof e) return this._getFullList(e, t);
        let s = 1e3;
        return (t = Object.assign({}, e, t)).batch && (s = t.batch, delete t.batch), this._getFullList(s, t);
    }
    async getList(e = 1, t = 30, s) {
        return (s = Object.assign({
            method: "GET"
        }, s)).query = Object.assign({
            page: e,
            perPage: t
        }, s.query), this.client.send(this.baseCrudPath, s).then((e)=>(e.items = e.items?.map((e)=>this.decode(e)) || [], e));
    }
    async getFirstListItem(e, t) {
        return (t = Object.assign({
            requestKey: "one_by_filter_" + this.baseCrudPath + "_" + e
        }, t)).query = Object.assign({
            filter: e,
            skipTotal: 1
        }, t.query), this.getList(1, 1, t).then((e)=>{
            if (!e?.items?.length) throw new $60b04fb58fc41388$export$dcaf143e197b2cd2({
                status: 404,
                response: {
                    code: 404,
                    message: "The requested resource wasn't found.",
                    data: {}
                }
            });
            return e.items[0];
        });
    }
    async getOne(e, t) {
        if (!e) throw new $60b04fb58fc41388$export$dcaf143e197b2cd2({
            url: this.client.buildURL(this.baseCrudPath + "/"),
            status: 404,
            response: {
                code: 404,
                message: "Missing required record id.",
                data: {}
            }
        });
        return t = Object.assign({
            method: "GET"
        }, t), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e), t).then((e)=>this.decode(e));
    }
    async create(e, t) {
        return t = Object.assign({
            method: "POST",
            body: e
        }, t), this.client.send(this.baseCrudPath, t).then((e)=>this.decode(e));
    }
    async update(e, t, s) {
        return s = Object.assign({
            method: "PATCH",
            body: t
        }, s), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e), s).then((e)=>this.decode(e));
    }
    async delete(e, t) {
        return t = Object.assign({
            method: "DELETE"
        }, t), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e), t).then(()=>!0);
    }
    _getFullList(e = 1e3, t) {
        (t = t || {}).query = Object.assign({
            skipTotal: 1
        }, t.query);
        let s = [], request = async (i)=>this.getList(i, e || 1e3, t).then((e)=>{
                const t = e.items;
                return s = s.concat(t), t.length == e.perPage ? request(i + 1) : s;
            });
        return request(1);
    }
}
function $60b04fb58fc41388$var$normalizeLegacyOptionsArgs(e, t, s, i) {
    const n = void 0 !== i;
    return n || void 0 !== s ? n ? (console.warn(e), t.body = Object.assign({}, t.body, s), t.query = Object.assign({}, t.query, i), t) : Object.assign(t, s) : t;
}
function $60b04fb58fc41388$var$resetAutoRefresh(e) {
    e._resetAutoRefresh?.();
}
class $60b04fb58fc41388$export$1b7d28e1ebf40328 extends $60b04fb58fc41388$export$d8ebe4a1f8b281ca {
    constructor(e, t){
        super(e), this.collectionIdOrName = t;
    }
    get baseCrudPath() {
        return this.baseCollectionPath + "/records";
    }
    get baseCollectionPath() {
        return "/api/collections/" + encodeURIComponent(this.collectionIdOrName);
    }
    get isSuperusers() {
        return "_superusers" == this.collectionIdOrName || "_pbc_2773867675" == this.collectionIdOrName;
    }
    async subscribe(e, t, s) {
        if (!e) throw new Error("Missing topic.");
        if (!t) throw new Error("Missing subscription callback.");
        return this.client.realtime.subscribe(this.collectionIdOrName + "/" + e, t, s);
    }
    async unsubscribe(e) {
        return e ? this.client.realtime.unsubscribe(this.collectionIdOrName + "/" + e) : this.client.realtime.unsubscribeByPrefix(this.collectionIdOrName);
    }
    async getFullList(e, t) {
        if ("number" == typeof e) return super.getFullList(e, t);
        const s = Object.assign({}, e, t);
        return super.getFullList(s);
    }
    async getList(e = 1, t = 30, s) {
        return super.getList(e, t, s);
    }
    async getFirstListItem(e, t) {
        return super.getFirstListItem(e, t);
    }
    async getOne(e, t) {
        return super.getOne(e, t);
    }
    async create(e, t) {
        return super.create(e, t);
    }
    async update(e, t, s) {
        return super.update(e, t, s).then((e)=>{
            if (this.client.authStore.record?.id === e?.id && (this.client.authStore.record?.collectionId === this.collectionIdOrName || this.client.authStore.record?.collectionName === this.collectionIdOrName)) {
                let t = Object.assign({}, this.client.authStore.record.expand), s = Object.assign({}, this.client.authStore.record, e);
                t && (s.expand = Object.assign(t, e.expand)), this.client.authStore.save(this.client.authStore.token, s);
            }
            return e;
        });
    }
    async delete(e, t) {
        return super.delete(e, t).then((t)=>(!t || this.client.authStore.record?.id !== e || this.client.authStore.record?.collectionId !== this.collectionIdOrName && this.client.authStore.record?.collectionName !== this.collectionIdOrName || this.client.authStore.clear(), t));
    }
    authResponse(e) {
        const t = this.decode(e?.record || {});
        return this.client.authStore.save(e?.token, t), Object.assign({}, e, {
            token: e?.token || "",
            record: t
        });
    }
    async listAuthMethods(e) {
        return e = Object.assign({
            method: "GET",
            fields: "mfa,otp,password,oauth2"
        }, e), this.client.send(this.baseCollectionPath + "/auth-methods", e);
    }
    async authWithPassword(e, t, s) {
        let i;
        s = Object.assign({
            method: "POST",
            body: {
                identity: e,
                password: t
            }
        }, s), this.isSuperusers && (i = s.autoRefreshThreshold, delete s.autoRefreshThreshold, s.autoRefresh || $60b04fb58fc41388$var$resetAutoRefresh(this.client));
        let n = await this.client.send(this.baseCollectionPath + "/auth-with-password", s);
        return n = this.authResponse(n), i && this.isSuperusers && function registerAutoRefresh(e, t, s, i) {
            $60b04fb58fc41388$var$resetAutoRefresh(e);
            const n = e.beforeSend, r = e.authStore.record, o = e.authStore.onChange((t, s)=>{
                (!t || s?.id != r?.id || (s?.collectionId || r?.collectionId) && s?.collectionId != r?.collectionId) && $60b04fb58fc41388$var$resetAutoRefresh(e);
            });
            e._resetAutoRefresh = function() {
                o(), e.beforeSend = n, delete e._resetAutoRefresh;
            }, e.beforeSend = async (r, o)=>{
                const a = e.authStore.token;
                if (o.query?.autoRefresh) return n ? n(r, o) : {
                    url: r,
                    sendOptions: o
                };
                let c = e.authStore.isValid;
                if (c && $60b04fb58fc41388$export$b007d77a962aa175(e.authStore.token, t)) try {
                    await s();
                } catch (e) {
                    c = !1;
                }
                c || await i();
                const l = o.headers || {};
                for(let t in l)if ("authorization" == t.toLowerCase() && a == l[t] && e.authStore.token) {
                    l[t] = e.authStore.token;
                    break;
                }
                return o.headers = l, n ? n(r, o) : {
                    url: r,
                    sendOptions: o
                };
            };
        }(this.client, i, ()=>this.authRefresh({
                autoRefresh: !0
            }), ()=>this.authWithPassword(e, t, Object.assign({
                autoRefresh: !0
            }, s))), n;
    }
    async authWithOAuth2Code(e, t, s, i, n, r, o) {
        let a = {
            method: "POST",
            body: {
                provider: e,
                code: t,
                codeVerifier: s,
                redirectURL: i,
                createData: n
            }
        };
        return a = $60b04fb58fc41388$var$normalizeLegacyOptionsArgs("This form of authWithOAuth2Code(provider, code, codeVerifier, redirectURL, createData?, body?, query?) is deprecated. Consider replacing it with authWithOAuth2Code(provider, code, codeVerifier, redirectURL, createData?, options?).", a, r, o), this.client.send(this.baseCollectionPath + "/auth-with-oauth2", a).then((e)=>this.authResponse(e));
    }
    authWithOAuth2(...e) {
        if (e.length > 1 || "string" == typeof e?.[0]) return console.warn("PocketBase: This form of authWithOAuth2() is deprecated and may get removed in the future. Please replace with authWithOAuth2Code() OR use the authWithOAuth2() realtime form as shown in https://pocketbase.io/docs/authentication/#oauth2-integration."), this.authWithOAuth2Code(e?.[0] || "", e?.[1] || "", e?.[2] || "", e?.[3] || "", e?.[4] || {}, e?.[5] || {}, e?.[6] || {});
        const t = e?.[0] || {};
        let s = null;
        t.urlCallback || (s = $60b04fb58fc41388$var$openBrowserPopup(void 0));
        const i = new $60b04fb58fc41388$export$94618cb2db738d0c(this.client);
        function cleanup() {
            s?.close(), i.unsubscribe();
        }
        const n = {}, r = t.requestKey;
        return r && (n.requestKey = r), this.listAuthMethods(n).then((e)=>{
            const n = e.oauth2.providers.find((e)=>e.name === t.provider);
            if (!n) throw new $60b04fb58fc41388$export$dcaf143e197b2cd2(new Error(`Missing or invalid provider "${t.provider}".`));
            const o = this.client.buildURL("/api/oauth2-redirect");
            return new Promise(async (e, a)=>{
                const c = r ? this.client.cancelControllers?.[r] : void 0;
                c && (c.signal.onabort = ()=>{
                    cleanup(), a(new $60b04fb58fc41388$export$dcaf143e197b2cd2({
                        isAbort: !0,
                        message: "manually cancelled"
                    }));
                }), i.onDisconnect = (e)=>{
                    e.length && a && (cleanup(), a(new $60b04fb58fc41388$export$dcaf143e197b2cd2(new Error("realtime connection interrupted"))));
                };
                try {
                    await i.subscribe("@oauth2", async (s)=>{
                        const r = i.clientId;
                        try {
                            if (!s.state || r !== s.state) throw new Error("State parameters don't match.");
                            if (s.error || !s.code) throw new Error("OAuth2 redirect error or missing code: " + s.error);
                            const i = Object.assign({}, t);
                            delete i.provider, delete i.scopes, delete i.createData, delete i.urlCallback, c?.signal?.onabort && (c.signal.onabort = null);
                            const a = await this.authWithOAuth2Code(n.name, s.code, n.codeVerifier, o, t.createData, i);
                            e(a);
                        } catch (e) {
                            a(new $60b04fb58fc41388$export$dcaf143e197b2cd2(e));
                        }
                        cleanup();
                    });
                    const r = {
                        state: i.clientId
                    };
                    t.scopes?.length && (r.scope = t.scopes.join(" "));
                    const l = this._replaceQueryParams(n.authURL + o, r);
                    let h = t.urlCallback || function(e) {
                        s ? s.location.href = e : s = $60b04fb58fc41388$var$openBrowserPopup(e);
                    };
                    await h(l);
                } catch (e) {
                    c?.signal?.onabort && (c.signal.onabort = null), cleanup(), a(new $60b04fb58fc41388$export$dcaf143e197b2cd2(e));
                }
            });
        }).catch((e)=>{
            throw cleanup(), e;
        });
    }
    async authRefresh(e, t) {
        let s = {
            method: "POST"
        };
        return s = $60b04fb58fc41388$var$normalizeLegacyOptionsArgs("This form of authRefresh(body?, query?) is deprecated. Consider replacing it with authRefresh(options?).", s, e, t), this.client.send(this.baseCollectionPath + "/auth-refresh", s).then((e)=>this.authResponse(e));
    }
    async requestPasswordReset(e, t, s) {
        let i = {
            method: "POST",
            body: {
                email: e
            }
        };
        return i = $60b04fb58fc41388$var$normalizeLegacyOptionsArgs("This form of requestPasswordReset(email, body?, query?) is deprecated. Consider replacing it with requestPasswordReset(email, options?).", i, t, s), this.client.send(this.baseCollectionPath + "/request-password-reset", i).then(()=>!0);
    }
    async confirmPasswordReset(e, t, s, i, n) {
        let r = {
            method: "POST",
            body: {
                token: e,
                password: t,
                passwordConfirm: s
            }
        };
        return r = $60b04fb58fc41388$var$normalizeLegacyOptionsArgs("This form of confirmPasswordReset(token, password, passwordConfirm, body?, query?) is deprecated. Consider replacing it with confirmPasswordReset(token, password, passwordConfirm, options?).", r, i, n), this.client.send(this.baseCollectionPath + "/confirm-password-reset", r).then(()=>!0);
    }
    async requestVerification(e, t, s) {
        let i = {
            method: "POST",
            body: {
                email: e
            }
        };
        return i = $60b04fb58fc41388$var$normalizeLegacyOptionsArgs("This form of requestVerification(email, body?, query?) is deprecated. Consider replacing it with requestVerification(email, options?).", i, t, s), this.client.send(this.baseCollectionPath + "/request-verification", i).then(()=>!0);
    }
    async confirmVerification(e, t, s) {
        let i = {
            method: "POST",
            body: {
                token: e
            }
        };
        return i = $60b04fb58fc41388$var$normalizeLegacyOptionsArgs("This form of confirmVerification(token, body?, query?) is deprecated. Consider replacing it with confirmVerification(token, options?).", i, t, s), this.client.send(this.baseCollectionPath + "/confirm-verification", i).then(()=>{
            const t = $60b04fb58fc41388$export$26ddc56bc995240a(e), s = this.client.authStore.record;
            return s && !s.verified && s.id === t.id && s.collectionId === t.collectionId && (s.verified = !0, this.client.authStore.save(this.client.authStore.token, s)), !0;
        });
    }
    async requestEmailChange(e, t, s) {
        let i = {
            method: "POST",
            body: {
                newEmail: e
            }
        };
        return i = $60b04fb58fc41388$var$normalizeLegacyOptionsArgs("This form of requestEmailChange(newEmail, body?, query?) is deprecated. Consider replacing it with requestEmailChange(newEmail, options?).", i, t, s), this.client.send(this.baseCollectionPath + "/request-email-change", i).then(()=>!0);
    }
    async confirmEmailChange(e, t, s, i) {
        let n = {
            method: "POST",
            body: {
                token: e,
                password: t
            }
        };
        return n = $60b04fb58fc41388$var$normalizeLegacyOptionsArgs("This form of confirmEmailChange(token, password, body?, query?) is deprecated. Consider replacing it with confirmEmailChange(token, password, options?).", n, s, i), this.client.send(this.baseCollectionPath + "/confirm-email-change", n).then(()=>{
            const t = $60b04fb58fc41388$export$26ddc56bc995240a(e), s = this.client.authStore.record;
            return s && s.id === t.id && s.collectionId === t.collectionId && this.client.authStore.clear(), !0;
        });
    }
    async listExternalAuths(e, t) {
        return this.client.collection("_externalAuths").getFullList(Object.assign({}, t, {
            filter: this.client.filter("recordRef = {:id}", {
                id: e
            })
        }));
    }
    async unlinkExternalAuth(e, t, s) {
        const i = await this.client.collection("_externalAuths").getFirstListItem(this.client.filter("recordRef = {:recordId} && provider = {:provider}", {
            recordId: e,
            provider: t
        }));
        return this.client.collection("_externalAuths").delete(i.id, s).then(()=>!0);
    }
    async requestOTP(e, t) {
        return t = Object.assign({
            method: "POST",
            body: {
                email: e
            }
        }, t), this.client.send(this.baseCollectionPath + "/request-otp", t);
    }
    async authWithOTP(e, t, s) {
        return s = Object.assign({
            method: "POST",
            body: {
                otpId: e,
                password: t
            }
        }, s), this.client.send(this.baseCollectionPath + "/auth-with-otp", s).then((e)=>this.authResponse(e));
    }
    async impersonate(e, t, s) {
        (s = Object.assign({
            method: "POST",
            body: {
                duration: t
            }
        }, s)).headers = s.headers || {}, s.headers.Authorization || (s.headers.Authorization = this.client.authStore.token);
        const i = new $60b04fb58fc41388$export$2e2bcd8739ae039(this.client.baseURL, new $60b04fb58fc41388$export$68a044b9d3f6e888, this.client.lang), n = await i.send(this.baseCollectionPath + "/impersonate/" + encodeURIComponent(e), s);
        return i.authStore.save(n?.token, this.decode(n?.record || {})), i;
    }
    _replaceQueryParams(e, t = {}) {
        let s = e, i = "";
        e.indexOf("?") >= 0 && (s = e.substring(0, e.indexOf("?")), i = e.substring(e.indexOf("?") + 1));
        const n = {}, r = i.split("&");
        for (const e of r){
            if ("" == e) continue;
            const t = e.split("=");
            n[decodeURIComponent(t[0].replace(/\+/g, " "))] = decodeURIComponent((t[1] || "").replace(/\+/g, " "));
        }
        for(let e in t)t.hasOwnProperty(e) && (null == t[e] ? delete n[e] : n[e] = t[e]);
        i = "";
        for(let e in n)n.hasOwnProperty(e) && ("" != i && (i += "&"), i += encodeURIComponent(e.replace(/%20/g, "+")) + "=" + encodeURIComponent(n[e].replace(/%20/g, "+")));
        return "" != i ? s + "?" + i : s;
    }
}
function $60b04fb58fc41388$var$openBrowserPopup(e) {
    if ("undefined" == typeof window || !window?.open) throw new $60b04fb58fc41388$export$dcaf143e197b2cd2(new Error("Not in a browser context - please pass a custom urlCallback function."));
    let t = 1024, s = 768, i = window.innerWidth, n = window.innerHeight;
    t = t > i ? i : t, s = s > n ? n : s;
    let r = i / 2 - t / 2, o = n / 2 - s / 2;
    return window.open(e, "popup_window", "width=" + t + ",height=" + s + ",top=" + o + ",left=" + r + ",resizable,menubar=no");
}
class $60b04fb58fc41388$export$133889e600929275 extends $60b04fb58fc41388$export$d8ebe4a1f8b281ca {
    get baseCrudPath() {
        return "/api/collections";
    }
    async import(e, t = !1, s) {
        return s = Object.assign({
            method: "PUT",
            body: {
                collections: e,
                deleteMissing: t
            }
        }, s), this.client.send(this.baseCrudPath + "/import", s).then(()=>!0);
    }
    async truncate(e, t) {
        return t = Object.assign({
            method: "DELETE"
        }, t), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e) + "/truncate", t).then(()=>!0);
    }
    async getScaffolds(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send(this.baseCrudPath + "/meta/scaffolds", e);
    }
    async getAllOAuth2Providers(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send(this.baseCrudPath + "/meta/oauth2-providers", e);
    }
    async dryRunViewQuery(e, t) {
        return t = Object.assign({
            method: "POST",
            body: {
                query: e
            }
        }, t), this.client.send(this.baseCrudPath + "/meta/dry-run-view", t);
    }
}
class $60b04fb58fc41388$export$e2c5c1c0df6e287f extends $60b04fb58fc41388$var$BaseService {
    async getList(e = 1, t = 30, s) {
        return (s = Object.assign({
            method: "GET"
        }, s)).query = Object.assign({
            page: e,
            perPage: t
        }, s.query), this.client.send("/api/logs", s);
    }
    async getOne(e, t) {
        if (!e) throw new $60b04fb58fc41388$export$dcaf143e197b2cd2({
            url: this.client.buildURL("/api/logs/"),
            status: 404,
            response: {
                code: 404,
                message: "Missing required log id.",
                data: {}
            }
        });
        return t = Object.assign({
            method: "GET"
        }, t), this.client.send("/api/logs/" + encodeURIComponent(e), t);
    }
    async getStats(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/logs/stats", e);
    }
}
class $60b04fb58fc41388$export$4fba2293eb4aeaad extends $60b04fb58fc41388$var$BaseService {
    async check(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/health", e);
    }
}
class $60b04fb58fc41388$var$FileService extends $60b04fb58fc41388$var$BaseService {
    getUrl(e, t, s = {}) {
        return console.warn("Please replace pb.files.getUrl() with pb.files.getURL()"), this.getURL(e, t, s);
    }
    getURL(e, t, s = {}) {
        if (!t || !e?.id || !e?.collectionId && !e?.collectionName) return "";
        const i = [];
        i.push("api"), i.push("files"), i.push(encodeURIComponent(e.collectionId || e.collectionName)), i.push(encodeURIComponent(e.id)), i.push(encodeURIComponent(t));
        let n = this.client.buildURL(i.join("/"));
        !1 === s.download && delete s.download;
        const r = $60b04fb58fc41388$export$a2e7490059781fcf(s);
        return r && (n += (n.includes("?") ? "&" : "?") + r), n;
    }
    async getToken(e) {
        return e = Object.assign({
            method: "POST"
        }, e), this.client.send("/api/files/token", e).then((e)=>e?.token || "");
    }
}
class $60b04fb58fc41388$var$BackupService extends $60b04fb58fc41388$var$BaseService {
    async getFullList(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/backups", e);
    }
    async create(e, t) {
        return t = Object.assign({
            method: "POST",
            body: {
                name: e
            }
        }, t), this.client.send("/api/backups", t).then(()=>!0);
    }
    async upload(e, t) {
        return t = Object.assign({
            method: "POST",
            body: e
        }, t), this.client.send("/api/backups/upload", t).then(()=>!0);
    }
    async delete(e, t) {
        return t = Object.assign({
            method: "DELETE"
        }, t), this.client.send(`/api/backups/${encodeURIComponent(e)}`, t).then(()=>!0);
    }
    async restore(e, t) {
        return t = Object.assign({
            method: "POST"
        }, t), this.client.send(`/api/backups/${encodeURIComponent(e)}/restore`, t).then(()=>!0);
    }
    getDownloadUrl(e, t) {
        return console.warn("Please replace pb.backups.getDownloadUrl() with pb.backups.getDownloadURL()"), this.getDownloadURL(e, t);
    }
    getDownloadURL(e, t) {
        return this.client.buildURL(`/api/backups/${encodeURIComponent(t)}?token=${encodeURIComponent(e)}`);
    }
}
class $60b04fb58fc41388$var$CronService extends $60b04fb58fc41388$var$BaseService {
    async getFullList(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/crons", e);
    }
    async run(e, t) {
        return t = Object.assign({
            method: "POST"
        }, t), this.client.send(`/api/crons/${encodeURIComponent(e)}`, t).then(()=>!0);
    }
}
class $60b04fb58fc41388$var$SQLService extends $60b04fb58fc41388$var$BaseService {
    async run(e, t) {
        return t = Object.assign({
            method: "POST",
            body: {
                query: e
            }
        }, t), this.client.send("/api/sql", t);
    }
}
function $60b04fb58fc41388$var$isFile(e) {
    return "undefined" != typeof Blob && e instanceof Blob || "undefined" != typeof File && e instanceof File || null !== e && "object" == typeof e && e.uri && ("undefined" != typeof navigator && "ReactNative" === navigator.product || "undefined" != typeof $parcel$global && $parcel$global.HermesInternal);
}
function $60b04fb58fc41388$var$isFormData(e) {
    return e && ("FormData" === e.constructor?.name || "undefined" != typeof FormData && e instanceof FormData);
}
function $60b04fb58fc41388$var$hasFileField(e) {
    for(const t in e){
        const s = Array.isArray(e[t]) ? e[t] : [
            e[t]
        ];
        for (const e of s)if ($60b04fb58fc41388$var$isFile(e)) return !0;
    }
    return !1;
}
const $60b04fb58fc41388$var$r = /^[\-\.\d]+$/;
function $60b04fb58fc41388$var$inferFormDataValue(e) {
    if ("string" != typeof e) return e;
    if ("true" == e) return !0;
    if ("false" == e) return !1;
    if (("-" === e[0] || e[0] >= "0" && e[0] <= "9") && $60b04fb58fc41388$var$r.test(e)) {
        let t = +e;
        if ("" + t === e) return t;
    }
    return e;
}
class $60b04fb58fc41388$export$c161353d28232608 extends $60b04fb58fc41388$var$BaseService {
    constructor(){
        super(...arguments), this.requests = [], this.subs = {};
    }
    collection(e) {
        return this.subs[e] || (this.subs[e] = new $60b04fb58fc41388$export$a17dc285df58a3a1(this.requests, e)), this.subs[e];
    }
    async send(e) {
        const t = new FormData, s = [];
        for(let e = 0; e < this.requests.length; e++){
            const i = this.requests[e];
            if (s.push({
                method: i.method,
                url: i.url,
                headers: i.headers,
                body: i.json
            }), i.files) for(let s in i.files){
                const n = i.files[s] || [];
                for (let i of n)t.append("requests." + e + "." + s, i);
            }
        }
        return t.append("@jsonPayload", JSON.stringify({
            requests: s
        })), e = Object.assign({
            method: "POST",
            body: t
        }, e), this.client.send("/api/batch", e);
    }
}
class $60b04fb58fc41388$export$a17dc285df58a3a1 {
    constructor(e, t){
        this.requests = [], this.requests = e, this.collectionIdOrName = t;
    }
    upsert(e, t) {
        t = Object.assign({
            body: e || {}
        }, t);
        const s = {
            method: "PUT",
            url: "/api/collections/" + encodeURIComponent(this.collectionIdOrName) + "/records"
        };
        this.prepareRequest(s, t), this.requests.push(s);
    }
    create(e, t) {
        t = Object.assign({
            body: e || {}
        }, t);
        const s = {
            method: "POST",
            url: "/api/collections/" + encodeURIComponent(this.collectionIdOrName) + "/records"
        };
        this.prepareRequest(s, t), this.requests.push(s);
    }
    update(e, t, s) {
        s = Object.assign({
            body: t || {}
        }, s);
        const i = {
            method: "PATCH",
            url: "/api/collections/" + encodeURIComponent(this.collectionIdOrName) + "/records/" + encodeURIComponent(e)
        };
        this.prepareRequest(i, s), this.requests.push(i);
    }
    delete(e, t) {
        t = Object.assign({}, t);
        const s = {
            method: "DELETE",
            url: "/api/collections/" + encodeURIComponent(this.collectionIdOrName) + "/records/" + encodeURIComponent(e)
        };
        this.prepareRequest(s, t), this.requests.push(s);
    }
    prepareRequest(e, t) {
        if ($60b04fb58fc41388$export$d4eab50bd87f5014(t), e.headers = t.headers, e.json = {}, e.files = {}, void 0 !== t.query) {
            const s = $60b04fb58fc41388$export$a2e7490059781fcf(t.query);
            s && (e.url += (e.url.includes("?") ? "&" : "?") + s);
        }
        let s = t.body;
        $60b04fb58fc41388$var$isFormData(s) && (s = function convertFormDataToObject(e) {
            let t = {};
            return e.forEach((e, s)=>{
                if ("@jsonPayload" === s && "string" == typeof e) try {
                    let s = JSON.parse(e);
                    Object.assign(t, s);
                } catch (e) {
                    console.warn("@jsonPayload error:", e);
                }
                else void 0 !== t[s] ? (Array.isArray(t[s]) || (t[s] = [
                    t[s]
                ]), t[s].push($60b04fb58fc41388$var$inferFormDataValue(e))) : t[s] = $60b04fb58fc41388$var$inferFormDataValue(e);
            }), t;
        }(s));
        for(const t in s){
            const i = s[t];
            if ($60b04fb58fc41388$var$isFile(i)) e.files[t] = e.files[t] || [], e.files[t].push(i);
            else if (Array.isArray(i)) {
                const s = [], n = [];
                for (const e of i)$60b04fb58fc41388$var$isFile(e) ? s.push(e) : n.push(e);
                if (s.length > 0 && s.length == i.length) {
                    e.files[t] = e.files[t] || [];
                    for (let i of s)e.files[t].push(i);
                } else if (e.json[t] = n, s.length > 0) {
                    let i = t;
                    t.startsWith("+") || t.endsWith("+") || (i += "+"), e.files[i] = e.files[i] || [];
                    for (let t of s)e.files[i].push(t);
                }
            } else e.json[t] = i;
        }
    }
}
class $60b04fb58fc41388$export$2e2bcd8739ae039 {
    get baseUrl() {
        return this.baseURL;
    }
    set baseUrl(e) {
        this.baseURL = e;
    }
    constructor(e = "/", t, s = "en-US"){
        this.cancelControllers = {}, this.recordServices = {}, this.enableAutoCancellation = !0, this.baseURL = e, this.lang = s, t ? this.authStore = t : "undefined" != typeof window && window.Deno ? this.authStore = new $60b04fb58fc41388$export$68a044b9d3f6e888 : this.authStore = new $60b04fb58fc41388$export$6439a4b85bcd7f5d, this.collections = new $60b04fb58fc41388$export$133889e600929275(this), this.files = new $60b04fb58fc41388$var$FileService(this), this.logs = new $60b04fb58fc41388$export$e2c5c1c0df6e287f(this), this.settings = new $60b04fb58fc41388$var$SettingsService(this), this.realtime = new $60b04fb58fc41388$export$94618cb2db738d0c(this), this.health = new $60b04fb58fc41388$export$4fba2293eb4aeaad(this), this.backups = new $60b04fb58fc41388$var$BackupService(this), this.crons = new $60b04fb58fc41388$var$CronService(this), this.sql = new $60b04fb58fc41388$var$SQLService(this);
    }
    get admins() {
        return this.collection("_superusers");
    }
    createBatch() {
        return new $60b04fb58fc41388$export$c161353d28232608(this);
    }
    collection(e) {
        return this.recordServices[e] || (this.recordServices[e] = new $60b04fb58fc41388$export$1b7d28e1ebf40328(this, e)), this.recordServices[e];
    }
    autoCancellation(e) {
        return this.enableAutoCancellation = !!e, this;
    }
    cancelRequest(e) {
        return this.cancelControllers[e] && (this.cancelControllers[e].abort(), delete this.cancelControllers[e]), this;
    }
    cancelAllRequests() {
        for(let e in this.cancelControllers)this.cancelControllers[e].abort();
        return this.cancelControllers = {}, this;
    }
    filter(e, t) {
        if (!t) return e;
        for(let s in t){
            let i = t[s];
            switch(typeof i){
                case "boolean":
                case "number":
                    i = "" + i;
                    break;
                case "string":
                    i = "'" + i.replace(/'/g, "\\'") + "'";
                    break;
                default:
                    i = null === i ? "null" : i instanceof Date ? "'" + i.toISOString().replace("T", " ") + "'" : "'" + JSON.stringify(i).replace(/'/g, "\\'") + "'";
            }
            e = e.replaceAll("{:" + s + "}", i);
        }
        return e;
    }
    getFileUrl(e, t, s = {}) {
        return console.warn("Please replace pb.getFileUrl() with pb.files.getURL()"), this.files.getURL(e, t, s);
    }
    buildUrl(e) {
        return console.warn("Please replace pb.buildUrl() with pb.buildURL()"), this.buildURL(e);
    }
    buildURL(e) {
        let t = this.baseURL;
        return "undefined" == typeof window || !window.location || t.startsWith("https://") || t.startsWith("http://") || (t = window.location.origin?.endsWith("/") ? window.location.origin.substring(0, window.location.origin.length - 1) : window.location.origin || "", this.baseURL.startsWith("/") || (t += window.location.pathname || "/", t += t.endsWith("/") ? "" : "/"), t += this.baseURL), e && (t += t.endsWith("/") ? "" : "/", t += e.startsWith("/") ? e.substring(1) : e), t;
    }
    async send(e, t) {
        t = this.initSendOptions(e, t);
        let s = this.buildURL(e);
        if (this.beforeSend) {
            const e = Object.assign({}, await this.beforeSend(s, t));
            void 0 !== e.url || void 0 !== e.options ? (s = e.url || s, t = e.options || t) : Object.keys(e).length && (t = e, console?.warn && console.warn("Deprecated format of beforeSend return: please use `return { url, options }`, instead of `return options`."));
        }
        if (void 0 !== t.query) {
            const e = $60b04fb58fc41388$export$a2e7490059781fcf(t.query);
            e && (s += (s.includes("?") ? "&" : "?") + e), delete t.query;
        }
        "application/json" == this.getHeader(t.headers, "Content-Type") && t.body && "string" != typeof t.body && (t.body = JSON.stringify(t.body));
        return (t.fetch || fetch)(s, t).then(async (e)=>{
            let s = {};
            try {
                s = await e.json();
            } catch (e) {
                if (t.signal?.aborted || "AbortError" == e?.name || "Aborted" == e?.message) throw e;
            }
            if (this.afterSend && (s = await this.afterSend(e, s, t)), e.status >= 400) throw new $60b04fb58fc41388$export$dcaf143e197b2cd2({
                url: e.url,
                status: e.status,
                data: s
            });
            return s;
        }).catch((e)=>{
            throw new $60b04fb58fc41388$export$dcaf143e197b2cd2(e);
        });
    }
    initSendOptions(e, t) {
        if ((t = Object.assign({
            method: "GET"
        }, t)).body = function convertToFormDataIfNeeded(e) {
            if ("undefined" == typeof FormData || void 0 === e || "object" != typeof e || null === e || $60b04fb58fc41388$var$isFormData(e) || !$60b04fb58fc41388$var$hasFileField(e)) return e;
            const t = new FormData;
            for(const s in e){
                const i = e[s];
                if (void 0 !== i) {
                    if ("object" != typeof i || $60b04fb58fc41388$var$hasFileField({
                        data: i
                    })) {
                        const e = Array.isArray(i) ? i : [
                            i
                        ];
                        for (let i of e)t.append(s, i);
                    } else {
                        let e = {};
                        e[s] = i, t.append("@jsonPayload", JSON.stringify(e));
                    }
                }
            }
            return t;
        }(t.body), $60b04fb58fc41388$export$d4eab50bd87f5014(t), t.query = Object.assign({}, t.params, t.query), void 0 === t.requestKey && (!1 === t.$autoCancel || !1 === t.query.$autoCancel ? t.requestKey = null : (t.$cancelKey || t.query.$cancelKey) && (t.requestKey = t.$cancelKey || t.query.$cancelKey)), delete t.$autoCancel, delete t.query.$autoCancel, delete t.$cancelKey, delete t.query.$cancelKey, null !== this.getHeader(t.headers, "Content-Type") || $60b04fb58fc41388$var$isFormData(t.body) || (t.headers = Object.assign({}, t.headers, {
            "Content-Type": "application/json"
        })), null === this.getHeader(t.headers, "Accept-Language") && (t.headers = Object.assign({}, t.headers, {
            "Accept-Language": this.lang
        })), this.authStore.token && null === this.getHeader(t.headers, "Authorization") && (t.headers = Object.assign({}, t.headers, {
            Authorization: this.authStore.token
        })), this.enableAutoCancellation && null !== t.requestKey) {
            const s = t.requestKey || (t.method || "GET") + e;
            delete t.requestKey, this.cancelRequest(s);
            const i = new AbortController;
            this.cancelControllers[s] = i, t.signal = i.signal;
        }
        return t;
    }
    getHeader(e, t) {
        e = e || {}, t = t.toLowerCase();
        for(let s in e)if (s.toLowerCase() == t) return e[s];
        return null;
    }
}
class $60b04fb58fc41388$export$c94662ed41386ffd extends $60b04fb58fc41388$export$68a044b9d3f6e888 {
    constructor(e){
        super(), this.queue = [], this.saveFunc = e.save, this.clearFunc = e.clear, this._enqueue(()=>this._loadInitial(e.initial));
    }
    save(e, t) {
        super.save(e, t);
        let s = "";
        try {
            s = JSON.stringify({
                token: e,
                record: t
            });
        } catch (e) {
            console.warn("AsyncAuthStore: failed to stringify the new state");
        }
        this._enqueue(()=>this.saveFunc(s));
    }
    clear() {
        super.clear(), this.clearFunc ? this._enqueue(()=>this.clearFunc()) : this._enqueue(()=>this.saveFunc(""));
    }
    async _loadInitial(e) {
        try {
            if (e = await e) {
                let t;
                "string" == typeof e ? t = JSON.parse(e) || {} : "object" == typeof e && (t = e), this.save(t.token || "", t.record || t.model || null);
            }
        } catch (e) {}
    }
    _enqueue(e) {
        this.queue.push(e), 1 == this.queue.length && this._dequeue();
    }
    _dequeue() {
        this.queue.length && this.queue[0]().finally(()=>{
            this.queue.shift(), this.queue.length && this._dequeue();
        });
    }
}


/**
 * Logtail library options
 */ var $f5843436022d14b5$export$243e62d78d3b544d;
(function(LogLevel) {
    // core log levels - available as functions
    LogLevel["Error"] = "error";
    LogLevel["Warn"] = "warn";
    LogLevel["Info"] = "info";
    LogLevel["Debug"] = "debug";
    // extra log levels - recognized when passed from logging frameworks
    LogLevel["Fatal"] = "fatal";
    LogLevel["Http"] = "http";
    LogLevel["Verbose"] = "verbose";
    LogLevel["Silly"] = "silly";
    LogLevel["Trace"] = "trace";
})($f5843436022d14b5$export$243e62d78d3b544d || ($f5843436022d14b5$export$243e62d78d3b544d = {}));


/*
 * Default buffer size
 */ const $d3bd8c096af54dcc$var$DEFAULT_BUFFER_SIZE = 1000;
/*
 * Default flush timeout
 */ const $d3bd8c096af54dcc$var$DEFAULT_FLUSH_TIMEOUT = 1000;
/*
 * Default retry count
 */ const $d3bd8c096af54dcc$var$DEFAULT_RETRY_COUNT = 3;
/*
 * Default retry backoff
 */ const $d3bd8c096af54dcc$var$DEFAULT_RETRY_BACKOFF = 100;
const $d3bd8c096af54dcc$export$a8bbed3c2f27a07 = (log)=>JSON.stringify(log).length + 1;
function $d3bd8c096af54dcc$export$2e2bcd8739ae039(size = $d3bd8c096af54dcc$var$DEFAULT_BUFFER_SIZE, flushTimeout = $d3bd8c096af54dcc$var$DEFAULT_FLUSH_TIMEOUT, retryCount = $d3bd8c096af54dcc$var$DEFAULT_RETRY_COUNT, retryBackoff = $d3bd8c096af54dcc$var$DEFAULT_RETRY_BACKOFF, sizeBytes = 0, calculateLogSizeBytes = $d3bd8c096af54dcc$export$a8bbed3c2f27a07) {
    let timeout;
    let cb;
    let buffer = [];
    let bufferSizeBytes = 0;
    let retry = 0;
    // Wait until the minimum retry backoff time has passed before retrying
    let minRetryBackoff = 0;
    /*
     * Process then flush the list
     */ async function flush() {
        if (timeout) clearTimeout(timeout);
        timeout = null;
        const currentBuffer = buffer;
        const currentBufferSizeKB = bufferSizeBytes;
        buffer = [];
        bufferSizeBytes = 0;
        try {
            await cb(currentBuffer.map((d)=>d.log));
            currentBuffer.forEach((d)=>d.resolve(d.log));
            retry = 0;
        } catch (e) {
            if (retry < retryCount) {
                retry++;
                minRetryBackoff = Date.now() + retryBackoff;
                buffer = buffer.concat(currentBuffer);
                bufferSizeBytes += currentBufferSizeKB;
                await setupTimeout();
                return;
            }
            currentBuffer.map((d)=>d.reject(e));
            retry = 0;
        }
    }
    /*
     * Start timeout to flush
     */ async function setupTimeout() {
        if (timeout) return;
        return new Promise((resolve)=>{
            timeout = setTimeout(async function() {
                await flush();
                resolve();
            }, flushTimeout);
        });
    }
    /*
     * Batcher which takes a process function
     * @param fn - Any function to process list
     */ return {
        initPusher: function(fn) {
            cb = fn;
            /*
             * Pushes each log into list
             * @param log: ILogtailLog - Any object to push into list
             */ return async function(log) {
                return new Promise(async (resolve, reject)=>{
                    buffer.push({
                        log: log,
                        resolve: resolve,
                        reject: reject
                    });
                    // We can skip log size calculation if there is no max size set
                    if (sizeBytes > 0) bufferSizeBytes += calculateLogSizeBytes(log);
                    // If the buffer is full enough, flush it
                    // Unless we're still waiting for the minimum retry backoff time
                    const isBufferFullEnough = buffer.length >= size || sizeBytes > 0 && bufferSizeBytes >= sizeBytes;
                    if (isBufferFullEnough && Date.now() > minRetryBackoff) await flush();
                    else await setupTimeout();
                    return resolve;
                });
            };
        },
        flush: flush
    };
}

const $6f7efb35372c7a9a$var$RESOLUTION = 64;
function $6f7efb35372c7a9a$export$2e2bcd8739ae039(milliseconds, max, functionName = "The function") {
    if (milliseconds <= 0 || max <= 0) return (fn)=>fn;
    let callCounts = [
        0
    ];
    let lastErrorOutput = 0;
    let lastIntervalTime = Date.now();
    function updateCallCounts() {
        const now = Date.now();
        const intervalLength = milliseconds / $6f7efb35372c7a9a$var$RESOLUTION;
        if (now < lastIntervalTime + intervalLength) return;
        // Prepend callCounts with correct number of zeroes and keep its length to RESOLUTION at max
        const intervalCountSinceLast = Math.floor((now - lastIntervalTime) / intervalLength);
        callCounts = Array(Math.min(intervalCountSinceLast, $6f7efb35372c7a9a$var$RESOLUTION)).fill(0).concat(callCounts).slice(0, $6f7efb35372c7a9a$var$RESOLUTION);
        lastIntervalTime += intervalCountSinceLast * intervalLength;
    }
    function getTotalCallCount() {
        return callCounts.reduce((total, item)=>total + item);
    }
    function incrementCallCount() {
        callCounts[0]++;
    }
    return (fn)=>{
        return async (...args)=>{
            updateCallCounts();
            if (getTotalCallCount() < max) {
                incrementCallCount();
                return await fn(...args);
            }
            const now = Date.now();
            if (lastErrorOutput < now - milliseconds) {
                lastErrorOutput = now;
                console.error(`${functionName} was called more than ${max} times during last ${milliseconds}ms. Ignoring.`);
            }
        };
    };
}

/**
 * Queue, for FIFO access to arbitrary objects. Intended to be a faster
 * replacement for a Javascript array.
 */ class $945eb74b408d68a7$export$2e2bcd8739ae039 {
    constructor(){
        /**
         * First node in the tree
         */ /**
         * Number of items in the queue
         */ this.length = 0;
    }
    /**
     * Pushes a value into the queue.
     * @param value - Any object to push into the queue
     */ push(value) {
        const node = {
            value: value
        };
        this.last = this.last ? this.last.next = node : this.first = node;
        this.length++;
    }
    /**
     * Remove a value from the start of the queue (FIFO) and return it
     */ shift() {
        if (this.first) {
            const { value: value } = this.first;
            this.first = this.first.next;
            if (!--this.length) this.last = undefined;
            return value;
        }
    }
}


function $01fc09a963746757$export$2e2bcd8739ae039(max, queueMax = -1) {
    // Current iteration cycle
    let current = 0;
    // Create a FIFO queue
    const queue = new (0, $945eb74b408d68a7$export$2e2bcd8739ae039)();
    /**
     * Throttle function that throttles the passed func according to `max`
     * @param fn - async function to resolve
     */ function throttle(fn) {
        return async (...args)=>{
            return new Promise((resolve, reject)=>{
                /**
                 * Handler for resolving the Promise chain
                 */ async function handler() {
                    // Only resolve if the `max` hasn't been exhausted
                    if (current < max) {
                        // Increment the available slot size
                        current++;
                        try {
                            // Await the passed function here first, to determine if any
                            // errors are thrown, so they can be handled by our outside `reject`
                            resolve(await fn(...args));
                        } catch (e) {
                            reject(e);
                        }
                        // Since this has now resolved, make the slot available again
                        current--;
                        // If there are items waiting in the queue, resolve the next
                        // Promise
                        if (queue.length > 0) queue.shift()();
                    } else if (queueMax < 0 || queue.length < queueMax) // The `max` has been exceeded and if queue limit hasn't been hit - push onto the queue to wait
                    queue.push(handler);
                    else {
                        // Reject this call due to queue limit
                        reject(new Error("Queue max limit exceeded"));
                        return;
                    }
                }
                // Return the async handler
                return handler();
            });
        };
    }
    // Return the throttle function
    return throttle;
}


var $40942cc54f276662$exports = {};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
'use strict';
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
'use strict';
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $034686670a8a195b$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup['-'.charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup['_'.charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
var $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        var len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        var buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d4ecdbf520e63dca$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case 'base64':
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $034686670a8a195b$export$6100ba28696e12de(buf);
    else return $034686670a8a195b$export$6100ba28696e12de(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $034686670a8a195b$export$d622b2ad8d90c771($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $40942cc54f276662$require$Buffer = $d4ecdbf520e63dca$export$a143d493d941bafc;
'use strict';
class $40942cc54f276662$var$NonError extends Error {
    constructor(message){
        super($40942cc54f276662$var$NonError._prepareSuperMessage(message));
        Object.defineProperty(this, 'name', {
            value: 'NonError',
            configurable: true,
            writable: true
        });
        if (Error.captureStackTrace) Error.captureStackTrace(this, $40942cc54f276662$var$NonError);
    }
    static _prepareSuperMessage(message) {
        try {
            return JSON.stringify(message);
        } catch  {
            return String(message);
        }
    }
}
const $40942cc54f276662$var$commonProperties = [
    {
        property: 'name',
        enumerable: false
    },
    {
        property: 'message',
        enumerable: false
    },
    {
        property: 'stack',
        enumerable: false
    },
    {
        property: 'code',
        enumerable: true
    }
];
const $40942cc54f276662$var$isCalled = Symbol('.toJSON called');
const $40942cc54f276662$var$toJSON = (from)=>{
    from[$40942cc54f276662$var$isCalled] = true;
    const json = from.toJSON();
    delete from[$40942cc54f276662$var$isCalled];
    return json;
};
const $40942cc54f276662$var$destroyCircular = ({ from: from, seen: seen, to_: to_, forceEnumerable: forceEnumerable, maxDepth: maxDepth, depth: depth })=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    if (depth >= maxDepth) return to;
    if (typeof from.toJSON === 'function' && from[$40942cc54f276662$var$isCalled] !== true) return $40942cc54f276662$var$toJSON(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof $40942cc54f276662$require$Buffer === 'function' && $40942cc54f276662$require$Buffer.isBuffer(value)) {
            to[key] = '[object Buffer]';
            continue;
        }
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            depth++;
            to[key] = $40942cc54f276662$var$destroyCircular({
                from: from[key],
                seen: seen.slice(),
                forceEnumerable: forceEnumerable,
                maxDepth: maxDepth,
                depth: depth
            });
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const { property: property, enumerable: enumerable } of $40942cc54f276662$var$commonProperties)if (typeof from[property] === 'string') Object.defineProperty(to, property, {
        value: from[property],
        enumerable: forceEnumerable ? true : enumerable,
        configurable: true,
        writable: true
    });
    return to;
};
const $40942cc54f276662$var$serializeError = (value, options = {})=>{
    const { maxDepth: maxDepth = Number.POSITIVE_INFINITY } = options;
    if (typeof value === 'object' && value !== null) return $40942cc54f276662$var$destroyCircular({
        from: value,
        seen: [],
        forceEnumerable: true,
        maxDepth: maxDepth,
        depth: 0
    });
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $40942cc54f276662$var$deserializeError = (value, options = {})=>{
    const { maxDepth: maxDepth = Number.POSITIVE_INFINITY } = options;
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error(); // eslint-disable-line unicorn/error-message
        $40942cc54f276662$var$destroyCircular({
            from: value,
            seen: [],
            to_: newError,
            maxDepth: maxDepth,
            depth: 0
        });
        return newError;
    }
    return new $40942cc54f276662$var$NonError(value);
};
$40942cc54f276662$exports = {
    serializeError: $40942cc54f276662$var$serializeError,
    deserializeError: $40942cc54f276662$var$deserializeError
};


// Set default options for Logtail
const $3229095391eb793d$var$defaultOptions = {
    // Default sync endpoint (protocol + domain)
    endpoint: "https://in.logs.betterstack.com",
    // Maximum number of logs to sync in a single request to Better Stack
    batchSize: 1000,
    // Size of logs (in KiB) to trigger sync to Better Stack (0 to disable)
    batchSizeKiB: 0,
    // Max interval (in milliseconds) before a batch of logs proceeds to syncing
    batchInterval: 1000,
    // Maximum number of times to retry a failed sync request
    retryCount: 3,
    // Minimum number of milliseconds to wait before retrying a failed sync request
    retryBackoff: 100,
    // Maximum number of sync requests to make concurrently
    syncMax: 5,
    // Maximum number of sync requests that can be queued (-1 for unlimited queue)
    syncQueuedMax: 100,
    // Length of the checked window for logs burst protection in milliseconds (0 to disable)
    burstProtectionMilliseconds: 5000,
    // Maximum number of accepted logs in the specified time window (0 to disable)
    burstProtectionMax: 10000,
    // If true, errors when sending logs will be ignored
    // Has precedence over throwExceptions
    ignoreExceptions: false,
    // If true, errors when sending logs will result in a thrown exception
    throwExceptions: false,
    // Maximum depth (number of attribute levels) of a context object
    contextObjectMaxDepth: 50,
    // Produce a warn log when context object max depth is reached
    contextObjectMaxDepthWarn: true,
    // Produce a warning when circular reference is found in context object
    contextObjectCircularRefWarn: true,
    // If true, all logs will be sent to standard console output functions (console.info, console.warn, ...)
    sendLogsToConsoleOutput: false,
    // If true, all logs will be sent to Better Stack
    sendLogsToBetterStack: true,
    // Function to be used to calculate size of logs in bytes (to evaluate batchSizeLimitKiB)
    calculateLogSizeBytes: (0, $d3bd8c096af54dcc$export$a8bbed3c2f27a07),
    // If true, stack context (file, line, method) will be captured on each log entry
    captureStackContext: true
};
/**
 * Logtail core class for logging to the Better Stack service
 */ class $3229095391eb793d$var$Logtail {
    /* CONSTRUCTOR */ /**
     * Initializes a new Logtail instance
     *
     * @param sourceToken: string - Private source token for logging to Better Stack
     * @param options?: ILogtailOptions - Optionally specify Logtail options
     */ constructor(sourceToken, options){
        // Middleware
        this._middleware = [];
        // Number of logs logged
        this._countLogged = 0;
        // Number of logs successfully synced with Logtail
        this._countSynced = 0;
        // Number of logs that failed to be synced to Logtail
        this._countDropped = 0;
        // First, check we have a valid source token
        if (typeof sourceToken !== "string" || sourceToken === "") throw new Error("Logtail source token missing");
        // Store the source token, to use for syncing with Better Stack
        this._sourceToken = sourceToken;
        // Merge default and user options
        this._options = Object.assign(Object.assign({}, $3229095391eb793d$var$defaultOptions), options);
        // Create a throttler, for sync operations
        const throttle = (0, $01fc09a963746757$export$2e2bcd8739ae039)(this._options.syncMax, this._options.syncQueuedMax);
        // Sync after throttling
        const throttler = throttle((logs)=>{
            return this._sync(logs);
        });
        // Burst protection for logging
        this._logBurstProtection = (0, $6f7efb35372c7a9a$export$2e2bcd8739ae039)(this._options.burstProtectionMilliseconds, this._options.burstProtectionMax, "Logging");
        this.log = this._logBurstProtection(this.log.bind(this));
        // Create a batcher, for aggregating logs by buffer size/interval
        const batcher = (0, $d3bd8c096af54dcc$export$2e2bcd8739ae039)(this._options.batchSize, this._options.batchInterval, this._options.retryCount, this._options.retryBackoff, this._options.batchSizeKiB * 1024, this._options.calculateLogSizeBytes);
        this._batch = batcher.initPusher((logs)=>{
            return throttler(logs);
        });
        this._flush = batcher.flush;
    }
    /* PUBLIC METHODS */ /**
     * Flush batched logs to Logtail
     */ async flush() {
        return this._flush();
    }
    /**
     * Number of entries logged
     *
     * @returns number
     */ get logged() {
        return this._countLogged;
    }
    /**
     * Number of log entries synced with Better Stack
     *
     * @returns number
     */ get synced() {
        return this._countSynced;
    }
    /**
     * Number of entries dropped
     *
     * @returns number
     */ get dropped() {
        return this._countDropped;
    }
    /**
     * Log an entry, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param level (LogLevel) - Level to log at (debug|info|warn|error)
     * @param context: (Context) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async log(message, level = (0, $f5843436022d14b5$export$243e62d78d3b544d).Info, context = {}) {
        // Wrap context in an object, if it's not already
        if (typeof context !== "object") {
            const wrappedContext = {
                extra: context
            };
            context = wrappedContext;
        }
        if (context instanceof Error) {
            const wrappedContext = {
                error: context
            };
            context = wrappedContext;
        }
        if (this._options.sendLogsToConsoleOutput) switch(level){
            case "debug":
                console.debug(message, context);
                break;
            case "info":
                console.info(message, context);
                break;
            case "warn":
                console.warn(message, context);
                break;
            case "error":
                console.error(message, context);
                break;
            default:
                console.log(`[${level.toUpperCase()}]`, message, context);
                break;
        }
        // Check that we have a sync function
        if (typeof this._sync !== "function") throw new Error("No Logtail logger sync function provided");
        // Increment log count
        this._countLogged++;
        // Start building the log message
        let log = Object.assign(Object.assign({
            // Implicit date timestamp
            dt: new Date(),
            level: // Explicit level
            level
        }, context), message instanceof Error ? (0, $40942cc54f276662$exports.serializeError)(message) : {
            message: message
        });
        let transformedLog = log;
        for (const middleware of this._middleware){
            let newTransformedLog = await middleware(transformedLog);
            if (newTransformedLog == null) // Don't push the log if it was filtered out in a middleware
            return transformedLog;
            transformedLog = newTransformedLog;
        }
        // Manually serialize the log data
        transformedLog = this.serialize(transformedLog, this._options.contextObjectMaxDepth);
        if (!this._options.sendLogsToBetterStack) // Return the resulting log before sending it
        return transformedLog;
        try {
            // Push the log through the batcher, and sync
            await this._batch(transformedLog);
            // Increment sync count
            this._countSynced++;
        } catch (e) {
            // Increment dropped count
            this._countDropped++;
            // Catch any errors - re-throw if `ignoreExceptions` == false
            if (!this._options.ignoreExceptions) {
                if (this._options.throwExceptions) throw e;
                else // Output to console
                console.error(e);
            }
        }
        // Return the resulting log
        return transformedLog;
    }
    serialize(value, maxDepth, visitedObjects = new WeakSet()) {
        if (value === null || typeof value === "boolean" || typeof value === "number" || typeof value === "string") return value;
        else if (value instanceof Date) {
            // Date instances can be invalid & toISOString() will fail
            if (isNaN(value.getTime())) return value.toString();
            return value.toISOString();
        } else if (value instanceof Error) return (0, $40942cc54f276662$exports.serializeError)(value);
        else if ((typeof value === "object" || Array.isArray(value)) && (maxDepth < 1 || visitedObjects.has(value))) {
            if (visitedObjects.has(value)) {
                if (this._options.contextObjectCircularRefWarn) console.warn(`[Logtail] Found a circular reference when serializing logs. Please do not use circular references in your logs.`);
                return "<omitted circular reference>";
            }
            if (this._options.contextObjectMaxDepthWarn) console.warn(`[Logtail] Max depth of ${this._options.contextObjectMaxDepth} reached when serializing logs. Please do not use excessive object depth in your logs.`);
            return `<omitted context beyond configured max depth: ${this._options.contextObjectMaxDepth}>`;
        } else if (Array.isArray(value)) {
            visitedObjects.add(value);
            const serializedArray = value.map((item)=>this.serialize(item, maxDepth - 1, visitedObjects));
            visitedObjects.delete(value);
            return serializedArray;
        } else if (typeof value === "object") {
            const serializedObject = {};
            visitedObjects.add(value);
            Object.entries(value).forEach((item)=>{
                const key = item[0];
                const value = item[1];
                const serializedValue = this.serialize(value, maxDepth - 1, visitedObjects);
                if (serializedValue !== undefined) serializedObject[key] = serializedValue;
            });
            visitedObjects.delete(value);
            return serializedObject;
        } else if (typeof value === "undefined") return undefined;
        else return `<omitted unserializable ${typeof value}>`;
    }
    /**
     *
     * Debug level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async debug(message, context = {}) {
        return this.log(message, (0, $f5843436022d14b5$export$243e62d78d3b544d).Debug, context);
    }
    /**
     *
     * Info level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async info(message, context = {}) {
        return this.log(message, (0, $f5843436022d14b5$export$243e62d78d3b544d).Info, context);
    }
    /**
     *
     * Warning level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async warn(message, context = {}) {
        return this.log(message, (0, $f5843436022d14b5$export$243e62d78d3b544d).Warn, context);
    }
    /**
     *
     * Warning level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async error(message, context = {}) {
        return this.log(message, (0, $f5843436022d14b5$export$243e62d78d3b544d).Error, context);
    }
    /**
     * Sets the sync method - i.e. the final step in the pipeline to get logs
     * over to Better Stack
     *
     * @param fn - Pipeline function to use as sync method
     */ setSync(fn) {
        this._sync = fn;
    }
    /**
     * Add a middleware function to the logging pipeline
     *
     * @param fn - Function to add to the log pipeline
     * @returns void
     */ use(fn) {
        this._middleware.push(fn);
    }
    /**
     * Remove a function from the pipeline
     *
     * @param fn - Pipeline function
     * @returns void
     */ remove(fn) {
        this._middleware = this._middleware.filter((p)=>p !== fn);
    }
}
class $3229095391eb793d$export$2e2bcd8739ae039 extends $3229095391eb793d$var$Logtail {
    async log(message, level = (0, $f5843436022d14b5$export$243e62d78d3b544d).Info, context = {}) {
        return super.log(message, level, context);
    }
}


class $7cdb33198b30337c$export$5fefc2586e00a689 extends (0, $3229095391eb793d$export$2e2bcd8739ae039) {
    constructor(sourceToken, options){
        // After reaching 48KiB, the batch will get flushed automatically to avoid 64KiB body limit for keepalive requests
        super(sourceToken, Object.assign({
            batchSizeKiB: 48
        }, options));
        // Sync function
        const sync = async (logs)=>{
            const res = await fetch(this._options.endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${this._sourceToken}`
                },
                body: JSON.stringify(logs),
                keepalive: true
            });
            if (res.ok) return logs;
            /**
             * TODO: if status is 50x throw custom ServerError
             * to be used in retry logic
             */ throw new Error(res.statusText);
        };
        // Set the throttled sync function
        this.setSync(sync);
        this.configureFlushOnPageLeave();
    }
    /**
     * Override `Base` log to add browser-specific context
     *
     * @param message: string - Log message
     * @param level (LogLevel) - Level to log at (debug|info|warn|error)
     * @param context: (Context) - Log context for passing structured data
     * @returns Promise<ILogtailLog> after syncing
     */ async log(message, level, context = {}) {
        // Wrap context in an object, if it's not already
        if (typeof context !== "object") {
            const wrappedContext = {
                extra: context
            };
            context = wrappedContext;
        }
        if (context instanceof Error) {
            const wrappedContext = {
                error: context
            };
            context = wrappedContext;
        }
        context = Object.assign(Object.assign({}, this.getCurrentContext()), context);
        return super.log(message, level, context);
    }
    getCurrentContext() {
        var _a, _b, _c;
        const context = {};
        if (typeof window !== "undefined") {
            context.url = (_a = window.location) === null || _a === void 0 ? void 0 : _a.href;
            context.device_pixel_ratio = window.devicePixelRatio;
            context.screen_width = (_b = window.screen) === null || _b === void 0 ? void 0 : _b.width;
            context.screen_height = (_c = window.screen) === null || _c === void 0 ? void 0 : _c.height;
            context.window_width = window.innerWidth;
            context.window_height = window.innerHeight;
        }
        if (typeof navigator !== "undefined") {
            context.user_locale = navigator.userLanguage || navigator.language;
            context.user_agent = navigator.userAgent;
        }
        return context;
    }
    configureFlushOnPageLeave() {
        if (typeof document === "undefined") return;
        document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "hidden") this.flush();
        });
    }
}


var $5417c7548333a287$export$2e2bcd8739ae039 = (token)=>{
    if (token && token !== "debug") return new (0, $7cdb33198b30337c$export$5fefc2586e00a689)(token);
    else if (token && token === "debug") return console;
    else return {
        log: ()=>{},
        info: ()=>{},
        warn: ()=>{},
        error: ()=>{}
    };
};


const $73c78eb17587057f$var$pb = new (0, $60b04fb58fc41388$export$2e2bcd8739ae039)("https://api.konsens.it");
const $73c78eb17587057f$var$logger = (0, $5417c7548333a287$export$2e2bcd8739ae039)("rZjUn6befD8mShdVCqpvuABM");
function $73c78eb17587057f$export$2e2bcd8739ae039(output) {
    return async (incomingMessage)=>{
        switch(incomingMessage.tag){
            case "LogError":
                $73c78eb17587057f$var$logger.error("LogError", incomingMessage.value);
                break;
            case "GetQuestion":
                {
                    let response;
                    try {
                        response = await $73c78eb17587057f$var$pb.collection("questions").getOne(incomingMessage.value, {
                            fields: "id,title,phase,author,description,created,expiresAt,proposalsEndedAt,ratingEndedAt,phaseCodePublic"
                        });
                    } catch (error) {
                        if (error.status === 404 && error?.response?.message === "The requested resource wasn't found.") {
                            output("GoToNotFound");
                            break;
                        }
                        output("ReceivedError", error?.response?.message);
                        $73c78eb17587057f$var$logger.error("GetQuestion", {
                            id: incomingMessage.value,
                            error: error
                        });
                        break;
                    }
                    let proposals, ratings;
                    try {
                        [proposals, ratings] = await Promise.all([
                            $73c78eb17587057f$var$pb.collection("proposals").getFullList({
                                fields: "id,title,description,isExcluded,questionId,created"
                            }, {
                                filter: `questionId="${incomingMessage.value}"`
                            }),
                            $73c78eb17587057f$var$pb.collection("ratings").getFullList({
                                fields: "proposalId,author,points,created"
                            }, {
                                filter: `questionId="${incomingMessage.value}"`
                            })
                        ]);
                    } catch (error) {
                        output("ReceivedError", error.message);
                        $73c78eb17587057f$var$logger.error("GetQuestion", {
                            id: incomingMessage.value,
                            error: error
                        });
                        break;
                    }
                    const { id: id, title: title, phase: phase, author: author, description: description, created: created, proposalsEndedAt: proposalsEndedAt, ratingEndedAt: ratingEndedAt, phaseCodePublic: phaseCodePublic } = response;
                    const expiresAt = $73c78eb17587057f$var$getExpiresAt(created);
                    const question = {
                        id: id,
                        title: title,
                        phase: phase,
                        author: author,
                        description: description || null,
                        createdAt: new Date(created).getTime(),
                        expiresAt: new Date(expiresAt).getTime(),
                        proposalsEndedAt: proposalsEndedAt ? new Date(proposalsEndedAt).getTime() : null,
                        ratingEndedAt: ratingEndedAt ? new Date(ratingEndedAt).getTime() : null,
                        proposals: proposals.map((proposal)=>({
                                id: proposal.id,
                                title: proposal.title,
                                description: proposal.description || null,
                                isExcluded: proposal.isExcluded,
                                questionId: proposal.questionId,
                                createdAt: new Date(proposal.created).getTime()
                            })) || [],
                        ratings: ratings.map((rating)=>({
                                proposalId: rating.proposalId || "DEFAULT",
                                author: rating.author,
                                points: rating.points,
                                createdAt: new Date(rating.created).getTime()
                            })) || [],
                        phaseCodePublic: phaseCodePublic || null
                    };
                    output("ReceivedQuestion", question);
                    break;
                }
            case "PostNewQuestion":
                {
                    const { title: submittedTitle, author: submittedAuthor, description: submittedDescription, phaseCode: submittedPhaseCode } = incomingMessage.value;
                    let phaseCode;
                    let phaseCodePublic;
                    if (submittedPhaseCode) {
                        phaseCode = await $73c78eb17587057f$var$sha256(submittedPhaseCode);
                        phaseCodePublic = await $73c78eb17587057f$var$sha256(phaseCode);
                    }
                    const data = {
                        title: submittedTitle,
                        author: submittedAuthor,
                        description: submittedDescription,
                        phase: "PROPOSAL",
                        ...phaseCodePublic && {
                            phaseCodePublic: phaseCodePublic
                        }
                    };
                    let record;
                    try {
                        record = await $73c78eb17587057f$var$pb.collection("questions").create(data);
                        if (phaseCode) await $73c78eb17587057f$var$pb.collection("phasecodes").create({
                            phasecode: phaseCode,
                            questionId: record.id
                        });
                    } catch (error) {
                        output("ReceivedError", error.message);
                        $73c78eb17587057f$var$logger.error("PostNewQuestion", {
                            error: error
                        });
                        break;
                    }
                    const expiresAt = $73c78eb17587057f$var$getExpiresAt(record.created);
                    const newQuestion = {
                        id: record.id,
                        title: record.title,
                        author: record.author,
                        description: record.description || null,
                        phase: record.phase,
                        createdAt: new Date(record.created).getTime(),
                        expiresAt: new Date(expiresAt).getTime(),
                        proposals: [],
                        ratings: [],
                        phaseCodePublic: record.phaseCodePublic || null
                    };
                    output("ReceivedQuestion", newQuestion);
                    break;
                }
            case "PostNewProposal":
                {
                    const { value: { questionId: submittedQuestionId, title: submittedTitle, description: submittedDescription } } = incomingMessage;
                    const data = {
                        questionId: submittedQuestionId,
                        title: submittedTitle,
                        description: submittedDescription
                    };
                    let record;
                    try {
                        record = await $73c78eb17587057f$var$pb.collection("proposals").create(data);
                    } catch (error) {
                        output("ReceivedError", error.message);
                        $73c78eb17587057f$var$logger.error("PostNewProposal", {
                            id: submittedQuestionId,
                            error: error
                        });
                        break;
                    }
                    const { id: id, title: title, description: description, isExcluded: isExcluded, created: created } = record;
                    const newProposal = {
                        id: id,
                        title: title,
                        isExcluded: isExcluded,
                        ...description && {
                            description: description
                        },
                        createdAt: new Date(created).getTime()
                    };
                    output("ReceivedPublishedProposal", newProposal);
                    break;
                }
            case "ExcludeProposal":
                {
                    const { proposalId: proposalId, isExcluded: isExcluded } = incomingMessage.value;
                    await $73c78eb17587057f$var$pb.collection("proposals").update(proposalId, {
                        isExcluded: isExcluded
                    });
                    break;
                }
            case "GoToRatingPhase":
                {
                    const { questionId: questionId, phaseCode: phaseCode } = incomingMessage.value;
                    let record;
                    try {
                        record = await $73c78eb17587057f$var$pb.collection("questions").update(questionId, {
                            phase: "RATING",
                            proposalsEndedAt: new Date()
                        }, {
                            fields: "id,title,phase,author,description,created,expiresAt,proposalsEndedAt,ratingEndedAt,phaseCodePublic,expand.proposals_via_questionId.id,expand.proposals_via_questionId.title,expand.proposals_via_questionId.description,expand.proposals_via_questionId.isExcluded,expand.proposals_via_questionId.questionId,expand.proposals_via_questionId.created,expand.ratings_via_questionId.proposalId,expand.ratings_via_questionId.author,expand.ratings_via_questionId.points,expand.ratings_via_questionId.created",
                            expand: "proposals_via_questionId,ratings_via_questionId",
                            headers: {
                                "X-Phase-Code": await $73c78eb17587057f$var$sha256(phaseCode) || ""
                            }
                        });
                    } catch (error) {
                        output("ReceivedError", error.message);
                        $73c78eb17587057f$var$logger.error("GoToRatingPhase", {
                            id: questionId,
                            error: error
                        });
                        break;
                    }
                    const expiresAt = $73c78eb17587057f$var$getExpiresAt(record.created);
                    const updatedQuestion = {
                        id: record.id,
                        title: record.title,
                        author: record.author,
                        description: record.description || null,
                        phase: record.phase,
                        createdAt: new Date(record.created).getTime(),
                        expiresAt: new Date(expiresAt).getTime(),
                        proposals: [],
                        ratings: [],
                        phaseCodePublic: record.phaseCodePublic || null,
                        proposalsEndedAt: record.proposalsEndedAt ? new Date(record.proposalsEndedAt).getTime() : null,
                        ratingEndedAt: record.ratingEndedAt ? new Date(record.ratingEndedAt).getTime() : null,
                        proposals: record.expand?.proposals_via_questionId?.map((proposal)=>({
                                ...proposal,
                                description: proposal.description || null,
                                createdAt: new Date(proposal.created).getTime()
                            })) || [],
                        ratings: record.expand?.ratings_via_questionId?.map((rating)=>({
                                ...rating,
                                proposalId: rating.proposalId ?? "DEFAULT",
                                createdAt: new Date(rating.created).getTime()
                            })) || []
                    };
                    output("ReceivedQuestion", updatedQuestion);
                    break;
                }
            case "PostRatings":
                {
                    const { questionId: questionId, author: author, ratings: ratings } = incomingMessage.value;
                    const batchRatings = $73c78eb17587057f$var$pb.createBatch();
                    for (const [proposalId, points] of ratings){
                        const data = {
                            author: author,
                            points: points,
                            proposalId: proposalId,
                            questionId: questionId
                        };
                        batchRatings.collection("ratings").create(data);
                    }
                    let result;
                    try {
                        result = await batchRatings.send();
                    } catch (error) {
                        output("ReceivedError", error.message);
                        $73c78eb17587057f$var$logger.error("PostNewRatings", {
                            id: questionId,
                            error: error
                        });
                    }
                    const publishedRating = result.map((rating)=>({
                            ...rating.body,
                            proposalId: rating.body.proposalId ?? "DEFAULT",
                            createdAt: new Date(rating.body.created).getTime()
                        }));
                    output("ReceivedPublishedRating", publishedRating);
                    break;
                }
            case "GoToResultPhase":
                {
                    const { questionId: questionId, phaseCode: phaseCode } = incomingMessage.value;
                    let record;
                    try {
                        record = await $73c78eb17587057f$var$pb.collection("questions").update(questionId, {
                            phase: "RESULT",
                            ratingEndedAt: new Date()
                        }, {
                            fields: "id,title,phase,author,description,created,expiresAt,proposalsEndedAt,ratingEndedAt,phaseCodePublic,expand.proposals_via_questionId.id,expand.proposals_via_questionId.title,expand.proposals_via_questionId.description,expand.proposals_via_questionId.isExcluded,expand.proposals_via_questionId.questionId,expand.proposals_via_questionId.created,expand.ratings_via_questionId.proposalId,expand.ratings_via_questionId.author,expand.ratings_via_questionId.points,expand.ratings_via_questionId.created",
                            expand: "proposals_via_questionId,ratings_via_questionId",
                            headers: {
                                "X-Phase-Code": await $73c78eb17587057f$var$sha256(phaseCode) || ""
                            }
                        });
                    } catch (error) {
                        output("ReceivedError", error.message);
                        $73c78eb17587057f$var$logger.error("GoToResultPhase", {
                            id: questionId,
                            error: error
                        });
                        break;
                    }
                    const expiresAt = $73c78eb17587057f$var$getExpiresAt(record.created);
                    const updatedQuestion = {
                        id: record.id,
                        title: record.title,
                        author: record.author,
                        description: record.description || null,
                        phase: record.phase,
                        createdAt: new Date(record.created).getTime(),
                        expiresAt: new Date(expiresAt).getTime(),
                        proposals: [],
                        ratings: [],
                        phaseCodePublic: record.phaseCodePublic || null,
                        proposalsEndedAt: record.proposalsEndedAt ? new Date(record.proposalsEndedAt).getTime() : null,
                        ratingEndedAt: record.ratingEndedAt ? new Date(record.ratingEndedAt).getTime() : null,
                        proposals: record.expand?.proposals_via_questionId?.map((proposal)=>({
                                ...proposal,
                                description: proposal.description || null,
                                createdAt: new Date(proposal.created).getTime()
                            })) || [],
                        ratings: record.expand?.ratings_via_questionId?.map((rating)=>({
                                ...rating,
                                proposalId: rating.proposalId ?? "DEFAULT",
                                createdAt: new Date(rating.created).getTime()
                            })) || []
                    };
                    output("ReceivedQuestion", updatedQuestion);
                    break;
                }
            case "DeleteQuestion":
                {
                    const { questionId: questionId, phaseCode: phaseCode } = incomingMessage.value;
                    await $73c78eb17587057f$var$pb.collection("questions").delete(questionId, {
                        headers: {
                            "X-Phase-Code": await $73c78eb17587057f$var$sha256(phaseCode) || ""
                        }
                    });
                    break;
                }
            case "SubscribeToPhaseChanges":
                {
                    const questionId = incomingMessage.value;
                    await $73c78eb17587057f$var$pb.collection("questions").subscribe(questionId, async ({ record: record, action: action })=>{
                        if (action === "delete") output("QuestionDeleted");
                        else {
                            const sanitizedData = {
                                proposalsEndedAt: record.proposalsEndedAt ? new Date(record.proposalsEndedAt).getTime() : null,
                                ratingEndedAt: record.ratingEndedAt ? new Date(record.ratingEndedAt).getTime() : null
                            };
                            output("ReceivedPhaseChange", sanitizedData);
                        }
                    }, {
                        fields: "proposalsEndedAt, ratingEndedAt, expand.proposals_via_questionId.id, expand.proposals_via_questionId.title, expand.proposals_via_questionId.description, expand.proposals_via_questionId.isExcluded, expand.proposals_via_questionId.questionId, expand.proposals_via_questionId.created, expand.ratings_via_questionId.proposalId, expand.ratings_via_questionId.author, expand.ratings_via_questionId.points, expand.ratings_via_questionId.created",
                        expand: "proposals_via_questionId,ratings_via_questionId"
                    });
                    break;
                }
            case "SubscribeToNewProposals":
                {
                    const questionId = incomingMessage.value;
                    await $73c78eb17587057f$var$pb.collection("proposals").subscribe("*", async ({ record: record })=>{
                        try {
                            const proposals = await $73c78eb17587057f$var$pb.collection("questions").getOne(record.questionId, {
                                fields: "expand.proposals_via_questionId.id,expand.proposals_via_questionId.title,expand.proposals_via_questionId.description,expand.proposals_via_questionId.isExcluded,expand.proposals_via_questionId.questionId,expand.proposals_via_questionId.created",
                                expand: "proposals_via_questionId"
                            });
                            const updatedProposals = proposals.expand.proposals_via_questionId.map((proposal)=>({
                                    ...proposal,
                                    description: proposal.description || null,
                                    createdAt: new Date(proposal.created).getTime()
                                }));
                            output("ReceivedNewProposals", updatedProposals);
                        } catch (error) {
                            if (error.message.includes("autocancelled")) return;
                            console.error(error);
                        }
                    }, {
                        filter: `questionId="${questionId}"`
                    });
                    break;
                }
            case "SubscribeToNewRatings":
                {
                    const questionId = incomingMessage.value;
                    await $73c78eb17587057f$var$pb.collection("ratings").subscribe("*", async ({ record: record })=>{
                        try {
                            const ratings = await $73c78eb17587057f$var$pb.collection("questions").getOne(record.questionId, {
                                fields: "expand.ratings_via_questionId.proposalId,expand.ratings_via_questionId.author,expand.ratings_via_questionId.points,expand.ratings_via_questionId.created",
                                expand: "ratings_via_questionId"
                            });
                            const updatedRatings = ratings.expand.ratings_via_questionId.map((rating)=>({
                                    ...rating,
                                    proposalId: rating.proposalId ?? "DEFAULT",
                                    createdAt: new Date(rating.created).getTime()
                                }));
                            output("ReceivedNewRatings", updatedRatings);
                        } catch (error) {
                            if (error.message.includes("autocancelled")) return;
                            console.error(error);
                        }
                    }, {
                        filter: `questionId="${questionId}"`
                    });
                    break;
                }
            case "UnsubscribeFromPhaseChanges":
                $73c78eb17587057f$var$pb.collection("questions").unsubscribe(incomingMessage.value);
                break;
            case "UnsubscribeFromNewProposals":
                $73c78eb17587057f$var$pb.collection("proposals").unsubscribe("*");
                break;
            case "UnsubscribeFromNewRatings":
                $73c78eb17587057f$var$pb.collection("ratings").unsubscribe("*");
                break;
            case "HashPhaseCode":
                {
                    const text = incomingMessage.value;
                    const hash = await $73c78eb17587057f$var$sha256(await $73c78eb17587057f$var$sha256(text));
                    output("ReceivedHashedPhaseCode", hash);
                    break;
                }
            case "HashDeleteCode":
                {
                    const text = incomingMessage.value;
                    const hash = await $73c78eb17587057f$var$sha256(await $73c78eb17587057f$var$sha256(text));
                    output("ReceivedHashedDeleteCode", hash);
                    break;
                }
            default:
                $73c78eb17587057f$var$logger.error("JS received unkown message from Elm", incomingMessage);
        }
    };
}
async function $73c78eb17587057f$var$sha256(text) {
    if (typeof text !== "string") return null;
    try {
        const msgUint8 = new TextEncoder().encode(text);
        const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, "0")).join("");
        return hashHex;
    } catch (error) {
        return null;
    }
}
function $73c78eb17587057f$var$getExpiresAt(created) {
    const expiresAt = new Date(created);
    expiresAt.setDate(expiresAt.getDate() + 43);
    expiresAt.setUTCHours(0, 0, 0);
    return expiresAt;
}


var $8b0a2fc63d791dc6$exports = {};
$8b0a2fc63d791dc6$exports = $parcel$resolve("4uhYv");


const $1f0dc3b9307be026$var$app = (0, $51bb400a14a72998$exports.Elm).Main.init({
    flags: {
        seed: Date.now(),
        now: Math.round(Date.now()),
        url: window.location.href,
        copy: window.COPY,
        config: {
            appUrlEnglish: "https://lets.konsens.it",
            appUrlGerman: "https://mit.konsens.it",
            appUrlSpanish: "https://con.konsens.it",
            websiteUrl: "https://konsens.it/es",
            tinyteamUrl: "https://www.tinyteam.de",
            donateUrl: "https://paypal.me/marthaberlin",
            feedbackFormUrl: "https://tally.so/embed/3yPklX?hideTitle=1&alignLeft=1",
            logoUrl: new URL($8b0a2fc63d791dc6$exports).href
        }
    },
    node: document.getElementById("app")
});
$1f0dc3b9307be026$var$app.ports.toJS.subscribe((0, $73c78eb17587057f$export$2e2bcd8739ae039)((tag, value)=>$1f0dc3b9307be026$var$app.ports.fromJS.send({
        tag: tag,
        value: value
    })));
$1f0dc3b9307be026$var$app.ports.selectText.subscribe((identifier)=>{
    document.querySelector(identifier).select();
});
$1f0dc3b9307be026$var$app.ports.copyToClipboard.subscribe(async ([elementId, text])=>{
    const button = document.getElementById(elementId);
    await navigator.clipboard.writeText(text);
    button.querySelector("div").classList.remove("opacity-0");
    button.querySelector("button").classList.add("opacity-0");
    setTimeout(()=>{
        button.querySelector("div").classList.add("opacity-0");
        button.querySelector("button").classList.remove("opacity-0");
    }, 2000);
});
$1f0dc3b9307be026$var$app.ports.showToast.subscribe(async (message)=>{
    const toast = document.getElementById("toast");
    if (message !== "") toast.lastElementChild.innerHTML = message;
    else toast.lastElementChild.innerHTML = "Sorry, someting went wrong. Please try again.";
    if (!toast.classList.contains("opacity-0")) return;
    toast.classList.remove("opacity-0", "-translate-y-1/2");
    setTimeout(()=>{
        toast.classList.add("opacity-0", "-translate-y-1/2");
    }, 5000);
});

$1f0dc3b9307be026$var$app.ports.pressedFoundErrorButton.subscribe(async (questionId)=>{
    await $1f0dc3b9307be026$var$loadExternalScript("https://tally.so/widgets/embed.js");
    const Bowser = await (parcelRequire("doPjA"));
    const { browser: browser, os: os } = Bowser.parse(window.navigator.userAgent);
    Tally.openPopup("nrje5l", {
        layout: "modal",
        width: 500,
        hideTitle: true,
        hiddenFields: {
            question_id: questionId,
            browser: [
                browser.name,
                browser.version
            ].join(" "),
            os: [
                os.name,
                os.versionName,
                os.version
            ].join(" ")
        }
    });
});
$1f0dc3b9307be026$var$app.ports.disableScrolling.subscribe((boolean)=>{
    document.body.classList.toggle("disable-scrolling", boolean);
});
$1f0dc3b9307be026$var$app.ports.updateUrl.subscribe((url)=>{
    if (url.startsWith("http")) window.location.href = url;
    else history.replaceState(null, "", url);
});
$1f0dc3b9307be026$var$app.ports.updateTitle.subscribe((title)=>{
    document.title = title + " | Let\u2019s konsens it!";
});
class $1f0dc3b9307be026$var$TextareaAutosize extends HTMLElement {
    connectedCallback() {
        const textarea = this.querySelector("textarea");
        if (textarea) (0, $48fcce4feeb834ff$export$2e2bcd8739ae039)(textarea);
    }
}
customElements.define("textarea-autosize", $1f0dc3b9307be026$var$TextareaAutosize);
async function $1f0dc3b9307be026$var$loadExternalScript(url) {
    return new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.src = url;
        script.onload = resolve;
        script.onerorr = reject;
        document.body.appendChild(script);
    });
}


//# sourceMappingURL=repo.6ffb1b2f.js.map
